/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AcceptAnswerRequest
 */
export interface AcceptAnswerRequest {
    /**
     * 
     * @type {string}
     * @memberof AcceptAnswerRequest
     */
    'thoughtPublicId': string;
}
/**
 * 
 * @export
 * @interface AccountLinkageViewDTO
 */
export interface AccountLinkageViewDTO {
    /**
     * 
     * @type {string}
     * @memberof AccountLinkageViewDTO
     */
    'username'?: string;
    /**
     * 
     * @type {AccountRiskSnapshotDTO}
     * @memberof AccountLinkageViewDTO
     */
    'latestSnapshot'?: AccountRiskSnapshotDTO;
    /**
     * 
     * @type {Array<LinkedAccountDTO>}
     * @memberof AccountLinkageViewDTO
     */
    'linkedAccounts'?: Array<LinkedAccountDTO>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccountLinkageViewDTO
     */
    'clusterMembers'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AccountRiskSnapshotDTO
 */
export interface AccountRiskSnapshotDTO {
    /**
     * 
     * @type {string}
     * @memberof AccountRiskSnapshotDTO
     */
    'snapshotAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof AccountRiskSnapshotDTO
     */
    'riskScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountRiskSnapshotDTO
     */
    'botLikelihood'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AccountRiskSnapshotDTO
     */
    'clustered'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AccountRiskSnapshotDTO
     */
    'linkedAccountsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountRiskSnapshotDTO
     */
    'strongestLinkScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountRiskSnapshotDTO
     */
    'recentLoginFailureCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountRiskSnapshotDTO
     */
    'recentSignupNeighborCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof AccountRiskSnapshotDTO
     */
    'lastCountryCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AccountRiskSnapshotDTO
     */
    'lastAsn'?: string;
}
/**
 * 
 * @export
 * @interface AchievementCabinetDTO
 */
export interface AchievementCabinetDTO {
    /**
     * 
     * @type {boolean}
     * @memberof AchievementCabinetDTO
     */
    'ownProfile'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AchievementCabinetDTO
     */
    'earnedRungCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AchievementCabinetDTO
     */
    'earnedFamilyCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof AchievementCabinetDTO
     */
    'totalRungCount'?: number;
    /**
     * 
     * @type {Array<Layer>}
     * @memberof AchievementCabinetDTO
     */
    'layers'?: Array<Layer>;
    /**
     * 
     * @type {Array<Distinction>}
     * @memberof AchievementCabinetDTO
     */
    'distinctions'?: Array<Distinction>;
    /**
     * 
     * @type {VoiceOfMonth}
     * @memberof AchievementCabinetDTO
     */
    'voiceOfMonth'?: VoiceOfMonth;
    /**
     * 
     * @type {string}
     * @memberof AchievementCabinetDTO
     */
    'featuredDistinctionChoice'?: string;
}
/**
 * 
 * @export
 * @interface AddDiscussionToGroupResultDTO
 */
export interface AddDiscussionToGroupResultDTO {
    /**
     * 
     * @type {string}
     * @memberof AddDiscussionToGroupResultDTO
     */
    'status'?: AddDiscussionToGroupResultDTOStatusEnum;
}

export const AddDiscussionToGroupResultDTOStatusEnum = {
    Added: 'ADDED',
    PendingLeaderReview: 'PENDING_LEADER_REVIEW',
    AlreadyAdded: 'ALREADY_ADDED'
} as const;

export type AddDiscussionToGroupResultDTOStatusEnum = typeof AddDiscussionToGroupResultDTOStatusEnum[keyof typeof AddDiscussionToGroupResultDTOStatusEnum];

/**
 * 
 * @export
 * @interface AjaxValidationErrorResult
 */
export interface AjaxValidationErrorResult {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof AjaxValidationErrorResult
     */
    'errors'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface AppInstallReportRequest
 */
export interface AppInstallReportRequest {
    /**
     * 
     * @type {string}
     * @memberof AppInstallReportRequest
     */
    'installId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppInstallReportRequest
     */
    'platform'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppInstallReportRequest
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppInstallReportRequest
     */
    'utmSource'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppInstallReportRequest
     */
    'utmMedium'?: string;
    /**
     * 
     * @type {string}
     * @memberof AppInstallReportRequest
     */
    'utmCampaign'?: string;
    /**
     * 
     * @type {number}
     * @memberof AppInstallReportRequest
     */
    'referrerClickSeconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof AppInstallReportRequest
     */
    'installBeginSeconds'?: number;
    /**
     * 
     * @type {string}
     * @memberof AppInstallReportRequest
     */
    'appVersion'?: string;
}
/**
 * 
 * @export
 * @interface AskRequest
 */
export interface AskRequest {
    /**
     * 
     * @type {string}
     * @memberof AskRequest
     */
    'username'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AskRequest
     */
    'suggested'?: boolean;
}
/**
 * 
 * @export
 * @interface AskState
 */
export interface AskState {
    /**
     * 
     * @type {Array<Suggestion>}
     * @memberof AskState
     */
    'suggestions'?: Array<Suggestion>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AskState
     */
    'asked'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AskState
     */
    'remaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof AskState
     */
    'max'?: number;
}
/**
 * 
 * @export
 * @interface AuthorAffinityResponse
 */
export interface AuthorAffinityResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AuthorAffinityResponse
     */
    'hasReadAnotherPostByAuthor': boolean;
}
/**
 * 
 * @export
 * @interface AuthorPostBreakdownDto
 */
export interface AuthorPostBreakdownDto {
    /**
     * 
     * @type {string}
     * @memberof AuthorPostBreakdownDto
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthorPostBreakdownDto
     */
    'periodType'?: AuthorPostBreakdownDtoPeriodTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AuthorPostBreakdownDto
     */
    'periodCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof AuthorPostBreakdownDto
     */
    'startAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthorPostBreakdownDto
     */
    'endAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthorPostBreakdownDto
     */
    'humanizedHint'?: string;
    /**
     * 
     * @type {Array<AuthorReadSourceSliceDto>}
     * @memberof AuthorPostBreakdownDto
     */
    'sources'?: Array<AuthorReadSourceSliceDto>;
    /**
     * 
     * @type {number}
     * @memberof AuthorPostBreakdownDto
     */
    'attributedReads'?: number;
    /**
     * 
     * @type {Array<AuthorPostBreakdownRowDto>}
     * @memberof AuthorPostBreakdownDto
     */
    'posts'?: Array<AuthorPostBreakdownRowDto>;
    /**
     * 
     * @type {number}
     * @memberof AuthorPostBreakdownDto
     */
    'postLimit'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AuthorPostBreakdownDto
     */
    'postsTruncated'?: boolean;
}

export const AuthorPostBreakdownDtoPeriodTypeEnum = {
    Hour: 'hour',
    Day: 'day',
    Week: 'week',
    Month: 'month'
} as const;

export type AuthorPostBreakdownDtoPeriodTypeEnum = typeof AuthorPostBreakdownDtoPeriodTypeEnum[keyof typeof AuthorPostBreakdownDtoPeriodTypeEnum];

/**
 * 
 * @export
 * @interface AuthorPostBreakdownRowDto
 */
export interface AuthorPostBreakdownRowDto {
    /**
     * 
     * @type {string}
     * @memberof AuthorPostBreakdownRowDto
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthorPostBreakdownRowDto
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthorPostBreakdownRowDto
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthorPostBreakdownRowDto
     */
    'publishedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof AuthorPostBreakdownRowDto
     */
    'reads'?: number;
    /**
     * 
     * @type {number}
     * @memberof AuthorPostBreakdownRowDto
     */
    'readers'?: number;
    /**
     * 
     * @type {number}
     * @memberof AuthorPostBreakdownRowDto
     */
    'thoughts'?: number;
    /**
     * 
     * @type {number}
     * @memberof AuthorPostBreakdownRowDto
     */
    'conversations'?: number;
}
/**
 * 
 * @export
 * @interface AuthorReadSourceSliceDto
 */
export interface AuthorReadSourceSliceDto {
    /**
     * 
     * @type {string}
     * @memberof AuthorReadSourceSliceDto
     */
    'source'?: string;
    /**
     * 
     * @type {number}
     * @memberof AuthorReadSourceSliceDto
     */
    'reads'?: number;
}
/**
 * 
 * @export
 * @interface BackfillResult
 */
export interface BackfillResult {
    /**
     * 
     * @type {number}
     * @memberof BackfillResult
     */
    'scanned'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackfillResult
     */
    'updated'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackfillResult
     */
    'alreadyPresent'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackfillResult
     */
    'objectMissing'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackfillResult
     */
    'metadataMissing'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackfillResult
     */
    'failed'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackfillResult
     */
    'lastScannedId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BackfillResult
     */
    'hasMore'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BackfillResult
     */
    'enabled'?: boolean;
}
/**
 * 
 * @export
 * @interface BanUserRequest
 */
export interface BanUserRequest {
    /**
     * 
     * @type {string}
     * @memberof BanUserRequest
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof BanUserRequest
     */
    'reason': string;
    /**
     * 
     * @type {string}
     * @memberof BanUserRequest
     */
    'reasonType': BanUserRequestReasonTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BanUserRequest
     */
    'duration': BanUserRequestDurationEnum;
    /**
     * 
     * @type {string}
     * @memberof BanUserRequest
     */
    'targetUsername'?: string;
}

export const BanUserRequestReasonTypeEnum = {
    Spam: 'SPAM',
    Harassment: 'HARASSMENT',
    HateSpeech: 'HATE_SPEECH',
    Abuse: 'ABUSE',
    RuleViolation: 'RULE_VIOLATION',
    Copyright: 'COPYRIGHT',
    AiSlop: 'AI_SLOP',
    Other: 'OTHER'
} as const;

export type BanUserRequestReasonTypeEnum = typeof BanUserRequestReasonTypeEnum[keyof typeof BanUserRequestReasonTypeEnum];
export const BanUserRequestDurationEnum = {
    Permanent: 'PERMANENT',
    OneDay: 'ONE_DAY',
    ThreeDays: 'THREE_DAYS',
    OneWeek: 'ONE_WEEK',
    OneMonth: 'ONE_MONTH'
} as const;

export type BanUserRequestDurationEnum = typeof BanUserRequestDurationEnum[keyof typeof BanUserRequestDurationEnum];

/**
 * 
 * @export
 * @interface BannedUserDTO
 */
export interface BannedUserDTO {
    /**
     * 
     * @type {string}
     * @memberof BannedUserDTO
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof BannedUserDTO
     */
    'duration'?: BannedUserDTODurationEnum;
    /**
     * 
     * @type {string}
     * @memberof BannedUserDTO
     */
    'bannedUntil'?: string;
    /**
     * 
     * @type {string}
     * @memberof BannedUserDTO
     */
    'reasonType'?: BannedUserDTOReasonTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BannedUserDTO
     */
    'bannedBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof BannedUserDTO
     */
    'bannedByProfileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof BannedUserDTO
     */
    'bannedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof BannedUserDTO
     */
    'conversationsParticipatedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof BannedUserDTO
     */
    'discussionsAuthoredCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof BannedUserDTO
     */
    'mindsChangedReceivedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof BannedUserDTO
     */
    'userId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BannedUserDTO
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BannedUserDTO
     */
    'profileStatement'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BannedUserDTO
     */
    'isViewerFollowing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BannedUserDTO
     */
    'argumentsAuthoredCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof BannedUserDTO
     */
    'agreementsReceivedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof BannedUserDTO
     */
    'followersCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof BannedUserDTO
     */
    'followingCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BannedUserDTO
     */
    'viewerIsOwner'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BannedUserDTO
     */
    'canMessage'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BannedUserDTO
     */
    'profileViewsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof BannedUserDTO
     */
    'profileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof BannedUserDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {string}
     * @memberof BannedUserDTO
     */
    'viewerFollowingAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof BannedUserDTO
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof BannedUserDTO
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof BannedUserDTO
     */
    'creationDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BannedUserDTO
     */
    'isFollowingViewer'?: boolean;
}

export const BannedUserDTODurationEnum = {
    Permanent: 'PERMANENT',
    OneDay: 'ONE_DAY',
    ThreeDays: 'THREE_DAYS',
    OneWeek: 'ONE_WEEK',
    OneMonth: 'ONE_MONTH'
} as const;

export type BannedUserDTODurationEnum = typeof BannedUserDTODurationEnum[keyof typeof BannedUserDTODurationEnum];
export const BannedUserDTOReasonTypeEnum = {
    Spam: 'SPAM',
    Harassment: 'HARASSMENT',
    HateSpeech: 'HATE_SPEECH',
    Abuse: 'ABUSE',
    RuleViolation: 'RULE_VIOLATION',
    Copyright: 'COPYRIGHT',
    AiSlop: 'AI_SLOP',
    Other: 'OTHER'
} as const;

export type BannedUserDTOReasonTypeEnum = typeof BannedUserDTOReasonTypeEnum[keyof typeof BannedUserDTOReasonTypeEnum];

/**
 * 
 * @export
 * @interface BestThoughtDTO
 */
export interface BestThoughtDTO {
    /**
     * 
     * @type {string}
     * @memberof BestThoughtDTO
     */
    'thoughtPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BestThoughtDTO
     */
    'authorUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof BestThoughtDTO
     */
    'authorProfileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof BestThoughtDTO
     */
    'preview'?: string;
    /**
     * 
     * @type {number}
     * @memberof BestThoughtDTO
     */
    'sameSideAgreements'?: number;
}
/**
 * 
 * @export
 * @interface BoardCardSummaryDTO
 */
export interface BoardCardSummaryDTO {
    /**
     * 
     * @type {string}
     * @memberof BoardCardSummaryDTO
     */
    'kind'?: string;
    /**
     * 
     * @type {Array<BoardSlotViewDTO>}
     * @memberof BoardCardSummaryDTO
     */
    'slots'?: Array<BoardSlotViewDTO>;
    /**
     * 
     * @type {BoardItemViewDTO}
     * @memberof BoardCardSummaryDTO
     */
    'openItem'?: BoardItemViewDTO;
    /**
     * 
     * @type {Array<BoardItemViewDTO>}
     * @memberof BoardCardSummaryDTO
     */
    'placedItems'?: Array<BoardItemViewDTO>;
    /**
     * 
     * @type {Array<BoardItemViewDTO>}
     * @memberof BoardCardSummaryDTO
     */
    'upcomingItems'?: Array<BoardItemViewDTO>;
    /**
     * 
     * @type {string}
     * @memberof BoardCardSummaryDTO
     */
    'viewerVoteSlotKey'?: string;
    /**
     * 
     * @type {number}
     * @memberof BoardCardSummaryDTO
     */
    'itemsTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof BoardCardSummaryDTO
     */
    'itemsSettled'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BoardCardSummaryDTO
     */
    'complete'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BoardCardSummaryDTO
     */
    'labelColumnPx'?: number;
    /**
     * 
     * @type {number}
     * @memberof BoardCardSummaryDTO
     */
    'itemWindowHours'?: number;
}
/**
 * 
 * @export
 * @interface BoardItemAppendRequest
 */
export interface BoardItemAppendRequest {
    /**
     * 
     * @type {string}
     * @memberof BoardItemAppendRequest
     */
    'label'?: string;
}
/**
 * 
 * @export
 * @interface BoardItemInput
 */
export interface BoardItemInput {
    /**
     * 
     * @type {string}
     * @memberof BoardItemInput
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof BoardItemInput
     */
    'imagePublicId'?: string;
}
/**
 * 
 * @export
 * @interface BoardItemViewDTO
 */
export interface BoardItemViewDTO {
    /**
     * 
     * @type {number}
     * @memberof BoardItemViewDTO
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof BoardItemViewDTO
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof BoardItemViewDTO
     */
    'imagePublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BoardItemViewDTO
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof BoardItemViewDTO
     */
    'openedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof BoardItemViewDTO
     */
    'settledSlotKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof BoardItemViewDTO
     */
    'settledAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof BoardItemViewDTO
     */
    'settleMethod'?: string;
    /**
     * 
     * @type {string}
     * @memberof BoardItemViewDTO
     */
    'overrideReason'?: string;
    /**
     * 
     * @type {number}
     * @memberof BoardItemViewDTO
     */
    'votesCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof BoardItemViewDTO
     */
    'thoughtsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof BoardItemViewDTO
     */
    'viewerSlotKey'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BoardItemViewDTO
     */
    'open'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BoardItemViewDTO
     */
    'settled'?: boolean;
}
/**
 * 
 * @export
 * @interface BoardMuteState
 */
export interface BoardMuteState {
    /**
     * 
     * @type {string}
     * @memberof BoardMuteState
     */
    'groupPublicId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BoardMuteState
     */
    'muted'?: boolean;
}
/**
 * 
 * @export
 * @interface BoardSettleRequest
 */
export interface BoardSettleRequest {
    /**
     * 
     * @type {string}
     * @memberof BoardSettleRequest
     */
    'mode'?: string;
    /**
     * 
     * @type {string}
     * @memberof BoardSettleRequest
     */
    'slotKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof BoardSettleRequest
     */
    'overrideReason'?: string;
}
/**
 * 
 * @export
 * @interface BoardSlotViewDTO
 */
export interface BoardSlotViewDTO {
    /**
     * 
     * @type {string}
     * @memberof BoardSlotViewDTO
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof BoardSlotViewDTO
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof BoardSlotViewDTO
     */
    'colorToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof BoardSlotViewDTO
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface BoardViewDTO
 */
export interface BoardViewDTO {
    /**
     * 
     * @type {string}
     * @memberof BoardViewDTO
     */
    'kind'?: string;
    /**
     * 
     * @type {string}
     * @memberof BoardViewDTO
     */
    'schemaJson'?: string;
    /**
     * 
     * @type {Array<BoardSlotViewDTO>}
     * @memberof BoardViewDTO
     */
    'slots'?: Array<BoardSlotViewDTO>;
    /**
     * 
     * @type {BoardItemViewDTO}
     * @memberof BoardViewDTO
     */
    'openItem'?: BoardItemViewDTO;
    /**
     * 
     * @type {Array<BoardItemViewDTO>}
     * @memberof BoardViewDTO
     */
    'settledItems'?: Array<BoardItemViewDTO>;
    /**
     * 
     * @type {Array<BoardItemViewDTO>}
     * @memberof BoardViewDTO
     */
    'upcomingItems'?: Array<BoardItemViewDTO>;
    /**
     * 
     * @type {number}
     * @memberof BoardViewDTO
     */
    'queuedRemaining'?: number;
    /**
     * 
     * @type {number}
     * @memberof BoardViewDTO
     */
    'itemsTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof BoardViewDTO
     */
    'itemsSettled'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BoardViewDTO
     */
    'complete'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BoardViewDTO
     */
    'itemWindowHours'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BoardViewDTO
     */
    'viewerIsOwner'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BoardViewDTO
     */
    'viewerVoteSlotKey'?: string;
    /**
     * 
     * @type {number}
     * @memberof BoardViewDTO
     */
    'labelColumnPx'?: number;
    /**
     * 
     * @type {string}
     * @memberof BoardViewDTO
     */
    'leaderSlotKey'?: string;
}
/**
 * 
 * @export
 * @interface BoardVoteRequest
 */
export interface BoardVoteRequest {
    /**
     * 
     * @type {string}
     * @memberof BoardVoteRequest
     */
    'slotKey': string;
}
/**
 * 
 * @export
 * @interface Candidate
 */
export interface Candidate {
    /**
     * 
     * @type {string}
     * @memberof Candidate
     */
    'kind'?: string;
    /**
     * 
     * @type {string}
     * @memberof Candidate
     */
    'targetPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Candidate
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof Candidate
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface CaptureSignupEmailRequest
 */
export interface CaptureSignupEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof CaptureSignupEmailRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CaptureSignupEmailRequest
     */
    'surface'?: string;
}
/**
 * 
 * @export
 * @interface ChangeEmailRequest
 */
export interface ChangeEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangeEmailRequest
     */
    'newEmail': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeEmailRequest
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeEmailRequest
     */
    'code'?: string;
}
/**
 * 
 * @export
 * @interface ChangePasswordRequest
 */
export interface ChangePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    'oldPassword': string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    'confirmPassword': string;
}
/**
 * 
 * @export
 * @interface ChangeUsernameRequest
 */
export interface ChangeUsernameRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangeUsernameRequest
     */
    'username': string;
}
/**
 * 
 * @export
 * @interface ChatCounterpartyDTO
 */
export interface ChatCounterpartyDTO {
    /**
     * 
     * @type {number}
     * @memberof ChatCounterpartyDTO
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChatCounterpartyDTO
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatCounterpartyDTO
     */
    'groupPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatCounterpartyDTO
     */
    'displayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatCounterpartyDTO
     */
    'imageUrl'?: string;
}
/**
 * 
 * @export
 * @interface ChatMessageDTO
 */
export interface ChatMessageDTO {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDTO
     */
    'threadPublicId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ChatMessageDTO
     */
    'senderUserId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDTO
     */
    'senderUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDTO
     */
    'senderProfileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDTO
     */
    'body'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChatMessageDTO
     */
    'viewerOwnMessage'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDTO
     */
    'clientRequestId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChatMessageDTO
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatMessageDTO
     */
    'viewerCanPromote'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDTO
     */
    'promotedDiscussionSlug'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDTO
     */
    'replyToMessagePublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDTO
     */
    'replyToSenderUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDTO
     */
    'replyToExcerpt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChatMessageDTO
     */
    'replyToDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDTO
     */
    'attachments'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChatMessageDTO
     */
    'viewerBlockedAuthor'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDTO
     */
    'reactionCounts'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDTO
     */
    'viewerReactions'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatMessageDTO
     */
    'editedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChatMessageDTO
     */
    'forwarded'?: boolean;
}
/**
 * 
 * @export
 * @interface ChatMessageReactionRequest
 */
export interface ChatMessageReactionRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatMessageReactionRequest
     */
    'reaction'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChatMessageReactionRequest
     */
    'active'?: boolean;
}
/**
 * 
 * @export
 * @interface ChatThreadDetailDTO
 */
export interface ChatThreadDetailDTO {
    /**
     * 
     * @type {string}
     * @memberof ChatThreadDetailDTO
     */
    'threadPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatThreadDetailDTO
     */
    'kind'?: ChatThreadDetailDTOKindEnum;
    /**
     * 
     * @type {number}
     * @memberof ChatThreadDetailDTO
     */
    'participantUserId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChatThreadDetailDTO
     */
    'participantUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatThreadDetailDTO
     */
    'participantProfileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatThreadDetailDTO
     */
    'groupPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatThreadDetailDTO
     */
    'groupName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatThreadDetailDTO
     */
    'groupImageUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof ChatThreadDetailDTO
     */
    'memberCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChatThreadDetailDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatThreadDetailDTO
     */
    'lastMessageAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatThreadDetailDTO
     */
    'lastReadMessagePublicId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ChatThreadDetailDTO
     */
    'unreadMessageCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChatThreadDetailDTO
     */
    'canMessage'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChatThreadDetailDTO
     */
    'viewerRestrictionReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatThreadDetailDTO
     */
    'viewerRestrictedUntil'?: string;
}

export const ChatThreadDetailDTOKindEnum = {
    Direct: 'DIRECT',
    Group: 'GROUP'
} as const;

export type ChatThreadDetailDTOKindEnum = typeof ChatThreadDetailDTOKindEnum[keyof typeof ChatThreadDetailDTOKindEnum];

/**
 * 
 * @export
 * @interface ChatThreadSummaryDTO
 */
export interface ChatThreadSummaryDTO {
    /**
     * 
     * @type {string}
     * @memberof ChatThreadSummaryDTO
     */
    'threadPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatThreadSummaryDTO
     */
    'kind'?: ChatThreadSummaryDTOKindEnum;
    /**
     * 
     * @type {ChatCounterpartyDTO}
     * @memberof ChatThreadSummaryDTO
     */
    'counterparty'?: ChatCounterpartyDTO;
    /**
     * 
     * @type {string}
     * @memberof ChatThreadSummaryDTO
     */
    'lastMessagePreview'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatThreadSummaryDTO
     */
    'lastMessageSenderUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatThreadSummaryDTO
     */
    'lastMessageAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChatThreadSummaryDTO
     */
    'unread'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatThreadSummaryDTO
     */
    'awaitingReply'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatThreadSummaryDTO
     */
    'lastMessageDeleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChatThreadSummaryDTO
     */
    'memberCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ChatThreadSummaryDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChatThreadSummaryDTO
     */
    'favorite'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatThreadSummaryDTO
     */
    'mentioned'?: boolean;
}

export const ChatThreadSummaryDTOKindEnum = {
    Direct: 'DIRECT',
    Group: 'GROUP'
} as const;

export type ChatThreadSummaryDTOKindEnum = typeof ChatThreadSummaryDTOKindEnum[keyof typeof ChatThreadSummaryDTOKindEnum];

/**
 * 
 * @export
 * @interface ChatUnreadCountDTO
 */
export interface ChatUnreadCountDTO {
    /**
     * 
     * @type {number}
     * @memberof ChatUnreadCountDTO
     */
    'unreadCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatUnreadCountDTO
     */
    'directUnreadCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatUnreadCountDTO
     */
    'groupUnreadCount'?: number;
}
/**
 * 
 * @export
 * @interface CircleOfferDTO
 */
export interface CircleOfferDTO {
    /**
     * 
     * @type {string}
     * @memberof CircleOfferDTO
     */
    'status'?: CircleOfferDTOStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CircleOfferDTO
     */
    'language'?: string;
    /**
     * 
     * @type {string}
     * @memberof CircleOfferDTO
     */
    'circleGroupPublicId'?: string;
}

export const CircleOfferDTOStatusEnum = {
    None: 'NONE',
    Offered: 'OFFERED',
    Joined: 'JOINED',
    Placed: 'PLACED',
    Lapsed: 'LAPSED'
} as const;

export type CircleOfferDTOStatusEnum = typeof CircleOfferDTOStatusEnum[keyof typeof CircleOfferDTOStatusEnum];

/**
 * 
 * @export
 * @interface CircleOfferRequest
 */
export interface CircleOfferRequest {
    /**
     * 
     * @type {string}
     * @memberof CircleOfferRequest
     */
    'discussionPublicId': string;
}
/**
 * 
 * @export
 * @interface ClientLogDto
 */
export interface ClientLogDto {
    /**
     * 
     * @type {string}
     * @memberof ClientLogDto
     */
    'level'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientLogDto
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientLogDto
     */
    'stack'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientLogDto
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientLogDto
     */
    'userAgent'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientLogDto
     */
    'ts'?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ClientLogDto
     */
    'extra'?: { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface ClipMultipartCompleteRequest
 */
export interface ClipMultipartCompleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ClipMultipartCompleteRequest
     */
    'imagePublicId': string;
    /**
     * 
     * @type {string}
     * @memberof ClipMultipartCompleteRequest
     */
    'uploadId': string;
    /**
     * 
     * @type {Array<Part>}
     * @memberof ClipMultipartCompleteRequest
     */
    'parts': Array<Part>;
}
/**
 * 
 * @export
 * @interface ClipMultipartPartUrlRequest
 */
export interface ClipMultipartPartUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof ClipMultipartPartUrlRequest
     */
    'imagePublicId': string;
    /**
     * 
     * @type {string}
     * @memberof ClipMultipartPartUrlRequest
     */
    'uploadId': string;
    /**
     * 
     * @type {number}
     * @memberof ClipMultipartPartUrlRequest
     */
    'partNumber': number;
    /**
     * 
     * @type {number}
     * @memberof ClipMultipartPartUrlRequest
     */
    'contentLengthBytes': number;
}
/**
 * 
 * @export
 * @interface ClipMultipartPartUrlResponse
 */
export interface ClipMultipartPartUrlResponse {
    /**
     * 
     * @type {string}
     * @memberof ClipMultipartPartUrlResponse
     */
    'presignedUrl'?: string;
}
/**
 * 
 * @export
 * @interface ClipMultipartUploadCompletedResponse
 */
export interface ClipMultipartUploadCompletedResponse {
    /**
     * 
     * @type {string}
     * @memberof ClipMultipartUploadCompletedResponse
     */
    'ownerUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClipMultipartUploadCompletedResponse
     */
    'imagePublicId'?: string;
}
/**
 * 
 * @export
 * @interface ClipMultipartUploadCreatedResponse
 */
export interface ClipMultipartUploadCreatedResponse {
    /**
     * 
     * @type {string}
     * @memberof ClipMultipartUploadCreatedResponse
     */
    'imagePublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClipMultipartUploadCreatedResponse
     */
    'ownerUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClipMultipartUploadCreatedResponse
     */
    'uploadId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClipMultipartUploadCreatedResponse
     */
    'partSizeBytes'?: number;
    /**
     * 
     * @type {number}
     * @memberof ClipMultipartUploadCreatedResponse
     */
    'partCount'?: number;
}
/**
 * 
 * @export
 * @interface ColorDto
 */
export interface ColorDto {
    /**
     * 
     * @type {string}
     * @memberof ColorDto
     */
    'border'?: string;
    /**
     * 
     * @type {string}
     * @memberof ColorDto
     */
    'background'?: string;
}
/**
 * 
 * @export
 * @interface ComposerSignalRequest
 */
export interface ComposerSignalRequest {
    /**
     * 
     * @type {string}
     * @memberof ComposerSignalRequest
     */
    'signal'?: string;
    /**
     * 
     * @type {string}
     * @memberof ComposerSignalRequest
     */
    'entityType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ComposerSignalRequest
     */
    'entityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ComposerSignalRequest
     */
    'stage'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ComposerSignalRequest
     */
    'blockedFields'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ComposerSignalRequest
     */
    'blockedFieldsEffective'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ComposerSignalRequest
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof ComposerSignalRequest
     */
    'bodySize'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ComposerSignalRequest
     */
    'publishAttempted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ComposerSignalRequest
     */
    'reachedPreview'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ComposerSignalRequest
     */
    'facet'?: string;
    /**
     * 
     * @type {number}
     * @memberof ComposerSignalRequest
     */
    'boardItems'?: number;
}
/**
 * 
 * @export
 * @interface ConnectionEventDTO
 */
export interface ConnectionEventDTO {
    /**
     * 
     * @type {string}
     * @memberof ConnectionEventDTO
     */
    'occurredAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectionEventDTO
     */
    'eventType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectionEventDTO
     */
    'authMethod'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectionEventDTO
     */
    'countryCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectionEventDTO
     */
    'cityName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectionEventDTO
     */
    'asn'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectionEventDTO
     */
    'requestSource'?: string;
}
/**
 * 
 * @export
 * @interface ContactRequest
 */
export interface ContactRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ContactRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactRequest
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof ContactRequest
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface CountDiscussionViewRequest
 */
export interface CountDiscussionViewRequest {
    /**
     * 
     * @type {string}
     * @memberof CountDiscussionViewRequest
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof CountDiscussionViewRequest
     */
    'sourceDetail'?: string;
    /**
     * 
     * @type {string}
     * @memberof CountDiscussionViewRequest
     */
    'shareToken'?: string;
}
/**
 * 
 * @export
 * @interface CreateContentReportRequest
 */
export interface CreateContentReportRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateContentReportRequest
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateContentReportRequest
     */
    'reasonType': CreateContentReportRequestReasonTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateContentReportRequest
     */
    'attachmentImagePublicIds'?: Array<string>;
}

export const CreateContentReportRequestReasonTypeEnum = {
    Spam: 'SPAM',
    Harassment: 'HARASSMENT',
    HateSpeech: 'HATE_SPEECH',
    Abuse: 'ABUSE',
    SexualContent: 'SEXUAL_CONTENT',
    Csae: 'CSAE',
    ViolenceOrThreats: 'VIOLENCE_OR_THREATS',
    IllegalContent: 'ILLEGAL_CONTENT',
    FraudOrImpersonation: 'FRAUD_OR_IMPERSONATION',
    PrivacyViolation: 'PRIVACY_VIOLATION',
    SelfHarm: 'SELF_HARM',
    RuleViolation: 'RULE_VIOLATION',
    Copyright: 'COPYRIGHT',
    AiSlop: 'AI_SLOP',
    LowQuality: 'LOW_QUALITY',
    Other: 'OTHER'
} as const;

export type CreateContentReportRequestReasonTypeEnum = typeof CreateContentReportRequestReasonTypeEnum[keyof typeof CreateContentReportRequestReasonTypeEnum];

/**
 * 
 * @export
 * @interface CreateDiscussionAddToGroupRequest
 */
export interface CreateDiscussionAddToGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateDiscussionAddToGroupRequest
     */
    'note'?: string;
}
/**
 * 
 * @export
 * @interface CreateGroupBoardMessageRequest
 */
export interface CreateGroupBoardMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateGroupBoardMessageRequest
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof CreateGroupBoardMessageRequest
     */
    'parentMessagePublicId'?: string;
}
/**
 * 
 * @export
 * @interface CreateGroupInviteLinkRequest
 */
export interface CreateGroupInviteLinkRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CreateGroupInviteLinkRequest
     */
    'neverExpires'?: boolean;
}
/**
 * 
 * @export
 * @interface CreateGroupInviteRequestRequest
 */
export interface CreateGroupInviteRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateGroupInviteRequestRequest
     */
    'username': string;
}
/**
 * 
 * @export
 * @interface CreateGroupRequest
 */
export interface CreateGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateGroupRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateGroupRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGroupRequest
     */
    'thumbnailUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGroupRequest
     */
    'bannerUrl'?: string;
    /**
     * 
     * @type {SeavienLanguageTag}
     * @memberof CreateGroupRequest
     */
    'mainLocale': SeavienLanguageTag;
    /**
     * 
     * @type {boolean}
     * @memberof CreateGroupRequest
     */
    'privateAccess'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateGroupRequest
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateGroupRequest
     */
    'discussionSubmissionPolicy'?: CreateGroupRequestDiscussionSubmissionPolicyEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateGroupRequest
     */
    'tags'?: Array<string>;
}

export const CreateGroupRequestDiscussionSubmissionPolicyEnum = {
    OpenMemberAdd: 'OPEN_MEMBER_ADD',
    LeaderApprovalRequired: 'LEADER_APPROVAL_REQUIRED'
} as const;

export type CreateGroupRequestDiscussionSubmissionPolicyEnum = typeof CreateGroupRequestDiscussionSubmissionPolicyEnum[keyof typeof CreateGroupRequestDiscussionSubmissionPolicyEnum];

/**
 * 
 * @export
 * @interface CreateGroupResourceRequest
 */
export interface CreateGroupResourceRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateGroupResourceRequest
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CreateGroupResourceRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGroupResourceRequest
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof CreateGroupResourceRequest
     */
    'sortOrder'?: number;
}
/**
 * 
 * @export
 * @interface CreateGroupRuleRequest
 */
export interface CreateGroupRuleRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateGroupRuleRequest
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CreateGroupRuleRequest
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateGroupRuleRequest
     */
    'sortOrder'?: number;
}
/**
 * 
 * @export
 * @interface CreateLinkPreviewRequest
 */
export interface CreateLinkPreviewRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateLinkPreviewRequest
     */
    'url': string;
}
/**
 * 
 * @export
 * @interface CreateMemeTemplateRequest
 */
export interface CreateMemeTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateMemeTemplateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMemeTemplateRequest
     */
    'sourceImagePublicId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateMemeTemplateRequest
     */
    'tags'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMemeTemplateRequest
     */
    'defaultTextBoxes'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateMemeTemplateRequest
     */
    'perceptualHash'?: string;
}
/**
 * 
 * @export
 * @interface CreateNewsletterRequest
 */
export interface CreateNewsletterRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateNewsletterRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateNewsletterRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNewsletterRequest
     */
    'promiseLine'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNewsletterRequest
     */
    'logoUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNewsletterRequest
     */
    'coverUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNewsletterRequest
     */
    'senderDisplayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNewsletterRequest
     */
    'discoverability'?: CreateNewsletterRequestDiscoverabilityEnum;
    /**
     * 
     * @type {SeavienLanguageTag}
     * @memberof CreateNewsletterRequest
     */
    'mainLocale'?: SeavienLanguageTag;
}

export const CreateNewsletterRequestDiscoverabilityEnum = {
    Public: 'PUBLIC',
    Unlisted: 'UNLISTED'
} as const;

export type CreateNewsletterRequestDiscoverabilityEnum = typeof CreateNewsletterRequestDiscoverabilityEnum[keyof typeof CreateNewsletterRequestDiscoverabilityEnum];

/**
 * 
 * @export
 * @interface CreatePinnedDiscussionRequest
 */
export interface CreatePinnedDiscussionRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePinnedDiscussionRequest
     */
    'discussionPublicId': string;
}
/**
 * 
 * @export
 * @interface CreatePresignedUploadImageUrlRequest
 */
export interface CreatePresignedUploadImageUrlRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePresignedUploadImageUrlRequest
     */
    'contentType': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePresignedUploadImageUrlRequest
     */
    'imageName': string;
    /**
     * 
     * @type {number}
     * @memberof CreatePresignedUploadImageUrlRequest
     */
    'sizeInBytes': number;
}
/**
 * 
 * @export
 * @interface CreateRelatedGroupRequest
 */
export interface CreateRelatedGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateRelatedGroupRequest
     */
    'relatedGroupPublicId': string;
    /**
     * 
     * @type {number}
     * @memberof CreateRelatedGroupRequest
     */
    'sortOrder'?: number;
}
/**
 * 
 * @export
 * @interface CreateSeriesRequest
 */
export interface CreateSeriesRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateSeriesRequest
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSeriesRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSeriesRequest
     */
    'thumbnailUrl'?: string;
    /**
     * 
     * @type {SeavienLanguageTag}
     * @memberof CreateSeriesRequest
     */
    'mainLocale': SeavienLanguageTag;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSeriesRequest
     */
    'privateAccess'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSeriesRequest
     */
    'sensitive'?: boolean;
}


/**
 * 
 * @export
 * @interface CreateUsernameRequest
 */
export interface CreateUsernameRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateUsernameRequest
     */
    'username': string;
}
/**
 * 
 * @export
 * @interface CsrfToken
 */
export interface CsrfToken {
    /**
     * 
     * @type {string}
     * @memberof CsrfToken
     */
    'token'?: string;
    /**
     * 
     * @type {string}
     * @memberof CsrfToken
     */
    'headerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CsrfToken
     */
    'parameterName'?: string;
}
/**
 * 
 * @export
 * @interface DeclineGroupInviteRequestRequest
 */
export interface DeclineGroupInviteRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof DeclineGroupInviteRequestRequest
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface DeleteAccountRequest
 */
export interface DeleteAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof DeleteAccountRequest
     */
    'confirmationText': string;
    /**
     * 
     * @type {string}
     * @memberof DeleteAccountRequest
     */
    'password'?: string;
}
/**
 * 
 * @export
 * @interface DiscussionArchiveStateDTO
 */
export interface DiscussionArchiveStateDTO {
    /**
     * 
     * @type {string}
     * @memberof DiscussionArchiveStateDTO
     */
    'discussionPublicId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionArchiveStateDTO
     */
    'archived'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionArchiveStateDTO
     */
    'archivedAt'?: string;
}
/**
 * 
 * @export
 * @interface DiscussionDraftCountsDTO
 */
export interface DiscussionDraftCountsDTO {
    /**
     * 
     * @type {number}
     * @memberof DiscussionDraftCountsDTO
     */
    'inProgressCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionDraftCountsDTO
     */
    'scheduledCount'?: number;
}
/**
 * 
 * @export
 * @interface DiscussionDraftDTO
 */
export interface DiscussionDraftDTO {
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftDTO
     */
    'discussionPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftDTO
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftDTO
     */
    'excerpt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftDTO
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftDTO
     */
    'modifiedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftDTO
     */
    'scheduledPublishAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionDraftDTO
     */
    'privateAccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftDTO
     */
    'languageTag'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionDraftDTO
     */
    'schedulePublishReverted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftDTO
     */
    'bodyPreview'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftDTO
     */
    'deletedAt'?: string;
}
/**
 * 
 * @export
 * @interface DiscussionDraftEditorDTO
 */
export interface DiscussionDraftEditorDTO {
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftEditorDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftEditorDTO
     */
    'discussionPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftEditorDTO
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftEditorDTO
     */
    'excerpt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftEditorDTO
     */
    'sourceJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftEditorDTO
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DiscussionDraftEditorDTO
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {SeavienLanguageTag}
     * @memberof DiscussionDraftEditorDTO
     */
    'languageTag'?: SeavienLanguageTag;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionDraftEditorDTO
     */
    'privateAccess'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionDraftEditorDTO
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftEditorDTO
     */
    'sensitiveSource'?: DiscussionDraftEditorDTOSensitiveSourceEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionDraftEditorDTO
     */
    'spoiler'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftEditorDTO
     */
    'scheduledPublishAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof DiscussionDraftEditorDTO
     */
    'selectedGroupTargetsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionDraftEditorDTO
     */
    'selectedSeriesTargetsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftEditorDTO
     */
    'originTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftEditorDTO
     */
    'originLocale'?: string;
    /**
     * 
     * @type {number}
     * @memberof DiscussionDraftEditorDTO
     */
    'rowVersion'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionDraftEditorDTO
     */
    'reviewFacetSelected'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftEditorDTO
     */
    'reviewSubjectPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftEditorDTO
     */
    'reviewSubjectName'?: string;
    /**
     * 
     * @type {number}
     * @memberof DiscussionDraftEditorDTO
     */
    'reviewRatingHalfStars'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionDraftEditorDTO
     */
    'questionFacetSelected'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionDraftEditorDTO
     */
    'boardFacetSelected'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftEditorDTO
     */
    'boardKind'?: DiscussionDraftEditorDTOBoardKindEnum;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftEditorDTO
     */
    'boardSchemaJson'?: string;
    /**
     * 
     * @type {number}
     * @memberof DiscussionDraftEditorDTO
     */
    'boardItemWindowHours'?: number;
    /**
     * 
     * @type {Array<SeedItem>}
     * @memberof DiscussionDraftEditorDTO
     */
    'boardItems'?: Array<SeedItem>;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionDraftEditorDTO
     */
    'pollFacetSelected'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DiscussionDraftEditorDTO
     */
    'pollOptions'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof DiscussionDraftEditorDTO
     */
    'pollCloseWindowHours'?: number;
}

export const DiscussionDraftEditorDTOSensitiveSourceEnum = {
    Manual: 'MANUAL',
    AutoByDiscussion: 'AUTO_BY_DISCUSSION',
    AutoByExternalMedia: 'AUTO_BY_EXTERNAL_MEDIA',
    ModeratorOverride: 'MODERATOR_OVERRIDE'
} as const;

export type DiscussionDraftEditorDTOSensitiveSourceEnum = typeof DiscussionDraftEditorDTOSensitiveSourceEnum[keyof typeof DiscussionDraftEditorDTOSensitiveSourceEnum];
export const DiscussionDraftEditorDTOBoardKindEnum = {
    Tiers: 'TIERS',
    Matrix: 'MATRIX'
} as const;

export type DiscussionDraftEditorDTOBoardKindEnum = typeof DiscussionDraftEditorDTOBoardKindEnum[keyof typeof DiscussionDraftEditorDTOBoardKindEnum];

/**
 * 
 * @export
 * @interface DiscussionDraftPublishTargetCountsDTO
 */
export interface DiscussionDraftPublishTargetCountsDTO {
    /**
     * 
     * @type {number}
     * @memberof DiscussionDraftPublishTargetCountsDTO
     */
    'selectedGroupTargetsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionDraftPublishTargetCountsDTO
     */
    'selectedSeriesTargetsCount'?: number;
}
/**
 * 
 * @export
 * @interface DiscussionDraftVersionDTO
 */
export interface DiscussionDraftVersionDTO {
    /**
     * 
     * @type {number}
     * @memberof DiscussionDraftVersionDTO
     */
    'versionNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftVersionDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftVersionDTO
     */
    'triggerKind'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftVersionDTO
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftVersionDTO
     */
    'excerpt'?: string;
    /**
     * 
     * @type {number}
     * @memberof DiscussionDraftVersionDTO
     */
    'bodyTextLength'?: number;
    /**
     * 
     * @type {string}
     * @memberof DiscussionDraftVersionDTO
     */
    'bodyPreview'?: string;
}
/**
 * 
 * @export
 * @interface DiscussionEmbedSnapshotDTO
 */
export interface DiscussionEmbedSnapshotDTO {
    /**
     * 
     * @type {string}
     * @memberof DiscussionEmbedSnapshotDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionEmbedSnapshotDTO
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionEmbedSnapshotDTO
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionEmbedSnapshotDTO
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionEmbedSnapshotDTO
     */
    'profileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionEmbedSnapshotDTO
     */
    'excerpt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionEmbedSnapshotDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof DiscussionEmbedSnapshotDTO
     */
    'agreementUsersCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionEmbedSnapshotDTO
     */
    'thoughtsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof DiscussionEmbedSnapshotDTO
     */
    'imageUrl'?: string;
}
/**
 * 
 * @export
 * @interface DiscussionFollowStateDTO
 */
export interface DiscussionFollowStateDTO {
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionFollowStateDTO
     */
    'following'?: boolean;
}
/**
 * 
 * @export
 * @interface DiscussionNotificationMuteStateDTO
 */
export interface DiscussionNotificationMuteStateDTO {
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionNotificationMuteStateDTO
     */
    'muted'?: boolean;
}
/**
 * 
 * @export
 * @interface DiscussionPageDataResponse
 */
export interface DiscussionPageDataResponse {
    /**
     * 
     * @type {string}
     * @memberof DiscussionPageDataResponse
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionPageDataResponse
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionPageDataResponse
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionPageDataResponse
     */
    'pageName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionPageDataResponse
     */
    'authorUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionPageDataResponse
     */
    'authorProfileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionPageDataResponse
     */
    'authorFeaturedDistinction'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionPageDataResponse
     */
    'authorVoiceOfMonthGroupName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionPageDataResponse
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionPageDataResponse
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionPageDataResponse
     */
    'editedAfterReplyAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionPageDataResponse
     */
    'privateAccess'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionPageDataResponse
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionPageDataResponse
     */
    'spoiler'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionPageDataResponse
     */
    'archived'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionPageDataResponse
     */
    'archivedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionPageDataResponse
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionPageDataResponse
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionPageDataResponse
     */
    'deletedByModerator'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionPageDataResponse
     */
    'deletedReasonType'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionPageDataResponse
     */
    'deletedMessage'?: string;
    /**
     * 
     * @type {number}
     * @memberof DiscussionPageDataResponse
     */
    'agreementsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionPageDataResponse
     */
    'disagreementsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionPageDataResponse
     */
    'addedToSeriesCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionPageDataResponse
     */
    'conversationsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionPageDataResponse
     */
    'argumentsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionPageDataResponse
     */
    'participantsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionPageDataResponse
     */
    'requestsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionPageDataResponse
     */
    'quotedByCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionPageDataResponse
     */
    'viewsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionPageDataResponse
     */
    'bodyTextLength'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionPageDataResponse
     */
    'initiallyAgreeing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionPageDataResponse
     */
    'initiallyDisagreeing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionPageDataResponse
     */
    'initiallyAddedToAnySeries'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionPageDataResponse
     */
    'initiallySavedToBookmarks'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionPageDataResponse
     */
    'initiallyFollowingAuthor'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionPageDataResponse
     */
    'authorFollowableByPrompt'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionPageDataResponse
     */
    'viewerLastVisitedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionPageDataResponse
     */
    'contentHtml'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionPageDataResponse
     */
    'languageTag'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionPageDataResponse
     */
    'isQuestion'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionPageDataResponse
     */
    'questionState'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionPageDataResponse
     */
    'acceptedThoughtPublicId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionPageDataResponse
     */
    'askToAnswerAvailable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionPageDataResponse
     */
    'reviewSubjectName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionPageDataResponse
     */
    'reviewSubjectSlug'?: string;
    /**
     * 
     * @type {number}
     * @memberof DiscussionPageDataResponse
     */
    'reviewRatingHalfStars'?: number;
    /**
     * 
     * @type {string}
     * @memberof DiscussionPageDataResponse
     */
    'reviewSubjectPublicId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionPageDataResponse
     */
    'mindChanged'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionPageDataResponse
     */
    'passageAnchorsEligible'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DiscussionPageDataResponse
     */
    'passageBlockIds'?: Array<string>;
    /**
     * 
     * @type {BoardViewDTO}
     * @memberof DiscussionPageDataResponse
     */
    'board'?: BoardViewDTO;
    /**
     * 
     * @type {PollViewDTO}
     * @memberof DiscussionPageDataResponse
     */
    'poll'?: PollViewDTO;
    /**
     * 
     * @type {SeriesReadingContextDTO}
     * @memberof DiscussionPageDataResponse
     */
    'seriesReadingContext'?: SeriesReadingContextDTO;
}
/**
 * 
 * @export
 * @interface DiscussionRequestToAddToGroupDTO
 */
export interface DiscussionRequestToAddToGroupDTO {
    /**
     * 
     * @type {number}
     * @memberof DiscussionRequestToAddToGroupDTO
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DiscussionRequestToAddToGroupDTO
     */
    'groupName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionRequestToAddToGroupDTO
     */
    'isViewerFollowing'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionRequestToAddToGroupDTO
     */
    'profileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionRequestToAddToGroupDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionRequestToAddToGroupDTO
     */
    'requestStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionRequestToAddToGroupDTO
     */
    'groupSlug'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionRequestToAddToGroupDTO
     */
    'groupPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionRequestToAddToGroupDTO
     */
    'groupThumbnailUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionRequestToAddToGroupDTO
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionRequestToAddToGroupDTO
     */
    'requestPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionRequestToAddToGroupDTO
     */
    'requestNote'?: string;
    /**
     * 
     * @type {number}
     * @memberof DiscussionRequestToAddToGroupDTO
     */
    'groupDiscussionsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof DiscussionRequestToAddToGroupDTO
     */
    'requestCreatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionRequestToAddToGroupDTO
     */
    'userDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionRequestToAddToGroupDTO
     */
    'groupDescription'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionRequestToAddToGroupDTO
     */
    'groupPrivateAccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionRequestToAddToGroupDTO
     */
    'groupCreatedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof DiscussionRequestToAddToGroupDTO
     */
    'groupMembersCount'?: number;
}
/**
 * 
 * @export
 * @interface DiscussionVersionSummaryDTO
 */
export interface DiscussionVersionSummaryDTO {
    /**
     * 
     * @type {number}
     * @memberof DiscussionVersionSummaryDTO
     */
    'versionNumber'?: number;
    /**
     * 
     * @type {string}
     * @memberof DiscussionVersionSummaryDTO
     */
    'createdAt'?: string;
}
/**
 * 
 * @export
 * @interface DiscussionWithoutContentDTO
 */
export interface DiscussionWithoutContentDTO {
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionWithoutContentDTO
     */
    'isAddedToBookmarksSeries'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DiscussionWithoutContentDTO
     */
    'discussionAddedToSeriesCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionWithoutContentDTO
     */
    'spoiler'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTO
     */
    'excerpt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTO
     */
    'slug'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionWithoutContentDTO
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTO
     */
    'title'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionWithoutContentDTO
     */
    'isPoll'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTO
     */
    'archivedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTO
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {number}
     * @memberof DiscussionWithoutContentDTO
     */
    'bodyTextLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionWithoutContentDTO
     */
    'topScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionWithoutContentDTO
     */
    'conversationsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionWithoutContentDTO
     */
    'viewsCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionWithoutContentDTO
     */
    'deletedByModerator'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTO
     */
    'deletedReasonType'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTO
     */
    'authorProfileImageUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionWithoutContentDTO
     */
    'isUserAgreeing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionWithoutContentDTO
     */
    'isUserDisagreeing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DiscussionWithoutContentDTO
     */
    'agreementsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionWithoutContentDTO
     */
    'disagreementsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionWithoutContentDTO
     */
    'argumentsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTO
     */
    'searchScore'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTO
     */
    'participatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionWithoutContentDTO
     */
    'isAddedToAnySeries'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionWithoutContentDTO
     */
    'isViewerFollowingAuthor'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionWithoutContentDTO
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionWithoutContentDTO
     */
    'archived'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTO
     */
    'deletedMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTO
     */
    'cardMediaItems'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTO
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTO
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionWithoutContentDTO
     */
    'privateAccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTO
     */
    'sourceType'?: string;
    /**
     * 
     * @type {number}
     * @memberof DiscussionWithoutContentDTO
     */
    'discussionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTO
     */
    'authorUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTO
     */
    'recommendationSource'?: string;
}
/**
 * 
 * @export
 * @interface DiscussionWithoutContentDTOInSeries
 */
export interface DiscussionWithoutContentDTOInSeries {
    /**
     * 
     * @type {number}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'bodyTextLength'?: number;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'seriesAddedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'publicId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'isAddedToBookmarksSeries'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'discussionAddedToSeriesCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'spoiler'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'excerpt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'slug'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'title'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'isPoll'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'archivedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {number}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'topScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'conversationsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'viewsCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'deletedByModerator'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'deletedReasonType'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'authorProfileImageUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'isUserAgreeing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'isUserDisagreeing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'agreementsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'disagreementsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'argumentsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'searchScore'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'participatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'isAddedToAnySeries'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'isViewerFollowingAuthor'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'archived'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'deletedMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'cardMediaItems'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'createdAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'privateAccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'sourceType'?: string;
    /**
     * 
     * @type {number}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'discussionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'authorUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionWithoutContentDTOInSeries
     */
    'recommendationSource'?: string;
}
/**
 * 
 * @export
 * @interface DiscussionsToAddToGroupDTO
 */
export interface DiscussionsToAddToGroupDTO {
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'locale'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'isPendingAddToGroupRequest'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'isDiscussionAdded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'isDiscussionExcluded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'isAddedToBookmarksSeries'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'discussionAddedToSeriesCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'spoiler'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'excerpt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'slug'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'title'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'isPoll'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'archivedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {number}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'bodyTextLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'topScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'conversationsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'viewsCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'deletedByModerator'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'deletedReasonType'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'authorProfileImageUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'isUserAgreeing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'isUserDisagreeing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'agreementsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'disagreementsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'argumentsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'searchScore'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'participatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'isAddedToAnySeries'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'isViewerFollowingAuthor'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'archived'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'deletedMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'cardMediaItems'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'privateAccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'sourceType'?: string;
    /**
     * 
     * @type {number}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'discussionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'authorUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToGroupDTO
     */
    'recommendationSource'?: string;
}
/**
 * 
 * @export
 * @interface DiscussionsToAddToSeriesDTO
 */
export interface DiscussionsToAddToSeriesDTO {
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'isDiscussionAdded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'isAddedToBookmarksSeries'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'discussionAddedToSeriesCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'spoiler'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'excerpt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'slug'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'title'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'isPoll'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'archivedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {number}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'bodyTextLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'topScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'conversationsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'viewsCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'deletedByModerator'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'deletedReasonType'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'authorProfileImageUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'isUserAgreeing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'isUserDisagreeing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'agreementsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'disagreementsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'argumentsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'searchScore'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'participatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'isAddedToAnySeries'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'isViewerFollowingAuthor'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'archived'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'deletedMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'cardMediaItems'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'privateAccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'sourceType'?: string;
    /**
     * 
     * @type {number}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'discussionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'authorUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscussionsToAddToSeriesDTO
     */
    'recommendationSource'?: string;
}
/**
 * 
 * @export
 * @interface DismissDistinctionCelebrationRequest
 */
export interface DismissDistinctionCelebrationRequest {
    /**
     * 
     * @type {string}
     * @memberof DismissDistinctionCelebrationRequest
     */
    'kind'?: string;
    /**
     * 
     * @type {string}
     * @memberof DismissDistinctionCelebrationRequest
     */
    'distinctionKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof DismissDistinctionCelebrationRequest
     */
    'groupPublicId'?: string;
}
/**
 * 
 * @export
 * @interface DismissDistinctionCelebrationResponse
 */
export interface DismissDistinctionCelebrationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof DismissDistinctionCelebrationResponse
     */
    'stamped'?: boolean;
}
/**
 * 
 * @export
 * @interface Distinction
 */
export interface Distinction {
    /**
     * 
     * @type {string}
     * @memberof Distinction
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof Distinction
     */
    'awardedAt'?: string;
}
/**
 * 
 * @export
 * @interface DistinctionCelebrationDTO
 */
export interface DistinctionCelebrationDTO {
    /**
     * 
     * @type {string}
     * @memberof DistinctionCelebrationDTO
     */
    'kind'?: string;
    /**
     * 
     * @type {string}
     * @memberof DistinctionCelebrationDTO
     */
    'distinctionKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof DistinctionCelebrationDTO
     */
    'groupPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DistinctionCelebrationDTO
     */
    'groupName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DistinctionCelebrationDTO
     */
    'month'?: string;
    /**
     * 
     * @type {string}
     * @memberof DistinctionCelebrationDTO
     */
    'awardedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DistinctionCelebrationDTO
     */
    'explicitPick'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DistinctionCelebrationDTO
     */
    'shownInByline'?: boolean;
}
/**
 * 
 * @export
 * @interface DistinctionCelebrationResponse
 */
export interface DistinctionCelebrationResponse {
    /**
     * 
     * @type {DistinctionCelebrationDTO}
     * @memberof DistinctionCelebrationResponse
     */
    'celebration'?: DistinctionCelebrationDTO;
}
/**
 * 
 * @export
 * @interface DraftGroupsToAddDiscussionModalBootstrapDTO
 */
export interface DraftGroupsToAddDiscussionModalBootstrapDTO {
    /**
     * 
     * @type {Array<DraftGroupsToAddDiscussionToDTO>}
     * @memberof DraftGroupsToAddDiscussionModalBootstrapDTO
     */
    'leaderGroups'?: Array<DraftGroupsToAddDiscussionToDTO>;
    /**
     * 
     * @type {Array<DraftGroupsToAddDiscussionToDTO>}
     * @memberof DraftGroupsToAddDiscussionModalBootstrapDTO
     */
    'memberGroups'?: Array<DraftGroupsToAddDiscussionToDTO>;
    /**
     * 
     * @type {string}
     * @memberof DraftGroupsToAddDiscussionModalBootstrapDTO
     */
    'discussionLanguageTag'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DraftGroupsToAddDiscussionModalBootstrapDTO
     */
    'leaderGroupsTruncated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DraftGroupsToAddDiscussionModalBootstrapDTO
     */
    'memberGroupsTruncated'?: boolean;
}
/**
 * 
 * @export
 * @interface DraftGroupsToAddDiscussionToDTO
 */
export interface DraftGroupsToAddDiscussionToDTO {
    /**
     * 
     * @type {boolean}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'isSelectedForPublish'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'isCircle'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'circleLanguage'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'circleEndsAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'isDiscussionAdded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'isDiscussionExcluded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'isSubmissionPending'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'isUserRequestedToJoinGroup'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'slug'?: string;
    /**
     * 
     * @type {number}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'groupId'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {number}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'viewsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'searchScore'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'modifiedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'isUserBanned'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'isUserLeaderOfGroup'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'isUserPartOfGroup'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'thumbnailUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'bannerUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'mainLocale'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'lastDiscussionAddedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'creatorUserId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'membersCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'discussionsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'creatorUsername'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'privateAccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'activityShown'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'visitorsThisWeek'?: number;
    /**
     * 
     * @type {number}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'contributionsThisWeek'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'isNewGroup'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DraftGroupsToAddDiscussionToDTO
     */
    'creatorProfileImageUrl'?: string;
}
/**
 * 
 * @export
 * @interface DraftSeriesToAddDiscussionToDTO
 */
export interface DraftSeriesToAddDiscussionToDTO {
    /**
     * 
     * @type {boolean}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'isSelectedForPublish'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'isDiscussionAdded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'imageUrls'?: string;
    /**
     * 
     * @type {number}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'viewsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'searchScore'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'modifiedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'ownerUsername'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'isViewerFollowing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'followersCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'cardMediaItems'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'bookmarksCollection'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'seriesId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'isViewerOwner'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'thumbnailUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'mainLocale'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'lastDiscussionAddedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'ownerProfileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'viewerFollowingAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'discussionsCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'privateAccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'description'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DraftSeriesToAddDiscussionToDTO
     */
    'recentDiscussionTitles'?: Array<string>;
}
/**
 * 
 * @export
 * @interface EditChatMessageRequest
 */
export interface EditChatMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof EditChatMessageRequest
     */
    'body': string;
}
/**
 * 
 * @export
 * @interface EditThoughtRequest
 */
export interface EditThoughtRequest {
    /**
     * 
     * @type {string}
     * @memberof EditThoughtRequest
     */
    'sourceJson': string;
    /**
     * 
     * @type {boolean}
     * @memberof EditThoughtRequest
     */
    'spoiler'?: boolean;
}
/**
 * 
 * @export
 * @interface EditThoughtResponse
 */
export interface EditThoughtResponse {
    /**
     * 
     * @type {string}
     * @memberof EditThoughtResponse
     */
    'publicId': string;
    /**
     * 
     * @type {string}
     * @memberof EditThoughtResponse
     */
    'htmlContent': string;
    /**
     * 
     * @type {boolean}
     * @memberof EditThoughtResponse
     */
    'spoiler': boolean;
    /**
     * 
     * @type {string}
     * @memberof EditThoughtResponse
     */
    'editedAt': string | null;
    /**
     * 
     * @type {number}
     * @memberof EditThoughtResponse
     */
    'versionCount': number;
}
/**
 * 
 * @export
 * @interface EligibilityResponse
 */
export interface EligibilityResponse {
    /**
     * 
     * @type {boolean}
     * @memberof EligibilityResponse
     */
    'eligible'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EligibilityResponse
     */
    'ruleVersion'?: number;
    /**
     * 
     * @type {number}
     * @memberof EligibilityResponse
     */
    'delayMs'?: number;
    /**
     * 
     * @type {number}
     * @memberof EligibilityResponse
     */
    'minSessionSeconds'?: number;
}
/**
 * 
 * @export
 * @interface EndorseThoughtRequest
 */
export interface EndorseThoughtRequest {
    /**
     * 
     * @type {string}
     * @memberof EndorseThoughtRequest
     */
    'kind': string;
    /**
     * 
     * @type {string}
     * @memberof EndorseThoughtRequest
     */
    'note'?: string;
}
/**
 * 
 * @export
 * @interface ExposureRequest
 */
export interface ExposureRequest {
    /**
     * 
     * @type {string}
     * @memberof ExposureRequest
     */
    'experiment'?: string;
}
/**
 * 
 * @export
 * @interface ExternalLinkPreviewDTO
 */
export interface ExternalLinkPreviewDTO {
    /**
     * 
     * @type {string}
     * @memberof ExternalLinkPreviewDTO
     */
    'requestedUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalLinkPreviewDTO
     */
    'resolvedUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalLinkPreviewDTO
     */
    'canonicalUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalLinkPreviewDTO
     */
    'displayUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalLinkPreviewDTO
     */
    'siteName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalLinkPreviewDTO
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalLinkPreviewDTO
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalLinkPreviewDTO
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalLinkPreviewDTO
     */
    'source'?: string;
}
/**
 * 
 * @export
 * @interface ExternalSubscribeRequest
 */
export interface ExternalSubscribeRequest {
    /**
     * 
     * @type {string}
     * @memberof ExternalSubscribeRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface Family
 */
export interface Family {
    /**
     * 
     * @type {string}
     * @memberof Family
     */
    'familyKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof Family
     */
    'layer'?: string;
    /**
     * 
     * @type {string}
     * @memberof Family
     */
    'visibilityClass'?: string;
    /**
     * 
     * @type {number}
     * @memberof Family
     */
    'highestTierEarned'?: number;
    /**
     * 
     * @type {number}
     * @memberof Family
     */
    'measure'?: number;
    /**
     * 
     * @type {number}
     * @memberof Family
     */
    'nextThreshold'?: number;
    /**
     * 
     * @type {number}
     * @memberof Family
     */
    'ladderLength'?: number;
    /**
     * 
     * @type {Array<Rung>}
     * @memberof Family
     */
    'rungs'?: Array<Rung>;
}
/**
 * 
 * @export
 * @interface FeatureItemRequest
 */
export interface FeatureItemRequest {
    /**
     * 
     * @type {string}
     * @memberof FeatureItemRequest
     */
    'kind': string;
    /**
     * 
     * @type {string}
     * @memberof FeatureItemRequest
     */
    'targetPublicId': string;
}
/**
 * 
 * @export
 * @interface FeaturedCandidatesDTO
 */
export interface FeaturedCandidatesDTO {
    /**
     * 
     * @type {Array<Candidate>}
     * @memberof FeaturedCandidatesDTO
     */
    'discussions'?: Array<Candidate>;
    /**
     * 
     * @type {Array<Candidate>}
     * @memberof FeaturedCandidatesDTO
     */
    'thoughts'?: Array<Candidate>;
    /**
     * 
     * @type {Array<Candidate>}
     * @memberof FeaturedCandidatesDTO
     */
    'series'?: Array<Candidate>;
    /**
     * 
     * @type {Array<Candidate>}
     * @memberof FeaturedCandidatesDTO
     */
    'stances'?: Array<Candidate>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FeaturedCandidatesDTO
     */
    'featuredKeys'?: Array<string>;
}
/**
 * 
 * @export
 * @interface FeaturedItemDTO
 */
export interface FeaturedItemDTO {
    /**
     * 
     * @type {string}
     * @memberof FeaturedItemDTO
     */
    'kind'?: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedItemDTO
     */
    'targetPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedItemDTO
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedItemDTO
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof FeaturedItemDTO
     */
    'stance'?: string;
}
/**
 * 
 * @export
 * @interface FeedClickRequest
 */
export interface FeedClickRequest {
    /**
     * 
     * @type {string}
     * @memberof FeedClickRequest
     */
    'discussionPublicId': string;
    /**
     * 
     * @type {number}
     * @memberof FeedClickRequest
     */
    'slot': number;
    /**
     * 
     * @type {string}
     * @memberof FeedClickRequest
     */
    'primarySource'?: string;
    /**
     * 
     * @type {string}
     * @memberof FeedClickRequest
     */
    'recommendationSource'?: string;
}
/**
 * 
 * @export
 * @interface FileDeclaration
 */
export interface FileDeclaration {
    /**
     * 
     * @type {string}
     * @memberof FileDeclaration
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof FileDeclaration
     */
    'sizeBytes'?: number;
    /**
     * 
     * @type {string}
     * @memberof FileDeclaration
     */
    'contentType'?: string;
}
/**
 * 
 * @export
 * @interface FirstSessionChecklistStateDTO
 */
export interface FirstSessionChecklistStateDTO {
    /**
     * 
     * @type {boolean}
     * @memberof FirstSessionChecklistStateDTO
     */
    'follow'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FirstSessionChecklistStateDTO
     */
    'group'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FirstSessionChecklistStateDTO
     */
    'post'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FirstSessionChecklistStateDTO
     */
    'reply'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FirstSessionChecklistStateDTO
     */
    'languages'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FirstSessionChecklistStateDTO
     */
    'closed'?: boolean;
}
/**
 * @type FollowUser404Response
 * @export
 */
export type FollowUser404Response = object | string;

/**
 * 
 * @export
 * @interface FormRefusalSignalRequest
 */
export interface FormRefusalSignalRequest {
    /**
     * 
     * @type {string}
     * @memberof FormRefusalSignalRequest
     */
    'form'?: string;
    /**
     * 
     * @type {string}
     * @memberof FormRefusalSignalRequest
     */
    'field'?: string;
    /**
     * 
     * @type {number}
     * @memberof FormRefusalSignalRequest
     */
    'refusals'?: number;
}
/**
 * 
 * @export
 * @interface GroupBoardBulkMuteRequest
 */
export interface GroupBoardBulkMuteRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof GroupBoardBulkMuteRequest
     */
    'groupPublicIds'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof GroupBoardBulkMuteRequest
     */
    'muted'?: boolean;
}
/**
 * 
 * @export
 * @interface GroupBoardMemberRestrictionDTO
 */
export interface GroupBoardMemberRestrictionDTO {
    /**
     * 
     * @type {string}
     * @memberof GroupBoardMemberRestrictionDTO
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupBoardMemberRestrictionDTO
     */
    'profileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupBoardMemberRestrictionDTO
     */
    'restrictedByUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupBoardMemberRestrictionDTO
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupBoardMemberRestrictionDTO
     */
    'restrictedUntil'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupBoardMemberRestrictionDTO
     */
    'createdAt'?: string;
}
/**
 * 
 * @export
 * @interface GroupBoardMessageDTO
 */
export interface GroupBoardMessageDTO {
    /**
     * 
     * @type {string}
     * @memberof GroupBoardMessageDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupBoardMessageDTO
     */
    'authorUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupBoardMessageDTO
     */
    'authorProfileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupBoardMessageDTO
     */
    'body'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupBoardMessageDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupBoardMessageDTO
     */
    'editedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupBoardMessageDTO
     */
    'replyCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupBoardMessageDTO
     */
    'lastReplyAt'?: string;
    /**
     * 
     * @type {Array<GroupBoardMessageDTO>}
     * @memberof GroupBoardMessageDTO
     */
    'replies'?: Array<GroupBoardMessageDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof GroupBoardMessageDTO
     */
    'hasMoreReplies'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupBoardMessageDTO
     */
    'viewerCanEdit'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupBoardMessageDTO
     */
    'viewerCanRemove'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupBoardMessageDTO
     */
    'viewerCanPromote'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupBoardMessageDTO
     */
    'viewerCanReport'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupBoardMessageDTO
     */
    'promotedDiscussionSlug'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupBoardMessageDTO
     */
    'paginationParameter'?: string;
}
/**
 * 
 * @export
 * @interface GroupBoardMuteStateDTO
 */
export interface GroupBoardMuteStateDTO {
    /**
     * 
     * @type {boolean}
     * @memberof GroupBoardMuteStateDTO
     */
    'muted'?: boolean;
}
/**
 * 
 * @export
 * @interface GroupBoardPurgeResultDTO
 */
export interface GroupBoardPurgeResultDTO {
    /**
     * 
     * @type {number}
     * @memberof GroupBoardPurgeResultDTO
     */
    'removedCount'?: number;
}
/**
 * 
 * @export
 * @interface GroupBoardViewDTO
 */
export interface GroupBoardViewDTO {
    /**
     * 
     * @type {string}
     * @memberof GroupBoardViewDTO
     */
    'boardPublicId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupBoardViewDTO
     */
    'locked'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupBoardViewDTO
     */
    'lockedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupBoardViewDTO
     */
    'lockedByUsername'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupBoardViewDTO
     */
    'viewerIsMember'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupBoardViewDTO
     */
    'viewerCanPost'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupBoardViewDTO
     */
    'viewerCanModerate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupBoardViewDTO
     */
    'viewerCanLock'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupBoardViewDTO
     */
    'unreadCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GroupBoardViewDTO
     */
    'unreadCountCapped'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupBoardViewDTO
     */
    'viewerHasMutedBoard'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupBoardViewDTO
     */
    'pinnedSource'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupBoardViewDTO
     */
    'pinnedMessagePublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupBoardViewDTO
     */
    'pinnedBody'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupBoardViewDTO
     */
    'pinnedAuthorUsername'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupBoardViewDTO
     */
    'viewerCanPin'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupBoardViewDTO
     */
    'viewerCanUnpin'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupBoardViewDTO
     */
    'viewerCanEditWelcome'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupBoardViewDTO
     */
    'welcomeMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupBoardViewDTO
     */
    'lastReadMessagePublicId'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupBoardViewDTO
     */
    'slowModeSeconds'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupBoardViewDTO
     */
    'postingPolicy'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupBoardViewDTO
     */
    'viewerIsLeader'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupBoardViewDTO
     */
    'viewerRestricted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupBoardViewDTO
     */
    'viewerRestrictedUntil'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupBoardViewDTO
     */
    'openReportCount'?: number;
    /**
     * 
     * @type {Array<GroupChatPostAdditionDTO>}
     * @memberof GroupBoardViewDTO
     */
    'recentPostAdditions'?: Array<GroupChatPostAdditionDTO>;
    /**
     * 
     * @type {string}
     * @memberof GroupBoardViewDTO
     */
    'viewerAccountRestrictionReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupBoardViewDTO
     */
    'viewerAccountRestrictedUntil'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupBoardViewDTO
     */
    'viewerLeadershipLevel'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupBoardViewDTO
     */
    'imagesEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupBoardViewDTO
     */
    'groupPrivate'?: boolean;
}
/**
 * 
 * @export
 * @interface GroupBoardWelcomeDTO
 */
export interface GroupBoardWelcomeDTO {
    /**
     * 
     * @type {string}
     * @memberof GroupBoardWelcomeDTO
     */
    'welcomeMessage'?: string;
}
/**
 * 
 * @export
 * @interface GroupChatMentionSuggestionDTO
 */
export interface GroupChatMentionSuggestionDTO {
    /**
     * 
     * @type {string}
     * @memberof GroupChatMentionSuggestionDTO
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupChatMentionSuggestionDTO
     */
    'profileImageUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupChatMentionSuggestionDTO
     */
    'recentSpeaker'?: boolean;
}
/**
 * 
 * @export
 * @interface GroupChatMessageSearchResultDTO
 */
export interface GroupChatMessageSearchResultDTO {
    /**
     * 
     * @type {string}
     * @memberof GroupChatMessageSearchResultDTO
     */
    'messagePublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupChatMessageSearchResultDTO
     */
    'senderUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupChatMessageSearchResultDTO
     */
    'senderProfileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupChatMessageSearchResultDTO
     */
    'body'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupChatMessageSearchResultDTO
     */
    'createdAt'?: string;
}
/**
 * 
 * @export
 * @interface GroupChatOpenReportDTO
 */
export interface GroupChatOpenReportDTO {
    /**
     * 
     * @type {string}
     * @memberof GroupChatOpenReportDTO
     */
    'messagePublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupChatOpenReportDTO
     */
    'authorUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupChatOpenReportDTO
     */
    'authorProfileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupChatOpenReportDTO
     */
    'body'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupChatOpenReportDTO
     */
    'messageRemoved'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupChatOpenReportDTO
     */
    'messageCreatedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupChatOpenReportDTO
     */
    'reportCount'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GroupChatOpenReportDTO
     */
    'reasonTypes'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GroupChatOpenReportDTO
     */
    'firstReportedAt'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof GroupChatOpenReportDTO
     */
    'reportIds'?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof GroupChatOpenReportDTO
     */
    'leaderCanClose'?: boolean;
}
/**
 * 
 * @export
 * @interface GroupChatPostAdditionDTO
 */
export interface GroupChatPostAdditionDTO {
    /**
     * 
     * @type {string}
     * @memberof GroupChatPostAdditionDTO
     */
    'discussionPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupChatPostAdditionDTO
     */
    'discussionSlug'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupChatPostAdditionDTO
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupChatPostAdditionDTO
     */
    'addedAt'?: string;
}
/**
 * 
 * @export
 * @interface GroupChatPromotionDTO
 */
export interface GroupChatPromotionDTO {
    /**
     * 
     * @type {string}
     * @memberof GroupChatPromotionDTO
     */
    'draftPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupChatPromotionDTO
     */
    'groupPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupChatPromotionDTO
     */
    'messagePublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupChatPromotionDTO
     */
    'promotedDiscussionSlug'?: string;
}
/**
 * 
 * @export
 * @interface GroupChatReportResolutionDTO
 */
export interface GroupChatReportResolutionDTO {
    /**
     * 
     * @type {number}
     * @memberof GroupChatReportResolutionDTO
     */
    'closedCount'?: number;
}
/**
 * 
 * @export
 * @interface GroupChatSuggestionDTO
 */
export interface GroupChatSuggestionDTO {
    /**
     * 
     * @type {string}
     * @memberof GroupChatSuggestionDTO
     */
    'groupPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupChatSuggestionDTO
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupChatSuggestionDTO
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupChatSuggestionDTO
     */
    'memberCount'?: number;
}
/**
 * 
 * @export
 * @interface GroupDTO
 */
export interface GroupDTO {
    /**
     * 
     * @type {string}
     * @memberof GroupDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDTO
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDTO
     */
    'isUserRequestedToJoinGroup'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupDTO
     */
    'slug'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupDTO
     */
    'groupId'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GroupDTO
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GroupDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupDTO
     */
    'viewsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupDTO
     */
    'searchScore'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDTO
     */
    'modifiedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDTO
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDTO
     */
    'isUserBanned'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDTO
     */
    'isUserLeaderOfGroup'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDTO
     */
    'isUserPartOfGroup'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupDTO
     */
    'thumbnailUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDTO
     */
    'bannerUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDTO
     */
    'mainLocale'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDTO
     */
    'lastDiscussionAddedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupDTO
     */
    'creatorUserId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupDTO
     */
    'membersCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupDTO
     */
    'discussionsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupDTO
     */
    'creatorUsername'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDTO
     */
    'privateAccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupDTO
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDTO
     */
    'activityShown'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupDTO
     */
    'visitorsThisWeek'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupDTO
     */
    'contributionsThisWeek'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDTO
     */
    'isNewGroup'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupDTO
     */
    'creatorProfileImageUrl'?: string;
}
/**
 * 
 * @export
 * @interface GroupDiscussionDTO
 */
export interface GroupDiscussionDTO {
    /**
     * 
     * @type {number}
     * @memberof GroupDiscussionDTO
     */
    'authorGroupContributionsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionDTO
     */
    'groupName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionDTO
     */
    'groupSlug'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionDTO
     */
    'groupPublicId'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupDiscussionDTO
     */
    'excludedByUserId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionDTO
     */
    'excludedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionDTO
     */
    'authorGroupFlair'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionDTO
     */
    'isExcluded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionDTO
     */
    'excludedReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionDTO
     */
    'isAddedToBookmarksSeries'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupDiscussionDTO
     */
    'discussionAddedToSeriesCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionDTO
     */
    'spoiler'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionDTO
     */
    'excerpt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionDTO
     */
    'slug'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionDTO
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionDTO
     */
    'title'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionDTO
     */
    'isPoll'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionDTO
     */
    'archivedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionDTO
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupDiscussionDTO
     */
    'bodyTextLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupDiscussionDTO
     */
    'topScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupDiscussionDTO
     */
    'conversationsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupDiscussionDTO
     */
    'viewsCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionDTO
     */
    'deletedByModerator'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionDTO
     */
    'deletedReasonType'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionDTO
     */
    'authorProfileImageUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionDTO
     */
    'isUserAgreeing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionDTO
     */
    'isUserDisagreeing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupDiscussionDTO
     */
    'agreementsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupDiscussionDTO
     */
    'disagreementsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupDiscussionDTO
     */
    'argumentsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionDTO
     */
    'searchScore'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionDTO
     */
    'participatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionDTO
     */
    'isAddedToAnySeries'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionDTO
     */
    'isViewerFollowingAuthor'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionDTO
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionDTO
     */
    'archived'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionDTO
     */
    'deletedMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionDTO
     */
    'cardMediaItems'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionDTO
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionDTO
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionDTO
     */
    'privateAccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionDTO
     */
    'sourceType'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupDiscussionDTO
     */
    'discussionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionDTO
     */
    'authorUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionDTO
     */
    'recommendationSource'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionDTO
     */
    'authorSensitive'?: boolean;
}
/**
 * 
 * @export
 * @interface GroupDiscussionSubmissionDTO
 */
export interface GroupDiscussionSubmissionDTO {
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'requesterProfileImageUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'requesterIsViewerFollowing'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'sourceDiscussionRequestPublicId'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'requesterUserId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'requestStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'groupPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'requesterUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'requestNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'submissionPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'enteredLeaderReviewAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'requestCreatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'requesterDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'isAddedToBookmarksSeries'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'discussionAddedToSeriesCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'spoiler'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'excerpt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'slug'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'title'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'isPoll'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'archivedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'bodyTextLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'topScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'conversationsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'viewsCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'deletedByModerator'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'deletedReasonType'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'authorProfileImageUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'isUserAgreeing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'isUserDisagreeing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'agreementsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'disagreementsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'argumentsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'searchScore'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'participatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'isAddedToAnySeries'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'isViewerFollowingAuthor'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'archived'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'deletedMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'cardMediaItems'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'privateAccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'sourceType'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'discussionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'authorUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionDTO
     */
    'recommendationSource'?: string;
}
/**
 * 
 * @export
 * @interface GroupDiscussionSubmissionReviewDialogDTO
 */
export interface GroupDiscussionSubmissionReviewDialogDTO {
    /**
     * 
     * @type {GroupDiscussionSubmissionDTO}
     * @memberof GroupDiscussionSubmissionReviewDialogDTO
     */
    'submission'?: GroupDiscussionSubmissionDTO;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionSubmissionReviewDialogDTO
     */
    'actionable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionSubmissionReviewDialogDTO
     */
    'resolvedState'?: string;
}
/**
 * 
 * @export
 * @interface GroupDiscussionsToAddModalBootstrapDTO
 */
export interface GroupDiscussionsToAddModalBootstrapDTO {
    /**
     * 
     * @type {Array<DiscussionsToAddToGroupDTO>}
     * @memberof GroupDiscussionsToAddModalBootstrapDTO
     */
    'authoredDiscussions'?: Array<DiscussionsToAddToGroupDTO>;
    /**
     * 
     * @type {Array<DiscussionsToAddToGroupDTO>}
     * @memberof GroupDiscussionsToAddModalBootstrapDTO
     */
    'participatedDiscussions'?: Array<DiscussionsToAddToGroupDTO>;
    /**
     * 
     * @type {Array<DiscussionsToAddToGroupDTO>}
     * @memberof GroupDiscussionsToAddModalBootstrapDTO
     */
    'seriesDiscussions'?: Array<DiscussionsToAddToGroupDTO>;
    /**
     * 
     * @type {string}
     * @memberof GroupDiscussionsToAddModalBootstrapDTO
     */
    'mainLocale'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionsToAddModalBootstrapDTO
     */
    'authoredTruncated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionsToAddModalBootstrapDTO
     */
    'participatedTruncated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionsToAddModalBootstrapDTO
     */
    'seriesTruncated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupDiscussionsToAddModalBootstrapDTO
     */
    'viewerIsLeader'?: boolean;
}
/**
 * 
 * @export
 * @interface GroupInvitationDTO
 */
export interface GroupInvitationDTO {
    /**
     * 
     * @type {string}
     * @memberof GroupInvitationDTO
     */
    'invitedByProfileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInvitationDTO
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInvitationDTO
     */
    'profileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInvitationDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInvitationDTO
     */
    'invitedByUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInvitationDTO
     */
    'leadershipLevel'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInvitationDTO
     */
    'invitationPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInvitationDTO
     */
    'username'?: string;
}
/**
 * 
 * @export
 * @interface GroupInviteLinkDTO
 */
export interface GroupInviteLinkDTO {
    /**
     * 
     * @type {string}
     * @memberof GroupInviteLinkDTO
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInviteLinkDTO
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInviteLinkDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInviteLinkDTO
     */
    'expiresAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInviteLinkDTO
     */
    'createdByUsername'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupInviteLinkDTO
     */
    'redemptionCount'?: number;
}
/**
 * 
 * @export
 * @interface GroupInviteLinkJoinDTO
 */
export interface GroupInviteLinkJoinDTO {
    /**
     * 
     * @type {string}
     * @memberof GroupInviteLinkJoinDTO
     */
    'groupPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInviteLinkJoinDTO
     */
    'outcome'?: string;
}
/**
 * 
 * @export
 * @interface GroupInviteLinkPreviewDTO
 */
export interface GroupInviteLinkPreviewDTO {
    /**
     * 
     * @type {string}
     * @memberof GroupInviteLinkPreviewDTO
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInviteLinkPreviewDTO
     */
    'groupPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInviteLinkPreviewDTO
     */
    'groupName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupInviteLinkPreviewDTO
     */
    'privateGroup'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupInviteLinkPreviewDTO
     */
    'viewerIsMember'?: boolean;
}
/**
 * 
 * @export
 * @interface GroupInviteRequestDTO
 */
export interface GroupInviteRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof GroupInviteRequestDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInviteRequestDTO
     */
    'groupPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInviteRequestDTO
     */
    'groupName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInviteRequestDTO
     */
    'invitedUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInviteRequestDTO
     */
    'requestedByUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInviteRequestDTO
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInviteRequestDTO
     */
    'declineReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInviteRequestDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupInviteRequestDTO
     */
    'resolvedAt'?: string;
}
/**
 * 
 * @export
 * @interface GroupInviteRequestResultDTO
 */
export interface GroupInviteRequestResultDTO {
    /**
     * 
     * @type {string}
     * @memberof GroupInviteRequestResultDTO
     */
    'status'?: GroupInviteRequestResultDTOStatusEnum;
}

export const GroupInviteRequestResultDTOStatusEnum = {
    Requested: 'REQUESTED',
    AlreadyRequested: 'ALREADY_REQUESTED',
    AlreadyInvited: 'ALREADY_INVITED',
    AlreadyInGroup: 'ALREADY_IN_GROUP'
} as const;

export type GroupInviteRequestResultDTOStatusEnum = typeof GroupInviteRequestResultDTOStatusEnum[keyof typeof GroupInviteRequestResultDTOStatusEnum];

/**
 * 
 * @export
 * @interface GroupLeadershipAssignmentRequest
 */
export interface GroupLeadershipAssignmentRequest {
    /**
     * 
     * @type {string}
     * @memberof GroupLeadershipAssignmentRequest
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof GroupLeadershipAssignmentRequest
     */
    'leadershipLevel'?: GroupLeadershipAssignmentRequestLeadershipLevelEnum;
}

export const GroupLeadershipAssignmentRequestLeadershipLevelEnum = {
    Owner: 'OWNER',
    Administrator: 'ADMINISTRATOR',
    Moderator: 'MODERATOR'
} as const;

export type GroupLeadershipAssignmentRequestLeadershipLevelEnum = typeof GroupLeadershipAssignmentRequestLeadershipLevelEnum[keyof typeof GroupLeadershipAssignmentRequestLeadershipLevelEnum];

/**
 * 
 * @export
 * @interface GroupLinkCardDTO
 */
export interface GroupLinkCardDTO {
    /**
     * 
     * @type {string}
     * @memberof GroupLinkCardDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupLinkCardDTO
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupLinkCardDTO
     */
    'memberCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GroupLinkCardDTO
     */
    'privateGroup'?: boolean;
}
/**
 * 
 * @export
 * @interface GroupListBatchRequest
 */
export interface GroupListBatchRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof GroupListBatchRequest
     */
    'add'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GroupListBatchRequest
     */
    'remove'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GroupListDTO
 */
export interface GroupListDTO {
    /**
     * 
     * @type {string}
     * @memberof GroupListDTO
     */
    'listKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupListDTO
     */
    'kind'?: GroupListDTOKindEnum;
    /**
     * 
     * @type {string}
     * @memberof GroupListDTO
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GroupListDTO
     */
    'groupPublicIds'?: Array<string>;
}

export const GroupListDTOKindEnum = {
    Favorites: 'FAVORITES',
    Custom: 'CUSTOM'
} as const;

export type GroupListDTOKindEnum = typeof GroupListDTOKindEnum[keyof typeof GroupListDTOKindEnum];

/**
 * 
 * @export
 * @interface GroupListNameRequest
 */
export interface GroupListNameRequest {
    /**
     * 
     * @type {string}
     * @memberof GroupListNameRequest
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface GroupListOrderRequest
 */
export interface GroupListOrderRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof GroupListOrderRequest
     */
    'groupPublicIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GroupMemberDTO
 */
export interface GroupMemberDTO {
    /**
     * 
     * @type {string}
     * @memberof GroupMemberDTO
     */
    'flair'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupMemberDTO
     */
    'groupPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupMemberDTO
     */
    'leadershipLevel'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupMemberDTO
     */
    'groupContributionsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupMemberDTO
     */
    'bannedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupMemberDTO
     */
    'isBanned'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupMemberDTO
     */
    'groupDiscussionsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupMemberDTO
     */
    'groupBoardMessagesCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupMemberDTO
     */
    'addedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupMemberDTO
     */
    'conversationsParticipatedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupMemberDTO
     */
    'discussionsAuthoredCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupMemberDTO
     */
    'mindsChangedReceivedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupMemberDTO
     */
    'userId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GroupMemberDTO
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupMemberDTO
     */
    'profileStatement'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupMemberDTO
     */
    'isViewerFollowing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupMemberDTO
     */
    'argumentsAuthoredCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupMemberDTO
     */
    'agreementsReceivedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupMemberDTO
     */
    'followersCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupMemberDTO
     */
    'followingCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GroupMemberDTO
     */
    'viewerIsOwner'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupMemberDTO
     */
    'canMessage'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupMemberDTO
     */
    'profileViewsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupMemberDTO
     */
    'profileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupMemberDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupMemberDTO
     */
    'viewerFollowingAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupMemberDTO
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupMemberDTO
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupMemberDTO
     */
    'creationDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupMemberDTO
     */
    'isFollowingViewer'?: boolean;
}
/**
 * 
 * @export
 * @interface GroupModerationEventDTO
 */
export interface GroupModerationEventDTO {
    /**
     * 
     * @type {string}
     * @memberof GroupModerationEventDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupModerationEventDTO
     */
    'action'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupModerationEventDTO
     */
    'actorUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupModerationEventDTO
     */
    'actorProfileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupModerationEventDTO
     */
    'targetUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupModerationEventDTO
     */
    'targetMessagePublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupModerationEventDTO
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupModerationEventDTO
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupModerationEventDTO
     */
    'expiresAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupModerationEventDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupModerationEventDTO
     */
    'stillActive'?: boolean;
}
/**
 * 
 * @export
 * @interface GroupOwnershipTransferRequest
 */
export interface GroupOwnershipTransferRequest {
    /**
     * 
     * @type {string}
     * @memberof GroupOwnershipTransferRequest
     */
    'username': string;
}
/**
 * 
 * @export
 * @interface GroupRecommendationRequest
 */
export interface GroupRecommendationRequest {
    /**
     * 
     * @type {string}
     * @memberof GroupRecommendationRequest
     */
    'username': string;
}
/**
 * 
 * @export
 * @interface GroupResource
 */
export interface GroupResource {
    /**
     * 
     * @type {number}
     * @memberof GroupResource
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupResource
     */
    'groupId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupResource
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupResource
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupResource
     */
    'url'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupResource
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupResource
     */
    'createdByUserId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupResource
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupResource
     */
    'modifiedAt'?: string;
}
/**
 * 
 * @export
 * @interface GroupRule
 */
export interface GroupRule {
    /**
     * 
     * @type {number}
     * @memberof GroupRule
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupRule
     */
    'groupId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupRule
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupRule
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupRule
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupRule
     */
    'createdByUserId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupRule
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupRule
     */
    'modifiedAt'?: string;
}
/**
 * 
 * @export
 * @interface GroupTagCountDTO
 */
export interface GroupTagCountDTO {
    /**
     * 
     * @type {string}
     * @memberof GroupTagCountDTO
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupTagCountDTO
     */
    'groupCount'?: number;
}
/**
 * 
 * @export
 * @interface GroupsToAddDiscussionModalBootstrapDTO
 */
export interface GroupsToAddDiscussionModalBootstrapDTO {
    /**
     * 
     * @type {Array<GroupsToAddDiscussionToDTO>}
     * @memberof GroupsToAddDiscussionModalBootstrapDTO
     */
    'leaderGroups'?: Array<GroupsToAddDiscussionToDTO>;
    /**
     * 
     * @type {Array<GroupsToAddDiscussionToDTO>}
     * @memberof GroupsToAddDiscussionModalBootstrapDTO
     */
    'memberGroups'?: Array<GroupsToAddDiscussionToDTO>;
    /**
     * 
     * @type {string}
     * @memberof GroupsToAddDiscussionModalBootstrapDTO
     */
    'discussionLanguageTag'?: string;
}
/**
 * 
 * @export
 * @interface GroupsToAddDiscussionToDTO
 */
export interface GroupsToAddDiscussionToDTO {
    /**
     * 
     * @type {boolean}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'isDiscussionAdded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'isDiscussionExcluded'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'isSubmissionPending'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'isUserRequestedToJoinGroup'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'slug'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'groupId'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'viewsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'searchScore'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'modifiedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'isUserBanned'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'isUserLeaderOfGroup'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'isUserPartOfGroup'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'thumbnailUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'bannerUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'mainLocale'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'lastDiscussionAddedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'creatorUserId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'membersCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'discussionsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'creatorUsername'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'privateAccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'activityShown'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'visitorsThisWeek'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'contributionsThisWeek'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'isNewGroup'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupsToAddDiscussionToDTO
     */
    'creatorProfileImageUrl'?: string;
}
/**
 * 
 * @export
 * @interface GroupsToInviteUserToDTO
 */
export interface GroupsToInviteUserToDTO {
    /**
     * 
     * @type {boolean}
     * @memberof GroupsToInviteUserToDTO
     */
    'isUserAlreadyInGroup'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupsToInviteUserToDTO
     */
    'isInvitePending'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupsToInviteUserToDTO
     */
    'hasPendingJoinRequest'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupsToInviteUserToDTO
     */
    'viewerAction'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupsToInviteUserToDTO
     */
    'isRecommendationPending'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupsToInviteUserToDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupsToInviteUserToDTO
     */
    'name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupsToInviteUserToDTO
     */
    'isUserRequestedToJoinGroup'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupsToInviteUserToDTO
     */
    'slug'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupsToInviteUserToDTO
     */
    'groupId'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof GroupsToInviteUserToDTO
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GroupsToInviteUserToDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupsToInviteUserToDTO
     */
    'viewsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupsToInviteUserToDTO
     */
    'searchScore'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupsToInviteUserToDTO
     */
    'modifiedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupsToInviteUserToDTO
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupsToInviteUserToDTO
     */
    'isUserBanned'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupsToInviteUserToDTO
     */
    'isUserLeaderOfGroup'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupsToInviteUserToDTO
     */
    'isUserPartOfGroup'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupsToInviteUserToDTO
     */
    'thumbnailUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupsToInviteUserToDTO
     */
    'bannerUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupsToInviteUserToDTO
     */
    'mainLocale'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupsToInviteUserToDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupsToInviteUserToDTO
     */
    'lastDiscussionAddedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof GroupsToInviteUserToDTO
     */
    'creatorUserId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupsToInviteUserToDTO
     */
    'membersCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupsToInviteUserToDTO
     */
    'discussionsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof GroupsToInviteUserToDTO
     */
    'creatorUsername'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupsToInviteUserToDTO
     */
    'privateAccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupsToInviteUserToDTO
     */
    'description'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GroupsToInviteUserToDTO
     */
    'activityShown'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GroupsToInviteUserToDTO
     */
    'visitorsThisWeek'?: number;
    /**
     * 
     * @type {number}
     * @memberof GroupsToInviteUserToDTO
     */
    'contributionsThisWeek'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GroupsToInviteUserToDTO
     */
    'isNewGroup'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupsToInviteUserToDTO
     */
    'creatorProfileImageUrl'?: string;
}
/**
 * 
 * @export
 * @interface GroupsToInviteUserToModalBootstrapDTO
 */
export interface GroupsToInviteUserToModalBootstrapDTO {
    /**
     * 
     * @type {Array<GroupsToInviteUserToDTO>}
     * @memberof GroupsToInviteUserToModalBootstrapDTO
     */
    'leaderGroups'?: Array<GroupsToInviteUserToDTO>;
    /**
     * 
     * @type {Array<GroupsToInviteUserToDTO>}
     * @memberof GroupsToInviteUserToModalBootstrapDTO
     */
    'memberGroups'?: Array<GroupsToInviteUserToDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof GroupsToInviteUserToModalBootstrapDTO
     */
    'leaderGroupsTruncated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupsToInviteUserToModalBootstrapDTO
     */
    'memberGroupsTruncated'?: boolean;
}
/**
 * 
 * @export
 * @interface HandoffCandidate
 */
export interface HandoffCandidate {
    /**
     * 
     * @type {string}
     * @memberof HandoffCandidate
     */
    'discussionPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof HandoffCandidate
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof HandoffCandidate
     */
    'excerpt'?: string;
    /**
     * 
     * @type {string}
     * @memberof HandoffCandidate
     */
    'authorUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof HandoffCandidate
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof HandoffCandidate
     */
    'variant'?: string;
}
/**
 * 
 * @export
 * @interface HomeDiscoveryBootstrapDTO
 */
export interface HomeDiscoveryBootstrapDTO {
    /**
     * 
     * @type {Array<GroupDTO>}
     * @memberof HomeDiscoveryBootstrapDTO
     */
    'recommendedGroups'?: Array<GroupDTO>;
    /**
     * 
     * @type {Array<SeriesDTO>}
     * @memberof HomeDiscoveryBootstrapDTO
     */
    'recommendedSeries'?: Array<SeriesDTO>;
    /**
     * 
     * @type {Array<UserProfileDTO>}
     * @memberof HomeDiscoveryBootstrapDTO
     */
    'activePublishers'?: Array<UserProfileDTO>;
    /**
     * 
     * @type {Array<RecentlyViewedDiscussionDTO>}
     * @memberof HomeDiscoveryBootstrapDTO
     */
    'recentlyViewedDiscussions'?: Array<RecentlyViewedDiscussionDTO>;
    /**
     * 
     * @type {HomeViewerGraphSignalDTO}
     * @memberof HomeDiscoveryBootstrapDTO
     */
    'viewerGraph'?: HomeViewerGraphSignalDTO;
}
/**
 * 
 * @export
 * @interface HomeDiscussionFeedPageDTO
 */
export interface HomeDiscussionFeedPageDTO {
    /**
     * 
     * @type {Array<DiscussionWithoutContentDTO>}
     * @memberof HomeDiscussionFeedPageDTO
     */
    'items'?: Array<DiscussionWithoutContentDTO>;
    /**
     * 
     * @type {string}
     * @memberof HomeDiscussionFeedPageDTO
     */
    'nextCursor'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HomeDiscussionFeedPageDTO
     */
    'hasMore'?: boolean;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof HomeDiscussionFeedPageDTO
     */
    'newReplyCounts'?: { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface HomeGroupsFeedPageDTO
 */
export interface HomeGroupsFeedPageDTO {
    /**
     * 
     * @type {Array<GroupDiscussionDTO>}
     * @memberof HomeGroupsFeedPageDTO
     */
    'items'?: Array<GroupDiscussionDTO>;
    /**
     * 
     * @type {string}
     * @memberof HomeGroupsFeedPageDTO
     */
    'nextCursor'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HomeGroupsFeedPageDTO
     */
    'hasMore'?: boolean;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof HomeGroupsFeedPageDTO
     */
    'newReplyCounts'?: { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface HomeViewerGraphSignalDTO
 */
export interface HomeViewerGraphSignalDTO {
    /**
     * 
     * @type {string}
     * @memberof HomeViewerGraphSignalDTO
     */
    'tier'?: HomeViewerGraphSignalDTOTierEnum;
    /**
     * 
     * @type {number}
     * @memberof HomeViewerGraphSignalDTO
     */
    'followedUsers'?: number;
    /**
     * 
     * @type {number}
     * @memberof HomeViewerGraphSignalDTO
     */
    'groups'?: number;
    /**
     * 
     * @type {number}
     * @memberof HomeViewerGraphSignalDTO
     */
    'followedSeries'?: number;
}

export const HomeViewerGraphSignalDTOTierEnum = {
    Empty: 'EMPTY',
    Sparse: 'SPARSE',
    Established: 'ESTABLISHED'
} as const;

export type HomeViewerGraphSignalDTOTierEnum = typeof HomeViewerGraphSignalDTOTierEnum[keyof typeof HomeViewerGraphSignalDTOTierEnum];

/**
 * 
 * @export
 * @interface ImageDTO
 */
export interface ImageDTO {
    /**
     * 
     * @type {string}
     * @memberof ImageDTO
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ImageDTO
     */
    'ownerId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ImageDTO
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageDTO
     */
    'ownerUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageDTO
     */
    'failureCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof ImageDTO
     */
    'durationMs'?: number;
    /**
     * 
     * @type {string}
     * @memberof ImageDTO
     */
    'mediaKind'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageDTO
     */
    'imagePublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageDTO
     */
    'lastUsedAt'?: string;
}
/**
 * 
 * @export
 * @interface ImageUploadLinkResponse
 */
export interface ImageUploadLinkResponse {
    /**
     * 
     * @type {string}
     * @memberof ImageUploadLinkResponse
     */
    'presignedUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageUploadLinkResponse
     */
    'ownerUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageUploadLinkResponse
     */
    'imagePublicId'?: string;
}
/**
 * 
 * @export
 * @interface ImportDiscussionDraftFeedRequest
 */
export interface ImportDiscussionDraftFeedRequest {
    /**
     * 
     * @type {string}
     * @memberof ImportDiscussionDraftFeedRequest
     */
    'feedUrl': string;
    /**
     * 
     * @type {boolean}
     * @memberof ImportDiscussionDraftFeedRequest
     */
    'rightsAffirmed'?: boolean;
}
/**
 * 
 * @export
 * @interface ImportDiscussionDraftRequest
 */
export interface ImportDiscussionDraftRequest {
    /**
     * 
     * @type {string}
     * @memberof ImportDiscussionDraftRequest
     */
    'url': string;
    /**
     * 
     * @type {boolean}
     * @memberof ImportDiscussionDraftRequest
     */
    'rightsAffirmed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ImportDiscussionDraftRequest
     */
    'draftPublicId'?: string;
}
/**
 * 
 * @export
 * @interface ImportFilesCompleteRequest
 */
export interface ImportFilesCompleteRequest {
    /**
     * 
     * @type {string}
     * @memberof ImportFilesCompleteRequest
     */
    'uploadSetPublicId'?: string;
    /**
     * 
     * @type {Array<FileDeclaration>}
     * @memberof ImportFilesCompleteRequest
     */
    'files'?: Array<FileDeclaration>;
}
/**
 * 
 * @export
 * @interface ImportFilesPresignRequest
 */
export interface ImportFilesPresignRequest {
    /**
     * 
     * @type {Array<FileDeclaration>}
     * @memberof ImportFilesPresignRequest
     */
    'files'?: Array<FileDeclaration>;
}
/**
 * 
 * @export
 * @interface ImportNewsletterSubscribersRequest
 */
export interface ImportNewsletterSubscribersRequest {
    /**
     * 
     * @type {string}
     * @memberof ImportNewsletterSubscribersRequest
     */
    'csv'?: string;
}
/**
 * 
 * @export
 * @interface InviteLinkViewDTO
 */
export interface InviteLinkViewDTO {
    /**
     * 
     * @type {string}
     * @memberof InviteLinkViewDTO
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof InviteLinkViewDTO
     */
    'expiresAt'?: string;
}
/**
 * 
 * @export
 * @interface InviteUserToGroupResultDTO
 */
export interface InviteUserToGroupResultDTO {
    /**
     * 
     * @type {string}
     * @memberof InviteUserToGroupResultDTO
     */
    'status'?: InviteUserToGroupResultDTOStatusEnum;
}

export const InviteUserToGroupResultDTOStatusEnum = {
    Invited: 'INVITED',
    Added: 'ADDED',
    AlreadyInGroup: 'ALREADY_IN_GROUP',
    AlreadyInvited: 'ALREADY_INVITED'
} as const;

export type InviteUserToGroupResultDTOStatusEnum = typeof InviteUserToGroupResultDTOStatusEnum[keyof typeof InviteUserToGroupResultDTOStatusEnum];

/**
 * 
 * @export
 * @interface Item
 */
export interface Item {
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'sourceUrl': string;
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'sourceJson'?: string;
}
/**
 * 
 * @export
 * @interface Keys
 */
export interface Keys {
    /**
     * 
     * @type {string}
     * @memberof Keys
     */
    'p256dh'?: string;
    /**
     * 
     * @type {string}
     * @memberof Keys
     */
    'auth'?: string;
}
/**
 * 
 * @export
 * @interface KnownOriginDTO
 */
export interface KnownOriginDTO {
    /**
     * 
     * @type {string}
     * @memberof KnownOriginDTO
     */
    'asn'?: string;
    /**
     * 
     * @type {string}
     * @memberof KnownOriginDTO
     */
    'countryCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof KnownOriginDTO
     */
    'cityName'?: string;
    /**
     * 
     * @type {string}
     * @memberof KnownOriginDTO
     */
    'firstSeenAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof KnownOriginDTO
     */
    'lastSeenAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof KnownOriginDTO
     */
    'eventCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof KnownOriginDTO
     */
    'sharedAccountCount'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof KnownOriginDTO
     */
    'alsoUsedBy'?: Array<string>;
}
/**
 * 
 * @export
 * @interface LandDiscussionDraftFeedItemsRequest
 */
export interface LandDiscussionDraftFeedItemsRequest {
    /**
     * 
     * @type {string}
     * @memberof LandDiscussionDraftFeedItemsRequest
     */
    'feedUrl': string;
    /**
     * 
     * @type {boolean}
     * @memberof LandDiscussionDraftFeedItemsRequest
     */
    'rightsAffirmed'?: boolean;
    /**
     * 
     * @type {Array<Item>}
     * @memberof LandDiscussionDraftFeedItemsRequest
     */
    'items'?: Array<Item>;
    /**
     * 
     * @type {string}
     * @memberof LandDiscussionDraftFeedItemsRequest
     */
    'draftPublicId'?: string;
}
/**
 * 
 * @export
 * @interface Layer
 */
export interface Layer {
    /**
     * 
     * @type {string}
     * @memberof Layer
     */
    'layer'?: string;
    /**
     * 
     * @type {Array<Family>}
     * @memberof Layer
     */
    'families'?: Array<Family>;
}
/**
 * 
 * @export
 * @interface LinkEvidenceDTO
 */
export interface LinkEvidenceDTO {
    /**
     * 
     * @type {string}
     * @memberof LinkEvidenceDTO
     */
    'evidenceType'?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkEvidenceDTO
     */
    'strength'?: string;
    /**
     * 
     * @type {number}
     * @memberof LinkEvidenceDTO
     */
    'weight'?: number;
    /**
     * 
     * @type {string}
     * @memberof LinkEvidenceDTO
     */
    'firstSeenAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkEvidenceDTO
     */
    'lastSeenAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof LinkEvidenceDTO
     */
    'observationCount'?: number;
}
/**
 * 
 * @export
 * @interface LinkedAccountDTO
 */
export interface LinkedAccountDTO {
    /**
     * 
     * @type {string}
     * @memberof LinkedAccountDTO
     */
    'username'?: string;
    /**
     * 
     * @type {number}
     * @memberof LinkedAccountDTO
     */
    'linkScore'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof LinkedAccountDTO
     */
    'clustered'?: boolean;
    /**
     * 
     * @type {Array<LinkEvidenceDTO>}
     * @memberof LinkedAccountDTO
     */
    'evidence'?: Array<LinkEvidenceDTO>;
}
/**
 * 
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'password'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LoginRequest
     */
    'rememberMe'?: boolean;
}
/**
 * 
 * @export
 * @interface MarkChatThreadReadRequest
 */
export interface MarkChatThreadReadRequest {
    /**
     * 
     * @type {string}
     * @memberof MarkChatThreadReadRequest
     */
    'latestVisibleMessagePublicId'?: string;
}
/**
 * 
 * @export
 * @interface MarkImageAsUploadedRequest
 */
export interface MarkImageAsUploadedRequest {
    /**
     * 
     * @type {string}
     * @memberof MarkImageAsUploadedRequest
     */
    'imagePublicId': string;
}
/**
 * 
 * @export
 * @interface MarkMindChangedRequest
 */
export interface MarkMindChangedRequest {
    /**
     * 
     * @type {string}
     * @memberof MarkMindChangedRequest
     */
    'sourceJson': string;
    /**
     * 
     * @type {string}
     * @memberof MarkMindChangedRequest
     */
    'clientPublishId'?: string;
}
/**
 * 
 * @export
 * @interface MarkNotificationsAsReadRequest
 */
export interface MarkNotificationsAsReadRequest {
    /**
     * The notification types for the active sidebar tab
     * @type {Array<string>}
     * @memberof MarkNotificationsAsReadRequest
     */
    'notificationTypes'?: Array<MarkNotificationsAsReadRequestNotificationTypesEnum>;
    /**
     * Optional pagination parameter for loaded-range mark-read behavior; omit to mark the whole active section as read
     * @type {string}
     * @memberof MarkNotificationsAsReadRequest
     */
    'paginationParameter'?: string;
}

export const MarkNotificationsAsReadRequestNotificationTypesEnum = {
    NewOpeningThought: 'NEW_OPENING_THOUGHT',
    NewThoughtReply: 'NEW_THOUGHT_REPLY',
    GroupInvitationReceived: 'GROUP_INVITATION_RECEIVED',
    GroupInvitationAccepted: 'GROUP_INVITATION_ACCEPTED',
    NewGroupRequestToJoin: 'NEW_GROUP_REQUEST_TO_JOIN',
    NewDiscussionRequestToAddToGroup: 'NEW_DISCUSSION_REQUEST_TO_ADD_TO_GROUP',
    GroupRequestToJoinApproved: 'GROUP_REQUEST_TO_JOIN_APPROVED',
    GroupRequestToJoinRejected: 'GROUP_REQUEST_TO_JOIN_REJECTED',
    DiscussionRequestToAddToGroupApproved: 'DISCUSSION_REQUEST_TO_ADD_TO_GROUP_APPROVED',
    DiscussionRequestToAddToGroupRejected: 'DISCUSSION_REQUEST_TO_ADD_TO_GROUP_REJECTED',
    GroupDiscussionSubmissionPendingReview: 'GROUP_DISCUSSION_SUBMISSION_PENDING_REVIEW',
    GroupDiscussionSubmissionWaitingForLeaders: 'GROUP_DISCUSSION_SUBMISSION_WAITING_FOR_LEADERS',
    GroupDiscussionSubmissionApproved: 'GROUP_DISCUSSION_SUBMISSION_APPROVED',
    GroupDiscussionSubmissionRejected: 'GROUP_DISCUSSION_SUBMISSION_REJECTED',
    UserMentioned: 'USER_MENTIONED',
    GroupUserBanned: 'GROUP_USER_BANNED',
    GroupUserUnbanned: 'GROUP_USER_UNBANNED',
    GroupDiscussionExcluded: 'GROUP_DISCUSSION_EXCLUDED',
    GroupDiscussionUnexcluded: 'GROUP_DISCUSSION_UNEXCLUDED',
    NewsletterNewIssue: 'NEWSLETTER_NEW_ISSUE',
    ThoughtUpvoted: 'THOUGHT_UPVOTED',
    DeprecatedThoughtDownvoted: 'DEPRECATED_THOUGHT_DOWNVOTED',
    PrivateDiscussionAccessBlocked: 'PRIVATE_DISCUSSION_ACCESS_BLOCKED',
    NewFollower: 'NEW_FOLLOWER',
    DiscussionAddedToSeries: 'DISCUSSION_ADDED_TO_SERIES',
    SeriesNewDiscussion: 'SERIES_NEW_DISCUSSION',
    DiscussionAddedToGroup: 'DISCUSSION_ADDED_TO_GROUP',
    FollowedAuthorNewDiscussion: 'FOLLOWED_AUTHOR_NEW_DISCUSSION',
    SeriesFollowed: 'SERIES_FOLLOWED',
    NewGroupMember: 'NEW_GROUP_MEMBER',
    NewDiscussionInGroup: 'NEW_DISCUSSION_IN_GROUP',
    GroupLeaderAssigned: 'GROUP_LEADER_ASSIGNED',
    DiscussionPinnedInGroup: 'DISCUSSION_PINNED_IN_GROUP',
    ContentReportReviewed: 'CONTENT_REPORT_REVIEWED',
    GroupAnnouncementPosted: 'GROUP_ANNOUNCEMENT_POSTED',
    SupportRequestReceived: 'SUPPORT_REQUEST_RECEIVED',
    SupportReplySent: 'SUPPORT_REPLY_SENT',
    FirstToReply: 'FIRST_TO_REPLY',
    ThoughtPinned: 'THOUGHT_PINNED',
    AchievementEarned: 'ACHIEVEMENT_EARNED',
    AnswerAccepted: 'ANSWER_ACCEPTED',
    DiscussionUpvoted: 'DISCUSSION_UPVOTED',
    GroupBoardReply: 'GROUP_BOARD_REPLY',
    DiscussionAuthorReplied: 'DISCUSSION_AUTHOR_REPLIED',
    TopReply: 'TOP_REPLY',
    DiscussionGainingTraction: 'DISCUSSION_GAINING_TRACTION',
    ThoughtBookmarked: 'THOUGHT_BOOKMARKED',
    DiscussionBookmarked: 'DISCUSSION_BOOKMARKED',
    ReplyRequested: 'REPLY_REQUESTED',
    AnswerRequested: 'ANSWER_REQUESTED',
    MindChanged: 'MIND_CHANGED',
    BoardItemSettled: 'BOARD_ITEM_SETTLED',
    BoardCompleted: 'BOARD_COMPLETED',
    PollClosed: 'POLL_CLOSED',
    ScheduledThoughtPublishFailed: 'SCHEDULED_THOUGHT_PUBLISH_FAILED',
    GroupRecommendationReceived: 'GROUP_RECOMMENDATION_RECEIVED',
    GroupRecommendationJoined: 'GROUP_RECOMMENDATION_JOINED',
    MemberProposalReceived: 'MEMBER_PROPOSAL_RECEIVED',
    GroupInviteRequestReceived: 'GROUP_INVITE_REQUEST_RECEIVED',
    GroupInviteRequestApproved: 'GROUP_INVITE_REQUEST_APPROVED',
    GroupInviteRequestDeclined: 'GROUP_INVITE_REQUEST_DECLINED',
    UserReportReviewed: 'USER_REPORT_REVIEWED',
    EndorsementReceived: 'ENDORSEMENT_RECEIVED',
    EndorsementNoteReceived: 'ENDORSEMENT_NOTE_RECEIVED',
    DiscussionQuoted: 'DISCUSSION_QUOTED',
    FollowedPostNewReply: 'FOLLOWED_POST_NEW_REPLY',
    ModerationNotice: 'MODERATION_NOTICE',
    PostReply: 'POST_REPLY',
    GroupRequestExpired: 'GROUP_REQUEST_EXPIRED',
    GroupColeadOffered: 'GROUP_COLEAD_OFFERED',
    CircleFormed: 'CIRCLE_FORMED',
    SharedLinkRead: 'SHARED_LINK_READ'
} as const;

export type MarkNotificationsAsReadRequestNotificationTypesEnum = typeof MarkNotificationsAsReadRequestNotificationTypesEnum[keyof typeof MarkNotificationsAsReadRequestNotificationTypesEnum];

/**
 * 
 * @export
 * @interface MarkNotificationsSeenRequest
 */
export interface MarkNotificationsSeenRequest {
    /**
     * Public ids of the notifications currently rendered in the open drawer
     * @type {Array<string>}
     * @memberof MarkNotificationsSeenRequest
     */
    'notificationPublicIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface MediaAttentionRequest
 */
export interface MediaAttentionRequest {
    /**
     * 
     * @type {number}
     * @memberof MediaAttentionRequest
     */
    'attentiveMs'?: number;
    /**
     * 
     * @type {number}
     * @memberof MediaAttentionRequest
     */
    'itemsSeen'?: number;
    /**
     * 
     * @type {number}
     * @memberof MediaAttentionRequest
     */
    'opens'?: number;
    /**
     * 
     * @type {number}
     * @memberof MediaAttentionRequest
     */
    'plays'?: number;
    /**
     * 
     * @type {number}
     * @memberof MediaAttentionRequest
     */
    'watchThroughs'?: number;
    /**
     * 
     * @type {number}
     * @memberof MediaAttentionRequest
     */
    'firstAttentionMs'?: number;
}
/**
 * 
 * @export
 * @interface MemberConnectionOriginDTO
 */
export interface MemberConnectionOriginDTO {
    /**
     * 
     * @type {string}
     * @memberof MemberConnectionOriginDTO
     */
    'countryCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof MemberConnectionOriginDTO
     */
    'cityName'?: string;
    /**
     * 
     * @type {string}
     * @memberof MemberConnectionOriginDTO
     */
    'firstSeenAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof MemberConnectionOriginDTO
     */
    'lastSeenAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof MemberConnectionOriginDTO
     */
    'eventCount'?: number;
}
/**
 * 
 * @export
 * @interface MemberProposalAcceptRequest
 */
export interface MemberProposalAcceptRequest {
    /**
     * 
     * @type {string}
     * @memberof MemberProposalAcceptRequest
     */
    'title'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MemberProposalAcceptRequest
     */
    'discussionPublicIds'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof MemberProposalAcceptRequest
     */
    'privateAccess'?: boolean;
}
/**
 * 
 * @export
 * @interface MemberProposalAcceptResult
 */
export interface MemberProposalAcceptResult {
    /**
     * 
     * @type {boolean}
     * @memberof MemberProposalAcceptResult
     */
    'accepted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MemberProposalAcceptResult
     */
    'unavailable': boolean;
    /**
     * 
     * @type {string}
     * @memberof MemberProposalAcceptResult
     */
    'seriesPublicId': string | null;
    /**
     * 
     * @type {string}
     * @memberof MemberProposalAcceptResult
     */
    'seriesSlug': string | null;
}
/**
 * 
 * @export
 * @interface MemberProposalView
 */
export interface MemberProposalView {
    /**
     * 
     * @type {string}
     * @memberof MemberProposalView
     */
    'proposalPublicId': string;
    /**
     * 
     * @type {string}
     * @memberof MemberProposalView
     */
    'kind': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MemberProposalView
     */
    'available': boolean;
    /**
     * 
     * @type {string}
     * @memberof MemberProposalView
     */
    'suggestedTitle': string | null;
    /**
     * 
     * @type {SeriesItem}
     * @memberof MemberProposalView
     */
    'series'?: SeriesItem;
    /**
     * 
     * @type {Array<PostItem>}
     * @memberof MemberProposalView
     */
    'posts': Array<PostItem>;
    /**
     * 
     * @type {boolean}
     * @memberof MemberProposalView
     */
    'defaultPrivateAccess': boolean;
}
/**
 * 
 * @export
 * @interface MemberSubscriber
 */
export interface MemberSubscriber {
    /**
     * 
     * @type {string}
     * @memberof MemberSubscriber
     */
    'kind': MemberSubscriberKindEnum;
    /**
     * 
     * @type {string}
     * @memberof MemberSubscriber
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof MemberSubscriber
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof MemberSubscriber
     */
    'subscribedAt': string;
}

export const MemberSubscriberKindEnum = {
    Member: 'MEMBER'
} as const;

export type MemberSubscriberKindEnum = typeof MemberSubscriberKindEnum[keyof typeof MemberSubscriberKindEnum];

/**
 * 
 * @export
 * @interface MemeImageSummaryDTO
 */
export interface MemeImageSummaryDTO {
    /**
     * 
     * @type {string}
     * @memberof MemeImageSummaryDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MemeImageSummaryDTO
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof MemeImageSummaryDTO
     */
    'imagePublicId'?: string;
}
/**
 * 
 * @export
 * @interface MemeTemplateDetailDTO
 */
export interface MemeTemplateDetailDTO {
    /**
     * 
     * @type {string}
     * @memberof MemeTemplateDetailDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MemeTemplateDetailDTO
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof MemeTemplateDetailDTO
     */
    'imagePublicId'?: string;
    /**
     * 
     * @type {any}
     * @memberof MemeTemplateDetailDTO
     */
    'defaultTextBoxes'?: any;
}
/**
 * 
 * @export
 * @interface MemeTemplateMatchDTO
 */
export interface MemeTemplateMatchDTO {
    /**
     * 
     * @type {string}
     * @memberof MemeTemplateMatchDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MemeTemplateMatchDTO
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof MemeTemplateMatchDTO
     */
    'imagePublicId'?: string;
    /**
     * 
     * @type {number}
     * @memberof MemeTemplateMatchDTO
     */
    'distance'?: number;
}
/**
 * 
 * @export
 * @interface MemeTemplateSummaryDTO
 */
export interface MemeTemplateSummaryDTO {
    /**
     * 
     * @type {string}
     * @memberof MemeTemplateSummaryDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MemeTemplateSummaryDTO
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof MemeTemplateSummaryDTO
     */
    'imagePublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MemeTemplateSummaryDTO
     */
    'visibility'?: string;
    /**
     * 
     * @type {number}
     * @memberof MemeTemplateSummaryDTO
     */
    'usageCount'?: number;
}
/**
 * 
 * @export
 * @interface MetricSeriesDto
 */
export interface MetricSeriesDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof MetricSeriesDto
     */
    'labels'?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof MetricSeriesDto
     */
    'values'?: Array<number>;
}
/**
 * 
 * @export
 * @interface MetricsResponseDto
 */
export interface MetricsResponseDto {
    /**
     * 
     * @type {string}
     * @memberof MetricsResponseDto
     */
    'discussionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetricsResponseDto
     */
    'periodType'?: MetricsResponseDtoPeriodTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof MetricsResponseDto
     */
    'periodCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof MetricsResponseDto
     */
    'startAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetricsResponseDto
     */
    'endAt'?: string;
    /**
     * 
     * @type {{ [key: string]: MetricSeriesDto; }}
     * @memberof MetricsResponseDto
     */
    'series'?: { [key: string]: MetricSeriesDto; };
    /**
     * 
     * @type {{ [key: string]: ColorDto; }}
     * @memberof MetricsResponseDto
     */
    'colors'?: { [key: string]: ColorDto; };
    /**
     * 
     * @type {PeriodLimits}
     * @memberof MetricsResponseDto
     */
    'limits'?: PeriodLimits;
    /**
     * 
     * @type {string}
     * @memberof MetricsResponseDto
     */
    'humanizedHint'?: string;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof MetricsResponseDto
     */
    'startValues'?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof MetricsResponseDto
     */
    'snapshotTotals'?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: MetricSeriesDto; }}
     * @memberof MetricsResponseDto
     */
    'previousSeries'?: { [key: string]: MetricSeriesDto; };
}

export const MetricsResponseDtoPeriodTypeEnum = {
    Hour: 'hour',
    Day: 'day',
    Week: 'week',
    Month: 'month'
} as const;

export type MetricsResponseDtoPeriodTypeEnum = typeof MetricsResponseDtoPeriodTypeEnum[keyof typeof MetricsResponseDtoPeriodTypeEnum];

/**
 * 
 * @export
 * @interface MobileSocialAuthStartRequest
 */
export interface MobileSocialAuthStartRequest {
    /**
     * 
     * @type {string}
     * @memberof MobileSocialAuthStartRequest
     */
    'provider': MobileSocialAuthStartRequestProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof MobileSocialAuthStartRequest
     */
    'platform': MobileSocialAuthStartRequestPlatformEnum;
    /**
     * 
     * @type {string}
     * @memberof MobileSocialAuthStartRequest
     */
    'requestedPath'?: string;
}

export const MobileSocialAuthStartRequestProviderEnum = {
    Google: 'GOOGLE',
    Apple: 'APPLE'
} as const;

export type MobileSocialAuthStartRequestProviderEnum = typeof MobileSocialAuthStartRequestProviderEnum[keyof typeof MobileSocialAuthStartRequestProviderEnum];
export const MobileSocialAuthStartRequestPlatformEnum = {
    Ios: 'IOS',
    Android: 'ANDROID',
    WebStandalone: 'WEB_STANDALONE'
} as const;

export type MobileSocialAuthStartRequestPlatformEnum = typeof MobileSocialAuthStartRequestPlatformEnum[keyof typeof MobileSocialAuthStartRequestPlatformEnum];

/**
 * 
 * @export
 * @interface MobileSocialAuthStartResponse
 */
export interface MobileSocialAuthStartResponse {
    /**
     * 
     * @type {string}
     * @memberof MobileSocialAuthStartResponse
     */
    'authorizationUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof MobileSocialAuthStartResponse
     */
    'attemptPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MobileSocialAuthStartResponse
     */
    'returnMode'?: string;
}
/**
 * 
 * @export
 * @interface MuteReadingLanguageRequest
 */
export interface MuteReadingLanguageRequest {
    /**
     * 
     * @type {string}
     * @memberof MuteReadingLanguageRequest
     */
    'tag'?: string;
}
/**
 * 
 * @export
 * @interface MutedPostDTO
 */
export interface MutedPostDTO {
    /**
     * 
     * @type {string}
     * @memberof MutedPostDTO
     */
    'discussionPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof MutedPostDTO
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof MutedPostDTO
     */
    'mutedAt'?: string;
}
/**
 * 
 * @export
 * @interface NewsletterAnalyticsDTO
 */
export interface NewsletterAnalyticsDTO {
    /**
     * 
     * @type {string}
     * @memberof NewsletterAnalyticsDTO
     */
    'newsletterPublicId'?: string;
    /**
     * 
     * @type {number}
     * @memberof NewsletterAnalyticsDTO
     */
    'subscribers'?: number;
    /**
     * 
     * @type {number}
     * @memberof NewsletterAnalyticsDTO
     */
    'issuesPublished'?: number;
    /**
     * 
     * @type {number}
     * @memberof NewsletterAnalyticsDTO
     */
    'totalDelivered'?: number;
    /**
     * 
     * @type {number}
     * @memberof NewsletterAnalyticsDTO
     */
    'totalOpens'?: number;
    /**
     * 
     * @type {number}
     * @memberof NewsletterAnalyticsDTO
     */
    'totalClicks'?: number;
    /**
     * 
     * @type {Array<NewsletterIssueAnalyticsDTO>}
     * @memberof NewsletterAnalyticsDTO
     */
    'perIssue'?: Array<NewsletterIssueAnalyticsDTO>;
    /**
     * 
     * @type {number}
     * @memberof NewsletterAnalyticsDTO
     */
    'totalClickedDeliveries'?: number;
    /**
     * 
     * @type {Array<NewsletterSubscriberSourceDTO>}
     * @memberof NewsletterAnalyticsDTO
     */
    'sources'?: Array<NewsletterSubscriberSourceDTO>;
}
/**
 * 
 * @export
 * @interface NewsletterCreatedResponse
 */
export interface NewsletterCreatedResponse {
    /**
     * 
     * @type {boolean}
     * @memberof NewsletterCreatedResponse
     */
    'created': boolean;
    /**
     * 
     * @type {string}
     * @memberof NewsletterCreatedResponse
     */
    'newsletterPublicId': string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterCreatedResponse
     */
    'newsletterSlug': string;
    /**
     * 
     * @type {NewsletterDTO}
     * @memberof NewsletterCreatedResponse
     */
    'newsletter': NewsletterDTO;
}
/**
 * 
 * @export
 * @interface NewsletterDTO
 */
export interface NewsletterDTO {
    /**
     * 
     * @type {string}
     * @memberof NewsletterDTO
     */
    'publicId': string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterDTO
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterDTO
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterDTO
     */
    'promiseLine'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterDTO
     */
    'logoUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterDTO
     */
    'coverUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterDTO
     */
    'senderDisplayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterDTO
     */
    'discoverability': NewsletterDTODiscoverabilityEnum;
    /**
     * 
     * @type {string}
     * @memberof NewsletterDTO
     */
    'mainLocale': string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterDTO
     */
    'status': NewsletterDTOStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof NewsletterDTO
     */
    'closedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof NewsletterDTO
     */
    'subscribersCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof NewsletterDTO
     */
    'issuesCount': number;
    /**
     * 
     * @type {number}
     * @memberof NewsletterDTO
     */
    'viewsCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof NewsletterDTO
     */
    'sensitive': boolean;
    /**
     * 
     * @type {string}
     * @memberof NewsletterDTO
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterDTO
     */
    'modifiedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterDTO
     */
    'ownerUsername'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NewsletterDTO
     */
    'viewerOwner': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NewsletterDTO
     */
    'viewerSubscribed': boolean;
    /**
     * 
     * @type {number}
     * @memberof NewsletterDTO
     */
    'ownerConfirmedSubscriberCount'?: number;
}

export const NewsletterDTODiscoverabilityEnum = {
    Public: 'PUBLIC',
    Unlisted: 'UNLISTED'
} as const;

export type NewsletterDTODiscoverabilityEnum = typeof NewsletterDTODiscoverabilityEnum[keyof typeof NewsletterDTODiscoverabilityEnum];
export const NewsletterDTOStatusEnum = {
    Active: 'ACTIVE',
    Closed: 'CLOSED'
} as const;

export type NewsletterDTOStatusEnum = typeof NewsletterDTOStatusEnum[keyof typeof NewsletterDTOStatusEnum];

/**
 * 
 * @export
 * @interface NewsletterExternalSubscribeResponse
 */
export interface NewsletterExternalSubscribeResponse {
    /**
     * 
     * @type {boolean}
     * @memberof NewsletterExternalSubscribeResponse
     */
    'ok': boolean;
}
/**
 * 
 * @export
 * @interface NewsletterImportResultDTO
 */
export interface NewsletterImportResultDTO {
    /**
     * 
     * @type {string}
     * @memberof NewsletterImportResultDTO
     */
    'outcome'?: string;
    /**
     * 
     * @type {number}
     * @memberof NewsletterImportResultDTO
     */
    'added'?: number;
    /**
     * 
     * @type {number}
     * @memberof NewsletterImportResultDTO
     */
    'invalid'?: number;
    /**
     * 
     * @type {number}
     * @memberof NewsletterImportResultDTO
     */
    'skipped'?: number;
    /**
     * 
     * @type {number}
     * @memberof NewsletterImportResultDTO
     */
    'maxAddresses'?: number;
}
/**
 * 
 * @export
 * @interface NewsletterIssueAnalyticsDTO
 */
export interface NewsletterIssueAnalyticsDTO {
    /**
     * 
     * @type {string}
     * @memberof NewsletterIssueAnalyticsDTO
     */
    'issuePublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterIssueAnalyticsDTO
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterIssueAnalyticsDTO
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterIssueAnalyticsDTO
     */
    'publishedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof NewsletterIssueAnalyticsDTO
     */
    'delivered'?: number;
    /**
     * 
     * @type {number}
     * @memberof NewsletterIssueAnalyticsDTO
     */
    'opens'?: number;
    /**
     * 
     * @type {number}
     * @memberof NewsletterIssueAnalyticsDTO
     */
    'clicks'?: number;
    /**
     * 
     * @type {number}
     * @memberof NewsletterIssueAnalyticsDTO
     */
    'clickedDeliveries'?: number;
}
/**
 * 
 * @export
 * @interface NewsletterIssueDTO
 */
export interface NewsletterIssueDTO {
    /**
     * 
     * @type {string}
     * @memberof NewsletterIssueDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterIssueDTO
     */
    'newsletterPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterIssueDTO
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterIssueDTO
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterIssueDTO
     */
    'contentJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterIssueDTO
     */
    'coverUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterIssueDTO
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterIssueDTO
     */
    'scheduledAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterIssueDTO
     */
    'publishedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterIssueDTO
     */
    'sentAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof NewsletterIssueDTO
     */
    'recipientsAtSend'?: number;
    /**
     * 
     * @type {string}
     * @memberof NewsletterIssueDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterIssueDTO
     */
    'modifiedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NewsletterIssueDTO
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NewsletterIssueDTO
     */
    'sourceDiscussionPublicId'?: string;
}
/**
 * 
 * @export
 * @interface NewsletterIssueSendResponse
 */
export interface NewsletterIssueSendResponse {
    /**
     * 
     * @type {number}
     * @memberof NewsletterIssueSendResponse
     */
    'recipients': number;
    /**
     * 
     * @type {number}
     * @memberof NewsletterIssueSendResponse
     */
    'sent': number;
    /**
     * 
     * @type {number}
     * @memberof NewsletterIssueSendResponse
     */
    'failed': number;
    /**
     * 
     * @type {number}
     * @memberof NewsletterIssueSendResponse
     */
    'skipped': number;
    /**
     * 
     * @type {string}
     * @memberof NewsletterIssueSendResponse
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterIssueSendResponse
     */
    'scheduledAt'?: string;
}
/**
 * 
 * @export
 * @interface NewsletterMySubscriptionDTO
 */
export interface NewsletterMySubscriptionDTO {
    /**
     * 
     * @type {string}
     * @memberof NewsletterMySubscriptionDTO
     */
    'newsletterPublicId': string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterMySubscriptionDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterMySubscriptionDTO
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterMySubscriptionDTO
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface NewsletterSendPostChoiceDTO
 */
export interface NewsletterSendPostChoiceDTO {
    /**
     * 
     * @type {string}
     * @memberof NewsletterSendPostChoiceDTO
     */
    'newsletterPublicId': string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterSendPostChoiceDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterSendPostChoiceDTO
     */
    'slug': string;
    /**
     * 
     * @type {string}
     * @memberof NewsletterSendPostChoiceDTO
     */
    'issuePublicId'?: string;
}
/**
 * 
 * @export
 * @interface NewsletterSendPostResponse
 */
export interface NewsletterSendPostResponse {
    /**
     * 
     * @type {string}
     * @memberof NewsletterSendPostResponse
     */
    'outcome': NewsletterSendPostResponseOutcomeEnum;
    /**
     * 
     * @type {NewsletterIssueDTO}
     * @memberof NewsletterSendPostResponse
     */
    'issue'?: NewsletterIssueDTO;
    /**
     * 
     * @type {string}
     * @memberof NewsletterSendPostResponse
     */
    'newsletterSlug'?: string;
    /**
     * 
     * @type {Array<NewsletterSendPostChoiceDTO>}
     * @memberof NewsletterSendPostResponse
     */
    'choices': Array<NewsletterSendPostChoiceDTO>;
}

export const NewsletterSendPostResponseOutcomeEnum = {
    Created: 'CREATED',
    Existing: 'EXISTING',
    Choose: 'CHOOSE'
} as const;

export type NewsletterSendPostResponseOutcomeEnum = typeof NewsletterSendPostResponseOutcomeEnum[keyof typeof NewsletterSendPostResponseOutcomeEnum];

/**
 * @type NewsletterSubscriberDTO
 * @export
 */
export type NewsletterSubscriberDTO = { kind: 'MEMBER' } & MemberSubscriber | { kind: 'OUTSIDE' } & OutsideSubscriber;

/**
 * 
 * @export
 * @interface NewsletterSubscriberSourceDTO
 */
export interface NewsletterSubscriberSourceDTO {
    /**
     * 
     * @type {string}
     * @memberof NewsletterSubscriberSourceDTO
     */
    'consentSource': NewsletterSubscriberSourceDTOConsentSourceEnum;
    /**
     * 
     * @type {number}
     * @memberof NewsletterSubscriberSourceDTO
     */
    'subscribers': number;
}

export const NewsletterSubscriberSourceDTOConsentSourceEnum = {
    SelfWeb: 'SELF_WEB',
    SelfInapp: 'SELF_INAPP',
    Imported: 'IMPORTED',
    Api: 'API'
} as const;

export type NewsletterSubscriberSourceDTOConsentSourceEnum = typeof NewsletterSubscriberSourceDTOConsentSourceEnum[keyof typeof NewsletterSubscriberSourceDTOConsentSourceEnum];

/**
 * 
 * @export
 * @interface NewsletterTestSendResponse
 */
export interface NewsletterTestSendResponse {
    /**
     * 
     * @type {string}
     * @memberof NewsletterTestSendResponse
     */
    'sentTo': string;
}
/**
 * 
 * @export
 * @interface NewsletterUnsubscribeRequest
 */
export interface NewsletterUnsubscribeRequest {
    /**
     * 
     * @type {string}
     * @memberof NewsletterUnsubscribeRequest
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface OpeningThoughtWithConversationDTO
 */
export interface OpeningThoughtWithConversationDTO {
    /**
     * 
     * @type {ThoughtInDiscussionDTO}
     * @memberof OpeningThoughtWithConversationDTO
     */
    'openingArgument'?: ThoughtInDiscussionDTO;
    /**
     * 
     * @type {{ [key: string]: ThoughtInDiscussionDTO; }}
     * @memberof OpeningThoughtWithConversationDTO
     */
    'conversationsMap'?: { [key: string]: ThoughtInDiscussionDTO; };
    /**
     * 
     * @type {string}
     * @memberof OpeningThoughtWithConversationDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OpeningThoughtWithConversationDTO
     */
    'matchedDiscussionGroupPublicIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface OutsideSubscriber
 */
export interface OutsideSubscriber {
    /**
     * 
     * @type {string}
     * @memberof OutsideSubscriber
     */
    'kind': OutsideSubscriberKindEnum;
    /**
     * 
     * @type {string}
     * @memberof OutsideSubscriber
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof OutsideSubscriber
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof OutsideSubscriber
     */
    'subscribedAt': string;
}

export const OutsideSubscriberKindEnum = {
    Outside: 'OUTSIDE'
} as const;

export type OutsideSubscriberKindEnum = typeof OutsideSubscriberKindEnum[keyof typeof OutsideSubscriberKindEnum];

/**
 * 
 * @export
 * @interface PageGroupInviteRequestDTO
 */
export interface PageGroupInviteRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof PageGroupInviteRequestDTO
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageGroupInviteRequestDTO
     */
    'totalPages'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageGroupInviteRequestDTO
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageGroupInviteRequestDTO
     */
    'last'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageGroupInviteRequestDTO
     */
    'size'?: number;
    /**
     * 
     * @type {Array<GroupInviteRequestDTO>}
     * @memberof PageGroupInviteRequestDTO
     */
    'content'?: Array<GroupInviteRequestDTO>;
    /**
     * 
     * @type {number}
     * @memberof PageGroupInviteRequestDTO
     */
    'number'?: number;
    /**
     * 
     * @type {SortObject}
     * @memberof PageGroupInviteRequestDTO
     */
    'sort'?: SortObject;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageGroupInviteRequestDTO
     */
    'pageable'?: PageableObject;
    /**
     * 
     * @type {number}
     * @memberof PageGroupInviteRequestDTO
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageGroupInviteRequestDTO
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface PageIssueReportRequest
 */
export interface PageIssueReportRequest {
    /**
     * 
     * @type {string}
     * @memberof PageIssueReportRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof PageIssueReportRequest
     */
    'clientRequestId'?: string;
    /**
     * 
     * @type {number}
     * @memberof PageIssueReportRequest
     */
    'visualViewportHeight'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageIssueReportRequest
     */
    'visualViewportOffsetTop'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageIssueReportRequest
     */
    'visualViewportScale'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageIssueReportRequest
     */
    'innerHeight'?: number;
    /**
     * 
     * @type {string}
     * @memberof PageIssueReportRequest
     */
    'userAgent'?: string;
    /**
     * 
     * @type {string}
     * @memberof PageIssueReportRequest
     */
    'route'?: string;
    /**
     * 
     * @type {number}
     * @memberof PageIssueReportRequest
     */
    'shellRectTop'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageIssueReportRequest
     */
    'shellRectLeft'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageIssueReportRequest
     */
    'shellRectWidth'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageIssueReportRequest
     */
    'shellRectHeight'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageIssueReportRequest
     */
    'focusedElementFontSizePx'?: number;
}
/**
 * 
 * @export
 * @interface Pageable
 */
export interface Pageable {
    /**
     * 
     * @type {number}
     * @memberof Pageable
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof Pageable
     */
    'size'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof Pageable
     */
    'sort'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PageableObject
 */
export interface PageableObject {
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    'offset'?: number;
    /**
     * 
     * @type {SortObject}
     * @memberof PageableObject
     */
    'sort'?: SortObject;
    /**
     * 
     * @type {boolean}
     * @memberof PageableObject
     */
    'paged'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    'pageNumber'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    'pageSize'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageableObject
     */
    'unpaged'?: boolean;
}
/**
 * 
 * @export
 * @interface Part
 */
export interface Part {
    /**
     * 
     * @type {number}
     * @memberof Part
     */
    'partNumber': number;
    /**
     * 
     * @type {string}
     * @memberof Part
     */
    'eTag': string;
}
/**
 * 
 * @export
 * @interface PasswordResetRequest
 */
export interface PasswordResetRequest {
    /**
     * 
     * @type {string}
     * @memberof PasswordResetRequest
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof PasswordResetRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof PasswordResetRequest
     */
    'confirmPassword': string;
}
/**
 * 
 * @export
 * @interface PeriodLimits
 */
export interface PeriodLimits {
    /**
     * 
     * @type {number}
     * @memberof PeriodLimits
     */
    'min'?: number;
    /**
     * 
     * @type {number}
     * @memberof PeriodLimits
     */
    'max'?: number;
}
/**
 * 
 * @export
 * @interface PinnedGroupDiscussionSummaryDTO
 */
export interface PinnedGroupDiscussionSummaryDTO {
    /**
     * 
     * @type {number}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'discussionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'excerpt'?: string;
    /**
     * 
     * @type {number}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'topScore'?: number;
    /**
     * 
     * @type {string}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'cardMediaItems'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'spoiler'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'archived'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'archivedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'deletedByModerator'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'deletedReasonType'?: string;
    /**
     * 
     * @type {string}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'deletedMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'authorUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'authorProfileImageUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'isUserAgreeing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'isUserDisagreeing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'agreementsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'disagreementsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'conversationsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'argumentsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'searchScore'?: string;
    /**
     * 
     * @type {string}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'recommendationSource'?: string;
    /**
     * 
     * @type {string}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'sourceType'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'privateAccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'participatedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'discussionAddedToSeriesCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'isAddedToAnySeries'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'isAddedToBookmarksSeries'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'isViewerFollowingAuthor'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'isPoll'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'viewsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'bodyTextLength'?: number;
    /**
     * 
     * @type {string}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {number}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'pinId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {string}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'pinnedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PinnedGroupDiscussionSummaryDTO
     */
    'pinnedByUsername'?: string;
}
/**
 * 
 * @export
 * @interface PlaywrightFixtureCleanupResult
 */
export interface PlaywrightFixtureCleanupResult {
    /**
     * 
     * @type {boolean}
     * @memberof PlaywrightFixtureCleanupResult
     */
    'cleaned'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PlaywrightFixtureCleanupResult
     */
    'usersCleaned'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PollOptionResultDTO
 */
export interface PollOptionResultDTO {
    /**
     * 
     * @type {number}
     * @memberof PollOptionResultDTO
     */
    'optionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PollOptionResultDTO
     */
    'text'?: string;
    /**
     * 
     * @type {number}
     * @memberof PollOptionResultDTO
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {number}
     * @memberof PollOptionResultDTO
     */
    'votesCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof PollOptionResultDTO
     */
    'thoughtsCount'?: number;
    /**
     * 
     * @type {BestThoughtDTO}
     * @memberof PollOptionResultDTO
     */
    'bestThought'?: BestThoughtDTO;
}
/**
 * 
 * @export
 * @interface PollOptionViewDTO
 */
export interface PollOptionViewDTO {
    /**
     * 
     * @type {number}
     * @memberof PollOptionViewDTO
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PollOptionViewDTO
     */
    'text'?: string;
    /**
     * 
     * @type {number}
     * @memberof PollOptionViewDTO
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {number}
     * @memberof PollOptionViewDTO
     */
    'votesCount'?: number;
}
/**
 * 
 * @export
 * @interface PollResultsDTO
 */
export interface PollResultsDTO {
    /**
     * 
     * @type {string}
     * @memberof PollResultsDTO
     */
    'discussionPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PollResultsDTO
     */
    'closesAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PollResultsDTO
     */
    'closed'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PollResultsDTO
     */
    'totalVotes'?: number;
    /**
     * 
     * @type {number}
     * @memberof PollResultsDTO
     */
    'viewerOptionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PollResultsDTO
     */
    'side'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PollResultsDTO
     */
    'crossSide'?: boolean;
    /**
     * 
     * @type {Array<PollOptionResultDTO>}
     * @memberof PollResultsDTO
     */
    'options'?: Array<PollOptionResultDTO>;
}
/**
 * 
 * @export
 * @interface PollViewDTO
 */
export interface PollViewDTO {
    /**
     * 
     * @type {string}
     * @memberof PollViewDTO
     */
    'discussionPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PollViewDTO
     */
    'closesAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PollViewDTO
     */
    'closed'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PollViewDTO
     */
    'totalVotes'?: number;
    /**
     * 
     * @type {number}
     * @memberof PollViewDTO
     */
    'viewerOptionId'?: number;
    /**
     * 
     * @type {Array<PollOptionViewDTO>}
     * @memberof PollViewDTO
     */
    'options'?: Array<PollOptionViewDTO>;
}
/**
 * 
 * @export
 * @interface PollVoteRequest
 */
export interface PollVoteRequest {
    /**
     * 
     * @type {number}
     * @memberof PollVoteRequest
     */
    'optionId'?: number;
}
/**
 * 
 * @export
 * @interface Post
 */
export interface Post {
    /**
     * 
     * @type {string}
     * @memberof Post
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Post
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof Post
     */
    'title'?: string;
    /**
     * 
     * @type {number}
     * @memberof Post
     */
    'waitingPeopleCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof Post
     */
    'lastReplyAt'?: string;
}
/**
 * 
 * @export
 * @interface PostItem
 */
export interface PostItem {
    /**
     * 
     * @type {string}
     * @memberof PostItem
     */
    'publicId': string;
    /**
     * 
     * @type {string}
     * @memberof PostItem
     */
    'title': string | null;
}
/**
 * 
 * @export
 * @interface ProfileShowcaseDTO
 */
export interface ProfileShowcaseDTO {
    /**
     * 
     * @type {boolean}
     * @memberof ProfileShowcaseDTO
     */
    'viewerIsOwner'?: boolean;
    /**
     * 
     * @type {Array<FeaturedItemDTO>}
     * @memberof ProfileShowcaseDTO
     */
    'featured'?: Array<FeaturedItemDTO>;
    /**
     * 
     * @type {Array<FeaturedItemDTO>}
     * @memberof ProfileShowcaseDTO
     */
    'positions'?: Array<FeaturedItemDTO>;
}
/**
 * 
 * @export
 * @interface ProfileWallEntryDTOImpl
 */
export interface ProfileWallEntryDTOImpl {
    /**
     * 
     * @type {string}
     * @memberof ProfileWallEntryDTOImpl
     */
    'kind'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileWallEntryDTOImpl
     */
    'occurredAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProfileWallEntryDTOImpl
     */
    'sourceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProfileWallEntryDTOImpl
     */
    'discussionPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileWallEntryDTOImpl
     */
    'thoughtPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileWallEntryDTOImpl
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileWallEntryDTOImpl
     */
    'actorUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileWallEntryDTOImpl
     */
    'detail1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileWallEntryDTOImpl
     */
    'detail2'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileWallEntryDTOImpl
     */
    'viewerCanRemove'?: boolean;
}
/**
 * 
 * @export
 * @interface ProfileWallPage
 */
export interface ProfileWallPage {
    /**
     * 
     * @type {Array<ProfileWallEntryDTOImpl>}
     * @memberof ProfileWallPage
     */
    'entries'?: Array<ProfileWallEntryDTOImpl>;
    /**
     * 
     * @type {string}
     * @memberof ProfileWallPage
     */
    'nextCursor'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileWallPage
     */
    'viewerIsOwner'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileWallPage
     */
    'showAchievements'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileWallPage
     */
    'showEndorsements'?: boolean;
}
/**
 * 
 * @export
 * @interface PromptRequestedRequest
 */
export interface PromptRequestedRequest {
    /**
     * 
     * @type {number}
     * @memberof PromptRequestedRequest
     */
    'ruleVersion'?: number;
    /**
     * 
     * @type {string}
     * @memberof PromptRequestedRequest
     */
    'trigger'?: string;
    /**
     * 
     * @type {string}
     * @memberof PromptRequestedRequest
     */
    'platform'?: string;
    /**
     * 
     * @type {string}
     * @memberof PromptRequestedRequest
     */
    'appVersion'?: string;
}
/**
 * 
 * @export
 * @interface PublicMemeSummaryDTO
 */
export interface PublicMemeSummaryDTO {
    /**
     * 
     * @type {string}
     * @memberof PublicMemeSummaryDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicMemeSummaryDTO
     */
    'imagePublicId'?: string;
}
/**
 * 
 * @export
 * @interface PublishDiscussionRequest
 */
export interface PublishDiscussionRequest {
    /**
     * 
     * @type {string}
     * @memberof PublishDiscussionRequest
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof PublishDiscussionRequest
     */
    'excerpt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublishDiscussionRequest
     */
    'sourceJson': string;
    /**
     * 
     * @type {string}
     * @memberof PublishDiscussionRequest
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublishDiscussionRequest
     */
    'draftPublicId': string;
    /**
     * 
     * @type {string}
     * @memberof PublishDiscussionRequest
     */
    'discussionPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublishDiscussionRequest
     */
    'scheduledPublishAt'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PublishDiscussionRequest
     */
    'tags'?: Array<string>;
    /**
     * The type of tile on the map
     * @type {SeavienLanguageTag}
     * @memberof PublishDiscussionRequest
     */
    'languageTag'?: SeavienLanguageTag;
    /**
     * 
     * @type {boolean}
     * @memberof PublishDiscussionRequest
     */
    'privateAccess'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PublishDiscussionRequest
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PublishDiscussionRequest
     */
    'sensitiveSource'?: PublishDiscussionRequestSensitiveSourceEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PublishDiscussionRequest
     */
    'spoiler'?: boolean;
    /**
     * Whether the author marked this post as a review.
     * @type {boolean}
     * @memberof PublishDiscussionRequest
     */
    'reviewFacetSelected'?: boolean;
    /**
     * Public id of an existing subject the author picked from the suggestions.
     * @type {string}
     * @memberof PublishDiscussionRequest
     */
    'reviewSubjectPublicId'?: string;
    /**
     * Name of a new subject to create, when the author chose to create one inline.
     * @type {string}
     * @memberof PublishDiscussionRequest
     */
    'reviewSubjectName'?: string;
    /**
     * Rating in integer half-stars, 1..10 (0.5..5.0 stars).
     * @type {number}
     * @memberof PublishDiscussionRequest
     */
    'reviewRatingHalfStars'?: number;
    /**
     * Whether the author marked this post as a question.
     * @type {boolean}
     * @memberof PublishDiscussionRequest
     */
    'questionFacetSelected'?: boolean;
    /**
     * Whether the author marked this post as a board.
     * @type {boolean}
     * @memberof PublishDiscussionRequest
     */
    'boardFacetSelected'?: boolean;
    /**
     * TIERS or MATRIX.
     * @type {string}
     * @memberof PublishDiscussionRequest
     */
    'boardKind'?: string;
    /**
     * The authored board schema: slots, axes, item content mode.
     * @type {string}
     * @memberof PublishDiscussionRequest
     */
    'boardSchemaJson'?: string;
    /**
     * How long each item stays open for voting, 1-168 hours. Defaults to 24.
     * @type {number}
     * @memberof PublishDiscussionRequest
     */
    'boardItemWindowHours'?: number;
    /**
     * The items the author seeded the board with, in order.
     * @type {Array<BoardItemInput>}
     * @memberof PublishDiscussionRequest
     */
    'boardItems'?: Array<BoardItemInput>;
    /**
     * Whether the author marked this post as a poll.
     * @type {boolean}
     * @memberof PublishDiscussionRequest
     */
    'pollFacetSelected'?: boolean;
    /**
     * The poll options, 2-6, in the author\'s order.
     * @type {Array<string>}
     * @memberof PublishDiscussionRequest
     */
    'pollOptions'?: Array<string>;
    /**
     * How long voting stays open after publish, 1-168 hours. Defaults to 72.
     * @type {number}
     * @memberof PublishDiscussionRequest
     */
    'pollCloseWindowHours'?: number;
}

export const PublishDiscussionRequestSensitiveSourceEnum = {
    Manual: 'MANUAL',
    AutoByDiscussion: 'AUTO_BY_DISCUSSION',
    AutoByExternalMedia: 'AUTO_BY_EXTERNAL_MEDIA',
    ModeratorOverride: 'MODERATOR_OVERRIDE'
} as const;

export type PublishDiscussionRequestSensitiveSourceEnum = typeof PublishDiscussionRequestSensitiveSourceEnum[keyof typeof PublishDiscussionRequestSensitiveSourceEnum];

/**
 * 
 * @export
 * @interface PublishDiscussionResponse
 */
export interface PublishDiscussionResponse {
    /**
     * 
     * @type {string}
     * @memberof PublishDiscussionResponse
     */
    'redirectTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublishDiscussionResponse
     */
    'scheduledPublishAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublishDiscussionResponse
     */
    'visibilityTier'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PublishDiscussionResponse
     */
    'firstPublish'?: boolean;
}
/**
 * 
 * @export
 * @interface PublishShortPostRequest
 */
export interface PublishShortPostRequest {
    /**
     * 
     * @type {string}
     * @memberof PublishShortPostRequest
     */
    'sourceJson': string;
    /**
     * 
     * @type {string}
     * @memberof PublishShortPostRequest
     */
    'clientRequestId': string;
}
/**
 * 
 * @export
 * @interface PublishShortPostResponse
 */
export interface PublishShortPostResponse {
    /**
     * 
     * @type {string}
     * @memberof PublishShortPostResponse
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublishShortPostResponse
     */
    'redirectTo'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PublishShortPostResponse
     */
    'created'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PublishShortPostResponse
     */
    'visibilityTier'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PublishShortPostResponse
     */
    'firstPublish'?: boolean;
}
/**
 * 
 * @export
 * @interface PublishThoughtRequest
 */
export interface PublishThoughtRequest {
    /**
     * 
     * @type {string}
     * @memberof PublishThoughtRequest
     */
    'sourceJson': string;
    /**
     * 
     * @type {string}
     * @memberof PublishThoughtRequest
     */
    'clientPublishId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublishThoughtRequest
     */
    'openingArgumentPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublishThoughtRequest
     */
    'conversationPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublishThoughtRequest
     */
    'parentArgumentPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublishThoughtRequest
     */
    'parentRequestPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublishThoughtRequest
     */
    'discussionPublicId': string;
    /**
     * 
     * @type {string}
     * @memberof PublishThoughtRequest
     */
    'scheduledPublishAt'?: string;
    /**
     * 
     * @type {SeavienLanguageTag}
     * @memberof PublishThoughtRequest
     */
    'languageTag'?: SeavienLanguageTag;
    /**
     * 
     * @type {boolean}
     * @memberof PublishThoughtRequest
     */
    'spoiler'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PublishThoughtRequest
     */
    'boardItemId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PublishThoughtRequest
     */
    'anchorBlockId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublishThoughtRequest
     */
    'anchorExcerpt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublishThoughtRequest
     */
    'surface'?: string;
}


/**
 * 
 * @export
 * @interface PublishThoughtResponse
 */
export interface PublishThoughtResponse {
    /**
     * 
     * @type {ThoughtDTO}
     * @memberof PublishThoughtResponse
     */
    'thought'?: ThoughtDTO;
    /**
     * 
     * @type {string}
     * @memberof PublishThoughtResponse
     */
    'hostRelation'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublishThoughtResponse
     */
    'replyRelation'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublishThoughtResponse
     */
    'visibilityTier'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublishThoughtResponse
     */
    'scheduledPublishAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof PublishThoughtResponse
     */
    'publicationRequestPublicId'?: string;
}
/**
 * 
 * @export
 * @interface PushDeviceRegistrationRequest
 */
export interface PushDeviceRegistrationRequest {
    /**
     * 
     * @type {string}
     * @memberof PushDeviceRegistrationRequest
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof PushDeviceRegistrationRequest
     */
    'platform': string;
    /**
     * 
     * @type {string}
     * @memberof PushDeviceRegistrationRequest
     */
    'appVersion'?: string;
    /**
     * 
     * @type {string}
     * @memberof PushDeviceRegistrationRequest
     */
    'timeZone'?: string;
    /**
     * 
     * @type {string}
     * @memberof PushDeviceRegistrationRequest
     */
    'source'?: string;
}
/**
 * 
 * @export
 * @interface PushPauseStateDTO
 */
export interface PushPauseStateDTO {
    /**
     * 
     * @type {string}
     * @memberof PushPauseStateDTO
     */
    'pausedUntil'?: string;
}
/**
 * 
 * @export
 * @interface PushSubscriptionRequest
 */
export interface PushSubscriptionRequest {
    /**
     * 
     * @type {string}
     * @memberof PushSubscriptionRequest
     */
    'endpoint': string;
    /**
     * 
     * @type {Keys}
     * @memberof PushSubscriptionRequest
     */
    'keys'?: Keys;
    /**
     * 
     * @type {string}
     * @memberof PushSubscriptionRequest
     */
    'userAgent'?: string;
    /**
     * 
     * @type {string}
     * @memberof PushSubscriptionRequest
     */
    'timeZone'?: string;
}
/**
 * 
 * @export
 * @interface QuestionStateView
 */
export interface QuestionStateView {
    /**
     * 
     * @type {string}
     * @memberof QuestionStateView
     */
    'state': QuestionStateViewStateEnum;
    /**
     * 
     * @type {string}
     * @memberof QuestionStateView
     */
    'acceptedThoughtPublicId': string | null;
}

export const QuestionStateViewStateEnum = {
    Open: 'OPEN',
    Answered: 'ANSWERED',
    Resolved: 'RESOLVED'
} as const;

export type QuestionStateViewStateEnum = typeof QuestionStateViewStateEnum[keyof typeof QuestionStateViewStateEnum];

/**
 * 
 * @export
 * @interface ReadCompletionRequest
 */
export interface ReadCompletionRequest {
    /**
     * 
     * @type {number}
     * @memberof ReadCompletionRequest
     */
    'bodyLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReadCompletionRequest
     */
    'dwellMillis'?: number;
}
/**
 * 
 * @export
 * @interface ReadingLanguageItemDTO
 */
export interface ReadingLanguageItemDTO {
    /**
     * 
     * @type {string}
     * @memberof ReadingLanguageItemDTO
     */
    'languageTag'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadingLanguageItemDTO
     */
    'source'?: string;
}
/**
 * 
 * @export
 * @interface ReadingLanguagesViewDTO
 */
export interface ReadingLanguagesViewDTO {
    /**
     * 
     * @type {Array<ReadingLanguageItemDTO>}
     * @memberof ReadingLanguagesViewDTO
     */
    'included'?: Array<ReadingLanguageItemDTO>;
    /**
     * 
     * @type {Array<ReadingLanguageItemDTO>}
     * @memberof ReadingLanguagesViewDTO
     */
    'muted'?: Array<ReadingLanguageItemDTO>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReadingLanguagesViewDTO
     */
    'available'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ReadingLanguagesViewDTO
     */
    'autoAddEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReadingLanguagesViewDTO
     */
    'primaryTag'?: string;
}
/**
 * 
 * @export
 * @interface RecentlyViewedDiscussionDTO
 */
export interface RecentlyViewedDiscussionDTO {
    /**
     * 
     * @type {boolean}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'hasNewActivity'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'isAddedToBookmarksSeries'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'discussionAddedToSeriesCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'spoiler'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'excerpt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'slug'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'title'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'isPoll'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'archivedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {number}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'bodyTextLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'topScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'conversationsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'viewsCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'deletedByModerator'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'deletedReasonType'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'authorProfileImageUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'isUserAgreeing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'isUserDisagreeing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'agreementsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'disagreementsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'argumentsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'searchScore'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'participatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'isAddedToAnySeries'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'isViewerFollowingAuthor'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'archived'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'deletedMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'cardMediaItems'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'privateAccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'sourceType'?: string;
    /**
     * 
     * @type {number}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'discussionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'authorUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof RecentlyViewedDiscussionDTO
     */
    'recommendationSource'?: string;
}
/**
 * 
 * @export
 * @interface RejectDiscussionRequestRequest
 */
export interface RejectDiscussionRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof RejectDiscussionRequestRequest
     */
    'resolutionNote'?: string;
}
/**
 * 
 * @export
 * @interface RejectGroupRequestRequest
 */
export interface RejectGroupRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof RejectGroupRequestRequest
     */
    'resolutionNote'?: string;
}
/**
 * 
 * @export
 * @interface RelatedDiscussionDTO
 */
export interface RelatedDiscussionDTO {
    /**
     * 
     * @type {number}
     * @memberof RelatedDiscussionDTO
     */
    'discussionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RelatedDiscussionDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelatedDiscussionDTO
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelatedDiscussionDTO
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelatedDiscussionDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelatedDiscussionDTO
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelatedDiscussionDTO
     */
    'excerpt'?: string;
    /**
     * 
     * @type {number}
     * @memberof RelatedDiscussionDTO
     */
    'topScore'?: number;
    /**
     * 
     * @type {string}
     * @memberof RelatedDiscussionDTO
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelatedDiscussionDTO
     */
    'cardMediaItems'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RelatedDiscussionDTO
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RelatedDiscussionDTO
     */
    'spoiler'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RelatedDiscussionDTO
     */
    'archived'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RelatedDiscussionDTO
     */
    'archivedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RelatedDiscussionDTO
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RelatedDiscussionDTO
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RelatedDiscussionDTO
     */
    'deletedByModerator'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RelatedDiscussionDTO
     */
    'deletedReasonType'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelatedDiscussionDTO
     */
    'deletedMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelatedDiscussionDTO
     */
    'authorUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelatedDiscussionDTO
     */
    'authorProfileImageUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RelatedDiscussionDTO
     */
    'isUserAgreeing'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RelatedDiscussionDTO
     */
    'isUserDisagreeing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RelatedDiscussionDTO
     */
    'agreementsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RelatedDiscussionDTO
     */
    'disagreementsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RelatedDiscussionDTO
     */
    'conversationsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RelatedDiscussionDTO
     */
    'argumentsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof RelatedDiscussionDTO
     */
    'searchScore'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelatedDiscussionDTO
     */
    'recommendationSource'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelatedDiscussionDTO
     */
    'sourceType'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RelatedDiscussionDTO
     */
    'privateAccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RelatedDiscussionDTO
     */
    'participatedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof RelatedDiscussionDTO
     */
    'discussionAddedToSeriesCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RelatedDiscussionDTO
     */
    'isAddedToAnySeries'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RelatedDiscussionDTO
     */
    'isAddedToBookmarksSeries'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RelatedDiscussionDTO
     */
    'isViewerFollowingAuthor'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RelatedDiscussionDTO
     */
    'isPoll'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RelatedDiscussionDTO
     */
    'viewsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RelatedDiscussionDTO
     */
    'bodyTextLength'?: number;
    /**
     * 
     * @type {string}
     * @memberof RelatedDiscussionDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelatedDiscussionDTO
     */
    'relationKind'?: string;
    /**
     * 
     * @type {number}
     * @memberof RelatedDiscussionDTO
     */
    'relationshipScore'?: number;
    /**
     * 
     * @type {number}
     * @memberof RelatedDiscussionDTO
     */
    'sameAgreeCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RelatedDiscussionDTO
     */
    'sameDisagreeCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RelatedDiscussionDTO
     */
    'crossPolarityCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RelatedDiscussionDTO
     */
    'sharedGroupCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof RelatedDiscussionDTO
     */
    'sharedSeriesCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof RelatedDiscussionDTO
     */
    'dominantReasonCode'?: string;
}
/**
 * 
 * @export
 * @interface RelatedGroupDTO
 */
export interface RelatedGroupDTO {
    /**
     * 
     * @type {number}
     * @memberof RelatedGroupDTO
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof RelatedGroupDTO
     */
    'groupId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RelatedGroupDTO
     */
    'groupPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelatedGroupDTO
     */
    'groupName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelatedGroupDTO
     */
    'groupSlug'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelatedGroupDTO
     */
    'groupThumbnailUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof RelatedGroupDTO
     */
    'relatedGroupId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RelatedGroupDTO
     */
    'relatedGroupPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelatedGroupDTO
     */
    'relatedGroupName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelatedGroupDTO
     */
    'relatedGroupSlug'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelatedGroupDTO
     */
    'relatedGroupThumbnailUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof RelatedGroupDTO
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {number}
     * @memberof RelatedGroupDTO
     */
    'createdByUserId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RelatedGroupDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RelatedGroupDTO
     */
    'modifiedAt'?: string;
}
/**
 * 
 * @export
 * @interface RemoveNewsletterSubscriberRequest
 */
export interface RemoveNewsletterSubscriberRequest {
    /**
     * 
     * @type {string}
     * @memberof RemoveNewsletterSubscriberRequest
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof RemoveNewsletterSubscriberRequest
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface ReorderRequest
 */
export interface ReorderRequest {
    /**
     * 
     * @type {string}
     * @memberof ReorderRequest
     */
    'kind': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReorderRequest
     */
    'targetPublicIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ReportChatMessageRequest
 */
export interface ReportChatMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportChatMessageRequest
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportChatMessageRequest
     */
    'reasonType': ReportChatMessageRequestReasonTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ReportChatMessageRequest
     */
    'block'?: boolean;
}

export const ReportChatMessageRequestReasonTypeEnum = {
    Spam: 'SPAM',
    Harassment: 'HARASSMENT',
    HateSpeech: 'HATE_SPEECH',
    Abuse: 'ABUSE',
    SexualContent: 'SEXUAL_CONTENT',
    Csae: 'CSAE',
    ViolenceOrThreats: 'VIOLENCE_OR_THREATS',
    IllegalContent: 'ILLEGAL_CONTENT',
    FraudOrImpersonation: 'FRAUD_OR_IMPERSONATION',
    PrivacyViolation: 'PRIVACY_VIOLATION',
    SelfHarm: 'SELF_HARM',
    RuleViolation: 'RULE_VIOLATION',
    Copyright: 'COPYRIGHT',
    AiSlop: 'AI_SLOP',
    LowQuality: 'LOW_QUALITY',
    Other: 'OTHER'
} as const;

export type ReportChatMessageRequestReasonTypeEnum = typeof ReportChatMessageRequestReasonTypeEnum[keyof typeof ReportChatMessageRequestReasonTypeEnum];

/**
 * 
 * @export
 * @interface ReportUserRequest
 */
export interface ReportUserRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportUserRequest
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof ReportUserRequest
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReportUserRequest
     */
    'reasonType': ReportUserRequestReasonTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ReportUserRequest
     */
    'block'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReportUserRequest
     */
    'attachmentImagePublicIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ReportUserRequest
     */
    'targetUsername'?: string;
}

export const ReportUserRequestReasonTypeEnum = {
    Spam: 'SPAM',
    Harassment: 'HARASSMENT',
    HateSpeech: 'HATE_SPEECH',
    Abuse: 'ABUSE',
    SexualContent: 'SEXUAL_CONTENT',
    ViolenceOrThreats: 'VIOLENCE_OR_THREATS',
    IllegalContent: 'ILLEGAL_CONTENT',
    FraudOrImpersonation: 'FRAUD_OR_IMPERSONATION',
    PrivacyViolation: 'PRIVACY_VIOLATION',
    SelfHarm: 'SELF_HARM',
    RuleViolation: 'RULE_VIOLATION',
    Copyright: 'COPYRIGHT',
    AiSlop: 'AI_SLOP',
    Csae: 'CSAE',
    Other: 'OTHER'
} as const;

export type ReportUserRequestReasonTypeEnum = typeof ReportUserRequestReasonTypeEnum[keyof typeof ReportUserRequestReasonTypeEnum];

/**
 * 
 * @export
 * @interface ResetAccountRequest
 */
export interface ResetAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof ResetAccountRequest
     * @deprecated
     */
    'resetType'?: ResetAccountRequestResetTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ResetAccountRequest
     */
    'email': string;
}

export const ResetAccountRequestResetTypeEnum = {
    Username: 'USERNAME',
    Password: 'PASSWORD'
} as const;

export type ResetAccountRequestResetTypeEnum = typeof ResetAccountRequestResetTypeEnum[keyof typeof ResetAccountRequestResetTypeEnum];

/**
 * 
 * @export
 * @interface Rung
 */
export interface Rung {
    /**
     * 
     * @type {number}
     * @memberof Rung
     */
    'tier'?: number;
    /**
     * 
     * @type {number}
     * @memberof Rung
     */
    'threshold'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Rung
     */
    'earned'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Rung
     */
    'earnedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof Rung
     */
    'rarityPercent'?: number;
}
/**
 * 
 * @export
 * @interface SafetyControlsSettingsDTO
 */
export interface SafetyControlsSettingsDTO {
    /**
     * 
     * @type {Array<UserSafetyListItemDTO>}
     * @memberof SafetyControlsSettingsDTO
     */
    'blockedUsers'?: Array<UserSafetyListItemDTO>;
    /**
     * 
     * @type {Array<UserSafetyListItemDTO>}
     * @memberof SafetyControlsSettingsDTO
     */
    'mutedUsers'?: Array<UserSafetyListItemDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyControlsSettingsDTO
     */
    'notifyOnMentions'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyControlsSettingsDTO
     */
    'notifyOnFollowedPosts'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyControlsSettingsDTO
     */
    'primaryDigestEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyControlsSettingsDTO
     */
    'includeMessagePreviewInEmail'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyControlsSettingsDTO
     */
    'activationNudgesEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyControlsSettingsDTO
     */
    'contentActivityEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyControlsSettingsDTO
     */
    'reengagementEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyControlsSettingsDTO
     */
    'writingTipsEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyControlsSettingsDTO
     */
    'newFromFollowingEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyControlsSettingsDTO
     */
    'pushRepliesEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyControlsSettingsDTO
     */
    'pushMentionsEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyControlsSettingsDTO
     */
    'pushRecognitionEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyControlsSettingsDTO
     */
    'pushDirectMessagesEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyControlsSettingsDTO
     */
    'pushInvitationsEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyControlsSettingsDTO
     */
    'notifyOnBoardSettled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyControlsSettingsDTO
     */
    'notifyOnBoardCompleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyControlsSettingsDTO
     */
    'notifyOnReplyRequests'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyControlsSettingsDTO
     */
    'notifyOnAnswerRequests'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyControlsSettingsDTO
     */
    'hostOptIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyControlsSettingsDTO
     */
    'welcomeHostLabelVisible'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyControlsSettingsDTO
     */
    'notifyOnRecognition'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyControlsSettingsDTO
     */
    'notifyOnPeople'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SafetyControlsSettingsDTO
     */
    'notifyOnGroupsAndSeries'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SafetyControlsSettingsDTO
     */
    'directMessagePolicy'?: string;
    /**
     * 
     * @type {string}
     * @memberof SafetyControlsSettingsDTO
     */
    'pushPausedUntil'?: string;
}
/**
 * 
 * @export
 * @interface SaveMemeRequest
 */
export interface SaveMemeRequest {
    /**
     * 
     * @type {File}
     * @memberof SaveMemeRequest
     */
    'file': File;
}
/**
 * 
 * @export
 * @interface SaveNewsletterIssueRequest
 */
export interface SaveNewsletterIssueRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveNewsletterIssueRequest
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof SaveNewsletterIssueRequest
     */
    'contentJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveNewsletterIssueRequest
     */
    'coverUrl'?: string;
}
/**
 * 
 * @export
 * @interface SaveUploadedMemeRequest
 */
export interface SaveUploadedMemeRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveUploadedMemeRequest
     */
    'imagePublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveUploadedMemeRequest
     */
    'templatePublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SaveUploadedMemeRequest
     */
    'layout'?: string;
}
/**
 * 
 * @export
 * @interface ScheduleNewsletterIssueRequest
 */
export interface ScheduleNewsletterIssueRequest {
    /**
     * 
     * @type {string}
     * @memberof ScheduleNewsletterIssueRequest
     */
    'scheduledAt': string;
}
/**
 * 
 * @export
 * @interface SearchResultClickedRequest
 */
export interface SearchResultClickedRequest {
    /**
     * 
     * @type {string}
     * @memberof SearchResultClickedRequest
     */
    'searchQuery'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchResultClickedRequest
     */
    'entityType'?: string;
    /**
     * 
     * @type {number}
     * @memberof SearchResultClickedRequest
     */
    'position'?: number;
    /**
     * 
     * @type {string}
     * @memberof SearchResultClickedRequest
     */
    'searchId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchResultClickedRequest
     */
    'prevSearchId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchResultClickedRequest
     */
    'uiLocale'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchResultClickedRequest
     */
    'languageScope'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchResultClickedRequest
     */
    'resolvedTab'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchResultClickedRequest
     */
    'preferredTab'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchResultClickedRequest
     */
    'entityPublicId'?: string;
}
/**
 * 
 * @export
 * @interface SearchResultCountsDTO
 */
export interface SearchResultCountsDTO {
    /**
     * 
     * @type {number}
     * @memberof SearchResultCountsDTO
     */
    'discussions'?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchResultCountsDTO
     */
    'arguments'?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchResultCountsDTO
     */
    'groups'?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchResultCountsDTO
     */
    'series'?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchResultCountsDTO
     */
    'users'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SearchResultCountsDTO
     */
    'timedOut'?: boolean;
}
/**
 * 
 * @export
 * @interface SearchSuggestionSelectedRequest
 */
export interface SearchSuggestionSelectedRequest {
    /**
     * 
     * @type {string}
     * @memberof SearchSuggestionSelectedRequest
     */
    'searchQuery'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchSuggestionSelectedRequest
     */
    'entityType'?: string;
    /**
     * 
     * @type {number}
     * @memberof SearchSuggestionSelectedRequest
     */
    'resultsShown'?: number;
    /**
     * 
     * @type {string}
     * @memberof SearchSuggestionSelectedRequest
     */
    'searchId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchSuggestionSelectedRequest
     */
    'prevSearchId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchSuggestionSelectedRequest
     */
    'uiLocale'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchSuggestionSelectedRequest
     */
    'languageScope'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchSuggestionSelectedRequest
     */
    'mode'?: string;
}
/**
 * 
 * @export
 * @interface SearchSuggestionsDTO
 */
export interface SearchSuggestionsDTO {
    /**
     * 
     * @type {Array<DiscussionWithoutContentDTO>}
     * @memberof SearchSuggestionsDTO
     */
    'discussions'?: Array<DiscussionWithoutContentDTO>;
    /**
     * 
     * @type {Array<GroupDTO>}
     * @memberof SearchSuggestionsDTO
     */
    'groups'?: Array<GroupDTO>;
    /**
     * 
     * @type {Array<UserProfileDTO>}
     * @memberof SearchSuggestionsDTO
     */
    'users'?: Array<UserProfileDTO>;
    /**
     * 
     * @type {Array<TagSuggestionDTO>}
     * @memberof SearchSuggestionsDTO
     */
    'tags'?: Array<TagSuggestionDTO>;
    /**
     * 
     * @type {string}
     * @memberof SearchSuggestionsDTO
     */
    'mode'?: SearchSuggestionsDTOModeEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchSuggestionsDTO
     */
    'normalizedQuery'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SearchSuggestionsDTO
     */
    'discussionGroupNames'?: { [key: string]: string; };
}

export const SearchSuggestionsDTOModeEnum = {
    Tag: 'TAG',
    User: 'USER',
    Text: 'TEXT'
} as const;

export type SearchSuggestionsDTOModeEnum = typeof SearchSuggestionsDTOModeEnum[keyof typeof SearchSuggestionsDTOModeEnum];

/**
 * 
 * @export
 * @interface SearchTypeResolutionDTO
 */
export interface SearchTypeResolutionDTO {
    /**
     * 
     * @type {string}
     * @memberof SearchTypeResolutionDTO
     */
    'resolvedType'?: string;
    /**
     * 
     * @type {Array<DiscussionWithoutContentDTO>}
     * @memberof SearchTypeResolutionDTO
     */
    'discussions'?: Array<DiscussionWithoutContentDTO>;
    /**
     * 
     * @type {Array<ThoughtInSearchDTO>}
     * @memberof SearchTypeResolutionDTO
     */
    'arguments'?: Array<ThoughtInSearchDTO>;
    /**
     * 
     * @type {Array<GroupDTO>}
     * @memberof SearchTypeResolutionDTO
     */
    'groups'?: Array<GroupDTO>;
    /**
     * 
     * @type {Array<SeriesDTO>}
     * @memberof SearchTypeResolutionDTO
     */
    'series'?: Array<SeriesDTO>;
    /**
     * 
     * @type {Array<UserProfileDTO>}
     * @memberof SearchTypeResolutionDTO
     */
    'users'?: Array<UserProfileDTO>;
    /**
     * 
     * @type {SearchResultCountsDTO}
     * @memberof SearchTypeResolutionDTO
     */
    'counts'?: SearchResultCountsDTO;
    /**
     * 
     * @type {boolean}
     * @memberof SearchTypeResolutionDTO
     */
    'timedOut'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SeavienLanguageTag = {
    Pt: 'pt',
    Fr: 'fr',
    De: 'de',
    It: 'it',
    Ro: 'ro',
    Es: 'es',
    Pl: 'pl',
    Sv: 'sv',
    Nl: 'nl',
    Da: 'da',
    Nb: 'nb',
    Fi: 'fi',
    Tr: 'tr',
    Cs: 'cs',
    Hu: 'hu',
    Id: 'id',
    Vi: 'vi',
    Fil: 'fil',
    Hi: 'hi',
    Ko: 'ko',
    Ms: 'ms',
    Th: 'th',
    Bn: 'bn',
    El: 'el',
    En: 'en'
} as const;

export type SeavienLanguageTag = typeof SeavienLanguageTag[keyof typeof SeavienLanguageTag];


/**
 * 
 * @export
 * @interface SeedItem
 */
export interface SeedItem {
    /**
     * 
     * @type {string}
     * @memberof SeedItem
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeedItem
     */
    'imagePublicId'?: string;
}
/**
 * 
 * @export
 * @interface SeedReplyRequestBody
 */
export interface SeedReplyRequestBody {
    /**
     * 
     * @type {string}
     * @memberof SeedReplyRequestBody
     */
    'routingReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeedReplyRequestBody
     */
    'evidenceDiscussionPublicId'?: string;
}
/**
 * 
 * @export
 * @interface SendChatMessageRequest
 */
export interface SendChatMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof SendChatMessageRequest
     */
    'threadPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SendChatMessageRequest
     */
    'targetUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof SendChatMessageRequest
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof SendChatMessageRequest
     */
    'clientRequestId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SendChatMessageRequest
     */
    'replyToMessagePublicId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SendChatMessageRequest
     */
    'attachmentImagePublicIds'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof SendChatMessageRequest
     */
    'forwarded'?: boolean;
}
/**
 * 
 * @export
 * @interface SendEmailVerificationRequest
 */
export interface SendEmailVerificationRequest {
    /**
     * 
     * @type {string}
     * @memberof SendEmailVerificationRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface SendInvitationRequest
 */
export interface SendInvitationRequest {
    /**
     * 
     * @type {string}
     * @memberof SendInvitationRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface SendPostToNewsletterRequest
 */
export interface SendPostToNewsletterRequest {
    /**
     * 
     * @type {string}
     * @memberof SendPostToNewsletterRequest
     */
    'newsletterPublicId'?: string;
}
/**
 * 
 * @export
 * @interface SendRequest
 */
export interface SendRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SendRequest
     */
    'overrideCap'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SendRequest
     */
    'overrideCadenceCeiling'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof SendRequest
     */
    'limitToRecipients'?: Array<number>;
}
/**
 * 
 * @export
 * @interface SeriesDTO
 */
export interface SeriesDTO {
    /**
     * 
     * @type {string}
     * @memberof SeriesDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesDTO
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesDTO
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesDTO
     */
    'imageUrls'?: string;
    /**
     * 
     * @type {number}
     * @memberof SeriesDTO
     */
    'viewsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof SeriesDTO
     */
    'searchScore'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesDTO
     */
    'modifiedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesDTO
     */
    'ownerUsername'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesDTO
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesDTO
     */
    'isViewerFollowing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SeriesDTO
     */
    'followersCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof SeriesDTO
     */
    'cardMediaItems'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesDTO
     */
    'bookmarksCollection'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SeriesDTO
     */
    'seriesId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesDTO
     */
    'isViewerOwner'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SeriesDTO
     */
    'thumbnailUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesDTO
     */
    'mainLocale'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesDTO
     */
    'lastDiscussionAddedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesDTO
     */
    'ownerProfileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesDTO
     */
    'viewerFollowingAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof SeriesDTO
     */
    'discussionsCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesDTO
     */
    'privateAccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SeriesDTO
     */
    'description'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SeriesDTO
     */
    'recentDiscussionTitles'?: Array<string>;
}
/**
 * 
 * @export
 * @interface SeriesDiscussionTargetDTO
 */
export interface SeriesDiscussionTargetDTO {
    /**
     * 
     * @type {string}
     * @memberof SeriesDiscussionTargetDTO
     */
    'discussionPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesDiscussionTargetDTO
     */
    'discussionSlugOrPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesDiscussionTargetDTO
     */
    'title'?: string;
}
/**
 * 
 * @export
 * @interface SeriesDiscussionsToAddModalBootstrapDTO
 */
export interface SeriesDiscussionsToAddModalBootstrapDTO {
    /**
     * 
     * @type {Array<DiscussionsToAddToSeriesDTO>}
     * @memberof SeriesDiscussionsToAddModalBootstrapDTO
     */
    'authoredDiscussions'?: Array<DiscussionsToAddToSeriesDTO>;
    /**
     * 
     * @type {Array<DiscussionsToAddToSeriesDTO>}
     * @memberof SeriesDiscussionsToAddModalBootstrapDTO
     */
    'participatedDiscussions'?: Array<DiscussionsToAddToSeriesDTO>;
    /**
     * 
     * @type {Array<DiscussionsToAddToSeriesDTO>}
     * @memberof SeriesDiscussionsToAddModalBootstrapDTO
     */
    'seriesDiscussions'?: Array<DiscussionsToAddToSeriesDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesDiscussionsToAddModalBootstrapDTO
     */
    'authoredTruncated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesDiscussionsToAddModalBootstrapDTO
     */
    'participatedTruncated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesDiscussionsToAddModalBootstrapDTO
     */
    'seriesTruncated'?: boolean;
}
/**
 * 
 * @export
 * @interface SeriesItem
 */
export interface SeriesItem {
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    'publicId': string;
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof SeriesItem
     */
    'slug': string | null;
}
/**
 * 
 * @export
 * @interface SeriesReadingContextDTO
 */
export interface SeriesReadingContextDTO {
    /**
     * 
     * @type {string}
     * @memberof SeriesReadingContextDTO
     */
    'seriesPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesReadingContextDTO
     */
    'seriesSlug'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesReadingContextDTO
     */
    'seriesTitle'?: string;
    /**
     * 
     * @type {number}
     * @memberof SeriesReadingContextDTO
     */
    'currentPosition'?: number;
    /**
     * 
     * @type {number}
     * @memberof SeriesReadingContextDTO
     */
    'totalCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesReadingContextDTO
     */
    'completed'?: boolean;
    /**
     * 
     * @type {SeriesDiscussionTargetDTO}
     * @memberof SeriesReadingContextDTO
     */
    'previousDiscussion'?: SeriesDiscussionTargetDTO;
    /**
     * 
     * @type {SeriesDiscussionTargetDTO}
     * @memberof SeriesReadingContextDTO
     */
    'nextDiscussion'?: SeriesDiscussionTargetDTO;
}
/**
 * 
 * @export
 * @interface SeriesToAddDiscussionTo
 */
export interface SeriesToAddDiscussionTo {
    /**
     * 
     * @type {boolean}
     * @memberof SeriesToAddDiscussionTo
     */
    'isDiscussionAdded'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SeriesToAddDiscussionTo
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesToAddDiscussionTo
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesToAddDiscussionTo
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesToAddDiscussionTo
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesToAddDiscussionTo
     */
    'imageUrls'?: string;
    /**
     * 
     * @type {number}
     * @memberof SeriesToAddDiscussionTo
     */
    'viewsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof SeriesToAddDiscussionTo
     */
    'searchScore'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesToAddDiscussionTo
     */
    'modifiedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesToAddDiscussionTo
     */
    'ownerUsername'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesToAddDiscussionTo
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesToAddDiscussionTo
     */
    'isViewerFollowing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SeriesToAddDiscussionTo
     */
    'followersCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof SeriesToAddDiscussionTo
     */
    'cardMediaItems'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesToAddDiscussionTo
     */
    'bookmarksCollection'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SeriesToAddDiscussionTo
     */
    'seriesId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesToAddDiscussionTo
     */
    'isViewerOwner'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SeriesToAddDiscussionTo
     */
    'thumbnailUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesToAddDiscussionTo
     */
    'mainLocale'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesToAddDiscussionTo
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesToAddDiscussionTo
     */
    'lastDiscussionAddedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesToAddDiscussionTo
     */
    'ownerProfileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof SeriesToAddDiscussionTo
     */
    'viewerFollowingAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof SeriesToAddDiscussionTo
     */
    'discussionsCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SeriesToAddDiscussionTo
     */
    'privateAccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SeriesToAddDiscussionTo
     */
    'description'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SeriesToAddDiscussionTo
     */
    'recentDiscussionTitles'?: Array<string>;
}
/**
 * 
 * @export
 * @interface SetReadingLanguageRequest
 */
export interface SetReadingLanguageRequest {
    /**
     * 
     * @type {string}
     * @memberof SetReadingLanguageRequest
     */
    'tag'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SetReadingLanguageRequest
     */
    'included'?: boolean;
}
/**
 * 
 * @export
 * @interface SettingsBootstrapDTO
 */
export interface SettingsBootstrapDTO {
    /**
     * 
     * @type {string}
     * @memberof SettingsBootstrapDTO
     */
    'username'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SettingsBootstrapDTO
     */
    'hasLocalPassword'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SettingsBootstrapDTO
     */
    'hideSensitiveMedia'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SettingsBootstrapDTO
     */
    'sensitivePreference'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SettingsBootstrapDTO
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SettingsBootstrapDTO
     */
    'sensitiveSource'?: string;
    /**
     * 
     * @type {string}
     * @memberof SettingsBootstrapDTO
     */
    'profileDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof SettingsBootstrapDTO
     */
    'imagePublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SettingsBootstrapDTO
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof SettingsBootstrapDTO
     */
    'confirmationPlaceholder'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SettingsBootstrapDTO
     */
    'usernameChangeAllowed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SettingsBootstrapDTO
     */
    'usernameChangeBlockedReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof SettingsBootstrapDTO
     */
    'usernameChangeNextEligibleAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof SettingsBootstrapDTO
     */
    'profileStatement'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SettingsBootstrapDTO
     */
    'canInvite'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SettingsBootstrapDTO
     */
    'email'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SettingsBootstrapDTO
     */
    'emailVerified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SettingsBootstrapDTO
     */
    'pendingEmail'?: string;
}
/**
 * 
 * @export
 * @interface ShareInitiatedRequest
 */
export interface ShareInitiatedRequest {
    /**
     * 
     * @type {string}
     * @memberof ShareInitiatedRequest
     */
    'surface'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShareInitiatedRequest
     */
    'channel'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShareInitiatedRequest
     */
    'entityType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShareInitiatedRequest
     */
    'entityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShareInitiatedRequest
     */
    'shareToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShareInitiatedRequest
     */
    'fromPage'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShareInitiatedRequest
     */
    'moment'?: string;
}
/**
 * 
 * @export
 * @interface SignupRequest
 */
export interface SignupRequest {
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'confirmPassword': string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'continueTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'uiLocale'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignupRequest
     */
    'invitationCode'?: string;
}
/**
 * 
 * @export
 * @interface SocialLinkRequestBody
 */
export interface SocialLinkRequestBody {
    /**
     * 
     * @type {string}
     * @memberof SocialLinkRequestBody
     */
    'username': string;
}
/**
 * 
 * @export
 * @interface SortObject
 */
export interface SortObject {
    /**
     * 
     * @type {boolean}
     * @memberof SortObject
     */
    'empty'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SortObject
     */
    'sorted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SortObject
     */
    'unsorted'?: boolean;
}
/**
 * 
 * @export
 * @interface StatusChangeRequest
 */
export interface StatusChangeRequest {
    /**
     * 
     * @type {string}
     * @memberof StatusChangeRequest
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof StatusChangeRequest
     */
    'note'?: string;
}
/**
 * 
 * @export
 * @interface SubjectMergeQueueEntryDTO
 */
export interface SubjectMergeQueueEntryDTO {
    /**
     * 
     * @type {string}
     * @memberof SubjectMergeQueueEntryDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubjectMergeQueueEntryDTO
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubjectMergeQueueEntryDTO
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubjectMergeQueueEntryDTO
     */
    'nameTight'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubjectMergeQueueEntryDTO
     */
    'createdAt'?: string;
}
/**
 * 
 * @export
 * @interface SubjectPageSummaryDTO
 */
export interface SubjectPageSummaryDTO {
    /**
     * 
     * @type {string}
     * @memberof SubjectPageSummaryDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubjectPageSummaryDTO
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubjectPageSummaryDTO
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubjectPageSummaryDTO
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof SubjectPageSummaryDTO
     */
    'ratingSum'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectPageSummaryDTO
     */
    'ratingCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof SubjectPageSummaryDTO
     */
    'canonicalSlug'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubjectPageSummaryDTO
     */
    'title'?: string;
}
/**
 * 
 * @export
 * @interface SubjectReviewDTO
 */
export interface SubjectReviewDTO {
    /**
     * 
     * @type {string}
     * @memberof SubjectReviewDTO
     */
    'discussionPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubjectReviewDTO
     */
    'slug'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubjectReviewDTO
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubjectReviewDTO
     */
    'excerpt'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubjectReviewDTO
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubjectReviewDTO
     */
    'authorUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubjectReviewDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof SubjectReviewDTO
     */
    'ratingHalfStars'?: number;
}
/**
 * 
 * @export
 * @interface SubjectSuggestionDTO
 */
export interface SubjectSuggestionDTO {
    /**
     * 
     * @type {string}
     * @memberof SubjectSuggestionDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubjectSuggestionDTO
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubjectSuggestionDTO
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {number}
     * @memberof SubjectSuggestionDTO
     */
    'ratingCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SubjectSuggestionDTO
     */
    'ratingAverageHalfStars'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubjectSuggestionDTO
     */
    'groupNames'?: Array<string>;
}
/**
 * 
 * @export
 * @interface Suggestion
 */
export interface Suggestion {
    /**
     * 
     * @type {string}
     * @memberof Suggestion
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof Suggestion
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof Suggestion
     */
    'profileImageUrl'?: string;
}
/**
 * 
 * @export
 * @interface SupportMessageRequest
 */
export interface SupportMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof SupportMessageRequest
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof SupportMessageRequest
     */
    'clientRequestId'?: string;
}
/**
 * 
 * @export
 * @interface TagSuggestionDTO
 */
export interface TagSuggestionDTO {
    /**
     * 
     * @type {string}
     * @memberof TagSuggestionDTO
     */
    'tag'?: string;
    /**
     * 
     * @type {string}
     * @memberof TagSuggestionDTO
     */
    'label'?: string;
}
/**
 * 
 * @export
 * @interface TargetUsernameRequest
 */
export interface TargetUsernameRequest {
    /**
     * 
     * @type {string}
     * @memberof TargetUsernameRequest
     */
    'targetUsername': string;
}
/**
 * 
 * @export
 * @interface ThoughtConversationContextDTO
 */
export interface ThoughtConversationContextDTO {
    /**
     * 
     * @type {string}
     * @memberof ThoughtConversationContextDTO
     */
    'anchorThoughtPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtConversationContextDTO
     */
    'discussionPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtConversationContextDTO
     */
    'discussionSlug'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtConversationContextDTO
     */
    'discussionTitle'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtConversationContextDTO
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ThoughtConversationContextDTO
     */
    'permalinkPath'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtConversationContextDTO
     */
    'canReply'?: boolean;
}
/**
 * 
 * @export
 * @interface ThoughtDTO
 */
export interface ThoughtDTO {
    /**
     * 
     * @type {string}
     * @memberof ThoughtDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ThoughtDTO
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ThoughtDTO
     */
    'authorFeaturedDistinction'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtDTO
     */
    'authorVoiceOfMonthGroupName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtDTO
     */
    'spoiler'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ThoughtDTO
     */
    'depth'?: number;
    /**
     * 
     * @type {string}
     * @memberof ThoughtDTO
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtDTO
     */
    'editedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtDTO
     */
    'anchorBlockId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtDTO
     */
    'anchorExcerpt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtDTO
     */
    'conversationPublicId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtDTO
     */
    'canMarkMindChanged'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtDTO
     */
    'canStartConversation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtDTO
     */
    'deletedByModerator'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ThoughtDTO
     */
    'deletedReasonType'?: string;
    /**
     * 
     * @type {number}
     * @memberof ThoughtDTO
     */
    'agreementsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ThoughtDTO
     */
    'disagreementsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ThoughtDTO
     */
    'htmlContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtDTO
     */
    'profileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtDTO
     */
    'parentArgumentPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtDTO
     */
    'safeUsername'?: string;
    /**
     * 
     * @type {number}
     * @memberof ThoughtDTO
     */
    'replyCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtDTO
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ThoughtDTO
     */
    'username'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtDTO
     */
    'accepted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ThoughtDTO
     */
    'descendantCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ThoughtDTO
     */
    'discussionAgreement'?: ThoughtDTODiscussionAgreementEnum;
    /**
     * 
     * @type {number}
     * @memberof ThoughtDTO
     */
    'argumentBookmarksCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtDTO
     */
    'isOpening'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtDTO
     */
    'isAgreed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtDTO
     */
    'isDisagreed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtDTO
     */
    'isBookmarked'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtDTO
     */
    'canDelete'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ThoughtDTO
     */
    'pinnedByUsername'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtDTO
     */
    'canAccept'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtDTO
     */
    'mindChanged'?: boolean;
    /**
     * 
     * @type {ThoughtEndorsementSummaryDTO}
     * @memberof ThoughtDTO
     */
    'endorsements'?: ThoughtEndorsementSummaryDTO;
    /**
     * 
     * @type {string}
     * @memberof ThoughtDTO
     */
    'boardItemLabel'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtDTO
     */
    'boardSlotLabel'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtDTO
     */
    'anchorState'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtDTO
     */
    'authorGroupFlair'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtDTO
     */
    'pinned'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtDTO
     */
    'canPin'?: boolean;
}

export const ThoughtDTODiscussionAgreementEnum = {
    Agree: 'AGREE',
    Disagree: 'DISAGREE'
} as const;

export type ThoughtDTODiscussionAgreementEnum = typeof ThoughtDTODiscussionAgreementEnum[keyof typeof ThoughtDTODiscussionAgreementEnum];

/**
 * 
 * @export
 * @interface ThoughtEmbedSnapshotDTO
 */
export interface ThoughtEmbedSnapshotDTO {
    /**
     * 
     * @type {string}
     * @memberof ThoughtEmbedSnapshotDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtEmbedSnapshotDTO
     */
    'discussionSlug'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtEmbedSnapshotDTO
     */
    'discussionTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtEmbedSnapshotDTO
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtEmbedSnapshotDTO
     */
    'profileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtEmbedSnapshotDTO
     */
    'htmlContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtEmbedSnapshotDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof ThoughtEmbedSnapshotDTO
     */
    'agreementsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ThoughtEmbedSnapshotDTO
     */
    'disagreementsCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtEmbedSnapshotDTO
     */
    'isOpening'?: boolean;
}
/**
 * 
 * @export
 * @interface ThoughtEndorsementSummaryDTO
 */
export interface ThoughtEndorsementSummaryDTO {
    /**
     * 
     * @type {number}
     * @memberof ThoughtEndorsementSummaryDTO
     */
    'count'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ThoughtEndorsementSummaryDTO
     */
    'kinds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ThoughtEndorsementSummaryDTO
     */
    'viewerKind'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtEndorsementSummaryDTO
     */
    'viewerHasNote'?: boolean;
}
/**
 * 
 * @export
 * @interface ThoughtInConversationDTO
 */
export interface ThoughtInConversationDTO {
    /**
     * 
     * @type {string}
     * @memberof ThoughtInConversationDTO
     */
    'editedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInConversationDTO
     */
    'languageTag'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInConversationDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ThoughtInConversationDTO
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInConversationDTO
     */
    'authorFeaturedDistinction'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInConversationDTO
     */
    'authorVoiceOfMonthGroupName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInConversationDTO
     */
    'spoiler'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ThoughtInConversationDTO
     */
    'depth'?: number;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInConversationDTO
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInConversationDTO
     */
    'anchorBlockId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInConversationDTO
     */
    'anchorExcerpt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInConversationDTO
     */
    'conversationPublicId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInConversationDTO
     */
    'canMarkMindChanged'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInConversationDTO
     */
    'canStartConversation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInConversationDTO
     */
    'deletedByModerator'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInConversationDTO
     */
    'deletedReasonType'?: string;
    /**
     * 
     * @type {number}
     * @memberof ThoughtInConversationDTO
     */
    'agreementsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ThoughtInConversationDTO
     */
    'disagreementsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInConversationDTO
     */
    'htmlContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInConversationDTO
     */
    'profileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInConversationDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInConversationDTO
     */
    'parentArgumentPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInConversationDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInConversationDTO
     */
    'safeUsername'?: string;
    /**
     * 
     * @type {number}
     * @memberof ThoughtInConversationDTO
     */
    'replyCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInConversationDTO
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInConversationDTO
     */
    'username'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInConversationDTO
     */
    'accepted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ThoughtInConversationDTO
     */
    'descendantCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInConversationDTO
     */
    'discussionAgreement'?: ThoughtInConversationDTODiscussionAgreementEnum;
    /**
     * 
     * @type {number}
     * @memberof ThoughtInConversationDTO
     */
    'argumentBookmarksCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInConversationDTO
     */
    'isOpening'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInConversationDTO
     */
    'isAgreed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInConversationDTO
     */
    'isDisagreed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInConversationDTO
     */
    'isBookmarked'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInConversationDTO
     */
    'canDelete'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInConversationDTO
     */
    'pinnedByUsername'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInConversationDTO
     */
    'canAccept'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInConversationDTO
     */
    'mindChanged'?: boolean;
    /**
     * 
     * @type {ThoughtEndorsementSummaryDTO}
     * @memberof ThoughtInConversationDTO
     */
    'endorsements'?: ThoughtEndorsementSummaryDTO;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInConversationDTO
     */
    'boardItemLabel'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInConversationDTO
     */
    'boardSlotLabel'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInConversationDTO
     */
    'anchorState'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInConversationDTO
     */
    'authorGroupFlair'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInConversationDTO
     */
    'pinned'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInConversationDTO
     */
    'canPin'?: boolean;
}

export const ThoughtInConversationDTODiscussionAgreementEnum = {
    Agree: 'AGREE',
    Disagree: 'DISAGREE'
} as const;

export type ThoughtInConversationDTODiscussionAgreementEnum = typeof ThoughtInConversationDTODiscussionAgreementEnum[keyof typeof ThoughtInConversationDTODiscussionAgreementEnum];

/**
 * 
 * @export
 * @interface ThoughtInDiscussionDTO
 */
export interface ThoughtInDiscussionDTO {
    /**
     * 
     * @type {string}
     * @memberof ThoughtInDiscussionDTO
     */
    'editedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInDiscussionDTO
     */
    'languageTag'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInDiscussionDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ThoughtInDiscussionDTO
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInDiscussionDTO
     */
    'authorFeaturedDistinction'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInDiscussionDTO
     */
    'authorVoiceOfMonthGroupName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInDiscussionDTO
     */
    'spoiler'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ThoughtInDiscussionDTO
     */
    'depth'?: number;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInDiscussionDTO
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInDiscussionDTO
     */
    'anchorBlockId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInDiscussionDTO
     */
    'anchorExcerpt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInDiscussionDTO
     */
    'conversationPublicId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInDiscussionDTO
     */
    'canMarkMindChanged'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInDiscussionDTO
     */
    'canStartConversation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInDiscussionDTO
     */
    'deletedByModerator'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInDiscussionDTO
     */
    'deletedReasonType'?: string;
    /**
     * 
     * @type {number}
     * @memberof ThoughtInDiscussionDTO
     */
    'agreementsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ThoughtInDiscussionDTO
     */
    'disagreementsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInDiscussionDTO
     */
    'htmlContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInDiscussionDTO
     */
    'profileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInDiscussionDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInDiscussionDTO
     */
    'parentArgumentPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInDiscussionDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInDiscussionDTO
     */
    'safeUsername'?: string;
    /**
     * 
     * @type {number}
     * @memberof ThoughtInDiscussionDTO
     */
    'replyCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInDiscussionDTO
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInDiscussionDTO
     */
    'username'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInDiscussionDTO
     */
    'accepted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ThoughtInDiscussionDTO
     */
    'descendantCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInDiscussionDTO
     */
    'discussionAgreement'?: ThoughtInDiscussionDTODiscussionAgreementEnum;
    /**
     * 
     * @type {number}
     * @memberof ThoughtInDiscussionDTO
     */
    'argumentBookmarksCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInDiscussionDTO
     */
    'isOpening'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInDiscussionDTO
     */
    'isAgreed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInDiscussionDTO
     */
    'isDisagreed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInDiscussionDTO
     */
    'isBookmarked'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInDiscussionDTO
     */
    'canDelete'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInDiscussionDTO
     */
    'pinnedByUsername'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInDiscussionDTO
     */
    'canAccept'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInDiscussionDTO
     */
    'mindChanged'?: boolean;
    /**
     * 
     * @type {ThoughtEndorsementSummaryDTO}
     * @memberof ThoughtInDiscussionDTO
     */
    'endorsements'?: ThoughtEndorsementSummaryDTO;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInDiscussionDTO
     */
    'boardItemLabel'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInDiscussionDTO
     */
    'boardSlotLabel'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInDiscussionDTO
     */
    'anchorState'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInDiscussionDTO
     */
    'authorGroupFlair'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInDiscussionDTO
     */
    'pinned'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInDiscussionDTO
     */
    'canPin'?: boolean;
}

export const ThoughtInDiscussionDTODiscussionAgreementEnum = {
    Agree: 'AGREE',
    Disagree: 'DISAGREE'
} as const;

export type ThoughtInDiscussionDTODiscussionAgreementEnum = typeof ThoughtInDiscussionDTODiscussionAgreementEnum[keyof typeof ThoughtInDiscussionDTODiscussionAgreementEnum];

/**
 * 
 * @export
 * @interface ThoughtInSearchDTO
 */
export interface ThoughtInSearchDTO {
    /**
     * 
     * @type {number}
     * @memberof ThoughtInSearchDTO
     */
    'discussionFollowersCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ThoughtInSearchDTO
     */
    'discussionAgreeingUsersCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ThoughtInSearchDTO
     */
    'discussionDisagreeingUsersCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'discussionAuthorUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'discussionAuthorProfileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'discussionSlug'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'discussionTitle'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInSearchDTO
     */
    'discussionSensitive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'viewerAgreedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'discussionCreatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'userAgreementMode'?: ThoughtInSearchDTOUserAgreementModeEnum;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'discussionImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'viewerAgreementMode'?: ThoughtInSearchDTOViewerAgreementModeEnum;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'userAgreedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'publicId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ThoughtInSearchDTO
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'authorFeaturedDistinction'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'authorVoiceOfMonthGroupName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInSearchDTO
     */
    'spoiler'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ThoughtInSearchDTO
     */
    'depth'?: number;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'deletedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'editedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'anchorBlockId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'anchorExcerpt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'conversationPublicId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInSearchDTO
     */
    'canMarkMindChanged'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInSearchDTO
     */
    'canStartConversation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInSearchDTO
     */
    'deletedByModerator'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'deletedReasonType'?: string;
    /**
     * 
     * @type {number}
     * @memberof ThoughtInSearchDTO
     */
    'agreementsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof ThoughtInSearchDTO
     */
    'disagreementsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'htmlContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'profileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'parentArgumentPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'safeUsername'?: string;
    /**
     * 
     * @type {number}
     * @memberof ThoughtInSearchDTO
     */
    'replyCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInSearchDTO
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'username'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInSearchDTO
     */
    'accepted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ThoughtInSearchDTO
     */
    'descendantCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'discussionAgreement'?: ThoughtInSearchDTODiscussionAgreementEnum;
    /**
     * 
     * @type {number}
     * @memberof ThoughtInSearchDTO
     */
    'argumentBookmarksCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInSearchDTO
     */
    'isOpening'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInSearchDTO
     */
    'isAgreed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInSearchDTO
     */
    'isDisagreed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInSearchDTO
     */
    'isBookmarked'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInSearchDTO
     */
    'canDelete'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'pinnedByUsername'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInSearchDTO
     */
    'canAccept'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInSearchDTO
     */
    'mindChanged'?: boolean;
    /**
     * 
     * @type {ThoughtEndorsementSummaryDTO}
     * @memberof ThoughtInSearchDTO
     */
    'endorsements'?: ThoughtEndorsementSummaryDTO;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'boardItemLabel'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'boardSlotLabel'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'anchorState'?: string;
    /**
     * 
     * @type {string}
     * @memberof ThoughtInSearchDTO
     */
    'authorGroupFlair'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInSearchDTO
     */
    'pinned'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtInSearchDTO
     */
    'canPin'?: boolean;
}

export const ThoughtInSearchDTOUserAgreementModeEnum = {
    Upvote: 'UPVOTE',
    Downvote: 'DOWNVOTE'
} as const;

export type ThoughtInSearchDTOUserAgreementModeEnum = typeof ThoughtInSearchDTOUserAgreementModeEnum[keyof typeof ThoughtInSearchDTOUserAgreementModeEnum];
export const ThoughtInSearchDTOViewerAgreementModeEnum = {
    Upvote: 'UPVOTE',
    Downvote: 'DOWNVOTE'
} as const;

export type ThoughtInSearchDTOViewerAgreementModeEnum = typeof ThoughtInSearchDTOViewerAgreementModeEnum[keyof typeof ThoughtInSearchDTOViewerAgreementModeEnum];
export const ThoughtInSearchDTODiscussionAgreementEnum = {
    Agree: 'AGREE',
    Disagree: 'DISAGREE'
} as const;

export type ThoughtInSearchDTODiscussionAgreementEnum = typeof ThoughtInSearchDTODiscussionAgreementEnum[keyof typeof ThoughtInSearchDTODiscussionAgreementEnum];

/**
 * 
 * @export
 * @interface ThoughtVersionsResponse
 */
export interface ThoughtVersionsResponse {
    /**
     * 
     * @type {string}
     * @memberof ThoughtVersionsResponse
     */
    'currentSourceJson': string;
    /**
     * 
     * @type {boolean}
     * @memberof ThoughtVersionsResponse
     */
    'currentSpoiler': boolean;
    /**
     * 
     * @type {Array<Version>}
     * @memberof ThoughtVersionsResponse
     */
    'versions': Array<Version>;
}
/**
 * 
 * @export
 * @interface UiCensusBatchRequest
 */
export interface UiCensusBatchRequest {
    /**
     * 
     * @type {string}
     * @memberof UiCensusBatchRequest
     */
    'surface'?: string;
    /**
     * 
     * @type {string}
     * @memberof UiCensusBatchRequest
     */
    'pageType'?: string;
    /**
     * 
     * @type {Array<UiCensusEntry>}
     * @memberof UiCensusBatchRequest
     */
    'entries'?: Array<UiCensusEntry>;
    /**
     * 
     * @type {Array<UiFrictionEntry>}
     * @memberof UiCensusBatchRequest
     */
    'friction'?: Array<UiFrictionEntry>;
}
/**
 * 
 * @export
 * @interface UiCensusEntry
 */
export interface UiCensusEntry {
    /**
     * 
     * @type {string}
     * @memberof UiCensusEntry
     */
    'controlId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UiCensusEntry
     */
    'pageType'?: string;
    /**
     * 
     * @type {number}
     * @memberof UiCensusEntry
     */
    'clicks'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UiCensusEntry
     */
    'firstInSession'?: boolean;
}
/**
 * 
 * @export
 * @interface UiFrictionEntry
 */
export interface UiFrictionEntry {
    /**
     * 
     * @type {string}
     * @memberof UiFrictionEntry
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof UiFrictionEntry
     */
    'controlId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UiFrictionEntry
     */
    'routeTemplate'?: string;
    /**
     * 
     * @type {number}
     * @memberof UiFrictionEntry
     */
    'burstSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof UiFrictionEntry
     */
    'elementRole'?: string;
}
/**
 * 
 * @export
 * @interface UnansweredRepliesDTO
 */
export interface UnansweredRepliesDTO {
    /**
     * 
     * @type {number}
     * @memberof UnansweredRepliesDTO
     */
    'waitingPeopleCount'?: number;
    /**
     * 
     * @type {Array<Post>}
     * @memberof UnansweredRepliesDTO
     */
    'posts'?: Array<Post>;
}
/**
 * 
 * @export
 * @interface UpdateContentPreferencesRequest
 */
export interface UpdateContentPreferencesRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateContentPreferencesRequest
     */
    'hideSensitiveMedia'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateContentPreferencesRequest
     */
    'sensitivePreference'?: UpdateContentPreferencesRequestSensitivePreferenceEnum;
}

export const UpdateContentPreferencesRequestSensitivePreferenceEnum = {
    Show: 'SHOW',
    Blur: 'BLUR',
    Hide: 'HIDE'
} as const;

export type UpdateContentPreferencesRequestSensitivePreferenceEnum = typeof UpdateContentPreferencesRequestSensitivePreferenceEnum[keyof typeof UpdateContentPreferencesRequestSensitivePreferenceEnum];

/**
 * 
 * @export
 * @interface UpdateDirectMessagePolicyRequest
 */
export interface UpdateDirectMessagePolicyRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateDirectMessagePolicyRequest
     */
    'directMessagePolicy': UpdateDirectMessagePolicyRequestDirectMessagePolicyEnum;
}

export const UpdateDirectMessagePolicyRequestDirectMessagePolicyEnum = {
    Everyone: 'EVERYONE',
    PeopleIFollow: 'PEOPLE_I_FOLLOW',
    Nobody: 'NOBODY'
} as const;

export type UpdateDirectMessagePolicyRequestDirectMessagePolicyEnum = typeof UpdateDirectMessagePolicyRequestDirectMessagePolicyEnum[keyof typeof UpdateDirectMessagePolicyRequestDirectMessagePolicyEnum];

/**
 * 
 * @export
 * @interface UpdateDiscussionDraftRequest
 */
export interface UpdateDiscussionDraftRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateDiscussionDraftRequest
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiscussionDraftRequest
     */
    'excerpt'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiscussionDraftRequest
     */
    'sourceJson'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiscussionDraftRequest
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiscussionDraftRequest
     */
    'draftPublicId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiscussionDraftRequest
     */
    'discussionPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiscussionDraftRequest
     */
    'scheduledPublishAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDiscussionDraftRequest
     */
    'privateAccess'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDiscussionDraftRequest
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateDiscussionDraftRequest
     */
    'sensitiveSource'?: UpdateDiscussionDraftRequestSensitiveSourceEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDiscussionDraftRequest
     */
    'spoiler'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateDiscussionDraftRequest
     */
    'tags'?: Array<string>;
    /**
     * The type of tile on the map
     * @type {SeavienLanguageTag}
     * @memberof UpdateDiscussionDraftRequest
     */
    'languageTag'?: SeavienLanguageTag;
    /**
     * Optimistic-concurrency token the client last received for this draft. When it is behind the stored row the save is refused with 409 DRAFT_SAVE_CONFLICT / STALE_TOKEN instead of silently overwriting whatever saved in between. Null is accepted for clients that predate the field — the shrink guard still applies.
     * @type {number}
     * @memberof UpdateDiscussionDraftRequest
     */
    'rowVersion'?: number;
    /**
     * Set only after the author has confirmed, in the composer, that they really mean to remove most of the draft\'s body. Waives the destructive-shrink guard for this one request. Never set it by default: it is the author\'s answer to a specific prompt, and a client that always sends true has re-opened the exact hole the guard closes.
     * @type {boolean}
     * @memberof UpdateDiscussionDraftRequest
     */
    'confirmDestructiveEdit'?: boolean;
    /**
     * True when this save came from the composer\'s debounced autosave timer rather than a deliberate author action. Only affects how the revision is labelled and throttled; it never relaxes a guard.
     * @type {boolean}
     * @memberof UpdateDiscussionDraftRequest
     */
    'autosave'?: boolean;
    /**
     * Whether the author marked this post as a review.
     * @type {boolean}
     * @memberof UpdateDiscussionDraftRequest
     */
    'reviewFacetSelected'?: boolean;
    /**
     * Public id of an existing subject the author picked from the suggestions.
     * @type {string}
     * @memberof UpdateDiscussionDraftRequest
     */
    'reviewSubjectPublicId'?: string;
    /**
     * Name of a new subject to create, when the author chose to create one inline.
     * @type {string}
     * @memberof UpdateDiscussionDraftRequest
     */
    'reviewSubjectName'?: string;
    /**
     * Rating in integer half-stars, 1..10 (0.5..5.0 stars).
     * @type {number}
     * @memberof UpdateDiscussionDraftRequest
     */
    'reviewRatingHalfStars'?: number;
    /**
     * Whether the author marked this post as a question.
     * @type {boolean}
     * @memberof UpdateDiscussionDraftRequest
     */
    'questionFacetSelected'?: boolean;
    /**
     * Whether the author marked this post as a board.
     * @type {boolean}
     * @memberof UpdateDiscussionDraftRequest
     */
    'boardFacetSelected'?: boolean;
    /**
     * TIERS or MATRIX.
     * @type {string}
     * @memberof UpdateDiscussionDraftRequest
     */
    'boardKind'?: string;
    /**
     * The authored board schema: slots, axes, item content mode.
     * @type {string}
     * @memberof UpdateDiscussionDraftRequest
     */
    'boardSchemaJson'?: string;
    /**
     * How long each item stays open for voting, 1-168 hours. Defaults to 24.
     * @type {number}
     * @memberof UpdateDiscussionDraftRequest
     */
    'boardItemWindowHours'?: number;
    /**
     * The items the author seeded the board with, in order.
     * @type {Array<BoardItemInput>}
     * @memberof UpdateDiscussionDraftRequest
     */
    'boardItems'?: Array<BoardItemInput>;
    /**
     * Whether the author marked this post as a poll.
     * @type {boolean}
     * @memberof UpdateDiscussionDraftRequest
     */
    'pollFacetSelected'?: boolean;
    /**
     * The poll options, 2-6, in the author\'s order.
     * @type {Array<string>}
     * @memberof UpdateDiscussionDraftRequest
     */
    'pollOptions'?: Array<string>;
    /**
     * How long voting stays open after publish, 1-168 hours. Defaults to 72.
     * @type {number}
     * @memberof UpdateDiscussionDraftRequest
     */
    'pollCloseWindowHours'?: number;
}

export const UpdateDiscussionDraftRequestSensitiveSourceEnum = {
    Manual: 'MANUAL',
    AutoByDiscussion: 'AUTO_BY_DISCUSSION',
    AutoByExternalMedia: 'AUTO_BY_EXTERNAL_MEDIA',
    ModeratorOverride: 'MODERATOR_OVERRIDE'
} as const;

export type UpdateDiscussionDraftRequestSensitiveSourceEnum = typeof UpdateDiscussionDraftRequestSensitiveSourceEnum[keyof typeof UpdateDiscussionDraftRequestSensitiveSourceEnum];

/**
 * 
 * @export
 * @interface UpdateGroupBoardMessageRequest
 */
export interface UpdateGroupBoardMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupBoardMessageRequest
     */
    'body': string;
}
/**
 * 
 * @export
 * @interface UpdateGroupGeneralRequest
 */
export interface UpdateGroupGeneralRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupGeneralRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupGeneralRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupGeneralRequest
     */
    'thumbnailUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupGeneralRequest
     */
    'bannerUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupGeneralRequest
     */
    'welcomeMessage'?: string;
    /**
     * 
     * @type {SeavienLanguageTag}
     * @memberof UpdateGroupGeneralRequest
     */
    'mainLocale': SeavienLanguageTag;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateGroupGeneralRequest
     */
    'privateAccess'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateGroupGeneralRequest
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupGeneralRequest
     */
    'discussionSubmissionPolicy'?: UpdateGroupGeneralRequestDiscussionSubmissionPolicyEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateGroupGeneralRequest
     */
    'tags'?: Array<string>;
}

export const UpdateGroupGeneralRequestDiscussionSubmissionPolicyEnum = {
    OpenMemberAdd: 'OPEN_MEMBER_ADD',
    LeaderApprovalRequired: 'LEADER_APPROVAL_REQUIRED'
} as const;

export type UpdateGroupGeneralRequestDiscussionSubmissionPolicyEnum = typeof UpdateGroupGeneralRequestDiscussionSubmissionPolicyEnum[keyof typeof UpdateGroupGeneralRequestDiscussionSubmissionPolicyEnum];

/**
 * 
 * @export
 * @interface UpdateGroupMemberFlairRequest
 */
export interface UpdateGroupMemberFlairRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupMemberFlairRequest
     */
    'flair'?: string;
}
/**
 * 
 * @export
 * @interface UpdateGroupNotificationPreferenceRequest
 */
export interface UpdateGroupNotificationPreferenceRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupNotificationPreferenceRequest
     */
    'level': string;
}
/**
 * 
 * @export
 * @interface UpdateGroupWelcomeMessageRequest
 */
export interface UpdateGroupWelcomeMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupWelcomeMessageRequest
     */
    'welcomeMessage'?: string;
}
/**
 * 
 * @export
 * @interface UpdateHomeFeedPreferenceRequest
 */
export interface UpdateHomeFeedPreferenceRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateHomeFeedPreferenceRequest
     */
    'defaultFeedType'?: UpdateHomeFeedPreferenceRequestDefaultFeedTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateHomeFeedPreferenceRequest
     */
    'allOrderingStyle'?: UpdateHomeFeedPreferenceRequestAllOrderingStyleEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateHomeFeedPreferenceRequest
     */
    'allTopRange'?: UpdateHomeFeedPreferenceRequestAllTopRangeEnum;
}

export const UpdateHomeFeedPreferenceRequestDefaultFeedTypeEnum = {
    Home: 'HOME',
    All: 'ALL',
    Groups: 'GROUPS',
    Following: 'FOLLOWING',
    Series: 'SERIES'
} as const;

export type UpdateHomeFeedPreferenceRequestDefaultFeedTypeEnum = typeof UpdateHomeFeedPreferenceRequestDefaultFeedTypeEnum[keyof typeof UpdateHomeFeedPreferenceRequestDefaultFeedTypeEnum];
export const UpdateHomeFeedPreferenceRequestAllOrderingStyleEnum = {
    Agreed: 'AGREED',
    Controversial: 'CONTROVERSIAL',
    Arguments: 'ARGUMENTS',
    Active: 'ACTIVE',
    New: 'NEW'
} as const;

export type UpdateHomeFeedPreferenceRequestAllOrderingStyleEnum = typeof UpdateHomeFeedPreferenceRequestAllOrderingStyleEnum[keyof typeof UpdateHomeFeedPreferenceRequestAllOrderingStyleEnum];
export const UpdateHomeFeedPreferenceRequestAllTopRangeEnum = {
    All: 'ALL',
    Day: 'DAY',
    Week: 'WEEK',
    Month: 'MONTH',
    Year: 'YEAR'
} as const;

export type UpdateHomeFeedPreferenceRequestAllTopRangeEnum = typeof UpdateHomeFeedPreferenceRequestAllTopRangeEnum[keyof typeof UpdateHomeFeedPreferenceRequestAllTopRangeEnum];

/**
 * 
 * @export
 * @interface UpdateLanguagePreferenceRequest
 */
export interface UpdateLanguagePreferenceRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateLanguagePreferenceRequest
     */
    'languageTag'?: string;
}
/**
 * 
 * @export
 * @interface UpdateNewsletterRequest
 */
export interface UpdateNewsletterRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateNewsletterRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateNewsletterRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateNewsletterRequest
     */
    'promiseLine'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateNewsletterRequest
     */
    'logoUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateNewsletterRequest
     */
    'coverUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateNewsletterRequest
     */
    'senderDisplayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateNewsletterRequest
     */
    'discoverability': UpdateNewsletterRequestDiscoverabilityEnum;
}

export const UpdateNewsletterRequestDiscoverabilityEnum = {
    Public: 'PUBLIC',
    Unlisted: 'UNLISTED'
} as const;

export type UpdateNewsletterRequestDiscoverabilityEnum = typeof UpdateNewsletterRequestDiscoverabilityEnum[keyof typeof UpdateNewsletterRequestDiscoverabilityEnum];

/**
 * 
 * @export
 * @interface UpdateNotificationPreferencesRequest
 */
export interface UpdateNotificationPreferencesRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationPreferencesRequest
     */
    'notifyOnMentions'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationPreferencesRequest
     */
    'notifyOnFollowedPosts'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationPreferencesRequest
     */
    'notifyOnBoardSettled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationPreferencesRequest
     */
    'notifyOnBoardCompleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationPreferencesRequest
     */
    'notifyOnReplyRequests'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationPreferencesRequest
     */
    'notifyOnAnswerRequests'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationPreferencesRequest
     */
    'hostOptIn'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationPreferencesRequest
     */
    'welcomeHostLabelVisible'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationPreferencesRequest
     */
    'notifyOnRecognition'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationPreferencesRequest
     */
    'notifyOnPeople'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationPreferencesRequest
     */
    'notifyOnGroupsAndSeries'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationPreferencesRequest
     */
    'primaryDigestEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationPreferencesRequest
     */
    'includeMessagePreviewInEmail'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationPreferencesRequest
     */
    'activationNudgesEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationPreferencesRequest
     */
    'contentActivityEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationPreferencesRequest
     */
    'reengagementEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationPreferencesRequest
     */
    'writingTipsEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationPreferencesRequest
     */
    'newFromFollowingEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationPreferencesRequest
     */
    'pushRepliesEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationPreferencesRequest
     */
    'pushMentionsEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationPreferencesRequest
     */
    'pushRecognitionEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationPreferencesRequest
     */
    'pushDirectMessagesEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNotificationPreferencesRequest
     */
    'pushInvitationsEnabled'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdatePinnedDiscussionOrderRequest
 */
export interface UpdatePinnedDiscussionOrderRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdatePinnedDiscussionOrderRequest
     */
    'sortOrder': number;
}
/**
 * 
 * @export
 * @interface UpdateProfileSettingsRequest
 */
export interface UpdateProfileSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileSettingsRequest
     */
    'profileDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileSettingsRequest
     */
    'imagePublicId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProfileSettingsRequest
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileSettingsRequest
     */
    'profileStatement'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileSettingsRequest
     */
    'featuredDistinction'?: string;
}
/**
 * 
 * @export
 * @interface UpdateReadingLanguageAutoAddRequest
 */
export interface UpdateReadingLanguageAutoAddRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateReadingLanguageAutoAddRequest
     */
    'enabled'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateReadingLanguagesRequest
 */
export interface UpdateReadingLanguagesRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateReadingLanguagesRequest
     */
    'included'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateReadingLanguagesRequest
     */
    'muted'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateReviewFacetRequest
 */
export interface UpdateReviewFacetRequest {
    /**
     * Public id of an existing subject the author picked from the suggestions.
     * @type {string}
     * @memberof UpdateReviewFacetRequest
     */
    'reviewSubjectPublicId'?: string;
    /**
     * Name of a new subject to create, when the author chose to create one inline.
     * @type {string}
     * @memberof UpdateReviewFacetRequest
     */
    'reviewSubjectName'?: string;
    /**
     * Integer half-stars, 1..10.
     * @type {number}
     * @memberof UpdateReviewFacetRequest
     */
    'reviewRatingHalfStars'?: number;
}
/**
 * 
 * @export
 * @interface UpdateSeriesDiscussionOrderRequest
 */
export interface UpdateSeriesDiscussionOrderRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateSeriesDiscussionOrderRequest
     */
    'discussionPublicIds': Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateSeriesGeneralRequest
 */
export interface UpdateSeriesGeneralRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateSeriesGeneralRequest
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSeriesGeneralRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSeriesGeneralRequest
     */
    'thumbnailUrl'?: string;
    /**
     * 
     * @type {SeavienLanguageTag}
     * @memberof UpdateSeriesGeneralRequest
     */
    'mainLocale': SeavienLanguageTag;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSeriesGeneralRequest
     */
    'privateAccess'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSeriesGeneralRequest
     */
    'sensitive'?: boolean;
}


/**
 * 
 * @export
 * @interface UpdateThemePreferenceRequest
 */
export interface UpdateThemePreferenceRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateThemePreferenceRequest
     */
    'themePreference'?: UpdateThemePreferenceRequestThemePreferenceEnum;
}

export const UpdateThemePreferenceRequestThemePreferenceEnum = {
    System: 'SYSTEM',
    Light: 'LIGHT',
    Dark: 'DARK'
} as const;

export type UpdateThemePreferenceRequestThemePreferenceEnum = typeof UpdateThemePreferenceRequestThemePreferenceEnum[keyof typeof UpdateThemePreferenceRequestThemePreferenceEnum];

/**
 * 
 * @export
 * @interface UserAsFollowerDTO
 */
export interface UserAsFollowerDTO {
    /**
     * 
     * @type {string}
     * @memberof UserAsFollowerDTO
     */
    'followedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof UserAsFollowerDTO
     */
    'conversationsParticipatedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserAsFollowerDTO
     */
    'discussionsAuthoredCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserAsFollowerDTO
     */
    'mindsChangedReceivedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserAsFollowerDTO
     */
    'userId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UserAsFollowerDTO
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserAsFollowerDTO
     */
    'profileStatement'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserAsFollowerDTO
     */
    'isViewerFollowing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserAsFollowerDTO
     */
    'argumentsAuthoredCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserAsFollowerDTO
     */
    'agreementsReceivedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserAsFollowerDTO
     */
    'followersCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserAsFollowerDTO
     */
    'followingCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UserAsFollowerDTO
     */
    'viewerIsOwner'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserAsFollowerDTO
     */
    'canMessage'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserAsFollowerDTO
     */
    'profileViewsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserAsFollowerDTO
     */
    'profileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAsFollowerDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAsFollowerDTO
     */
    'viewerFollowingAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAsFollowerDTO
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAsFollowerDTO
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAsFollowerDTO
     */
    'creationDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserAsFollowerDTO
     */
    'isFollowingViewer'?: boolean;
}
/**
 * 
 * @export
 * @interface UserAsFollowingDTO
 */
export interface UserAsFollowingDTO {
    /**
     * 
     * @type {string}
     * @memberof UserAsFollowingDTO
     */
    'followedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof UserAsFollowingDTO
     */
    'conversationsParticipatedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserAsFollowingDTO
     */
    'discussionsAuthoredCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserAsFollowingDTO
     */
    'mindsChangedReceivedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserAsFollowingDTO
     */
    'userId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UserAsFollowingDTO
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserAsFollowingDTO
     */
    'profileStatement'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserAsFollowingDTO
     */
    'isViewerFollowing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserAsFollowingDTO
     */
    'argumentsAuthoredCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserAsFollowingDTO
     */
    'agreementsReceivedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserAsFollowingDTO
     */
    'followersCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserAsFollowingDTO
     */
    'followingCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UserAsFollowingDTO
     */
    'viewerIsOwner'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserAsFollowingDTO
     */
    'canMessage'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserAsFollowingDTO
     */
    'profileViewsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserAsFollowingDTO
     */
    'profileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAsFollowingDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAsFollowingDTO
     */
    'viewerFollowingAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAsFollowingDTO
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAsFollowingDTO
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAsFollowingDTO
     */
    'creationDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserAsFollowingDTO
     */
    'isFollowingViewer'?: boolean;
}
/**
 * 
 * @export
 * @interface UserCollectionCountsDTO
 */
export interface UserCollectionCountsDTO {
    /**
     * 
     * @type {number}
     * @memberof UserCollectionCountsDTO
     */
    'participatedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserCollectionCountsDTO
     */
    'seriesCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserCollectionCountsDTO
     */
    'groupsLeaderCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserCollectionCountsDTO
     */
    'groupsMemberCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserCollectionCountsDTO
     */
    'savedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserCollectionCountsDTO
     */
    'archivedCount'?: number;
}
/**
 * 
 * @export
 * @interface UserConnectionOriginViewDTO
 */
export interface UserConnectionOriginViewDTO {
    /**
     * 
     * @type {string}
     * @memberof UserConnectionOriginViewDTO
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserConnectionOriginViewDTO
     */
    'captureStartedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserConnectionOriginViewDTO
     */
    'earliestKnownOriginAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserConnectionOriginViewDTO
     */
    'latestKnownOriginAt'?: string;
    /**
     * 
     * @type {Array<KnownOriginDTO>}
     * @memberof UserConnectionOriginViewDTO
     */
    'origins'?: Array<KnownOriginDTO>;
    /**
     * 
     * @type {Array<ConnectionEventDTO>}
     * @memberof UserConnectionOriginViewDTO
     */
    'recentEvents'?: Array<ConnectionEventDTO>;
}
/**
 * 
 * @export
 * @interface UserFeedbackRequest
 */
export interface UserFeedbackRequest {
    /**
     * 
     * @type {string}
     * @memberof UserFeedbackRequest
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof UserFeedbackRequest
     */
    'sourcePath'?: string;
}
/**
 * 
 * @export
 * @interface UserLinkCardDTO
 */
export interface UserLinkCardDTO {
    /**
     * 
     * @type {string}
     * @memberof UserLinkCardDTO
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserLinkCardDTO
     */
    'profileImageUrl'?: string;
}
/**
 * 
 * @export
 * @interface UserPageBootstrapDTO
 */
export interface UserPageBootstrapDTO {
    /**
     * 
     * @type {string}
     * @memberof UserPageBootstrapDTO
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserPageBootstrapDTO
     */
    'creationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserPageBootstrapDTO
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserPageBootstrapDTO
     */
    'profileImageUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserPageBootstrapDTO
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserPageBootstrapDTO
     */
    'isViewerFollowing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserPageBootstrapDTO
     */
    'discussionsAuthoredCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserPageBootstrapDTO
     */
    'argumentsAuthoredCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserPageBootstrapDTO
     */
    'agreementsReceivedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserPageBootstrapDTO
     */
    'mindsChangedReceivedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserPageBootstrapDTO
     */
    'followersCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserPageBootstrapDTO
     */
    'followingCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UserPageBootstrapDTO
     */
    'viewerIsOwner'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserPageBootstrapDTO
     */
    'profileStatement'?: string;
    /**
     * 
     * @type {UserCollectionCountsDTO}
     * @memberof UserPageBootstrapDTO
     */
    'collectionCounts'?: UserCollectionCountsDTO;
    /**
     * 
     * @type {boolean}
     * @memberof UserPageBootstrapDTO
     */
    'canMessage'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserPageBootstrapDTO
     */
    'welcomeHost'?: boolean;
}
/**
 * 
 * @export
 * @interface UserParticipatingInDiscussionDTO
 */
export interface UserParticipatingInDiscussionDTO {
    /**
     * 
     * @type {number}
     * @memberof UserParticipatingInDiscussionDTO
     */
    'discussionThoughtsCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserParticipatingInDiscussionDTO
     */
    'conversationsParticipatedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserParticipatingInDiscussionDTO
     */
    'discussionsAuthoredCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserParticipatingInDiscussionDTO
     */
    'mindsChangedReceivedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserParticipatingInDiscussionDTO
     */
    'userId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UserParticipatingInDiscussionDTO
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserParticipatingInDiscussionDTO
     */
    'profileStatement'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserParticipatingInDiscussionDTO
     */
    'isViewerFollowing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserParticipatingInDiscussionDTO
     */
    'argumentsAuthoredCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserParticipatingInDiscussionDTO
     */
    'agreementsReceivedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserParticipatingInDiscussionDTO
     */
    'followersCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserParticipatingInDiscussionDTO
     */
    'followingCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UserParticipatingInDiscussionDTO
     */
    'viewerIsOwner'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserParticipatingInDiscussionDTO
     */
    'canMessage'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserParticipatingInDiscussionDTO
     */
    'profileViewsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserParticipatingInDiscussionDTO
     */
    'profileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserParticipatingInDiscussionDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserParticipatingInDiscussionDTO
     */
    'viewerFollowingAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserParticipatingInDiscussionDTO
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserParticipatingInDiscussionDTO
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserParticipatingInDiscussionDTO
     */
    'creationDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserParticipatingInDiscussionDTO
     */
    'isFollowingViewer'?: boolean;
}
/**
 * 
 * @export
 * @interface UserProfileDTO
 */
export interface UserProfileDTO {
    /**
     * 
     * @type {number}
     * @memberof UserProfileDTO
     */
    'conversationsParticipatedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserProfileDTO
     */
    'discussionsAuthoredCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserProfileDTO
     */
    'mindsChangedReceivedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserProfileDTO
     */
    'userId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfileDTO
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDTO
     */
    'profileStatement'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfileDTO
     */
    'isViewerFollowing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserProfileDTO
     */
    'argumentsAuthoredCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserProfileDTO
     */
    'agreementsReceivedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserProfileDTO
     */
    'followersCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserProfileDTO
     */
    'followingCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfileDTO
     */
    'viewerIsOwner'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfileDTO
     */
    'canMessage'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserProfileDTO
     */
    'profileViewsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDTO
     */
    'profileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDTO
     */
    'viewerFollowingAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDTO
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDTO
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileDTO
     */
    'creationDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfileDTO
     */
    'isFollowingViewer'?: boolean;
}
/**
 * 
 * @export
 * @interface UserRequestingToJoinDTO
 */
export interface UserRequestingToJoinDTO {
    /**
     * 
     * @type {boolean}
     * @memberof UserRequestingToJoinDTO
     */
    'viewerHasBlockedRequester'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserRequestingToJoinDTO
     */
    'requestStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRequestingToJoinDTO
     */
    'requestPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRequestingToJoinDTO
     */
    'requestCreatedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof UserRequestingToJoinDTO
     */
    'conversationsParticipatedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserRequestingToJoinDTO
     */
    'discussionsAuthoredCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserRequestingToJoinDTO
     */
    'mindsChangedReceivedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserRequestingToJoinDTO
     */
    'userId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UserRequestingToJoinDTO
     */
    'sensitive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserRequestingToJoinDTO
     */
    'profileStatement'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserRequestingToJoinDTO
     */
    'isViewerFollowing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserRequestingToJoinDTO
     */
    'argumentsAuthoredCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserRequestingToJoinDTO
     */
    'agreementsReceivedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserRequestingToJoinDTO
     */
    'followersCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserRequestingToJoinDTO
     */
    'followingCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UserRequestingToJoinDTO
     */
    'viewerIsOwner'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserRequestingToJoinDTO
     */
    'canMessage'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserRequestingToJoinDTO
     */
    'profileViewsCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserRequestingToJoinDTO
     */
    'profileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRequestingToJoinDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRequestingToJoinDTO
     */
    'viewerFollowingAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRequestingToJoinDTO
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRequestingToJoinDTO
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRequestingToJoinDTO
     */
    'creationDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserRequestingToJoinDTO
     */
    'isFollowingViewer'?: boolean;
}
/**
 * 
 * @export
 * @interface UserSafetyListItemDTO
 */
export interface UserSafetyListItemDTO {
    /**
     * 
     * @type {number}
     * @memberof UserSafetyListItemDTO
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserSafetyListItemDTO
     */
    'profileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSafetyListItemDTO
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSafetyListItemDTO
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserSafetyListItemDTO
     */
    'relatedAt'?: string;
}
/**
 * 
 * @export
 * @interface UserSafetyStateDTO
 */
export interface UserSafetyStateDTO {
    /**
     * 
     * @type {boolean}
     * @memberof UserSafetyStateDTO
     */
    'blockedByViewer'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserSafetyStateDTO
     */
    'viewerBlockedByUser'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserSafetyStateDTO
     */
    'mutedByViewer'?: boolean;
}
/**
 * 
 * @export
 * @interface UserVisitorInsightsDTO
 */
export interface UserVisitorInsightsDTO {
    /**
     * 
     * @type {number}
     * @memberof UserVisitorInsightsDTO
     */
    'visitorsThisWeek'?: number;
}
/**
 * 
 * @export
 * @interface Version
 */
export interface Version {
    /**
     * 
     * @type {number}
     * @memberof Version
     */
    'versionNumber': number;
    /**
     * 
     * @type {string}
     * @memberof Version
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Version
     */
    'htmlContent': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Version
     */
    'spoiler': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Version
     */
    'silent': boolean;
}
/**
 * 
 * @export
 * @interface ViewerGroupInvitationDTO
 */
export interface ViewerGroupInvitationDTO {
    /**
     * 
     * @type {string}
     * @memberof ViewerGroupInvitationDTO
     */
    'invitedByProfileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ViewerGroupInvitationDTO
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ViewerGroupInvitationDTO
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ViewerGroupInvitationDTO
     */
    'invitedByUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof ViewerGroupInvitationDTO
     */
    'leadershipLevel'?: string;
    /**
     * 
     * @type {string}
     * @memberof ViewerGroupInvitationDTO
     */
    'invitationPublicId'?: string;
}
/**
 * 
 * @export
 * @interface ViewerGroupRequestDTO
 */
export interface ViewerGroupRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof ViewerGroupRequestDTO
     */
    'resolvedByProfileImageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof ViewerGroupRequestDTO
     */
    'paginationParameter'?: string;
    /**
     * 
     * @type {string}
     * @memberof ViewerGroupRequestDTO
     */
    'requestStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof ViewerGroupRequestDTO
     */
    'resolutionNote'?: string;
    /**
     * 
     * @type {string}
     * @memberof ViewerGroupRequestDTO
     */
    'requestPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ViewerGroupRequestDTO
     */
    'requestCreatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ViewerGroupRequestDTO
     */
    'requestResolvedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ViewerGroupRequestDTO
     */
    'resolvedByUsername'?: string;
}
/**
 * 
 * @export
 * @interface VoiceOfMonth
 */
export interface VoiceOfMonth {
    /**
     * 
     * @type {string}
     * @memberof VoiceOfMonth
     */
    'groupPublicId'?: string;
    /**
     * 
     * @type {string}
     * @memberof VoiceOfMonth
     */
    'groupName'?: string;
    /**
     * 
     * @type {string}
     * @memberof VoiceOfMonth
     */
    'month'?: string;
}
/**
 * 
 * @export
 * @interface WallPreferencesRequest
 */
export interface WallPreferencesRequest {
    /**
     * 
     * @type {boolean}
     * @memberof WallPreferencesRequest
     */
    'showAchievements'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WallPreferencesRequest
     */
    'showEndorsements'?: boolean;
}
/**
 * 
 * @export
 * @interface WelcomeHostInvitationAnswerRequest
 */
export interface WelcomeHostInvitationAnswerRequest {
    /**
     * 
     * @type {boolean}
     * @memberof WelcomeHostInvitationAnswerRequest
     */
    'accept': boolean;
}
/**
 * 
 * @export
 * @interface WelcomeHostInvitationDTO
 */
export interface WelcomeHostInvitationDTO {
    /**
     * 
     * @type {boolean}
     * @memberof WelcomeHostInvitationDTO
     */
    'eligible'?: boolean;
}

/**
 * AjaxAccountAccessControllerApi - axios parameter creator
 * @export
 */
export const AjaxAccountAccessControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ajaxLogin: async (loginRequest: LoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginRequest' is not null or undefined
            assertParamExists('ajaxLogin', 'loginRequest', loginRequest)
            const localVarPath = `/ajax/account/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CaptureSignupEmailRequest} captureSignupEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        captureSignupEmail: async (captureSignupEmailRequest: CaptureSignupEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'captureSignupEmailRequest' is not null or undefined
            assertParamExists('captureSignupEmail', 'captureSignupEmailRequest', captureSignupEmailRequest)
            const localVarPath = `/ajax/account/signup/capture-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(captureSignupEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {{ [key: string]: string; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmEmailVerification: async (requestBody?: { [key: string]: string; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/account/email_verification/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResetAccountRequest} resetAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processResetAccount: async (resetAccountRequest: ResetAccountRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetAccountRequest' is not null or undefined
            assertParamExists('processResetAccount', 'resetAccountRequest', resetAccountRequest)
            const localVarPath = `/ajax/account/reset_account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SocialLinkRequestBody} socialLinkRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSocialAccountLink: async (socialLinkRequestBody: SocialLinkRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'socialLinkRequestBody' is not null or undefined
            assertParamExists('requestSocialAccountLink', 'socialLinkRequestBody', socialLinkRequestBody)
            const localVarPath = `/ajax/account/social_link_request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(socialLinkRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {{ [key: string]: string; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendActivation: async (requestBody?: { [key: string]: string; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/account/account_activation_email/resend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PasswordResetRequest} passwordResetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (passwordResetRequest: PasswordResetRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'passwordResetRequest' is not null or undefined
            assertParamExists('resetPassword', 'passwordResetRequest', passwordResetRequest)
            const localVarPath = `/ajax/account/reset_password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(passwordResetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendEmailVerificationRequest} sendEmailVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailVerification: async (sendEmailVerificationRequest: SendEmailVerificationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendEmailVerificationRequest' is not null or undefined
            assertParamExists('sendEmailVerification', 'sendEmailVerificationRequest', sendEmailVerificationRequest)
            const localVarPath = `/ajax/account/email_verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendEmailVerificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SignupRequest} signupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signup: async (signupRequest: SignupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signupRequest' is not null or undefined
            assertParamExists('signup', 'signupRequest', signupRequest)
            const localVarPath = `/ajax/account/signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MobileSocialAuthStartRequest} mobileSocialAuthStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startMobileSocialAuth: async (mobileSocialAuthStartRequest: MobileSocialAuthStartRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mobileSocialAuthStartRequest' is not null or undefined
            assertParamExists('startMobileSocialAuth', 'mobileSocialAuthStartRequest', mobileSocialAuthStartRequest)
            const localVarPath = `/ajax/account/mobile/social/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mobileSocialAuthStartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MobileSocialAuthStartRequest} mobileSocialAuthStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startStandalonePwaSocialAuth: async (mobileSocialAuthStartRequest: MobileSocialAuthStartRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mobileSocialAuthStartRequest' is not null or undefined
            assertParamExists('startStandalonePwaSocialAuth', 'mobileSocialAuthStartRequest', mobileSocialAuthStartRequest)
            const localVarPath = `/ajax/account/app/social/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mobileSocialAuthStartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateUsernameRequest} createUsernameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitUsername: async (createUsernameRequest: CreateUsernameRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUsernameRequest' is not null or undefined
            assertParamExists('submitUsername', 'createUsernameRequest', createUsernameRequest)
            const localVarPath = `/ajax/account/login/social`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUsernameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {{ [key: string]: string; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUsername: async (requestBody?: { [key: string]: string; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/account/signup/validate-username`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxAccountAccessControllerApi - functional programming interface
 * @export
 */
export const AjaxAccountAccessControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxAccountAccessControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ajaxLogin(loginRequest: LoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ajaxLogin(loginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAccountAccessControllerApi.ajaxLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CaptureSignupEmailRequest} captureSignupEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async captureSignupEmail(captureSignupEmailRequest: CaptureSignupEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.captureSignupEmail(captureSignupEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAccountAccessControllerApi.captureSignupEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {{ [key: string]: string; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmEmailVerification(requestBody?: { [key: string]: string; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmEmailVerification(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAccountAccessControllerApi.confirmEmailVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ResetAccountRequest} resetAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processResetAccount(resetAccountRequest: ResetAccountRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processResetAccount(resetAccountRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAccountAccessControllerApi.processResetAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SocialLinkRequestBody} socialLinkRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestSocialAccountLink(socialLinkRequestBody: SocialLinkRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestSocialAccountLink(socialLinkRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAccountAccessControllerApi.requestSocialAccountLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {{ [key: string]: string; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendActivation(requestBody?: { [key: string]: string; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendActivation(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAccountAccessControllerApi.resendActivation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PasswordResetRequest} passwordResetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(passwordResetRequest: PasswordResetRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(passwordResetRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAccountAccessControllerApi.resetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendEmailVerificationRequest} sendEmailVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendEmailVerification(sendEmailVerificationRequest: SendEmailVerificationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendEmailVerification(sendEmailVerificationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAccountAccessControllerApi.sendEmailVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SignupRequest} signupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signup(signupRequest: SignupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signup(signupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAccountAccessControllerApi.signup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MobileSocialAuthStartRequest} mobileSocialAuthStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startMobileSocialAuth(mobileSocialAuthStartRequest: MobileSocialAuthStartRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MobileSocialAuthStartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startMobileSocialAuth(mobileSocialAuthStartRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAccountAccessControllerApi.startMobileSocialAuth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MobileSocialAuthStartRequest} mobileSocialAuthStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startStandalonePwaSocialAuth(mobileSocialAuthStartRequest: MobileSocialAuthStartRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MobileSocialAuthStartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startStandalonePwaSocialAuth(mobileSocialAuthStartRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAccountAccessControllerApi.startStandalonePwaSocialAuth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateUsernameRequest} createUsernameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitUsername(createUsernameRequest: CreateUsernameRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitUsername(createUsernameRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAccountAccessControllerApi.submitUsername']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {{ [key: string]: string; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateUsername(requestBody?: { [key: string]: string; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateUsername(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAccountAccessControllerApi.validateUsername']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxAccountAccessControllerApi - factory interface
 * @export
 */
export const AjaxAccountAccessControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxAccountAccessControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ajaxLogin(loginRequest: LoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.ajaxLogin(loginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CaptureSignupEmailRequest} captureSignupEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        captureSignupEmail(captureSignupEmailRequest: CaptureSignupEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.captureSignupEmail(captureSignupEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {{ [key: string]: string; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmEmailVerification(requestBody?: { [key: string]: string; }, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.confirmEmailVerification(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ResetAccountRequest} resetAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processResetAccount(resetAccountRequest: ResetAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.processResetAccount(resetAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SocialLinkRequestBody} socialLinkRequestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSocialAccountLink(socialLinkRequestBody: SocialLinkRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.requestSocialAccountLink(socialLinkRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {{ [key: string]: string; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendActivation(requestBody?: { [key: string]: string; }, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resendActivation(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PasswordResetRequest} passwordResetRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(passwordResetRequest: PasswordResetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.resetPassword(passwordResetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SendEmailVerificationRequest} sendEmailVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailVerification(sendEmailVerificationRequest: SendEmailVerificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.sendEmailVerification(sendEmailVerificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SignupRequest} signupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signup(signupRequest: SignupRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.signup(signupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MobileSocialAuthStartRequest} mobileSocialAuthStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startMobileSocialAuth(mobileSocialAuthStartRequest: MobileSocialAuthStartRequest, options?: RawAxiosRequestConfig): AxiosPromise<MobileSocialAuthStartResponse> {
            return localVarFp.startMobileSocialAuth(mobileSocialAuthStartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MobileSocialAuthStartRequest} mobileSocialAuthStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startStandalonePwaSocialAuth(mobileSocialAuthStartRequest: MobileSocialAuthStartRequest, options?: RawAxiosRequestConfig): AxiosPromise<MobileSocialAuthStartResponse> {
            return localVarFp.startStandalonePwaSocialAuth(mobileSocialAuthStartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateUsernameRequest} createUsernameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitUsername(createUsernameRequest: CreateUsernameRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.submitUsername(createUsernameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {{ [key: string]: string; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUsername(requestBody?: { [key: string]: string; }, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.validateUsername(requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxAccountAccessControllerApi - object-oriented interface
 * @export
 * @class AjaxAccountAccessControllerApi
 * @extends {BaseAPI}
 */
export class AjaxAccountAccessControllerApi extends BaseAPI {
    /**
     * 
     * @param {LoginRequest} loginRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAccountAccessControllerApi
     */
    public ajaxLogin(loginRequest: LoginRequest, options?: RawAxiosRequestConfig) {
        return AjaxAccountAccessControllerApiFp(this.configuration).ajaxLogin(loginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CaptureSignupEmailRequest} captureSignupEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAccountAccessControllerApi
     */
    public captureSignupEmail(captureSignupEmailRequest: CaptureSignupEmailRequest, options?: RawAxiosRequestConfig) {
        return AjaxAccountAccessControllerApiFp(this.configuration).captureSignupEmail(captureSignupEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {{ [key: string]: string; }} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAccountAccessControllerApi
     */
    public confirmEmailVerification(requestBody?: { [key: string]: string; }, options?: RawAxiosRequestConfig) {
        return AjaxAccountAccessControllerApiFp(this.configuration).confirmEmailVerification(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ResetAccountRequest} resetAccountRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAccountAccessControllerApi
     */
    public processResetAccount(resetAccountRequest: ResetAccountRequest, options?: RawAxiosRequestConfig) {
        return AjaxAccountAccessControllerApiFp(this.configuration).processResetAccount(resetAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SocialLinkRequestBody} socialLinkRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAccountAccessControllerApi
     */
    public requestSocialAccountLink(socialLinkRequestBody: SocialLinkRequestBody, options?: RawAxiosRequestConfig) {
        return AjaxAccountAccessControllerApiFp(this.configuration).requestSocialAccountLink(socialLinkRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {{ [key: string]: string; }} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAccountAccessControllerApi
     */
    public resendActivation(requestBody?: { [key: string]: string; }, options?: RawAxiosRequestConfig) {
        return AjaxAccountAccessControllerApiFp(this.configuration).resendActivation(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PasswordResetRequest} passwordResetRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAccountAccessControllerApi
     */
    public resetPassword(passwordResetRequest: PasswordResetRequest, options?: RawAxiosRequestConfig) {
        return AjaxAccountAccessControllerApiFp(this.configuration).resetPassword(passwordResetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SendEmailVerificationRequest} sendEmailVerificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAccountAccessControllerApi
     */
    public sendEmailVerification(sendEmailVerificationRequest: SendEmailVerificationRequest, options?: RawAxiosRequestConfig) {
        return AjaxAccountAccessControllerApiFp(this.configuration).sendEmailVerification(sendEmailVerificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SignupRequest} signupRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAccountAccessControllerApi
     */
    public signup(signupRequest: SignupRequest, options?: RawAxiosRequestConfig) {
        return AjaxAccountAccessControllerApiFp(this.configuration).signup(signupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MobileSocialAuthStartRequest} mobileSocialAuthStartRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAccountAccessControllerApi
     */
    public startMobileSocialAuth(mobileSocialAuthStartRequest: MobileSocialAuthStartRequest, options?: RawAxiosRequestConfig) {
        return AjaxAccountAccessControllerApiFp(this.configuration).startMobileSocialAuth(mobileSocialAuthStartRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MobileSocialAuthStartRequest} mobileSocialAuthStartRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAccountAccessControllerApi
     */
    public startStandalonePwaSocialAuth(mobileSocialAuthStartRequest: MobileSocialAuthStartRequest, options?: RawAxiosRequestConfig) {
        return AjaxAccountAccessControllerApiFp(this.configuration).startStandalonePwaSocialAuth(mobileSocialAuthStartRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateUsernameRequest} createUsernameRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAccountAccessControllerApi
     */
    public submitUsername(createUsernameRequest: CreateUsernameRequest, options?: RawAxiosRequestConfig) {
        return AjaxAccountAccessControllerApiFp(this.configuration).submitUsername(createUsernameRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {{ [key: string]: string; }} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAccountAccessControllerApi
     */
    public validateUsername(requestBody?: { [key: string]: string; }, options?: RawAxiosRequestConfig) {
        return AjaxAccountAccessControllerApiFp(this.configuration).validateUsername(requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxAdminAccountLinkageRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxAdminAccountLinkageRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountLinkage: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getAccountLinkage', 'username', username)
            const localVarPath = `/ajax/admin/moderation/linkage/users/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxAdminAccountLinkageRestControllerApi - functional programming interface
 * @export
 */
export const AjaxAdminAccountLinkageRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxAdminAccountLinkageRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountLinkage(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountLinkageViewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountLinkage(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAdminAccountLinkageRestControllerApi.getAccountLinkage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxAdminAccountLinkageRestControllerApi - factory interface
 * @export
 */
export const AjaxAdminAccountLinkageRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxAdminAccountLinkageRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountLinkage(username: string, options?: RawAxiosRequestConfig): AxiosPromise<AccountLinkageViewDTO> {
            return localVarFp.getAccountLinkage(username, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxAdminAccountLinkageRestControllerApi - object-oriented interface
 * @export
 * @class AjaxAdminAccountLinkageRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxAdminAccountLinkageRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAdminAccountLinkageRestControllerApi
     */
    public getAccountLinkage(username: string, options?: RawAxiosRequestConfig) {
        return AjaxAdminAccountLinkageRestControllerApiFp(this.configuration).getAccountLinkage(username, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxAdminConnectionOriginRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxAdminConnectionOriginRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectionOrigins: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getConnectionOrigins', 'username', username)
            const localVarPath = `/ajax/admin/moderation/connection-origins/users/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxAdminConnectionOriginRestControllerApi - functional programming interface
 * @export
 */
export const AjaxAdminConnectionOriginRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxAdminConnectionOriginRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConnectionOrigins(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserConnectionOriginViewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConnectionOrigins(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAdminConnectionOriginRestControllerApi.getConnectionOrigins']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxAdminConnectionOriginRestControllerApi - factory interface
 * @export
 */
export const AjaxAdminConnectionOriginRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxAdminConnectionOriginRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConnectionOrigins(username: string, options?: RawAxiosRequestConfig): AxiosPromise<UserConnectionOriginViewDTO> {
            return localVarFp.getConnectionOrigins(username, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxAdminConnectionOriginRestControllerApi - object-oriented interface
 * @export
 * @class AjaxAdminConnectionOriginRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxAdminConnectionOriginRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAdminConnectionOriginRestControllerApi
     */
    public getConnectionOrigins(username: string, options?: RawAxiosRequestConfig) {
        return AjaxAdminConnectionOriginRestControllerApiFp(this.configuration).getConnectionOrigins(username, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxAdminExperimentRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxAdminExperimentRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/admin/experiments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} key 
         * @param {StatusChangeRequest} statusChangeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setStatus: async (key: string, statusChangeRequest: StatusChangeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('setStatus', 'key', key)
            // verify required parameter 'statusChangeRequest' is not null or undefined
            assertParamExists('setStatus', 'statusChangeRequest', statusChangeRequest)
            const localVarPath = `/ajax/admin/experiments/{key}/status`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(statusChangeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxAdminExperimentRestControllerApi - functional programming interface
 * @export
 */
export const AjaxAdminExperimentRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxAdminExperimentRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: any; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAdminExperimentRestControllerApi.list']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} key 
         * @param {StatusChangeRequest} statusChangeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setStatus(key: string, statusChangeRequest: StatusChangeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setStatus(key, statusChangeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAdminExperimentRestControllerApi.setStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxAdminExperimentRestControllerApi - factory interface
 * @export
 */
export const AjaxAdminExperimentRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxAdminExperimentRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: any; }>> {
            return localVarFp.list(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} key 
         * @param {StatusChangeRequest} statusChangeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setStatus(key: string, statusChangeRequest: StatusChangeRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.setStatus(key, statusChangeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxAdminExperimentRestControllerApi - object-oriented interface
 * @export
 * @class AjaxAdminExperimentRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxAdminExperimentRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAdminExperimentRestControllerApi
     */
    public list(options?: RawAxiosRequestConfig) {
        return AjaxAdminExperimentRestControllerApiFp(this.configuration).list(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} key 
     * @param {StatusChangeRequest} statusChangeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAdminExperimentRestControllerApi
     */
    public setStatus(key: string, statusChangeRequest: StatusChangeRequest, options?: RawAxiosRequestConfig) {
        return AjaxAdminExperimentRestControllerApiFp(this.configuration).setStatus(key, statusChangeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxAdminIncidentNoticeRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxAdminIncidentNoticeRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dryRun1: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('dryRun1', 'slug', slug)
            const localVarPath = `/ajax/admin/incident-notice/{slug}/dry-run`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCampaigns1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/admin/incident-notice/campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {SendRequest} [sendRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        send1: async (slug: string, sendRequest?: SendRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('send1', 'slug', slug)
            const localVarPath = `/ajax/admin/incident-notice/{slug}/send`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxAdminIncidentNoticeRestControllerApi - functional programming interface
 * @export
 */
export const AjaxAdminIncidentNoticeRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxAdminIncidentNoticeRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dryRun1(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dryRun1(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAdminIncidentNoticeRestControllerApi.dryRun1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCampaigns1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCampaigns1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAdminIncidentNoticeRestControllerApi.listCampaigns1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {SendRequest} [sendRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async send1(slug: string, sendRequest?: SendRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.send1(slug, sendRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAdminIncidentNoticeRestControllerApi.send1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxAdminIncidentNoticeRestControllerApi - factory interface
 * @export
 */
export const AjaxAdminIncidentNoticeRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxAdminIncidentNoticeRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dryRun1(slug: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.dryRun1(slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCampaigns1(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.listCampaigns1(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} slug 
         * @param {SendRequest} [sendRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        send1(slug: string, sendRequest?: SendRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.send1(slug, sendRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxAdminIncidentNoticeRestControllerApi - object-oriented interface
 * @export
 * @class AjaxAdminIncidentNoticeRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxAdminIncidentNoticeRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAdminIncidentNoticeRestControllerApi
     */
    public dryRun1(slug: string, options?: RawAxiosRequestConfig) {
        return AjaxAdminIncidentNoticeRestControllerApiFp(this.configuration).dryRun1(slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAdminIncidentNoticeRestControllerApi
     */
    public listCampaigns1(options?: RawAxiosRequestConfig) {
        return AjaxAdminIncidentNoticeRestControllerApiFp(this.configuration).listCampaigns1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} slug 
     * @param {SendRequest} [sendRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAdminIncidentNoticeRestControllerApi
     */
    public send1(slug: string, sendRequest?: SendRequest, options?: RawAxiosRequestConfig) {
        return AjaxAdminIncidentNoticeRestControllerApiFp(this.configuration).send1(slug, sendRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxAdminMediaDimensionRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxAdminMediaDimensionRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [afterId] 
         * @param {number} [maxImages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        backfill: async (afterId?: number, maxImages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/admin/media-dimensions/backfill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (afterId !== undefined) {
                localVarQueryParameter['afterId'] = afterId;
            }

            if (maxImages !== undefined) {
                localVarQueryParameter['maxImages'] = maxImages;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxAdminMediaDimensionRestControllerApi - functional programming interface
 * @export
 */
export const AjaxAdminMediaDimensionRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxAdminMediaDimensionRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [afterId] 
         * @param {number} [maxImages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async backfill(afterId?: number, maxImages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackfillResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.backfill(afterId, maxImages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAdminMediaDimensionRestControllerApi.backfill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxAdminMediaDimensionRestControllerApi - factory interface
 * @export
 */
export const AjaxAdminMediaDimensionRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxAdminMediaDimensionRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [afterId] 
         * @param {number} [maxImages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        backfill(afterId?: number, maxImages?: number, options?: RawAxiosRequestConfig): AxiosPromise<BackfillResult> {
            return localVarFp.backfill(afterId, maxImages, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxAdminMediaDimensionRestControllerApi - object-oriented interface
 * @export
 * @class AjaxAdminMediaDimensionRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxAdminMediaDimensionRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} [afterId] 
     * @param {number} [maxImages] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAdminMediaDimensionRestControllerApi
     */
    public backfill(afterId?: number, maxImages?: number, options?: RawAxiosRequestConfig) {
        return AjaxAdminMediaDimensionRestControllerApiFp(this.configuration).backfill(afterId, maxImages, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxAdminProductAnnouncementRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxAdminProductAnnouncementRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dryRun: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('dryRun', 'slug', slug)
            const localVarPath = `/ajax/admin/product-announcement/{slug}/dry-run`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCampaigns: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/admin/product-announcement/campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {SendRequest} [sendRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        send: async (slug: string, sendRequest?: SendRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('send', 'slug', slug)
            const localVarPath = `/ajax/admin/product-announcement/{slug}/send`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxAdminProductAnnouncementRestControllerApi - functional programming interface
 * @export
 */
export const AjaxAdminProductAnnouncementRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxAdminProductAnnouncementRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dryRun(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dryRun(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAdminProductAnnouncementRestControllerApi.dryRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCampaigns(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCampaigns(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAdminProductAnnouncementRestControllerApi.listCampaigns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {SendRequest} [sendRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async send(slug: string, sendRequest?: SendRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.send(slug, sendRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAdminProductAnnouncementRestControllerApi.send']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxAdminProductAnnouncementRestControllerApi - factory interface
 * @export
 */
export const AjaxAdminProductAnnouncementRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxAdminProductAnnouncementRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dryRun(slug: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.dryRun(slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCampaigns(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.listCampaigns(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} slug 
         * @param {SendRequest} [sendRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        send(slug: string, sendRequest?: SendRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.send(slug, sendRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxAdminProductAnnouncementRestControllerApi - object-oriented interface
 * @export
 * @class AjaxAdminProductAnnouncementRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxAdminProductAnnouncementRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAdminProductAnnouncementRestControllerApi
     */
    public dryRun(slug: string, options?: RawAxiosRequestConfig) {
        return AjaxAdminProductAnnouncementRestControllerApiFp(this.configuration).dryRun(slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAdminProductAnnouncementRestControllerApi
     */
    public listCampaigns(options?: RawAxiosRequestConfig) {
        return AjaxAdminProductAnnouncementRestControllerApiFp(this.configuration).listCampaigns(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} slug 
     * @param {SendRequest} [sendRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAdminProductAnnouncementRestControllerApi
     */
    public send(slug: string, sendRequest?: SendRequest, options?: RawAxiosRequestConfig) {
        return AjaxAdminProductAnnouncementRestControllerApiFp(this.configuration).send(slug, sendRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxAdminSubjectRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxAdminSubjectRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} duplicatePublicId 
         * @param {string} canonicalPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merge: async (duplicatePublicId: string, canonicalPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'duplicatePublicId' is not null or undefined
            assertParamExists('merge', 'duplicatePublicId', duplicatePublicId)
            // verify required parameter 'canonicalPublicId' is not null or undefined
            assertParamExists('merge', 'canonicalPublicId', canonicalPublicId)
            const localVarPath = `/ajax/admin/subjects/{duplicatePublicId}/merge-into/{canonicalPublicId}`
                .replace(`{${"duplicatePublicId"}}`, encodeURIComponent(String(duplicatePublicId)))
                .replace(`{${"canonicalPublicId"}}`, encodeURIComponent(String(canonicalPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeQueue: async (limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/admin/subjects/merge-queue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxAdminSubjectRestControllerApi - functional programming interface
 * @export
 */
export const AjaxAdminSubjectRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxAdminSubjectRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} duplicatePublicId 
         * @param {string} canonicalPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merge(duplicatePublicId: string, canonicalPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.merge(duplicatePublicId, canonicalPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAdminSubjectRestControllerApi.merge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mergeQueue(limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SubjectMergeQueueEntryDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mergeQueue(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAdminSubjectRestControllerApi.mergeQueue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxAdminSubjectRestControllerApi - factory interface
 * @export
 */
export const AjaxAdminSubjectRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxAdminSubjectRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} duplicatePublicId 
         * @param {string} canonicalPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merge(duplicatePublicId: string, canonicalPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.merge(duplicatePublicId, canonicalPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeQueue(limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<SubjectMergeQueueEntryDTO>> {
            return localVarFp.mergeQueue(limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxAdminSubjectRestControllerApi - object-oriented interface
 * @export
 * @class AjaxAdminSubjectRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxAdminSubjectRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} duplicatePublicId 
     * @param {string} canonicalPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAdminSubjectRestControllerApi
     */
    public merge(duplicatePublicId: string, canonicalPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxAdminSubjectRestControllerApiFp(this.configuration).merge(duplicatePublicId, canonicalPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAdminSubjectRestControllerApi
     */
    public mergeQueue(limit?: number, options?: RawAxiosRequestConfig) {
        return AjaxAdminSubjectRestControllerApiFp(this.configuration).mergeQueue(limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxAdminTestSupportRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxAdminTestSupportRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanupPlaywrightFixtures: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/admin/test-support/cleanup-playwright-fixtures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxAdminTestSupportRestControllerApi - functional programming interface
 * @export
 */
export const AjaxAdminTestSupportRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxAdminTestSupportRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cleanupPlaywrightFixtures(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlaywrightFixtureCleanupResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cleanupPlaywrightFixtures(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAdminTestSupportRestControllerApi.cleanupPlaywrightFixtures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxAdminTestSupportRestControllerApi - factory interface
 * @export
 */
export const AjaxAdminTestSupportRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxAdminTestSupportRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanupPlaywrightFixtures(options?: RawAxiosRequestConfig): AxiosPromise<PlaywrightFixtureCleanupResult> {
            return localVarFp.cleanupPlaywrightFixtures(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxAdminTestSupportRestControllerApi - object-oriented interface
 * @export
 * @class AjaxAdminTestSupportRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxAdminTestSupportRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAdminTestSupportRestControllerApi
     */
    public cleanupPlaywrightFixtures(options?: RawAxiosRequestConfig) {
        return AjaxAdminTestSupportRestControllerApiFp(this.configuration).cleanupPlaywrightFixtures(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxAnswerRequestRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxAnswerRequestRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {AskRequest} [askRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ask: async (discussionPublicId: string, askRequest?: AskRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('ask', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/discussion/{discussionPublicId}/answer_request`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(askRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        state: async (discussionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('state', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/discussion/{discussionPublicId}/answer_request`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxAnswerRequestRestControllerApi - functional programming interface
 * @export
 */
export const AjaxAnswerRequestRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxAnswerRequestRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {AskRequest} [askRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ask(discussionPublicId: string, askRequest?: AskRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ask(discussionPublicId, askRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAnswerRequestRestControllerApi.ask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async state(discussionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AskState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.state(discussionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAnswerRequestRestControllerApi.state']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxAnswerRequestRestControllerApi - factory interface
 * @export
 */
export const AjaxAnswerRequestRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxAnswerRequestRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {AskRequest} [askRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ask(discussionPublicId: string, askRequest?: AskRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.ask(discussionPublicId, askRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        state(discussionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<AskState> {
            return localVarFp.state(discussionPublicId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxAnswerRequestRestControllerApi - object-oriented interface
 * @export
 * @class AjaxAnswerRequestRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxAnswerRequestRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} discussionPublicId 
     * @param {AskRequest} [askRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAnswerRequestRestControllerApi
     */
    public ask(discussionPublicId: string, askRequest?: AskRequest, options?: RawAxiosRequestConfig) {
        return AjaxAnswerRequestRestControllerApiFp(this.configuration).ask(discussionPublicId, askRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAnswerRequestRestControllerApi
     */
    public state(discussionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxAnswerRequestRestControllerApiFp(this.configuration).state(discussionPublicId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxAppInstallRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxAppInstallRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AppInstallReportRequest} [appInstallReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportInstall: async (appInstallReportRequest?: AppInstallReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/app/install`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(appInstallReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxAppInstallRestControllerApi - functional programming interface
 * @export
 */
export const AjaxAppInstallRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxAppInstallRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AppInstallReportRequest} [appInstallReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportInstall(appInstallReportRequest?: AppInstallReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: boolean; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportInstall(appInstallReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAppInstallRestControllerApi.reportInstall']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxAppInstallRestControllerApi - factory interface
 * @export
 */
export const AjaxAppInstallRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxAppInstallRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {AppInstallReportRequest} [appInstallReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportInstall(appInstallReportRequest?: AppInstallReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: boolean; }> {
            return localVarFp.reportInstall(appInstallReportRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxAppInstallRestControllerApi - object-oriented interface
 * @export
 * @class AjaxAppInstallRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxAppInstallRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {AppInstallReportRequest} [appInstallReportRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAppInstallRestControllerApi
     */
    public reportInstall(appInstallReportRequest?: AppInstallReportRequest, options?: RawAxiosRequestConfig) {
        return AjaxAppInstallRestControllerApiFp(this.configuration).reportInstall(appInstallReportRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxAppReviewRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxAppReviewRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} platform 
         * @param {string} trigger 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eligibility: async (platform: string, trigger: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platform' is not null or undefined
            assertParamExists('eligibility', 'platform', platform)
            // verify required parameter 'trigger' is not null or undefined
            assertParamExists('eligibility', 'trigger', trigger)
            const localVarPath = `/ajax/app-review/eligibility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (platform !== undefined) {
                localVarQueryParameter['platform'] = platform;
            }

            if (trigger !== undefined) {
                localVarQueryParameter['trigger'] = trigger;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PromptRequestedRequest} promptRequestedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promptRequested: async (promptRequestedRequest: PromptRequestedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'promptRequestedRequest' is not null or undefined
            assertParamExists('promptRequested', 'promptRequestedRequest', promptRequestedRequest)
            const localVarPath = `/ajax/app-review/prompt-requested`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promptRequestedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxAppReviewRestControllerApi - functional programming interface
 * @export
 */
export const AjaxAppReviewRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxAppReviewRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} platform 
         * @param {string} trigger 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async eligibility(platform: string, trigger: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EligibilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.eligibility(platform, trigger, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAppReviewRestControllerApi.eligibility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PromptRequestedRequest} promptRequestedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async promptRequested(promptRequestedRequest: PromptRequestedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.promptRequested(promptRequestedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxAppReviewRestControllerApi.promptRequested']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxAppReviewRestControllerApi - factory interface
 * @export
 */
export const AjaxAppReviewRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxAppReviewRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} platform 
         * @param {string} trigger 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eligibility(platform: string, trigger: string, options?: RawAxiosRequestConfig): AxiosPromise<EligibilityResponse> {
            return localVarFp.eligibility(platform, trigger, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PromptRequestedRequest} promptRequestedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promptRequested(promptRequestedRequest: PromptRequestedRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.promptRequested(promptRequestedRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxAppReviewRestControllerApi - object-oriented interface
 * @export
 * @class AjaxAppReviewRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxAppReviewRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} platform 
     * @param {string} trigger 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAppReviewRestControllerApi
     */
    public eligibility(platform: string, trigger: string, options?: RawAxiosRequestConfig) {
        return AjaxAppReviewRestControllerApiFp(this.configuration).eligibility(platform, trigger, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PromptRequestedRequest} promptRequestedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxAppReviewRestControllerApi
     */
    public promptRequested(promptRequestedRequest: PromptRequestedRequest, options?: RawAxiosRequestConfig) {
        return AjaxAppReviewRestControllerApiFp(this.configuration).promptRequested(promptRequestedRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxBoardRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxBoardRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {BoardItemAppendRequest} boardItemAppendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appendItem: async (discussionPublicId: string, boardItemAppendRequest: BoardItemAppendRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('appendItem', 'discussionPublicId', discussionPublicId)
            // verify required parameter 'boardItemAppendRequest' is not null or undefined
            assertParamExists('appendItem', 'boardItemAppendRequest', boardItemAppendRequest)
            const localVarPath = `/ajax/board/{discussionPublicId}/items`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(boardItemAppendRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {number} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pass: async (discussionPublicId: string, itemId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('pass', 'discussionPublicId', discussionPublicId)
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('pass', 'itemId', itemId)
            const localVarPath = `/ajax/board/{discussionPublicId}/items/{itemId}/pass`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)))
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {BoardSettleRequest} boardSettleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settle: async (discussionPublicId: string, boardSettleRequest: BoardSettleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('settle', 'discussionPublicId', discussionPublicId)
            // verify required parameter 'boardSettleRequest' is not null or undefined
            assertParamExists('settle', 'boardSettleRequest', boardSettleRequest)
            const localVarPath = `/ajax/board/{discussionPublicId}/settle`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(boardSettleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summaries: async (ids: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('summaries', 'ids', ids)
            const localVarPath = `/ajax/board/summaries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {number} itemId 
         * @param {BoardVoteRequest} boardVoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vote1: async (discussionPublicId: string, itemId: number, boardVoteRequest: BoardVoteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('vote1', 'discussionPublicId', discussionPublicId)
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('vote1', 'itemId', itemId)
            // verify required parameter 'boardVoteRequest' is not null or undefined
            assertParamExists('vote1', 'boardVoteRequest', boardVoteRequest)
            const localVarPath = `/ajax/board/{discussionPublicId}/items/{itemId}/vote`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)))
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(boardVoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxBoardRestControllerApi - functional programming interface
 * @export
 */
export const AjaxBoardRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxBoardRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {BoardItemAppendRequest} boardItemAppendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appendItem(discussionPublicId: string, boardItemAppendRequest: BoardItemAppendRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appendItem(discussionPublicId, boardItemAppendRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxBoardRestControllerApi.appendItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {number} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pass(discussionPublicId: string, itemId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pass(discussionPublicId, itemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxBoardRestControllerApi.pass']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {BoardSettleRequest} boardSettleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async settle(discussionPublicId: string, boardSettleRequest: BoardSettleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.settle(discussionPublicId, boardSettleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxBoardRestControllerApi.settle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async summaries(ids: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: BoardCardSummaryDTO; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.summaries(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxBoardRestControllerApi.summaries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {number} itemId 
         * @param {BoardVoteRequest} boardVoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vote1(discussionPublicId: string, itemId: number, boardVoteRequest: BoardVoteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vote1(discussionPublicId, itemId, boardVoteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxBoardRestControllerApi.vote1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxBoardRestControllerApi - factory interface
 * @export
 */
export const AjaxBoardRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxBoardRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {BoardItemAppendRequest} boardItemAppendRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appendItem(discussionPublicId: string, boardItemAppendRequest: BoardItemAppendRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.appendItem(discussionPublicId, boardItemAppendRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {number} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pass(discussionPublicId: string, itemId: number, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.pass(discussionPublicId, itemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {BoardSettleRequest} boardSettleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settle(discussionPublicId: string, boardSettleRequest: BoardSettleRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.settle(discussionPublicId, boardSettleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summaries(ids: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: BoardCardSummaryDTO; }> {
            return localVarFp.summaries(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {number} itemId 
         * @param {BoardVoteRequest} boardVoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vote1(discussionPublicId: string, itemId: number, boardVoteRequest: BoardVoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.vote1(discussionPublicId, itemId, boardVoteRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxBoardRestControllerApi - object-oriented interface
 * @export
 * @class AjaxBoardRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxBoardRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} discussionPublicId 
     * @param {BoardItemAppendRequest} boardItemAppendRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxBoardRestControllerApi
     */
    public appendItem(discussionPublicId: string, boardItemAppendRequest: BoardItemAppendRequest, options?: RawAxiosRequestConfig) {
        return AjaxBoardRestControllerApiFp(this.configuration).appendItem(discussionPublicId, boardItemAppendRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {number} itemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxBoardRestControllerApi
     */
    public pass(discussionPublicId: string, itemId: number, options?: RawAxiosRequestConfig) {
        return AjaxBoardRestControllerApiFp(this.configuration).pass(discussionPublicId, itemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {BoardSettleRequest} boardSettleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxBoardRestControllerApi
     */
    public settle(discussionPublicId: string, boardSettleRequest: BoardSettleRequest, options?: RawAxiosRequestConfig) {
        return AjaxBoardRestControllerApiFp(this.configuration).settle(discussionPublicId, boardSettleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxBoardRestControllerApi
     */
    public summaries(ids: Array<string>, options?: RawAxiosRequestConfig) {
        return AjaxBoardRestControllerApiFp(this.configuration).summaries(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {number} itemId 
     * @param {BoardVoteRequest} boardVoteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxBoardRestControllerApi
     */
    public vote1(discussionPublicId: string, itemId: number, boardVoteRequest: BoardVoteRequest, options?: RawAxiosRequestConfig) {
        return AjaxBoardRestControllerApiFp(this.configuration).vote1(discussionPublicId, itemId, boardVoteRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxChatLinkCardRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxChatLinkCardRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupCard: async (groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('groupCard', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/card`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userCard: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('userCard', 'username', username)
            const localVarPath = `/ajax/user/profile-card/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxChatLinkCardRestControllerApi - functional programming interface
 * @export
 */
export const AjaxChatLinkCardRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxChatLinkCardRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupCard(groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupLinkCardDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupCard(groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxChatLinkCardRestControllerApi.groupCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userCard(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserLinkCardDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userCard(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxChatLinkCardRestControllerApi.userCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxChatLinkCardRestControllerApi - factory interface
 * @export
 */
export const AjaxChatLinkCardRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxChatLinkCardRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupCard(groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<GroupLinkCardDTO> {
            return localVarFp.groupCard(groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userCard(username: string, options?: RawAxiosRequestConfig): AxiosPromise<UserLinkCardDTO> {
            return localVarFp.userCard(username, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxChatLinkCardRestControllerApi - object-oriented interface
 * @export
 * @class AjaxChatLinkCardRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxChatLinkCardRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxChatLinkCardRestControllerApi
     */
    public groupCard(groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxChatLinkCardRestControllerApiFp(this.configuration).groupCard(groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxChatLinkCardRestControllerApi
     */
    public userCard(username: string, options?: RawAxiosRequestConfig) {
        return AjaxChatLinkCardRestControllerApiFp(this.configuration).userCard(username, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxChatRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxChatRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} threadPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveThread: async (threadPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadPublicId' is not null or undefined
            assertParamExists('archiveThread', 'threadPublicId', threadPublicId)
            const localVarPath = `/ajax/chat/thread/{threadPublicId}/archive`
                .replace(`{${"threadPublicId"}}`, encodeURIComponent(String(threadPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePresignedUploadImageUrlRequest} createPresignedUploadImageUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAttachmentUploadLink: async (createPresignedUploadImageUrlRequest: CreatePresignedUploadImageUrlRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPresignedUploadImageUrlRequest' is not null or undefined
            assertParamExists('createAttachmentUploadLink', 'createPresignedUploadImageUrlRequest', createPresignedUploadImageUrlRequest)
            const localVarPath = `/ajax/chat/attachment/upload-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPresignedUploadImageUrlRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} messagePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMessage: async (messagePublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messagePublicId' is not null or undefined
            assertParamExists('deleteMessage', 'messagePublicId', messagePublicId)
            const localVarPath = `/ajax/chat/message/{messagePublicId}`
                .replace(`{${"messagePublicId"}}`, encodeURIComponent(String(messagePublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} messagePublicId 
         * @param {EditChatMessageRequest} editChatMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editMessage1: async (messagePublicId: string, editChatMessageRequest: EditChatMessageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messagePublicId' is not null or undefined
            assertParamExists('editMessage1', 'messagePublicId', messagePublicId)
            // verify required parameter 'editChatMessageRequest' is not null or undefined
            assertParamExists('editMessage1', 'editChatMessageRequest', editChatMessageRequest)
            const localVarPath = `/ajax/chat/message/{messagePublicId}`
                .replace(`{${"messagePublicId"}}`, encodeURIComponent(String(messagePublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editChatMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [paginationParameter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArchivedThreads: async (paginationParameter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/chat/threads/archived`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (paginationParameter !== undefined) {
                localVarQueryParameter['paginationParameter'] = paginationParameter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} attachmentPublicId 
         * @param {string} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachment: async (attachmentPublicId: string, size?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentPublicId' is not null or undefined
            assertParamExists('getAttachment', 'attachmentPublicId', attachmentPublicId)
            const localVarPath = `/ajax/chat/attachment/{attachmentPublicId}`
                .replace(`{${"attachmentPublicId"}}`, encodeURIComponent(String(attachmentPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupThread: async (groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('getGroupThread', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/chat/group-thread/{groupPublicId}`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [threadPublicId] 
         * @param {string} [groupPublicId] 
         * @param {string} [paginationParameter] 
         * @param {string} [aroundMessagePublicId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessages: async (threadPublicId?: string, groupPublicId?: string, paginationParameter?: string, aroundMessagePublicId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/chat/messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (threadPublicId !== undefined) {
                localVarQueryParameter['threadPublicId'] = threadPublicId;
            }

            if (groupPublicId !== undefined) {
                localVarQueryParameter['groupPublicId'] = groupPublicId;
            }

            if (paginationParameter !== undefined) {
                localVarQueryParameter['paginationParameter'] = paginationParameter;
            }

            if (aroundMessagePublicId !== undefined) {
                localVarQueryParameter['aroundMessagePublicId'] = aroundMessagePublicId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} threadPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThread: async (threadPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadPublicId' is not null or undefined
            assertParamExists('getThread', 'threadPublicId', threadPublicId)
            const localVarPath = `/ajax/chat/thread/{threadPublicId}`
                .replace(`{${"threadPublicId"}}`, encodeURIComponent(String(threadPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [paginationParameter] 
         * @param {string} [kind] 
         * @param {string} [list] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThreads: async (paginationParameter?: string, kind?: string, list?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/chat/threads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (paginationParameter !== undefined) {
                localVarQueryParameter['paginationParameter'] = paginationParameter;
            }

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }

            if (list !== undefined) {
                localVarQueryParameter['list'] = list;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/chat/unread-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [kind] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAllThreadsAsRead: async (kind?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/chat/threads/read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MarkImageAsUploadedRequest} markImageAsUploadedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAttachmentUploaded: async (markImageAsUploadedRequest: MarkImageAsUploadedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'markImageAsUploadedRequest' is not null or undefined
            assertParamExists('markAttachmentUploaded', 'markImageAsUploadedRequest', markImageAsUploadedRequest)
            const localVarPath = `/ajax/chat/attachment/uploaded`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markImageAsUploadedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} threadPublicId 
         * @param {MarkChatThreadReadRequest} [markChatThreadReadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markThreadAsRead: async (threadPublicId: string, markChatThreadReadRequest?: MarkChatThreadReadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadPublicId' is not null or undefined
            assertParamExists('markThreadAsRead', 'threadPublicId', threadPublicId)
            const localVarPath = `/ajax/chat/thread/{threadPublicId}/read`
                .replace(`{${"threadPublicId"}}`, encodeURIComponent(String(threadPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markChatThreadReadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} threadPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markThreadAsUnread: async (threadPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadPublicId' is not null or undefined
            assertParamExists('markThreadAsUnread', 'threadPublicId', threadPublicId)
            const localVarPath = `/ajax/chat/thread/{threadPublicId}/unread`
                .replace(`{${"threadPublicId"}}`, encodeURIComponent(String(threadPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TargetUsernameRequest} targetUsernameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openOrCreateThread: async (targetUsernameRequest: TargetUsernameRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'targetUsernameRequest' is not null or undefined
            assertParamExists('openOrCreateThread', 'targetUsernameRequest', targetUsernameRequest)
            const localVarPath = `/ajax/chat/thread`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(targetUsernameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} targetUsername 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewThread: async (targetUsername: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'targetUsername' is not null or undefined
            assertParamExists('previewThread', 'targetUsername', targetUsername)
            const localVarPath = `/ajax/chat/thread-preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (targetUsername !== undefined) {
                localVarQueryParameter['targetUsername'] = targetUsername;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} messagePublicId 
         * @param {ChatMessageReactionRequest} [chatMessageReactionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactToGroupChatMessage: async (messagePublicId: string, chatMessageReactionRequest?: ChatMessageReactionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messagePublicId' is not null or undefined
            assertParamExists('reactToGroupChatMessage', 'messagePublicId', messagePublicId)
            const localVarPath = `/ajax/chat/group-message/{messagePublicId}/reaction`
                .replace(`{${"messagePublicId"}}`, encodeURIComponent(String(messagePublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatMessageReactionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} messagePublicId 
         * @param {ChatMessageReactionRequest} [chatMessageReactionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactToMessage: async (messagePublicId: string, chatMessageReactionRequest?: ChatMessageReactionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messagePublicId' is not null or undefined
            assertParamExists('reactToMessage', 'messagePublicId', messagePublicId)
            const localVarPath = `/ajax/chat/message/{messagePublicId}/reaction`
                .replace(`{${"messagePublicId"}}`, encodeURIComponent(String(messagePublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatMessageReactionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} messagePublicId 
         * @param {CreateContentReportRequest} createContentReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGroupChatMessage: async (messagePublicId: string, createContentReportRequest: CreateContentReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messagePublicId' is not null or undefined
            assertParamExists('reportGroupChatMessage', 'messagePublicId', messagePublicId)
            // verify required parameter 'createContentReportRequest' is not null or undefined
            assertParamExists('reportGroupChatMessage', 'createContentReportRequest', createContentReportRequest)
            const localVarPath = `/ajax/chat/group-message/{messagePublicId}/report`
                .replace(`{${"messagePublicId"}}`, encodeURIComponent(String(messagePublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createContentReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} messagePublicId 
         * @param {ReportChatMessageRequest} reportChatMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportMessage: async (messagePublicId: string, reportChatMessageRequest: ReportChatMessageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messagePublicId' is not null or undefined
            assertParamExists('reportMessage', 'messagePublicId', messagePublicId)
            // verify required parameter 'reportChatMessageRequest' is not null or undefined
            assertParamExists('reportMessage', 'reportChatMessageRequest', reportChatMessageRequest)
            const localVarPath = `/ajax/chat/message/{messagePublicId}/report`
                .replace(`{${"messagePublicId"}}`, encodeURIComponent(String(messagePublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportChatMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendChatMessageRequest} sendChatMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessage: async (sendChatMessageRequest: SendChatMessageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendChatMessageRequest' is not null or undefined
            assertParamExists('sendMessage', 'sendChatMessageRequest', sendChatMessageRequest)
            const localVarPath = `/ajax/chat/message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendChatMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestGroups: async (query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/chat/group-suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} threadPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unarchiveThread: async (threadPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadPublicId' is not null or undefined
            assertParamExists('unarchiveThread', 'threadPublicId', threadPublicId)
            const localVarPath = `/ajax/chat/thread/{threadPublicId}/archive`
                .replace(`{${"threadPublicId"}}`, encodeURIComponent(String(threadPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxChatRestControllerApi - functional programming interface
 * @export
 */
export const AjaxChatRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxChatRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} threadPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveThread(threadPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatUnreadCountDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveThread(threadPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxChatRestControllerApi.archiveThread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreatePresignedUploadImageUrlRequest} createPresignedUploadImageUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAttachmentUploadLink(createPresignedUploadImageUrlRequest: CreatePresignedUploadImageUrlRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageUploadLinkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAttachmentUploadLink(createPresignedUploadImageUrlRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxChatRestControllerApi.createAttachmentUploadLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} messagePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMessage(messagePublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMessageDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMessage(messagePublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxChatRestControllerApi.deleteMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} messagePublicId 
         * @param {EditChatMessageRequest} editChatMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editMessage1(messagePublicId: string, editChatMessageRequest: EditChatMessageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMessageDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editMessage1(messagePublicId, editChatMessageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxChatRestControllerApi.editMessage1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [paginationParameter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArchivedThreads(paginationParameter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChatThreadSummaryDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArchivedThreads(paginationParameter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxChatRestControllerApi.getArchivedThreads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} attachmentPublicId 
         * @param {string} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttachment(attachmentPublicId: string, size?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttachment(attachmentPublicId, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxChatRestControllerApi.getAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupThread(groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatThreadDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupThread(groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxChatRestControllerApi.getGroupThread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [threadPublicId] 
         * @param {string} [groupPublicId] 
         * @param {string} [paginationParameter] 
         * @param {string} [aroundMessagePublicId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMessages(threadPublicId?: string, groupPublicId?: string, paginationParameter?: string, aroundMessagePublicId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChatMessageDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMessages(threadPublicId, groupPublicId, paginationParameter, aroundMessagePublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxChatRestControllerApi.getMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} threadPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getThread(threadPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatThreadDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getThread(threadPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxChatRestControllerApi.getThread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [paginationParameter] 
         * @param {string} [kind] 
         * @param {string} [list] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getThreads(paginationParameter?: string, kind?: string, list?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChatThreadSummaryDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getThreads(paginationParameter, kind, list, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxChatRestControllerApi.getThreads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnreadCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatUnreadCountDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnreadCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxChatRestControllerApi.getUnreadCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [kind] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAllThreadsAsRead(kind?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatUnreadCountDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAllThreadsAsRead(kind, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxChatRestControllerApi.markAllThreadsAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MarkImageAsUploadedRequest} markImageAsUploadedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAttachmentUploaded(markImageAsUploadedRequest: MarkImageAsUploadedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAttachmentUploaded(markImageAsUploadedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxChatRestControllerApi.markAttachmentUploaded']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} threadPublicId 
         * @param {MarkChatThreadReadRequest} [markChatThreadReadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markThreadAsRead(threadPublicId: string, markChatThreadReadRequest?: MarkChatThreadReadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatUnreadCountDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markThreadAsRead(threadPublicId, markChatThreadReadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxChatRestControllerApi.markThreadAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} threadPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markThreadAsUnread(threadPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatUnreadCountDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markThreadAsUnread(threadPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxChatRestControllerApi.markThreadAsUnread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TargetUsernameRequest} targetUsernameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openOrCreateThread(targetUsernameRequest: TargetUsernameRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatThreadDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openOrCreateThread(targetUsernameRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxChatRestControllerApi.openOrCreateThread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} targetUsername 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewThread(targetUsername: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatThreadDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewThread(targetUsername, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxChatRestControllerApi.previewThread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} messagePublicId 
         * @param {ChatMessageReactionRequest} [chatMessageReactionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reactToGroupChatMessage(messagePublicId: string, chatMessageReactionRequest?: ChatMessageReactionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMessageDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reactToGroupChatMessage(messagePublicId, chatMessageReactionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxChatRestControllerApi.reactToGroupChatMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} messagePublicId 
         * @param {ChatMessageReactionRequest} [chatMessageReactionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reactToMessage(messagePublicId: string, chatMessageReactionRequest?: ChatMessageReactionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMessageDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reactToMessage(messagePublicId, chatMessageReactionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxChatRestControllerApi.reactToMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} messagePublicId 
         * @param {CreateContentReportRequest} createContentReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportGroupChatMessage(messagePublicId: string, createContentReportRequest: CreateContentReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportGroupChatMessage(messagePublicId, createContentReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxChatRestControllerApi.reportGroupChatMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} messagePublicId 
         * @param {ReportChatMessageRequest} reportChatMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportMessage(messagePublicId: string, reportChatMessageRequest: ReportChatMessageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportMessage(messagePublicId, reportChatMessageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxChatRestControllerApi.reportMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendChatMessageRequest} sendChatMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendMessage(sendChatMessageRequest: SendChatMessageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatMessageDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendMessage(sendChatMessageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxChatRestControllerApi.sendMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestGroups(query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupChatSuggestionDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestGroups(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxChatRestControllerApi.suggestGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} threadPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unarchiveThread(threadPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatUnreadCountDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unarchiveThread(threadPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxChatRestControllerApi.unarchiveThread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxChatRestControllerApi - factory interface
 * @export
 */
export const AjaxChatRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxChatRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} threadPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveThread(threadPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<ChatUnreadCountDTO> {
            return localVarFp.archiveThread(threadPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreatePresignedUploadImageUrlRequest} createPresignedUploadImageUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAttachmentUploadLink(createPresignedUploadImageUrlRequest: CreatePresignedUploadImageUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImageUploadLinkResponse> {
            return localVarFp.createAttachmentUploadLink(createPresignedUploadImageUrlRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} messagePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMessage(messagePublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<ChatMessageDTO> {
            return localVarFp.deleteMessage(messagePublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} messagePublicId 
         * @param {EditChatMessageRequest} editChatMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editMessage1(messagePublicId: string, editChatMessageRequest: EditChatMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatMessageDTO> {
            return localVarFp.editMessage1(messagePublicId, editChatMessageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [paginationParameter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArchivedThreads(paginationParameter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChatThreadSummaryDTO>> {
            return localVarFp.getArchivedThreads(paginationParameter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} attachmentPublicId 
         * @param {string} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachment(attachmentPublicId: string, size?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.getAttachment(attachmentPublicId, size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupThread(groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<ChatThreadDetailDTO> {
            return localVarFp.getGroupThread(groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [threadPublicId] 
         * @param {string} [groupPublicId] 
         * @param {string} [paginationParameter] 
         * @param {string} [aroundMessagePublicId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessages(threadPublicId?: string, groupPublicId?: string, paginationParameter?: string, aroundMessagePublicId?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChatMessageDTO>> {
            return localVarFp.getMessages(threadPublicId, groupPublicId, paginationParameter, aroundMessagePublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} threadPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThread(threadPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<ChatThreadDetailDTO> {
            return localVarFp.getThread(threadPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [paginationParameter] 
         * @param {string} [kind] 
         * @param {string} [list] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThreads(paginationParameter?: string, kind?: string, list?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChatThreadSummaryDTO>> {
            return localVarFp.getThreads(paginationParameter, kind, list, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnreadCount(options?: RawAxiosRequestConfig): AxiosPromise<ChatUnreadCountDTO> {
            return localVarFp.getUnreadCount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [kind] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAllThreadsAsRead(kind?: string, options?: RawAxiosRequestConfig): AxiosPromise<ChatUnreadCountDTO> {
            return localVarFp.markAllThreadsAsRead(kind, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MarkImageAsUploadedRequest} markImageAsUploadedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAttachmentUploaded(markImageAsUploadedRequest: MarkImageAsUploadedRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImageDTO> {
            return localVarFp.markAttachmentUploaded(markImageAsUploadedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} threadPublicId 
         * @param {MarkChatThreadReadRequest} [markChatThreadReadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markThreadAsRead(threadPublicId: string, markChatThreadReadRequest?: MarkChatThreadReadRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatUnreadCountDTO> {
            return localVarFp.markThreadAsRead(threadPublicId, markChatThreadReadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} threadPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markThreadAsUnread(threadPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<ChatUnreadCountDTO> {
            return localVarFp.markThreadAsUnread(threadPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TargetUsernameRequest} targetUsernameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openOrCreateThread(targetUsernameRequest: TargetUsernameRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatThreadDetailDTO> {
            return localVarFp.openOrCreateThread(targetUsernameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} targetUsername 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewThread(targetUsername: string, options?: RawAxiosRequestConfig): AxiosPromise<ChatThreadDetailDTO> {
            return localVarFp.previewThread(targetUsername, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} messagePublicId 
         * @param {ChatMessageReactionRequest} [chatMessageReactionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactToGroupChatMessage(messagePublicId: string, chatMessageReactionRequest?: ChatMessageReactionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatMessageDTO> {
            return localVarFp.reactToGroupChatMessage(messagePublicId, chatMessageReactionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} messagePublicId 
         * @param {ChatMessageReactionRequest} [chatMessageReactionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactToMessage(messagePublicId: string, chatMessageReactionRequest?: ChatMessageReactionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatMessageDTO> {
            return localVarFp.reactToMessage(messagePublicId, chatMessageReactionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} messagePublicId 
         * @param {CreateContentReportRequest} createContentReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGroupChatMessage(messagePublicId: string, createContentReportRequest: CreateContentReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reportGroupChatMessage(messagePublicId, createContentReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} messagePublicId 
         * @param {ReportChatMessageRequest} reportChatMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportMessage(messagePublicId: string, reportChatMessageRequest: ReportChatMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reportMessage(messagePublicId, reportChatMessageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SendChatMessageRequest} sendChatMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessage(sendChatMessageRequest: SendChatMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatMessageDTO> {
            return localVarFp.sendMessage(sendChatMessageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestGroups(query?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupChatSuggestionDTO>> {
            return localVarFp.suggestGroups(query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} threadPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unarchiveThread(threadPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<ChatUnreadCountDTO> {
            return localVarFp.unarchiveThread(threadPublicId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxChatRestControllerApi - object-oriented interface
 * @export
 * @class AjaxChatRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxChatRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} threadPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxChatRestControllerApi
     */
    public archiveThread(threadPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxChatRestControllerApiFp(this.configuration).archiveThread(threadPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreatePresignedUploadImageUrlRequest} createPresignedUploadImageUrlRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxChatRestControllerApi
     */
    public createAttachmentUploadLink(createPresignedUploadImageUrlRequest: CreatePresignedUploadImageUrlRequest, options?: RawAxiosRequestConfig) {
        return AjaxChatRestControllerApiFp(this.configuration).createAttachmentUploadLink(createPresignedUploadImageUrlRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} messagePublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxChatRestControllerApi
     */
    public deleteMessage(messagePublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxChatRestControllerApiFp(this.configuration).deleteMessage(messagePublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} messagePublicId 
     * @param {EditChatMessageRequest} editChatMessageRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxChatRestControllerApi
     */
    public editMessage1(messagePublicId: string, editChatMessageRequest: EditChatMessageRequest, options?: RawAxiosRequestConfig) {
        return AjaxChatRestControllerApiFp(this.configuration).editMessage1(messagePublicId, editChatMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [paginationParameter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxChatRestControllerApi
     */
    public getArchivedThreads(paginationParameter?: string, options?: RawAxiosRequestConfig) {
        return AjaxChatRestControllerApiFp(this.configuration).getArchivedThreads(paginationParameter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} attachmentPublicId 
     * @param {string} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxChatRestControllerApi
     */
    public getAttachment(attachmentPublicId: string, size?: string, options?: RawAxiosRequestConfig) {
        return AjaxChatRestControllerApiFp(this.configuration).getAttachment(attachmentPublicId, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxChatRestControllerApi
     */
    public getGroupThread(groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxChatRestControllerApiFp(this.configuration).getGroupThread(groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [threadPublicId] 
     * @param {string} [groupPublicId] 
     * @param {string} [paginationParameter] 
     * @param {string} [aroundMessagePublicId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxChatRestControllerApi
     */
    public getMessages(threadPublicId?: string, groupPublicId?: string, paginationParameter?: string, aroundMessagePublicId?: string, options?: RawAxiosRequestConfig) {
        return AjaxChatRestControllerApiFp(this.configuration).getMessages(threadPublicId, groupPublicId, paginationParameter, aroundMessagePublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} threadPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxChatRestControllerApi
     */
    public getThread(threadPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxChatRestControllerApiFp(this.configuration).getThread(threadPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [paginationParameter] 
     * @param {string} [kind] 
     * @param {string} [list] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxChatRestControllerApi
     */
    public getThreads(paginationParameter?: string, kind?: string, list?: string, options?: RawAxiosRequestConfig) {
        return AjaxChatRestControllerApiFp(this.configuration).getThreads(paginationParameter, kind, list, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxChatRestControllerApi
     */
    public getUnreadCount(options?: RawAxiosRequestConfig) {
        return AjaxChatRestControllerApiFp(this.configuration).getUnreadCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [kind] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxChatRestControllerApi
     */
    public markAllThreadsAsRead(kind?: string, options?: RawAxiosRequestConfig) {
        return AjaxChatRestControllerApiFp(this.configuration).markAllThreadsAsRead(kind, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MarkImageAsUploadedRequest} markImageAsUploadedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxChatRestControllerApi
     */
    public markAttachmentUploaded(markImageAsUploadedRequest: MarkImageAsUploadedRequest, options?: RawAxiosRequestConfig) {
        return AjaxChatRestControllerApiFp(this.configuration).markAttachmentUploaded(markImageAsUploadedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} threadPublicId 
     * @param {MarkChatThreadReadRequest} [markChatThreadReadRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxChatRestControllerApi
     */
    public markThreadAsRead(threadPublicId: string, markChatThreadReadRequest?: MarkChatThreadReadRequest, options?: RawAxiosRequestConfig) {
        return AjaxChatRestControllerApiFp(this.configuration).markThreadAsRead(threadPublicId, markChatThreadReadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} threadPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxChatRestControllerApi
     */
    public markThreadAsUnread(threadPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxChatRestControllerApiFp(this.configuration).markThreadAsUnread(threadPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TargetUsernameRequest} targetUsernameRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxChatRestControllerApi
     */
    public openOrCreateThread(targetUsernameRequest: TargetUsernameRequest, options?: RawAxiosRequestConfig) {
        return AjaxChatRestControllerApiFp(this.configuration).openOrCreateThread(targetUsernameRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} targetUsername 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxChatRestControllerApi
     */
    public previewThread(targetUsername: string, options?: RawAxiosRequestConfig) {
        return AjaxChatRestControllerApiFp(this.configuration).previewThread(targetUsername, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} messagePublicId 
     * @param {ChatMessageReactionRequest} [chatMessageReactionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxChatRestControllerApi
     */
    public reactToGroupChatMessage(messagePublicId: string, chatMessageReactionRequest?: ChatMessageReactionRequest, options?: RawAxiosRequestConfig) {
        return AjaxChatRestControllerApiFp(this.configuration).reactToGroupChatMessage(messagePublicId, chatMessageReactionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} messagePublicId 
     * @param {ChatMessageReactionRequest} [chatMessageReactionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxChatRestControllerApi
     */
    public reactToMessage(messagePublicId: string, chatMessageReactionRequest?: ChatMessageReactionRequest, options?: RawAxiosRequestConfig) {
        return AjaxChatRestControllerApiFp(this.configuration).reactToMessage(messagePublicId, chatMessageReactionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} messagePublicId 
     * @param {CreateContentReportRequest} createContentReportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxChatRestControllerApi
     */
    public reportGroupChatMessage(messagePublicId: string, createContentReportRequest: CreateContentReportRequest, options?: RawAxiosRequestConfig) {
        return AjaxChatRestControllerApiFp(this.configuration).reportGroupChatMessage(messagePublicId, createContentReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} messagePublicId 
     * @param {ReportChatMessageRequest} reportChatMessageRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxChatRestControllerApi
     */
    public reportMessage(messagePublicId: string, reportChatMessageRequest: ReportChatMessageRequest, options?: RawAxiosRequestConfig) {
        return AjaxChatRestControllerApiFp(this.configuration).reportMessage(messagePublicId, reportChatMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SendChatMessageRequest} sendChatMessageRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxChatRestControllerApi
     */
    public sendMessage(sendChatMessageRequest: SendChatMessageRequest, options?: RawAxiosRequestConfig) {
        return AjaxChatRestControllerApiFp(this.configuration).sendMessage(sendChatMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [query] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxChatRestControllerApi
     */
    public suggestGroups(query?: string, options?: RawAxiosRequestConfig) {
        return AjaxChatRestControllerApiFp(this.configuration).suggestGroups(query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} threadPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxChatRestControllerApi
     */
    public unarchiveThread(threadPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxChatRestControllerApiFp(this.configuration).unarchiveThread(threadPublicId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxCircleRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxCircleRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        join: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/circle/join`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CircleOfferRequest} circleOfferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offer: async (circleOfferRequest: CircleOfferRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'circleOfferRequest' is not null or undefined
            assertParamExists('offer', 'circleOfferRequest', circleOfferRequest)
            const localVarPath = `/ajax/circle/offer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(circleOfferRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxCircleRestControllerApi - functional programming interface
 * @export
 */
export const AjaxCircleRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxCircleRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async join(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CircleOfferDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.join(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxCircleRestControllerApi.join']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CircleOfferRequest} circleOfferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async offer(circleOfferRequest: CircleOfferRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CircleOfferDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.offer(circleOfferRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxCircleRestControllerApi.offer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxCircleRestControllerApi - factory interface
 * @export
 */
export const AjaxCircleRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxCircleRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        join(options?: RawAxiosRequestConfig): AxiosPromise<CircleOfferDTO> {
            return localVarFp.join(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CircleOfferRequest} circleOfferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        offer(circleOfferRequest: CircleOfferRequest, options?: RawAxiosRequestConfig): AxiosPromise<CircleOfferDTO> {
            return localVarFp.offer(circleOfferRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxCircleRestControllerApi - object-oriented interface
 * @export
 * @class AjaxCircleRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxCircleRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxCircleRestControllerApi
     */
    public join(options?: RawAxiosRequestConfig) {
        return AjaxCircleRestControllerApiFp(this.configuration).join(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CircleOfferRequest} circleOfferRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxCircleRestControllerApi
     */
    public offer(circleOfferRequest: CircleOfferRequest, options?: RawAxiosRequestConfig) {
        return AjaxCircleRestControllerApiFp(this.configuration).offer(circleOfferRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxClientLogControllerApi - axios parameter creator
 * @export
 */
export const AjaxClientLogControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ClientLogDto} clientLogDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveClientLog: async (clientLogDto: ClientLogDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientLogDto' is not null or undefined
            assertParamExists('receiveClientLog', 'clientLogDto', clientLogDto)
            const localVarPath = `/api/client-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientLogDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxClientLogControllerApi - functional programming interface
 * @export
 */
export const AjaxClientLogControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxClientLogControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ClientLogDto} clientLogDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receiveClientLog(clientLogDto: ClientLogDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receiveClientLog(clientLogDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxClientLogControllerApi.receiveClientLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxClientLogControllerApi - factory interface
 * @export
 */
export const AjaxClientLogControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxClientLogControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {ClientLogDto} clientLogDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveClientLog(clientLogDto: ClientLogDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.receiveClientLog(clientLogDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxClientLogControllerApi - object-oriented interface
 * @export
 * @class AjaxClientLogControllerApi
 * @extends {BaseAPI}
 */
export class AjaxClientLogControllerApi extends BaseAPI {
    /**
     * 
     * @param {ClientLogDto} clientLogDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxClientLogControllerApi
     */
    public receiveClientLog(clientLogDto: ClientLogDto, options?: RawAxiosRequestConfig) {
        return AjaxClientLogControllerApiFp(this.configuration).receiveClientLog(clientLogDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxComposerSignalRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxComposerSignalRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ComposerSignalRequest} composerSignalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        composerSignal: async (composerSignalRequest: ComposerSignalRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'composerSignalRequest' is not null or undefined
            assertParamExists('composerSignal', 'composerSignalRequest', composerSignalRequest)
            const localVarPath = `/ajax/composer/signal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(composerSignalRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxComposerSignalRestControllerApi - functional programming interface
 * @export
 */
export const AjaxComposerSignalRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxComposerSignalRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ComposerSignalRequest} composerSignalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async composerSignal(composerSignalRequest: ComposerSignalRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.composerSignal(composerSignalRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxComposerSignalRestControllerApi.composerSignal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxComposerSignalRestControllerApi - factory interface
 * @export
 */
export const AjaxComposerSignalRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxComposerSignalRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {ComposerSignalRequest} composerSignalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        composerSignal(composerSignalRequest: ComposerSignalRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.composerSignal(composerSignalRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxComposerSignalRestControllerApi - object-oriented interface
 * @export
 * @class AjaxComposerSignalRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxComposerSignalRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {ComposerSignalRequest} composerSignalRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxComposerSignalRestControllerApi
     */
    public composerSignal(composerSignalRequest: ComposerSignalRequest, options?: RawAxiosRequestConfig) {
        return AjaxComposerSignalRestControllerApiFp(this.configuration).composerSignal(composerSignalRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxContactControllerApi - axios parameter creator
 * @export
 */
export const AjaxContactControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ContactRequest} contactRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitContactForm: async (contactRequest: ContactRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactRequest' is not null or undefined
            assertParamExists('submitContactForm', 'contactRequest', contactRequest)
            const localVarPath = `/ajax/contact/submit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SupportMessageRequest} supportMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitSupportMessage: async (supportMessageRequest: SupportMessageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'supportMessageRequest' is not null or undefined
            assertParamExists('submitSupportMessage', 'supportMessageRequest', supportMessageRequest)
            const localVarPath = `/ajax/contact/support`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(supportMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxContactControllerApi - functional programming interface
 * @export
 */
export const AjaxContactControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxContactControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ContactRequest} contactRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitContactForm(contactRequest: ContactRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitContactForm(contactRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxContactControllerApi.submitContactForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SupportMessageRequest} supportMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitSupportMessage(supportMessageRequest: SupportMessageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitSupportMessage(supportMessageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxContactControllerApi.submitSupportMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxContactControllerApi - factory interface
 * @export
 */
export const AjaxContactControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxContactControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {ContactRequest} contactRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitContactForm(contactRequest: ContactRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.submitContactForm(contactRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SupportMessageRequest} supportMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitSupportMessage(supportMessageRequest: SupportMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.submitSupportMessage(supportMessageRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxContactControllerApi - object-oriented interface
 * @export
 * @class AjaxContactControllerApi
 * @extends {BaseAPI}
 */
export class AjaxContactControllerApi extends BaseAPI {
    /**
     * 
     * @param {ContactRequest} contactRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxContactControllerApi
     */
    public submitContactForm(contactRequest: ContactRequest, options?: RawAxiosRequestConfig) {
        return AjaxContactControllerApiFp(this.configuration).submitContactForm(contactRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SupportMessageRequest} supportMessageRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxContactControllerApi
     */
    public submitSupportMessage(supportMessageRequest: SupportMessageRequest, options?: RawAxiosRequestConfig) {
        return AjaxContactControllerApiFp(this.configuration).submitSupportMessage(supportMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxCspReportRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxCspReportRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveViolationReport: async (body?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/security/csp-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxCspReportRestControllerApi - functional programming interface
 * @export
 */
export const AjaxCspReportRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxCspReportRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receiveViolationReport(body?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receiveViolationReport(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxCspReportRestControllerApi.receiveViolationReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxCspReportRestControllerApi - factory interface
 * @export
 */
export const AjaxCspReportRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxCspReportRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receiveViolationReport(body?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.receiveViolationReport(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxCspReportRestControllerApi - object-oriented interface
 * @export
 * @class AjaxCspReportRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxCspReportRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxCspReportRestControllerApi
     */
    public receiveViolationReport(body?: string, options?: RawAxiosRequestConfig) {
        return AjaxCspReportRestControllerApiFp(this.configuration).receiveViolationReport(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxCsrfControllerApi - axios parameter creator
 * @export
 */
export const AjaxCsrfControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CsrfToken} csrfToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        csrf: async (csrfToken: CsrfToken, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'csrfToken' is not null or undefined
            assertParamExists('csrf', 'csrfToken', csrfToken)
            const localVarPath = `/ajax/csrf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (csrfToken !== undefined) {
                for (const [key, value] of Object.entries(csrfToken)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxCsrfControllerApi - functional programming interface
 * @export
 */
export const AjaxCsrfControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxCsrfControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CsrfToken} csrfToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async csrf(csrfToken: CsrfToken, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.csrf(csrfToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxCsrfControllerApi.csrf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxCsrfControllerApi - factory interface
 * @export
 */
export const AjaxCsrfControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxCsrfControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {CsrfToken} csrfToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        csrf(csrfToken: CsrfToken, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.csrf(csrfToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxCsrfControllerApi - object-oriented interface
 * @export
 * @class AjaxCsrfControllerApi
 * @extends {BaseAPI}
 */
export class AjaxCsrfControllerApi extends BaseAPI {
    /**
     * 
     * @param {CsrfToken} csrfToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxCsrfControllerApi
     */
    public csrf(csrfToken: CsrfToken, options?: RawAxiosRequestConfig) {
        return AjaxCsrfControllerApiFp(this.configuration).csrf(csrfToken, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxDashboardRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxDashboardRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnansweredReplies: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/dashboard/unanswered-replies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxDashboardRestControllerApi - functional programming interface
 * @export
 */
export const AjaxDashboardRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxDashboardRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUnansweredReplies(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnansweredRepliesDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUnansweredReplies(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDashboardRestControllerApi.getUnansweredReplies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxDashboardRestControllerApi - factory interface
 * @export
 */
export const AjaxDashboardRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxDashboardRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUnansweredReplies(options?: RawAxiosRequestConfig): AxiosPromise<UnansweredRepliesDTO> {
            return localVarFp.getUnansweredReplies(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxDashboardRestControllerApi - object-oriented interface
 * @export
 * @class AjaxDashboardRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxDashboardRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDashboardRestControllerApi
     */
    public getUnansweredReplies(options?: RawAxiosRequestConfig) {
        return AjaxDashboardRestControllerApiFp(this.configuration).getUnansweredReplies(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxDiscussionFollowRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxDiscussionFollowRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followDiscussion: async (discussionPublicId: string, surface?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('followDiscussion', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/discussion/{discussionPublicId}/follow`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (surface !== undefined) {
                localVarQueryParameter['surface'] = surface;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscussionFollowState: async (discussionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('getDiscussionFollowState', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/discussion/{discussionPublicId}/follow`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {boolean} [fromNotification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unfollowDiscussion: async (discussionPublicId: string, fromNotification?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('unfollowDiscussion', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/discussion/{discussionPublicId}/follow`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromNotification !== undefined) {
                localVarQueryParameter['fromNotification'] = fromNotification;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxDiscussionFollowRestControllerApi - functional programming interface
 * @export
 */
export const AjaxDiscussionFollowRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxDiscussionFollowRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followDiscussion(discussionPublicId: string, surface?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscussionFollowStateDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followDiscussion(discussionPublicId, surface, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionFollowRestControllerApi.followDiscussion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiscussionFollowState(discussionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscussionFollowStateDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiscussionFollowState(discussionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionFollowRestControllerApi.getDiscussionFollowState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {boolean} [fromNotification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unfollowDiscussion(discussionPublicId: string, fromNotification?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscussionFollowStateDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unfollowDiscussion(discussionPublicId, fromNotification, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionFollowRestControllerApi.unfollowDiscussion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxDiscussionFollowRestControllerApi - factory interface
 * @export
 */
export const AjaxDiscussionFollowRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxDiscussionFollowRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followDiscussion(discussionPublicId: string, surface?: string, options?: RawAxiosRequestConfig): AxiosPromise<DiscussionFollowStateDTO> {
            return localVarFp.followDiscussion(discussionPublicId, surface, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscussionFollowState(discussionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<DiscussionFollowStateDTO> {
            return localVarFp.getDiscussionFollowState(discussionPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {boolean} [fromNotification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unfollowDiscussion(discussionPublicId: string, fromNotification?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DiscussionFollowStateDTO> {
            return localVarFp.unfollowDiscussion(discussionPublicId, fromNotification, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxDiscussionFollowRestControllerApi - object-oriented interface
 * @export
 * @class AjaxDiscussionFollowRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxDiscussionFollowRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} discussionPublicId 
     * @param {string} [surface] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionFollowRestControllerApi
     */
    public followDiscussion(discussionPublicId: string, surface?: string, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionFollowRestControllerApiFp(this.configuration).followDiscussion(discussionPublicId, surface, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionFollowRestControllerApi
     */
    public getDiscussionFollowState(discussionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionFollowRestControllerApiFp(this.configuration).getDiscussionFollowState(discussionPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {boolean} [fromNotification] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionFollowRestControllerApi
     */
    public unfollowDiscussion(discussionPublicId: string, fromNotification?: boolean, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionFollowRestControllerApiFp(this.configuration).unfollowDiscussion(discussionPublicId, fromNotification, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxDiscussionNotificationMuteRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxDiscussionNotificationMuteRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscussionNotificationMute: async (discussionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('getDiscussionNotificationMute', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/discussion/{discussionPublicId}/notification-mute`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        muteDiscussionNotifications: async (discussionPublicId: string, surface?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('muteDiscussionNotifications', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/discussion/{discussionPublicId}/notification-mute`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (surface !== undefined) {
                localVarQueryParameter['surface'] = surface;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmuteDiscussionNotifications: async (discussionPublicId: string, surface?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('unmuteDiscussionNotifications', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/discussion/{discussionPublicId}/notification-mute`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (surface !== undefined) {
                localVarQueryParameter['surface'] = surface;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxDiscussionNotificationMuteRestControllerApi - functional programming interface
 * @export
 */
export const AjaxDiscussionNotificationMuteRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxDiscussionNotificationMuteRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiscussionNotificationMute(discussionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscussionNotificationMuteStateDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiscussionNotificationMute(discussionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionNotificationMuteRestControllerApi.getDiscussionNotificationMute']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async muteDiscussionNotifications(discussionPublicId: string, surface?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscussionNotificationMuteStateDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.muteDiscussionNotifications(discussionPublicId, surface, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionNotificationMuteRestControllerApi.muteDiscussionNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unmuteDiscussionNotifications(discussionPublicId: string, surface?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscussionNotificationMuteStateDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unmuteDiscussionNotifications(discussionPublicId, surface, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionNotificationMuteRestControllerApi.unmuteDiscussionNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxDiscussionNotificationMuteRestControllerApi - factory interface
 * @export
 */
export const AjaxDiscussionNotificationMuteRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxDiscussionNotificationMuteRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscussionNotificationMute(discussionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<DiscussionNotificationMuteStateDTO> {
            return localVarFp.getDiscussionNotificationMute(discussionPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        muteDiscussionNotifications(discussionPublicId: string, surface?: string, options?: RawAxiosRequestConfig): AxiosPromise<DiscussionNotificationMuteStateDTO> {
            return localVarFp.muteDiscussionNotifications(discussionPublicId, surface, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmuteDiscussionNotifications(discussionPublicId: string, surface?: string, options?: RawAxiosRequestConfig): AxiosPromise<DiscussionNotificationMuteStateDTO> {
            return localVarFp.unmuteDiscussionNotifications(discussionPublicId, surface, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxDiscussionNotificationMuteRestControllerApi - object-oriented interface
 * @export
 * @class AjaxDiscussionNotificationMuteRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxDiscussionNotificationMuteRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} discussionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionNotificationMuteRestControllerApi
     */
    public getDiscussionNotificationMute(discussionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionNotificationMuteRestControllerApiFp(this.configuration).getDiscussionNotificationMute(discussionPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {string} [surface] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionNotificationMuteRestControllerApi
     */
    public muteDiscussionNotifications(discussionPublicId: string, surface?: string, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionNotificationMuteRestControllerApiFp(this.configuration).muteDiscussionNotifications(discussionPublicId, surface, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {string} [surface] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionNotificationMuteRestControllerApi
     */
    public unmuteDiscussionNotifications(discussionPublicId: string, surface?: string, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionNotificationMuteRestControllerApiFp(this.configuration).unmuteDiscussionNotifications(discussionPublicId, surface, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxDiscussionRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxDiscussionRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} publicDiscussionId 
         * @param {string} agreementMode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAgreementInDiscussion: async (publicDiscussionId: string, agreementMode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicDiscussionId' is not null or undefined
            assertParamExists('addAgreementInDiscussion', 'publicDiscussionId', publicDiscussionId)
            // verify required parameter 'agreementMode' is not null or undefined
            assertParamExists('addAgreementInDiscussion', 'agreementMode', agreementMode)
            const localVarPath = `/ajax/discussion/participate/{publicDiscussionId}/{agreementMode}`
                .replace(`{${"publicDiscussionId"}}`, encodeURIComponent(String(publicDiscussionId)))
                .replace(`{${"agreementMode"}}`, encodeURIComponent(String(agreementMode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveAddToGroupRequest: async (requestPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestPublicId' is not null or undefined
            assertParamExists('approveAddToGroupRequest', 'requestPublicId', requestPublicId)
            const localVarPath = `/ajax/discussion/request/{requestPublicId}/approve`
                .replace(`{${"requestPublicId"}}`, encodeURIComponent(String(requestPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveDiscussion: async (discussionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('archiveDiscussion', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/discussion/{discussionPublicId}/archive`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorAffinity: async (discussionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('authorAffinity', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/discussion/{discussionPublicId}/author-affinity`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {CountDiscussionViewRequest} [countDiscussionViewRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countView3: async (discussionPublicId: string, countDiscussionViewRequest?: CountDiscussionViewRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('countView3', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/discussion/count_view/{discussionPublicId}`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(countDiscussionViewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} groupPublicId 
         * @param {CreateDiscussionAddToGroupRequest} [createDiscussionAddToGroupRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddToGroupRequest: async (discussionPublicId: string, groupPublicId: string, createDiscussionAddToGroupRequest?: CreateDiscussionAddToGroupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('createAddToGroupRequest', 'discussionPublicId', discussionPublicId)
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('createAddToGroupRequest', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/discussion/{discussionPublicId}/request/group/{groupPublicId}`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)))
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDiscussionAddToGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} publicDiscussionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgreementInDiscussion: async (publicDiscussionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicDiscussionId' is not null or undefined
            assertParamExists('deleteAgreementInDiscussion', 'publicDiscussionId', publicDiscussionId)
            const localVarPath = `/ajax/discussion/participate/{publicDiscussionId}`
                .replace(`{${"publicDiscussionId"}}`, encodeURIComponent(String(publicDiscussionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDiscussion: async (discussionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('deleteDiscussion', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/discussion/{discussionPublicId}`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discussionEmbedSnapshot: async (discussionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('discussionEmbedSnapshot', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/discussion/{discussionPublicId}/embed`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionSlugOrPublicId 
         * @param {string} [fromSeriesPublicId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadDiscussionPageData: async (discussionSlugOrPublicId: string, fromSeriesPublicId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionSlugOrPublicId' is not null or undefined
            assertParamExists('loadDiscussionPageData', 'discussionSlugOrPublicId', discussionSlugOrPublicId)
            const localVarPath = `/ajax/discussion/page-data/{discussionSlugOrPublicId}`
                .replace(`{${"discussionSlugOrPublicId"}}`, encodeURIComponent(String(discussionSlugOrPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromSeriesPublicId !== undefined) {
                localVarQueryParameter['fromSeriesPublicId'] = fromSeriesPublicId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} source 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadGroupsModal: async (discussionPublicId: string, source: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('loadGroupsModal', 'discussionPublicId', discussionPublicId)
            // verify required parameter 'source' is not null or undefined
            assertParamExists('loadGroupsModal', 'source', source)
            const localVarPath = `/ajax/discussion/{discussionPublicId}/groups`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadGroupsModalBootstrap: async (discussionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('loadGroupsModalBootstrap', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/discussion/{discussionPublicId}/groups/modal-bootstrap`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadOwnVersionHistory: async (discussionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('loadOwnVersionHistory', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/discussion/{discussionPublicId}/versions`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadSeriesToAddDiscussionTo: async (discussionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('loadSeriesToAddDiscussionTo', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/discussion/{discussionPublicId}/series`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PublishShortPostRequest} publishShortPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishShortPost: async (publishShortPostRequest: PublishShortPostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publishShortPostRequest' is not null or undefined
            assertParamExists('publishShortPost', 'publishShortPostRequest', publishShortPostRequest)
            const localVarPath = `/ajax/discussion/short`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publishShortPostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionSlugOrPublicId 
         * @param {number} [cutoffQuoteId] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotedByDiscussions: async (discussionSlugOrPublicId: string, cutoffQuoteId?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionSlugOrPublicId' is not null or undefined
            assertParamExists('quotedByDiscussions', 'discussionSlugOrPublicId', discussionSlugOrPublicId)
            const localVarPath = `/ajax/discussion/{discussionSlugOrPublicId}/quoted-by`
                .replace(`{${"discussionSlugOrPublicId"}}`, encodeURIComponent(String(discussionSlugOrPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cutoffQuoteId !== undefined) {
                localVarQueryParameter['cutoffQuoteId'] = cutoffQuoteId;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {MediaAttentionRequest} [mediaAttentionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordMediaAttention: async (discussionPublicId: string, mediaAttentionRequest?: MediaAttentionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('recordMediaAttention', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/discussion/{discussionPublicId}/media_attention`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mediaAttentionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {ReadCompletionRequest} readCompletionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordReadCompletion: async (discussionPublicId: string, readCompletionRequest: ReadCompletionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('recordReadCompletion', 'discussionPublicId', discussionPublicId)
            // verify required parameter 'readCompletionRequest' is not null or undefined
            assertParamExists('recordReadCompletion', 'readCompletionRequest', readCompletionRequest)
            const localVarPath = `/ajax/discussion/{discussionPublicId}/read_complete`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(readCompletionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {RejectDiscussionRequestRequest} [rejectDiscussionRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectAddToGroupRequest: async (requestPublicId: string, rejectDiscussionRequestRequest?: RejectDiscussionRequestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestPublicId' is not null or undefined
            assertParamExists('rejectAddToGroupRequest', 'requestPublicId', requestPublicId)
            const localVarPath = `/ajax/discussion/request/{requestPublicId}/reject`
                .replace(`{${"requestPublicId"}}`, encodeURIComponent(String(requestPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rejectDiscussionRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {CreateContentReportRequest} createContentReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportDiscussion: async (discussionPublicId: string, createContentReportRequest: CreateContentReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('reportDiscussion', 'discussionPublicId', discussionPublicId)
            // verify required parameter 'createContentReportRequest' is not null or undefined
            assertParamExists('reportDiscussion', 'createContentReportRequest', createContentReportRequest)
            const localVarPath = `/ajax/discussion/{discussionPublicId}/report`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createContentReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreOwnDeletedDiscussion: async (discussionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('restoreOwnDeletedDiscussion', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/discussion/{discussionPublicId}/restore`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unarchiveDiscussion: async (discussionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('unarchiveDiscussion', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/discussion/{discussionPublicId}/unarchive`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxDiscussionRestControllerApi - functional programming interface
 * @export
 */
export const AjaxDiscussionRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxDiscussionRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} publicDiscussionId 
         * @param {string} agreementMode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAgreementInDiscussion(publicDiscussionId: string, agreementMode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAgreementInDiscussion(publicDiscussionId, agreementMode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionRestControllerApi.addAgreementInDiscussion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveAddToGroupRequest(requestPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveAddToGroupRequest(requestPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionRestControllerApi.approveAddToGroupRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveDiscussion(discussionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscussionArchiveStateDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveDiscussion(discussionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionRestControllerApi.archiveDiscussion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authorAffinity(discussionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorAffinityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authorAffinity(discussionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionRestControllerApi.authorAffinity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {CountDiscussionViewRequest} [countDiscussionViewRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countView3(discussionPublicId: string, countDiscussionViewRequest?: CountDiscussionViewRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countView3(discussionPublicId, countDiscussionViewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionRestControllerApi.countView3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} groupPublicId 
         * @param {CreateDiscussionAddToGroupRequest} [createDiscussionAddToGroupRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAddToGroupRequest(discussionPublicId: string, groupPublicId: string, createDiscussionAddToGroupRequest?: CreateDiscussionAddToGroupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAddToGroupRequest(discussionPublicId, groupPublicId, createDiscussionAddToGroupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionRestControllerApi.createAddToGroupRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} publicDiscussionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAgreementInDiscussion(publicDiscussionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAgreementInDiscussion(publicDiscussionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionRestControllerApi.deleteAgreementInDiscussion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDiscussion(discussionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDiscussion(discussionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionRestControllerApi.deleteDiscussion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discussionEmbedSnapshot(discussionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscussionEmbedSnapshotDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discussionEmbedSnapshot(discussionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionRestControllerApi.discussionEmbedSnapshot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionSlugOrPublicId 
         * @param {string} [fromSeriesPublicId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadDiscussionPageData(discussionSlugOrPublicId: string, fromSeriesPublicId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscussionPageDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadDiscussionPageData(discussionSlugOrPublicId, fromSeriesPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionRestControllerApi.loadDiscussionPageData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} source 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadGroupsModal(discussionPublicId: string, source: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupsToAddDiscussionToDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadGroupsModal(discussionPublicId, source, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionRestControllerApi.loadGroupsModal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadGroupsModalBootstrap(discussionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupsToAddDiscussionModalBootstrapDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadGroupsModalBootstrap(discussionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionRestControllerApi.loadGroupsModalBootstrap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadOwnVersionHistory(discussionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiscussionVersionSummaryDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadOwnVersionHistory(discussionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionRestControllerApi.loadOwnVersionHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadSeriesToAddDiscussionTo(discussionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SeriesToAddDiscussionTo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadSeriesToAddDiscussionTo(discussionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionRestControllerApi.loadSeriesToAddDiscussionTo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PublishShortPostRequest} publishShortPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishShortPost(publishShortPostRequest: PublishShortPostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublishShortPostResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishShortPost(publishShortPostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionRestControllerApi.publishShortPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionSlugOrPublicId 
         * @param {number} [cutoffQuoteId] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quotedByDiscussions(discussionSlugOrPublicId: string, cutoffQuoteId?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiscussionWithoutContentDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quotedByDiscussions(discussionSlugOrPublicId, cutoffQuoteId, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionRestControllerApi.quotedByDiscussions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {MediaAttentionRequest} [mediaAttentionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordMediaAttention(discussionPublicId: string, mediaAttentionRequest?: MediaAttentionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordMediaAttention(discussionPublicId, mediaAttentionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionRestControllerApi.recordMediaAttention']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {ReadCompletionRequest} readCompletionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordReadCompletion(discussionPublicId: string, readCompletionRequest: ReadCompletionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordReadCompletion(discussionPublicId, readCompletionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionRestControllerApi.recordReadCompletion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {RejectDiscussionRequestRequest} [rejectDiscussionRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectAddToGroupRequest(requestPublicId: string, rejectDiscussionRequestRequest?: RejectDiscussionRequestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectAddToGroupRequest(requestPublicId, rejectDiscussionRequestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionRestControllerApi.rejectAddToGroupRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {CreateContentReportRequest} createContentReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportDiscussion(discussionPublicId: string, createContentReportRequest: CreateContentReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportDiscussion(discussionPublicId, createContentReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionRestControllerApi.reportDiscussion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreOwnDeletedDiscussion(discussionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreOwnDeletedDiscussion(discussionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionRestControllerApi.restoreOwnDeletedDiscussion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unarchiveDiscussion(discussionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscussionArchiveStateDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unarchiveDiscussion(discussionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDiscussionRestControllerApi.unarchiveDiscussion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxDiscussionRestControllerApi - factory interface
 * @export
 */
export const AjaxDiscussionRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxDiscussionRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} publicDiscussionId 
         * @param {string} agreementMode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAgreementInDiscussion(publicDiscussionId: string, agreementMode: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.addAgreementInDiscussion(publicDiscussionId, agreementMode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveAddToGroupRequest(requestPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.approveAddToGroupRequest(requestPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveDiscussion(discussionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<DiscussionArchiveStateDTO> {
            return localVarFp.archiveDiscussion(discussionPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authorAffinity(discussionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<AuthorAffinityResponse> {
            return localVarFp.authorAffinity(discussionPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {CountDiscussionViewRequest} [countDiscussionViewRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countView3(discussionPublicId: string, countDiscussionViewRequest?: CountDiscussionViewRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.countView3(discussionPublicId, countDiscussionViewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} groupPublicId 
         * @param {CreateDiscussionAddToGroupRequest} [createDiscussionAddToGroupRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddToGroupRequest(discussionPublicId: string, groupPublicId: string, createDiscussionAddToGroupRequest?: CreateDiscussionAddToGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createAddToGroupRequest(discussionPublicId, groupPublicId, createDiscussionAddToGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} publicDiscussionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAgreementInDiscussion(publicDiscussionId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.deleteAgreementInDiscussion(publicDiscussionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDiscussion(discussionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDiscussion(discussionPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discussionEmbedSnapshot(discussionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<DiscussionEmbedSnapshotDTO> {
            return localVarFp.discussionEmbedSnapshot(discussionPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionSlugOrPublicId 
         * @param {string} [fromSeriesPublicId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadDiscussionPageData(discussionSlugOrPublicId: string, fromSeriesPublicId?: string, options?: RawAxiosRequestConfig): AxiosPromise<DiscussionPageDataResponse> {
            return localVarFp.loadDiscussionPageData(discussionSlugOrPublicId, fromSeriesPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} source 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadGroupsModal(discussionPublicId: string, source: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupsToAddDiscussionToDTO>> {
            return localVarFp.loadGroupsModal(discussionPublicId, source, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadGroupsModalBootstrap(discussionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<GroupsToAddDiscussionModalBootstrapDTO> {
            return localVarFp.loadGroupsModalBootstrap(discussionPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadOwnVersionHistory(discussionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DiscussionVersionSummaryDTO>> {
            return localVarFp.loadOwnVersionHistory(discussionPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadSeriesToAddDiscussionTo(discussionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SeriesToAddDiscussionTo>> {
            return localVarFp.loadSeriesToAddDiscussionTo(discussionPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PublishShortPostRequest} publishShortPostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishShortPost(publishShortPostRequest: PublishShortPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PublishShortPostResponse> {
            return localVarFp.publishShortPost(publishShortPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionSlugOrPublicId 
         * @param {number} [cutoffQuoteId] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotedByDiscussions(discussionSlugOrPublicId: string, cutoffQuoteId?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<DiscussionWithoutContentDTO>> {
            return localVarFp.quotedByDiscussions(discussionSlugOrPublicId, cutoffQuoteId, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {MediaAttentionRequest} [mediaAttentionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordMediaAttention(discussionPublicId: string, mediaAttentionRequest?: MediaAttentionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.recordMediaAttention(discussionPublicId, mediaAttentionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {ReadCompletionRequest} readCompletionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordReadCompletion(discussionPublicId: string, readCompletionRequest: ReadCompletionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.recordReadCompletion(discussionPublicId, readCompletionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {RejectDiscussionRequestRequest} [rejectDiscussionRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectAddToGroupRequest(requestPublicId: string, rejectDiscussionRequestRequest?: RejectDiscussionRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rejectAddToGroupRequest(requestPublicId, rejectDiscussionRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {CreateContentReportRequest} createContentReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportDiscussion(discussionPublicId: string, createContentReportRequest: CreateContentReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reportDiscussion(discussionPublicId, createContentReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreOwnDeletedDiscussion(discussionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.restoreOwnDeletedDiscussion(discussionPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unarchiveDiscussion(discussionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<DiscussionArchiveStateDTO> {
            return localVarFp.unarchiveDiscussion(discussionPublicId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxDiscussionRestControllerApi - object-oriented interface
 * @export
 * @class AjaxDiscussionRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxDiscussionRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} publicDiscussionId 
     * @param {string} agreementMode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionRestControllerApi
     */
    public addAgreementInDiscussion(publicDiscussionId: string, agreementMode: string, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionRestControllerApiFp(this.configuration).addAgreementInDiscussion(publicDiscussionId, agreementMode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} requestPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionRestControllerApi
     */
    public approveAddToGroupRequest(requestPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionRestControllerApiFp(this.configuration).approveAddToGroupRequest(requestPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionRestControllerApi
     */
    public archiveDiscussion(discussionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionRestControllerApiFp(this.configuration).archiveDiscussion(discussionPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionRestControllerApi
     */
    public authorAffinity(discussionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionRestControllerApiFp(this.configuration).authorAffinity(discussionPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {CountDiscussionViewRequest} [countDiscussionViewRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionRestControllerApi
     */
    public countView3(discussionPublicId: string, countDiscussionViewRequest?: CountDiscussionViewRequest, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionRestControllerApiFp(this.configuration).countView3(discussionPublicId, countDiscussionViewRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {string} groupPublicId 
     * @param {CreateDiscussionAddToGroupRequest} [createDiscussionAddToGroupRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionRestControllerApi
     */
    public createAddToGroupRequest(discussionPublicId: string, groupPublicId: string, createDiscussionAddToGroupRequest?: CreateDiscussionAddToGroupRequest, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionRestControllerApiFp(this.configuration).createAddToGroupRequest(discussionPublicId, groupPublicId, createDiscussionAddToGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} publicDiscussionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionRestControllerApi
     */
    public deleteAgreementInDiscussion(publicDiscussionId: string, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionRestControllerApiFp(this.configuration).deleteAgreementInDiscussion(publicDiscussionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionRestControllerApi
     */
    public deleteDiscussion(discussionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionRestControllerApiFp(this.configuration).deleteDiscussion(discussionPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionRestControllerApi
     */
    public discussionEmbedSnapshot(discussionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionRestControllerApiFp(this.configuration).discussionEmbedSnapshot(discussionPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionSlugOrPublicId 
     * @param {string} [fromSeriesPublicId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionRestControllerApi
     */
    public loadDiscussionPageData(discussionSlugOrPublicId: string, fromSeriesPublicId?: string, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionRestControllerApiFp(this.configuration).loadDiscussionPageData(discussionSlugOrPublicId, fromSeriesPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {string} source 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionRestControllerApi
     */
    public loadGroupsModal(discussionPublicId: string, source: string, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionRestControllerApiFp(this.configuration).loadGroupsModal(discussionPublicId, source, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionRestControllerApi
     */
    public loadGroupsModalBootstrap(discussionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionRestControllerApiFp(this.configuration).loadGroupsModalBootstrap(discussionPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionRestControllerApi
     */
    public loadOwnVersionHistory(discussionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionRestControllerApiFp(this.configuration).loadOwnVersionHistory(discussionPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionRestControllerApi
     */
    public loadSeriesToAddDiscussionTo(discussionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionRestControllerApiFp(this.configuration).loadSeriesToAddDiscussionTo(discussionPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PublishShortPostRequest} publishShortPostRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionRestControllerApi
     */
    public publishShortPost(publishShortPostRequest: PublishShortPostRequest, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionRestControllerApiFp(this.configuration).publishShortPost(publishShortPostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionSlugOrPublicId 
     * @param {number} [cutoffQuoteId] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionRestControllerApi
     */
    public quotedByDiscussions(discussionSlugOrPublicId: string, cutoffQuoteId?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionRestControllerApiFp(this.configuration).quotedByDiscussions(discussionSlugOrPublicId, cutoffQuoteId, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {MediaAttentionRequest} [mediaAttentionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionRestControllerApi
     */
    public recordMediaAttention(discussionPublicId: string, mediaAttentionRequest?: MediaAttentionRequest, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionRestControllerApiFp(this.configuration).recordMediaAttention(discussionPublicId, mediaAttentionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {ReadCompletionRequest} readCompletionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionRestControllerApi
     */
    public recordReadCompletion(discussionPublicId: string, readCompletionRequest: ReadCompletionRequest, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionRestControllerApiFp(this.configuration).recordReadCompletion(discussionPublicId, readCompletionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} requestPublicId 
     * @param {RejectDiscussionRequestRequest} [rejectDiscussionRequestRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionRestControllerApi
     */
    public rejectAddToGroupRequest(requestPublicId: string, rejectDiscussionRequestRequest?: RejectDiscussionRequestRequest, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionRestControllerApiFp(this.configuration).rejectAddToGroupRequest(requestPublicId, rejectDiscussionRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {CreateContentReportRequest} createContentReportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionRestControllerApi
     */
    public reportDiscussion(discussionPublicId: string, createContentReportRequest: CreateContentReportRequest, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionRestControllerApiFp(this.configuration).reportDiscussion(discussionPublicId, createContentReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionRestControllerApi
     */
    public restoreOwnDeletedDiscussion(discussionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionRestControllerApiFp(this.configuration).restoreOwnDeletedDiscussion(discussionPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDiscussionRestControllerApi
     */
    public unarchiveDiscussion(discussionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxDiscussionRestControllerApiFp(this.configuration).unarchiveDiscussion(discussionPublicId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxDistinctionRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxDistinctionRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DismissDistinctionCelebrationRequest} dismissDistinctionCelebrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissCelebration: async (dismissDistinctionCelebrationRequest: DismissDistinctionCelebrationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dismissDistinctionCelebrationRequest' is not null or undefined
            assertParamExists('dismissCelebration', 'dismissDistinctionCelebrationRequest', dismissDistinctionCelebrationRequest)
            const localVarPath = `/ajax/user/distinctions/celebration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dismissDistinctionCelebrationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCelebration: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/user/distinctions/celebration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxDistinctionRestControllerApi - functional programming interface
 * @export
 */
export const AjaxDistinctionRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxDistinctionRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {DismissDistinctionCelebrationRequest} dismissDistinctionCelebrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dismissCelebration(dismissDistinctionCelebrationRequest: DismissDistinctionCelebrationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DismissDistinctionCelebrationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dismissCelebration(dismissDistinctionCelebrationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDistinctionRestControllerApi.dismissCelebration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCelebration(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DistinctionCelebrationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCelebration(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxDistinctionRestControllerApi.getCelebration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxDistinctionRestControllerApi - factory interface
 * @export
 */
export const AjaxDistinctionRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxDistinctionRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {DismissDistinctionCelebrationRequest} dismissDistinctionCelebrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissCelebration(dismissDistinctionCelebrationRequest: DismissDistinctionCelebrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<DismissDistinctionCelebrationResponse> {
            return localVarFp.dismissCelebration(dismissDistinctionCelebrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCelebration(options?: RawAxiosRequestConfig): AxiosPromise<DistinctionCelebrationResponse> {
            return localVarFp.getCelebration(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxDistinctionRestControllerApi - object-oriented interface
 * @export
 * @class AjaxDistinctionRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxDistinctionRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {DismissDistinctionCelebrationRequest} dismissDistinctionCelebrationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDistinctionRestControllerApi
     */
    public dismissCelebration(dismissDistinctionCelebrationRequest: DismissDistinctionCelebrationRequest, options?: RawAxiosRequestConfig) {
        return AjaxDistinctionRestControllerApiFp(this.configuration).dismissCelebration(dismissDistinctionCelebrationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxDistinctionRestControllerApi
     */
    public getCelebration(options?: RawAxiosRequestConfig) {
        return AjaxDistinctionRestControllerApiFp(this.configuration).getCelebration(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxEndorsementRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxEndorsementRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} thoughtPublicId 
         * @param {EndorseThoughtRequest} endorseThoughtRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endorse: async (thoughtPublicId: string, endorseThoughtRequest: EndorseThoughtRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'thoughtPublicId' is not null or undefined
            assertParamExists('endorse', 'thoughtPublicId', thoughtPublicId)
            // verify required parameter 'endorseThoughtRequest' is not null or undefined
            assertParamExists('endorse', 'endorseThoughtRequest', endorseThoughtRequest)
            const localVarPath = `/ajax/endorsement/{thoughtPublicId}`
                .replace(`{${"thoughtPublicId"}}`, encodeURIComponent(String(thoughtPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(endorseThoughtRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} thoughtPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (thoughtPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'thoughtPublicId' is not null or undefined
            assertParamExists('remove', 'thoughtPublicId', thoughtPublicId)
            const localVarPath = `/ajax/endorsement/{thoughtPublicId}`
                .replace(`{${"thoughtPublicId"}}`, encodeURIComponent(String(thoughtPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxEndorsementRestControllerApi - functional programming interface
 * @export
 */
export const AjaxEndorsementRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxEndorsementRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} thoughtPublicId 
         * @param {EndorseThoughtRequest} endorseThoughtRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async endorse(thoughtPublicId: string, endorseThoughtRequest: EndorseThoughtRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThoughtEndorsementSummaryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.endorse(thoughtPublicId, endorseThoughtRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxEndorsementRestControllerApi.endorse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} thoughtPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(thoughtPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThoughtEndorsementSummaryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(thoughtPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxEndorsementRestControllerApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxEndorsementRestControllerApi - factory interface
 * @export
 */
export const AjaxEndorsementRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxEndorsementRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} thoughtPublicId 
         * @param {EndorseThoughtRequest} endorseThoughtRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        endorse(thoughtPublicId: string, endorseThoughtRequest: EndorseThoughtRequest, options?: RawAxiosRequestConfig): AxiosPromise<ThoughtEndorsementSummaryDTO> {
            return localVarFp.endorse(thoughtPublicId, endorseThoughtRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} thoughtPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(thoughtPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<ThoughtEndorsementSummaryDTO> {
            return localVarFp.remove(thoughtPublicId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxEndorsementRestControllerApi - object-oriented interface
 * @export
 * @class AjaxEndorsementRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxEndorsementRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} thoughtPublicId 
     * @param {EndorseThoughtRequest} endorseThoughtRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxEndorsementRestControllerApi
     */
    public endorse(thoughtPublicId: string, endorseThoughtRequest: EndorseThoughtRequest, options?: RawAxiosRequestConfig) {
        return AjaxEndorsementRestControllerApiFp(this.configuration).endorse(thoughtPublicId, endorseThoughtRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} thoughtPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxEndorsementRestControllerApi
     */
    public remove(thoughtPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxEndorsementRestControllerApiFp(this.configuration).remove(thoughtPublicId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxExperimentRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxExperimentRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ExposureRequest} exposureRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordExposure: async (exposureRequest: ExposureRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exposureRequest' is not null or undefined
            assertParamExists('recordExposure', 'exposureRequest', exposureRequest)
            const localVarPath = `/ajax/experiments/exposure`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exposureRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxExperimentRestControllerApi - functional programming interface
 * @export
 */
export const AjaxExperimentRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxExperimentRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ExposureRequest} exposureRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordExposure(exposureRequest: ExposureRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordExposure(exposureRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxExperimentRestControllerApi.recordExposure']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxExperimentRestControllerApi - factory interface
 * @export
 */
export const AjaxExperimentRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxExperimentRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {ExposureRequest} exposureRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordExposure(exposureRequest: ExposureRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.recordExposure(exposureRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxExperimentRestControllerApi - object-oriented interface
 * @export
 * @class AjaxExperimentRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxExperimentRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {ExposureRequest} exposureRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxExperimentRestControllerApi
     */
    public recordExposure(exposureRequest: ExposureRequest, options?: RawAxiosRequestConfig) {
        return AjaxExperimentRestControllerApiFp(this.configuration).recordExposure(exposureRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxFeedClickRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxFeedClickRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {FeedClickRequest} feedClickRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordFeedClick: async (feedClickRequest: FeedClickRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'feedClickRequest' is not null or undefined
            assertParamExists('recordFeedClick', 'feedClickRequest', feedClickRequest)
            const localVarPath = `/ajax/feed/click`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(feedClickRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxFeedClickRestControllerApi - functional programming interface
 * @export
 */
export const AjaxFeedClickRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxFeedClickRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {FeedClickRequest} feedClickRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordFeedClick(feedClickRequest: FeedClickRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordFeedClick(feedClickRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxFeedClickRestControllerApi.recordFeedClick']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxFeedClickRestControllerApi - factory interface
 * @export
 */
export const AjaxFeedClickRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxFeedClickRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {FeedClickRequest} feedClickRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordFeedClick(feedClickRequest: FeedClickRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.recordFeedClick(feedClickRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxFeedClickRestControllerApi - object-oriented interface
 * @export
 * @class AjaxFeedClickRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxFeedClickRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {FeedClickRequest} feedClickRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxFeedClickRestControllerApi
     */
    public recordFeedClick(feedClickRequest: FeedClickRequest, options?: RawAxiosRequestConfig) {
        return AjaxFeedClickRestControllerApiFp(this.configuration).recordFeedClick(feedClickRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxFeedSnapshotTestSupportRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxFeedSnapshotTestSupportRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actor: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('actor', 'username', username)
            const localVarPath = `/ajax/test-support/feed-snapshot/actor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/test-support/feed-snapshot/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxFeedSnapshotTestSupportRestControllerApi - functional programming interface
 * @export
 */
export const AjaxFeedSnapshotTestSupportRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxFeedSnapshotTestSupportRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actor(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actor(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxFeedSnapshotTestSupportRestControllerApi.actor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refresh(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refresh(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxFeedSnapshotTestSupportRestControllerApi.refresh']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxFeedSnapshotTestSupportRestControllerApi - factory interface
 * @export
 */
export const AjaxFeedSnapshotTestSupportRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxFeedSnapshotTestSupportRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actor(username: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.actor(username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.refresh(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxFeedSnapshotTestSupportRestControllerApi - object-oriented interface
 * @export
 * @class AjaxFeedSnapshotTestSupportRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxFeedSnapshotTestSupportRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxFeedSnapshotTestSupportRestControllerApi
     */
    public actor(username: string, options?: RawAxiosRequestConfig) {
        return AjaxFeedSnapshotTestSupportRestControllerApiFp(this.configuration).actor(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxFeedSnapshotTestSupportRestControllerApi
     */
    public refresh(options?: RawAxiosRequestConfig) {
        return AjaxFeedSnapshotTestSupportRestControllerApiFp(this.configuration).refresh(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxFormRefusalSignalRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxFormRefusalSignalRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {FormRefusalSignalRequest} [formRefusalSignalRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formRefusalSignal: async (formRefusalSignalRequest?: FormRefusalSignalRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/form/refusal_signal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(formRefusalSignalRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxFormRefusalSignalRestControllerApi - functional programming interface
 * @export
 */
export const AjaxFormRefusalSignalRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxFormRefusalSignalRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {FormRefusalSignalRequest} [formRefusalSignalRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async formRefusalSignal(formRefusalSignalRequest?: FormRefusalSignalRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.formRefusalSignal(formRefusalSignalRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxFormRefusalSignalRestControllerApi.formRefusalSignal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxFormRefusalSignalRestControllerApi - factory interface
 * @export
 */
export const AjaxFormRefusalSignalRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxFormRefusalSignalRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {FormRefusalSignalRequest} [formRefusalSignalRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        formRefusalSignal(formRefusalSignalRequest?: FormRefusalSignalRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.formRefusalSignal(formRefusalSignalRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxFormRefusalSignalRestControllerApi - object-oriented interface
 * @export
 * @class AjaxFormRefusalSignalRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxFormRefusalSignalRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {FormRefusalSignalRequest} [formRefusalSignalRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxFormRefusalSignalRestControllerApi
     */
    public formRefusalSignal(formRefusalSignalRequest?: FormRefusalSignalRequest, options?: RawAxiosRequestConfig) {
        return AjaxFormRefusalSignalRestControllerApiFp(this.configuration).formRefusalSignal(formRefusalSignalRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxGroupBoardRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxGroupBoardRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} messagePublicId 
         * @param {UpdateGroupBoardMessageRequest} updateGroupBoardMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editMessage: async (groupPublicId: string, messagePublicId: string, updateGroupBoardMessageRequest: UpdateGroupBoardMessageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('editMessage', 'groupPublicId', groupPublicId)
            // verify required parameter 'messagePublicId' is not null or undefined
            assertParamExists('editMessage', 'messagePublicId', messagePublicId)
            // verify required parameter 'updateGroupBoardMessageRequest' is not null or undefined
            assertParamExists('editMessage', 'updateGroupBoardMessageRequest', updateGroupBoardMessageRequest)
            const localVarPath = `/ajax/group/{groupPublicId}/board/messages/{messagePublicId}`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"messagePublicId"}}`, encodeURIComponent(String(messagePublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGroupBoardMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoard: async (groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('getBoard', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/board`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liftMemberRestriction: async (groupPublicId: string, username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('liftMemberRestriction', 'groupPublicId', groupPublicId)
            // verify required parameter 'username' is not null or undefined
            assertParamExists('liftMemberRestriction', 'username', username)
            const localVarPath = `/ajax/group/{groupPublicId}/board/members/{username}/restriction`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [cursor] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMessages: async (groupPublicId: string, cursor?: string, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('listMessages', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/board/messages`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} [beforeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listModerationLog: async (groupPublicId: string, beforeId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('listModerationLog', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/moderation/log`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (beforeId !== undefined) {
                localVarQueryParameter['beforeId'] = beforeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpenReports: async (groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('listOpenReports', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/moderation/reports`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} messagePublicId 
         * @param {string} [cursor] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReplies: async (groupPublicId: string, messagePublicId: string, cursor?: string, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('listReplies', 'groupPublicId', groupPublicId)
            // verify required parameter 'messagePublicId' is not null or undefined
            assertParamExists('listReplies', 'messagePublicId', messagePublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/board/messages/{messagePublicId}/replies`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"messagePublicId"}}`, encodeURIComponent(String(messagePublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRestrictions: async (groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('listRestrictions', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/board/restrictions`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockBoard: async (groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('lockBoard', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/board/lock`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markRead: async (groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('markRead', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/board/read`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mentionSuggestions: async (groupPublicId: string, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('mentionSuggestions', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/board/mention-suggestions`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} messagePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinMessage: async (groupPublicId: string, messagePublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('pinMessage', 'groupPublicId', groupPublicId)
            // verify required parameter 'messagePublicId' is not null or undefined
            assertParamExists('pinMessage', 'messagePublicId', messagePublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/board/messages/{messagePublicId}/pin`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"messagePublicId"}}`, encodeURIComponent(String(messagePublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {CreateGroupBoardMessageRequest} createGroupBoardMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMessage: async (groupPublicId: string, createGroupBoardMessageRequest: CreateGroupBoardMessageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('postMessage', 'groupPublicId', groupPublicId)
            // verify required parameter 'createGroupBoardMessageRequest' is not null or undefined
            assertParamExists('postMessage', 'createGroupBoardMessageRequest', createGroupBoardMessageRequest)
            const localVarPath = `/ajax/group/{groupPublicId}/board/messages`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGroupBoardMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} messagePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoteMessage: async (groupPublicId: string, messagePublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('promoteMessage', 'groupPublicId', groupPublicId)
            // verify required parameter 'messagePublicId' is not null or undefined
            assertParamExists('promoteMessage', 'messagePublicId', messagePublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/board/messages/{messagePublicId}/promote`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"messagePublicId"}}`, encodeURIComponent(String(messagePublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} username 
         * @param {PurgeMemberMessagesWindowEnum} [window] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purgeMemberMessages: async (groupPublicId: string, username: string, window?: PurgeMemberMessagesWindowEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('purgeMemberMessages', 'groupPublicId', groupPublicId)
            // verify required parameter 'username' is not null or undefined
            assertParamExists('purgeMemberMessages', 'username', username)
            const localVarPath = `/ajax/group/{groupPublicId}/board/members/{username}/purge`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (window !== undefined) {
                localVarQueryParameter['window'] = window;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} messagePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMessage: async (groupPublicId: string, messagePublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('removeMessage', 'groupPublicId', groupPublicId)
            // verify required parameter 'messagePublicId' is not null or undefined
            assertParamExists('removeMessage', 'messagePublicId', messagePublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/board/messages/{messagePublicId}`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"messagePublicId"}}`, encodeURIComponent(String(messagePublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} messagePublicId 
         * @param {string} outcome 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveReports: async (groupPublicId: string, messagePublicId: string, outcome: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('resolveReports', 'groupPublicId', groupPublicId)
            // verify required parameter 'messagePublicId' is not null or undefined
            assertParamExists('resolveReports', 'messagePublicId', messagePublicId)
            // verify required parameter 'outcome' is not null or undefined
            assertParamExists('resolveReports', 'outcome', outcome)
            const localVarPath = `/ajax/group/{groupPublicId}/moderation/reports/{messagePublicId}/resolve`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"messagePublicId"}}`, encodeURIComponent(String(messagePublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (outcome !== undefined) {
                localVarQueryParameter['outcome'] = outcome;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} username 
         * @param {RestrictMemberDurationEnum} duration 
         * @param {RestrictMemberReasonTypeEnum} [reasonType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restrictMember: async (groupPublicId: string, username: string, duration: RestrictMemberDurationEnum, reasonType?: RestrictMemberReasonTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('restrictMember', 'groupPublicId', groupPublicId)
            // verify required parameter 'username' is not null or undefined
            assertParamExists('restrictMember', 'username', username)
            // verify required parameter 'duration' is not null or undefined
            assertParamExists('restrictMember', 'duration', duration)
            const localVarPath = `/ajax/group/{groupPublicId}/board/members/{username}/restriction`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (duration !== undefined) {
                localVarQueryParameter['duration'] = duration;
            }

            if (reasonType !== undefined) {
                localVarQueryParameter['reasonType'] = reasonType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {UpdateGroupWelcomeMessageRequest} updateGroupWelcomeMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWelcome: async (groupPublicId: string, updateGroupWelcomeMessageRequest: UpdateGroupWelcomeMessageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('saveWelcome', 'groupPublicId', groupPublicId)
            // verify required parameter 'updateGroupWelcomeMessageRequest' is not null or undefined
            assertParamExists('saveWelcome', 'updateGroupWelcomeMessageRequest', updateGroupWelcomeMessageRequest)
            const localVarPath = `/ajax/group/{groupPublicId}/board/welcome`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGroupWelcomeMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMessages: async (groupPublicId: string, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('searchMessages', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/board/search`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {boolean} enabled 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setImagesEnabled: async (groupPublicId: string, enabled: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('setImagesEnabled', 'groupPublicId', groupPublicId)
            // verify required parameter 'enabled' is not null or undefined
            assertParamExists('setImagesEnabled', 'enabled', enabled)
            const localVarPath = `/ajax/group/{groupPublicId}/board/images`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (enabled !== undefined) {
                localVarQueryParameter['enabled'] = enabled;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {boolean} muted 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMuted: async (groupPublicId: string, muted: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('setMuted', 'groupPublicId', groupPublicId)
            // verify required parameter 'muted' is not null or undefined
            assertParamExists('setMuted', 'muted', muted)
            const localVarPath = `/ajax/group/{groupPublicId}/board/mute`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (muted !== undefined) {
                localVarQueryParameter['muted'] = muted;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GroupBoardBulkMuteRequest} groupBoardBulkMuteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMutedForGroups: async (groupBoardBulkMuteRequest: GroupBoardBulkMuteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupBoardBulkMuteRequest' is not null or undefined
            assertParamExists('setMutedForGroups', 'groupBoardBulkMuteRequest', groupBoardBulkMuteRequest)
            const localVarPath = `/ajax/group/boards/mute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groupBoardBulkMuteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {SetPostingPolicyPolicyEnum} policy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPostingPolicy: async (groupPublicId: string, policy: SetPostingPolicyPolicyEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('setPostingPolicy', 'groupPublicId', groupPublicId)
            // verify required parameter 'policy' is not null or undefined
            assertParamExists('setPostingPolicy', 'policy', policy)
            const localVarPath = `/ajax/group/{groupPublicId}/board/posting-policy`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (policy !== undefined) {
                localVarQueryParameter['policy'] = policy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} seconds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSlowMode: async (groupPublicId: string, seconds: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('setSlowMode', 'groupPublicId', groupPublicId)
            // verify required parameter 'seconds' is not null or undefined
            assertParamExists('setSlowMode', 'seconds', seconds)
            const localVarPath = `/ajax/group/{groupPublicId}/board/slow-mode`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (seconds !== undefined) {
                localVarQueryParameter['seconds'] = seconds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockBoard: async (groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('unlockBoard', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/board/lock`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} messagePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unpinMessage: async (groupPublicId: string, messagePublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('unpinMessage', 'groupPublicId', groupPublicId)
            // verify required parameter 'messagePublicId' is not null or undefined
            assertParamExists('unpinMessage', 'messagePublicId', messagePublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/board/messages/{messagePublicId}/pin`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"messagePublicId"}}`, encodeURIComponent(String(messagePublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxGroupBoardRestControllerApi - functional programming interface
 * @export
 */
export const AjaxGroupBoardRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxGroupBoardRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} messagePublicId 
         * @param {UpdateGroupBoardMessageRequest} updateGroupBoardMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editMessage(groupPublicId: string, messagePublicId: string, updateGroupBoardMessageRequest: UpdateGroupBoardMessageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupBoardMessageDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editMessage(groupPublicId, messagePublicId, updateGroupBoardMessageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupBoardRestControllerApi.editMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBoard(groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupBoardViewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBoard(groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupBoardRestControllerApi.getBoard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async liftMemberRestriction(groupPublicId: string, username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.liftMemberRestriction(groupPublicId, username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupBoardRestControllerApi.liftMemberRestriction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [cursor] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMessages(groupPublicId: string, cursor?: string, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupBoardMessageDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMessages(groupPublicId, cursor, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupBoardRestControllerApi.listMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} [beforeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listModerationLog(groupPublicId: string, beforeId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupModerationEventDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listModerationLog(groupPublicId, beforeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupBoardRestControllerApi.listModerationLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOpenReports(groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupChatOpenReportDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOpenReports(groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupBoardRestControllerApi.listOpenReports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} messagePublicId 
         * @param {string} [cursor] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listReplies(groupPublicId: string, messagePublicId: string, cursor?: string, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupBoardMessageDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listReplies(groupPublicId, messagePublicId, cursor, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupBoardRestControllerApi.listReplies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRestrictions(groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupBoardMemberRestrictionDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRestrictions(groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupBoardRestControllerApi.listRestrictions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lockBoard(groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupBoardViewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lockBoard(groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupBoardRestControllerApi.lockBoard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markRead(groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markRead(groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupBoardRestControllerApi.markRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mentionSuggestions(groupPublicId: string, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupChatMentionSuggestionDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mentionSuggestions(groupPublicId, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupBoardRestControllerApi.mentionSuggestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} messagePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pinMessage(groupPublicId: string, messagePublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupBoardMessageDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pinMessage(groupPublicId, messagePublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupBoardRestControllerApi.pinMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {CreateGroupBoardMessageRequest} createGroupBoardMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMessage(groupPublicId: string, createGroupBoardMessageRequest: CreateGroupBoardMessageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupBoardMessageDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMessage(groupPublicId, createGroupBoardMessageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupBoardRestControllerApi.postMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} messagePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async promoteMessage(groupPublicId: string, messagePublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupChatPromotionDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.promoteMessage(groupPublicId, messagePublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupBoardRestControllerApi.promoteMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} username 
         * @param {PurgeMemberMessagesWindowEnum} [window] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async purgeMemberMessages(groupPublicId: string, username: string, window?: PurgeMemberMessagesWindowEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupBoardPurgeResultDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.purgeMemberMessages(groupPublicId, username, window, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupBoardRestControllerApi.purgeMemberMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} messagePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeMessage(groupPublicId: string, messagePublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeMessage(groupPublicId, messagePublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupBoardRestControllerApi.removeMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} messagePublicId 
         * @param {string} outcome 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveReports(groupPublicId: string, messagePublicId: string, outcome: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupChatReportResolutionDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveReports(groupPublicId, messagePublicId, outcome, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupBoardRestControllerApi.resolveReports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} username 
         * @param {RestrictMemberDurationEnum} duration 
         * @param {RestrictMemberReasonTypeEnum} [reasonType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restrictMember(groupPublicId: string, username: string, duration: RestrictMemberDurationEnum, reasonType?: RestrictMemberReasonTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupBoardMemberRestrictionDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restrictMember(groupPublicId, username, duration, reasonType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupBoardRestControllerApi.restrictMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {UpdateGroupWelcomeMessageRequest} updateGroupWelcomeMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveWelcome(groupPublicId: string, updateGroupWelcomeMessageRequest: UpdateGroupWelcomeMessageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupBoardWelcomeDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveWelcome(groupPublicId, updateGroupWelcomeMessageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupBoardRestControllerApi.saveWelcome']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchMessages(groupPublicId: string, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupChatMessageSearchResultDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchMessages(groupPublicId, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupBoardRestControllerApi.searchMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {boolean} enabled 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setImagesEnabled(groupPublicId: string, enabled: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupBoardViewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setImagesEnabled(groupPublicId, enabled, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupBoardRestControllerApi.setImagesEnabled']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {boolean} muted 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setMuted(groupPublicId: string, muted: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupBoardMuteStateDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setMuted(groupPublicId, muted, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupBoardRestControllerApi.setMuted']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GroupBoardBulkMuteRequest} groupBoardBulkMuteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setMutedForGroups(groupBoardBulkMuteRequest: GroupBoardBulkMuteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BoardMuteState>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setMutedForGroups(groupBoardBulkMuteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupBoardRestControllerApi.setMutedForGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {SetPostingPolicyPolicyEnum} policy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPostingPolicy(groupPublicId: string, policy: SetPostingPolicyPolicyEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupBoardViewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPostingPolicy(groupPublicId, policy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupBoardRestControllerApi.setPostingPolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} seconds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setSlowMode(groupPublicId: string, seconds: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupBoardViewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setSlowMode(groupPublicId, seconds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupBoardRestControllerApi.setSlowMode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlockBoard(groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupBoardViewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlockBoard(groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupBoardRestControllerApi.unlockBoard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} messagePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unpinMessage(groupPublicId: string, messagePublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupBoardMessageDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unpinMessage(groupPublicId, messagePublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupBoardRestControllerApi.unpinMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxGroupBoardRestControllerApi - factory interface
 * @export
 */
export const AjaxGroupBoardRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxGroupBoardRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} messagePublicId 
         * @param {UpdateGroupBoardMessageRequest} updateGroupBoardMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editMessage(groupPublicId: string, messagePublicId: string, updateGroupBoardMessageRequest: UpdateGroupBoardMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupBoardMessageDTO> {
            return localVarFp.editMessage(groupPublicId, messagePublicId, updateGroupBoardMessageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBoard(groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<GroupBoardViewDTO> {
            return localVarFp.getBoard(groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        liftMemberRestriction(groupPublicId: string, username: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.liftMemberRestriction(groupPublicId, username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [cursor] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMessages(groupPublicId: string, cursor?: string, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupBoardMessageDTO>> {
            return localVarFp.listMessages(groupPublicId, cursor, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} [beforeId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listModerationLog(groupPublicId: string, beforeId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupModerationEventDTO>> {
            return localVarFp.listModerationLog(groupPublicId, beforeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpenReports(groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupChatOpenReportDTO>> {
            return localVarFp.listOpenReports(groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} messagePublicId 
         * @param {string} [cursor] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReplies(groupPublicId: string, messagePublicId: string, cursor?: string, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupBoardMessageDTO>> {
            return localVarFp.listReplies(groupPublicId, messagePublicId, cursor, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRestrictions(groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupBoardMemberRestrictionDTO>> {
            return localVarFp.listRestrictions(groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockBoard(groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<GroupBoardViewDTO> {
            return localVarFp.lockBoard(groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markRead(groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markRead(groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mentionSuggestions(groupPublicId: string, q?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupChatMentionSuggestionDTO>> {
            return localVarFp.mentionSuggestions(groupPublicId, q, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} messagePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinMessage(groupPublicId: string, messagePublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<GroupBoardMessageDTO> {
            return localVarFp.pinMessage(groupPublicId, messagePublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {CreateGroupBoardMessageRequest} createGroupBoardMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMessage(groupPublicId: string, createGroupBoardMessageRequest: CreateGroupBoardMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupBoardMessageDTO> {
            return localVarFp.postMessage(groupPublicId, createGroupBoardMessageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} messagePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoteMessage(groupPublicId: string, messagePublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<GroupChatPromotionDTO> {
            return localVarFp.promoteMessage(groupPublicId, messagePublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} username 
         * @param {PurgeMemberMessagesWindowEnum} [window] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purgeMemberMessages(groupPublicId: string, username: string, window?: PurgeMemberMessagesWindowEnum, options?: RawAxiosRequestConfig): AxiosPromise<GroupBoardPurgeResultDTO> {
            return localVarFp.purgeMemberMessages(groupPublicId, username, window, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} messagePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMessage(groupPublicId: string, messagePublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeMessage(groupPublicId, messagePublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} messagePublicId 
         * @param {string} outcome 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveReports(groupPublicId: string, messagePublicId: string, outcome: string, options?: RawAxiosRequestConfig): AxiosPromise<GroupChatReportResolutionDTO> {
            return localVarFp.resolveReports(groupPublicId, messagePublicId, outcome, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} username 
         * @param {RestrictMemberDurationEnum} duration 
         * @param {RestrictMemberReasonTypeEnum} [reasonType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restrictMember(groupPublicId: string, username: string, duration: RestrictMemberDurationEnum, reasonType?: RestrictMemberReasonTypeEnum, options?: RawAxiosRequestConfig): AxiosPromise<GroupBoardMemberRestrictionDTO> {
            return localVarFp.restrictMember(groupPublicId, username, duration, reasonType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {UpdateGroupWelcomeMessageRequest} updateGroupWelcomeMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveWelcome(groupPublicId: string, updateGroupWelcomeMessageRequest: UpdateGroupWelcomeMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupBoardWelcomeDTO> {
            return localVarFp.saveWelcome(groupPublicId, updateGroupWelcomeMessageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMessages(groupPublicId: string, q?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupChatMessageSearchResultDTO>> {
            return localVarFp.searchMessages(groupPublicId, q, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {boolean} enabled 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setImagesEnabled(groupPublicId: string, enabled: boolean, options?: RawAxiosRequestConfig): AxiosPromise<GroupBoardViewDTO> {
            return localVarFp.setImagesEnabled(groupPublicId, enabled, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {boolean} muted 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMuted(groupPublicId: string, muted: boolean, options?: RawAxiosRequestConfig): AxiosPromise<GroupBoardMuteStateDTO> {
            return localVarFp.setMuted(groupPublicId, muted, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GroupBoardBulkMuteRequest} groupBoardBulkMuteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMutedForGroups(groupBoardBulkMuteRequest: GroupBoardBulkMuteRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<BoardMuteState>> {
            return localVarFp.setMutedForGroups(groupBoardBulkMuteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {SetPostingPolicyPolicyEnum} policy 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPostingPolicy(groupPublicId: string, policy: SetPostingPolicyPolicyEnum, options?: RawAxiosRequestConfig): AxiosPromise<GroupBoardViewDTO> {
            return localVarFp.setPostingPolicy(groupPublicId, policy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} seconds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSlowMode(groupPublicId: string, seconds: number, options?: RawAxiosRequestConfig): AxiosPromise<GroupBoardViewDTO> {
            return localVarFp.setSlowMode(groupPublicId, seconds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockBoard(groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<GroupBoardViewDTO> {
            return localVarFp.unlockBoard(groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} messagePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unpinMessage(groupPublicId: string, messagePublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<GroupBoardMessageDTO> {
            return localVarFp.unpinMessage(groupPublicId, messagePublicId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxGroupBoardRestControllerApi - object-oriented interface
 * @export
 * @class AjaxGroupBoardRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxGroupBoardRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} messagePublicId 
     * @param {UpdateGroupBoardMessageRequest} updateGroupBoardMessageRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupBoardRestControllerApi
     */
    public editMessage(groupPublicId: string, messagePublicId: string, updateGroupBoardMessageRequest: UpdateGroupBoardMessageRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupBoardRestControllerApiFp(this.configuration).editMessage(groupPublicId, messagePublicId, updateGroupBoardMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupBoardRestControllerApi
     */
    public getBoard(groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupBoardRestControllerApiFp(this.configuration).getBoard(groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupBoardRestControllerApi
     */
    public liftMemberRestriction(groupPublicId: string, username: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupBoardRestControllerApiFp(this.configuration).liftMemberRestriction(groupPublicId, username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} [cursor] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupBoardRestControllerApi
     */
    public listMessages(groupPublicId: string, cursor?: string, pageSize?: number, options?: RawAxiosRequestConfig) {
        return AjaxGroupBoardRestControllerApiFp(this.configuration).listMessages(groupPublicId, cursor, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {number} [beforeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupBoardRestControllerApi
     */
    public listModerationLog(groupPublicId: string, beforeId?: number, options?: RawAxiosRequestConfig) {
        return AjaxGroupBoardRestControllerApiFp(this.configuration).listModerationLog(groupPublicId, beforeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupBoardRestControllerApi
     */
    public listOpenReports(groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupBoardRestControllerApiFp(this.configuration).listOpenReports(groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} messagePublicId 
     * @param {string} [cursor] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupBoardRestControllerApi
     */
    public listReplies(groupPublicId: string, messagePublicId: string, cursor?: string, pageSize?: number, options?: RawAxiosRequestConfig) {
        return AjaxGroupBoardRestControllerApiFp(this.configuration).listReplies(groupPublicId, messagePublicId, cursor, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupBoardRestControllerApi
     */
    public listRestrictions(groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupBoardRestControllerApiFp(this.configuration).listRestrictions(groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupBoardRestControllerApi
     */
    public lockBoard(groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupBoardRestControllerApiFp(this.configuration).lockBoard(groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupBoardRestControllerApi
     */
    public markRead(groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupBoardRestControllerApiFp(this.configuration).markRead(groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} [q] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupBoardRestControllerApi
     */
    public mentionSuggestions(groupPublicId: string, q?: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupBoardRestControllerApiFp(this.configuration).mentionSuggestions(groupPublicId, q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} messagePublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupBoardRestControllerApi
     */
    public pinMessage(groupPublicId: string, messagePublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupBoardRestControllerApiFp(this.configuration).pinMessage(groupPublicId, messagePublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {CreateGroupBoardMessageRequest} createGroupBoardMessageRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupBoardRestControllerApi
     */
    public postMessage(groupPublicId: string, createGroupBoardMessageRequest: CreateGroupBoardMessageRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupBoardRestControllerApiFp(this.configuration).postMessage(groupPublicId, createGroupBoardMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} messagePublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupBoardRestControllerApi
     */
    public promoteMessage(groupPublicId: string, messagePublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupBoardRestControllerApiFp(this.configuration).promoteMessage(groupPublicId, messagePublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} username 
     * @param {PurgeMemberMessagesWindowEnum} [window] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupBoardRestControllerApi
     */
    public purgeMemberMessages(groupPublicId: string, username: string, window?: PurgeMemberMessagesWindowEnum, options?: RawAxiosRequestConfig) {
        return AjaxGroupBoardRestControllerApiFp(this.configuration).purgeMemberMessages(groupPublicId, username, window, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} messagePublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupBoardRestControllerApi
     */
    public removeMessage(groupPublicId: string, messagePublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupBoardRestControllerApiFp(this.configuration).removeMessage(groupPublicId, messagePublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} messagePublicId 
     * @param {string} outcome 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupBoardRestControllerApi
     */
    public resolveReports(groupPublicId: string, messagePublicId: string, outcome: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupBoardRestControllerApiFp(this.configuration).resolveReports(groupPublicId, messagePublicId, outcome, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} username 
     * @param {RestrictMemberDurationEnum} duration 
     * @param {RestrictMemberReasonTypeEnum} [reasonType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupBoardRestControllerApi
     */
    public restrictMember(groupPublicId: string, username: string, duration: RestrictMemberDurationEnum, reasonType?: RestrictMemberReasonTypeEnum, options?: RawAxiosRequestConfig) {
        return AjaxGroupBoardRestControllerApiFp(this.configuration).restrictMember(groupPublicId, username, duration, reasonType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {UpdateGroupWelcomeMessageRequest} updateGroupWelcomeMessageRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupBoardRestControllerApi
     */
    public saveWelcome(groupPublicId: string, updateGroupWelcomeMessageRequest: UpdateGroupWelcomeMessageRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupBoardRestControllerApiFp(this.configuration).saveWelcome(groupPublicId, updateGroupWelcomeMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} [q] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupBoardRestControllerApi
     */
    public searchMessages(groupPublicId: string, q?: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupBoardRestControllerApiFp(this.configuration).searchMessages(groupPublicId, q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {boolean} enabled 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupBoardRestControllerApi
     */
    public setImagesEnabled(groupPublicId: string, enabled: boolean, options?: RawAxiosRequestConfig) {
        return AjaxGroupBoardRestControllerApiFp(this.configuration).setImagesEnabled(groupPublicId, enabled, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {boolean} muted 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupBoardRestControllerApi
     */
    public setMuted(groupPublicId: string, muted: boolean, options?: RawAxiosRequestConfig) {
        return AjaxGroupBoardRestControllerApiFp(this.configuration).setMuted(groupPublicId, muted, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GroupBoardBulkMuteRequest} groupBoardBulkMuteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupBoardRestControllerApi
     */
    public setMutedForGroups(groupBoardBulkMuteRequest: GroupBoardBulkMuteRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupBoardRestControllerApiFp(this.configuration).setMutedForGroups(groupBoardBulkMuteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {SetPostingPolicyPolicyEnum} policy 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupBoardRestControllerApi
     */
    public setPostingPolicy(groupPublicId: string, policy: SetPostingPolicyPolicyEnum, options?: RawAxiosRequestConfig) {
        return AjaxGroupBoardRestControllerApiFp(this.configuration).setPostingPolicy(groupPublicId, policy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {number} seconds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupBoardRestControllerApi
     */
    public setSlowMode(groupPublicId: string, seconds: number, options?: RawAxiosRequestConfig) {
        return AjaxGroupBoardRestControllerApiFp(this.configuration).setSlowMode(groupPublicId, seconds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupBoardRestControllerApi
     */
    public unlockBoard(groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupBoardRestControllerApiFp(this.configuration).unlockBoard(groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} messagePublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupBoardRestControllerApi
     */
    public unpinMessage(groupPublicId: string, messagePublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupBoardRestControllerApiFp(this.configuration).unpinMessage(groupPublicId, messagePublicId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const PurgeMemberMessagesWindowEnum = {
    LastHour: 'LAST_HOUR',
    LastDay: 'LAST_DAY',
    All: 'ALL'
} as const;
export type PurgeMemberMessagesWindowEnum = typeof PurgeMemberMessagesWindowEnum[keyof typeof PurgeMemberMessagesWindowEnum];
/**
 * @export
 */
export const RestrictMemberDurationEnum = {
    Permanent: 'PERMANENT',
    OneDay: 'ONE_DAY',
    ThreeDays: 'THREE_DAYS',
    OneWeek: 'ONE_WEEK',
    OneMonth: 'ONE_MONTH'
} as const;
export type RestrictMemberDurationEnum = typeof RestrictMemberDurationEnum[keyof typeof RestrictMemberDurationEnum];
/**
 * @export
 */
export const RestrictMemberReasonTypeEnum = {
    Spam: 'SPAM',
    Harassment: 'HARASSMENT',
    HateSpeech: 'HATE_SPEECH',
    Abuse: 'ABUSE',
    RuleViolation: 'RULE_VIOLATION',
    Copyright: 'COPYRIGHT',
    AiSlop: 'AI_SLOP',
    Other: 'OTHER'
} as const;
export type RestrictMemberReasonTypeEnum = typeof RestrictMemberReasonTypeEnum[keyof typeof RestrictMemberReasonTypeEnum];
/**
 * @export
 */
export const SetPostingPolicyPolicyEnum = {
    Members: 'MEMBERS',
    Leaders: 'LEADERS'
} as const;
export type SetPostingPolicyPolicyEnum = typeof SetPostingPolicyPolicyEnum[keyof typeof SetPostingPolicyPolicyEnum];


/**
 * AjaxGroupListRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxGroupListRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} listKey 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGroup: async (listKey: string, groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listKey' is not null or undefined
            assertParamExists('addGroup', 'listKey', listKey)
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('addGroup', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group-lists/{listKey}/groups/{groupPublicId}`
                .replace(`{${"listKey"}}`, encodeURIComponent(String(listKey)))
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} listKey 
         * @param {GroupListBatchRequest} groupListBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyBatch: async (listKey: string, groupListBatchRequest: GroupListBatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listKey' is not null or undefined
            assertParamExists('applyBatch', 'listKey', listKey)
            // verify required parameter 'groupListBatchRequest' is not null or undefined
            assertParamExists('applyBatch', 'groupListBatchRequest', groupListBatchRequest)
            const localVarPath = `/ajax/group-lists/{listKey}/groups`
                .replace(`{${"listKey"}}`, encodeURIComponent(String(listKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groupListBatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GroupListNameRequest} groupListNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createList: async (groupListNameRequest: GroupListNameRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupListNameRequest' is not null or undefined
            assertParamExists('createList', 'groupListNameRequest', groupListNameRequest)
            const localVarPath = `/ajax/group-lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groupListNameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} listKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteList: async (listKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listKey' is not null or undefined
            assertParamExists('deleteList', 'listKey', listKey)
            const localVarPath = `/ajax/group-lists/{listKey}`
                .replace(`{${"listKey"}}`, encodeURIComponent(String(listKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLists: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/group-lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} listKey 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeGroup: async (listKey: string, groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listKey' is not null or undefined
            assertParamExists('removeGroup', 'listKey', listKey)
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('removeGroup', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group-lists/{listKey}/groups/{groupPublicId}`
                .replace(`{${"listKey"}}`, encodeURIComponent(String(listKey)))
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} listKey 
         * @param {GroupListNameRequest} groupListNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameList: async (listKey: string, groupListNameRequest: GroupListNameRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listKey' is not null or undefined
            assertParamExists('renameList', 'listKey', listKey)
            // verify required parameter 'groupListNameRequest' is not null or undefined
            assertParamExists('renameList', 'groupListNameRequest', groupListNameRequest)
            const localVarPath = `/ajax/group-lists/{listKey}`
                .replace(`{${"listKey"}}`, encodeURIComponent(String(listKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groupListNameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} listKey 
         * @param {GroupListOrderRequest} groupListOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorder1: async (listKey: string, groupListOrderRequest: GroupListOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listKey' is not null or undefined
            assertParamExists('reorder1', 'listKey', listKey)
            // verify required parameter 'groupListOrderRequest' is not null or undefined
            assertParamExists('reorder1', 'groupListOrderRequest', groupListOrderRequest)
            const localVarPath = `/ajax/group-lists/{listKey}/order`
                .replace(`{${"listKey"}}`, encodeURIComponent(String(listKey)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groupListOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxGroupListRestControllerApi - functional programming interface
 * @export
 */
export const AjaxGroupListRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxGroupListRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} listKey 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addGroup(listKey: string, groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addGroup(listKey, groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupListRestControllerApi.addGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} listKey 
         * @param {GroupListBatchRequest} groupListBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyBatch(listKey: string, groupListBatchRequest: GroupListBatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyBatch(listKey, groupListBatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupListRestControllerApi.applyBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {GroupListNameRequest} groupListNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createList(groupListNameRequest: GroupListNameRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createList(groupListNameRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupListRestControllerApi.createList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} listKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteList(listKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteList(listKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupListRestControllerApi.deleteList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLists(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupListDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLists(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupListRestControllerApi.getLists']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} listKey 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeGroup(listKey: string, groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeGroup(listKey, groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupListRestControllerApi.removeGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} listKey 
         * @param {GroupListNameRequest} groupListNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renameList(listKey: string, groupListNameRequest: GroupListNameRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renameList(listKey, groupListNameRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupListRestControllerApi.renameList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} listKey 
         * @param {GroupListOrderRequest} groupListOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorder1(listKey: string, groupListOrderRequest: GroupListOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorder1(listKey, groupListOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupListRestControllerApi.reorder1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxGroupListRestControllerApi - factory interface
 * @export
 */
export const AjaxGroupListRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxGroupListRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} listKey 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGroup(listKey: string, groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<GroupListDTO> {
            return localVarFp.addGroup(listKey, groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} listKey 
         * @param {GroupListBatchRequest} groupListBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyBatch(listKey: string, groupListBatchRequest: GroupListBatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupListDTO> {
            return localVarFp.applyBatch(listKey, groupListBatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GroupListNameRequest} groupListNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createList(groupListNameRequest: GroupListNameRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupListDTO> {
            return localVarFp.createList(groupListNameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} listKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteList(listKey: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteList(listKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLists(options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupListDTO>> {
            return localVarFp.getLists(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} listKey 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeGroup(listKey: string, groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<GroupListDTO> {
            return localVarFp.removeGroup(listKey, groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} listKey 
         * @param {GroupListNameRequest} groupListNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renameList(listKey: string, groupListNameRequest: GroupListNameRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupListDTO> {
            return localVarFp.renameList(listKey, groupListNameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} listKey 
         * @param {GroupListOrderRequest} groupListOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorder1(listKey: string, groupListOrderRequest: GroupListOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupListDTO> {
            return localVarFp.reorder1(listKey, groupListOrderRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxGroupListRestControllerApi - object-oriented interface
 * @export
 * @class AjaxGroupListRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxGroupListRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} listKey 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupListRestControllerApi
     */
    public addGroup(listKey: string, groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupListRestControllerApiFp(this.configuration).addGroup(listKey, groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} listKey 
     * @param {GroupListBatchRequest} groupListBatchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupListRestControllerApi
     */
    public applyBatch(listKey: string, groupListBatchRequest: GroupListBatchRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupListRestControllerApiFp(this.configuration).applyBatch(listKey, groupListBatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GroupListNameRequest} groupListNameRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupListRestControllerApi
     */
    public createList(groupListNameRequest: GroupListNameRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupListRestControllerApiFp(this.configuration).createList(groupListNameRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} listKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupListRestControllerApi
     */
    public deleteList(listKey: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupListRestControllerApiFp(this.configuration).deleteList(listKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupListRestControllerApi
     */
    public getLists(options?: RawAxiosRequestConfig) {
        return AjaxGroupListRestControllerApiFp(this.configuration).getLists(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} listKey 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupListRestControllerApi
     */
    public removeGroup(listKey: string, groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupListRestControllerApiFp(this.configuration).removeGroup(listKey, groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} listKey 
     * @param {GroupListNameRequest} groupListNameRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupListRestControllerApi
     */
    public renameList(listKey: string, groupListNameRequest: GroupListNameRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupListRestControllerApiFp(this.configuration).renameList(listKey, groupListNameRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} listKey 
     * @param {GroupListOrderRequest} groupListOrderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupListRestControllerApi
     */
    public reorder1(listKey: string, groupListOrderRequest: GroupListOrderRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupListRestControllerApiFp(this.configuration).reorder1(listKey, groupListOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxGroupRecommendationRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxGroupRecommendationRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} recommendationPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissRecommendation: async (recommendationPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recommendationPublicId' is not null or undefined
            assertParamExists('dismissRecommendation', 'recommendationPublicId', recommendationPublicId)
            const localVarPath = `/ajax/group/recommendations/{recommendationPublicId}/dismiss`
                .replace(`{${"recommendationPublicId"}}`, encodeURIComponent(String(recommendationPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {GroupRecommendationRequest} groupRecommendationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recommendUser: async (groupPublicId: string, groupRecommendationRequest: GroupRecommendationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('recommendUser', 'groupPublicId', groupPublicId)
            // verify required parameter 'groupRecommendationRequest' is not null or undefined
            assertParamExists('recommendUser', 'groupRecommendationRequest', groupRecommendationRequest)
            const localVarPath = `/ajax/group/{groupPublicId}/recommendations`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groupRecommendationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxGroupRecommendationRestControllerApi - functional programming interface
 * @export
 */
export const AjaxGroupRecommendationRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxGroupRecommendationRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} recommendationPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dismissRecommendation(recommendationPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dismissRecommendation(recommendationPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRecommendationRestControllerApi.dismissRecommendation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {GroupRecommendationRequest} groupRecommendationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recommendUser(groupPublicId: string, groupRecommendationRequest: GroupRecommendationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recommendUser(groupPublicId, groupRecommendationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRecommendationRestControllerApi.recommendUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxGroupRecommendationRestControllerApi - factory interface
 * @export
 */
export const AjaxGroupRecommendationRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxGroupRecommendationRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} recommendationPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissRecommendation(recommendationPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.dismissRecommendation(recommendationPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {GroupRecommendationRequest} groupRecommendationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recommendUser(groupPublicId: string, groupRecommendationRequest: GroupRecommendationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.recommendUser(groupPublicId, groupRecommendationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxGroupRecommendationRestControllerApi - object-oriented interface
 * @export
 * @class AjaxGroupRecommendationRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxGroupRecommendationRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} recommendationPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRecommendationRestControllerApi
     */
    public dismissRecommendation(recommendationPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRecommendationRestControllerApiFp(this.configuration).dismissRecommendation(recommendationPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {GroupRecommendationRequest} groupRecommendationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRecommendationRestControllerApi
     */
    public recommendUser(groupPublicId: string, groupRecommendationRequest: GroupRecommendationRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupRecommendationRestControllerApiFp(this.configuration).recommendUser(groupPublicId, groupRecommendationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxGroupRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxGroupRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} invitationPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvitation: async (invitationPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invitationPublicId' is not null or undefined
            assertParamExists('acceptInvitation', 'invitationPublicId', invitationPublicId)
            const localVarPath = `/ajax/group/invitations/{invitationPublicId}/accept`
                .replace(`{${"invitationPublicId"}}`, encodeURIComponent(String(invitationPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDiscussionToGroup: async (groupPublicId: string, discussionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('addDiscussionToGroup', 'groupPublicId', groupPublicId)
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('addDiscussionToGroup', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/{discussionPublicId}`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} submissionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveDiscussionSubmission: async (submissionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionPublicId' is not null or undefined
            assertParamExists('approveDiscussionSubmission', 'submissionPublicId', submissionPublicId)
            const localVarPath = `/ajax/group/discussion-submissions/{submissionPublicId}/approve`
                .replace(`{${"submissionPublicId"}}`, encodeURIComponent(String(submissionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveInviteRequest: async (requestPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestPublicId' is not null or undefined
            assertParamExists('approveInviteRequest', 'requestPublicId', requestPublicId)
            const localVarPath = `/ajax/group/invite-request/{requestPublicId}/approve`
                .replace(`{${"requestPublicId"}}`, encodeURIComponent(String(requestPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveJoinRequest: async (requestPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestPublicId' is not null or undefined
            assertParamExists('approveJoinRequest', 'requestPublicId', requestPublicId)
            const localVarPath = `/ajax/group/request/{requestPublicId}/approve`
                .replace(`{${"requestPublicId"}}`, encodeURIComponent(String(requestPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveGroup: async (groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('archiveGroup', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/archive`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {GroupLeadershipAssignmentRequest} groupLeadershipAssignmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignLeadership: async (groupPublicId: string, groupLeadershipAssignmentRequest: GroupLeadershipAssignmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('assignLeadership', 'groupPublicId', groupPublicId)
            // verify required parameter 'groupLeadershipAssignmentRequest' is not null or undefined
            assertParamExists('assignLeadership', 'groupLeadershipAssignmentRequest', groupLeadershipAssignmentRequest)
            const localVarPath = `/ajax/group/{groupPublicId}/leadership`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groupLeadershipAssignmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {BanUserRequest} banUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        banUser: async (groupPublicId: string, banUserRequest: BanUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('banUser', 'groupPublicId', groupPublicId)
            // verify required parameter 'banUserRequest' is not null or undefined
            assertParamExists('banUser', 'banUserRequest', banUserRequest)
            const localVarPath = `/ajax/group/{groupPublicId}/ban`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(banUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearMemberFlair: async (groupPublicId: string, username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('clearMemberFlair', 'groupPublicId', groupPublicId)
            // verify required parameter 'username' is not null or undefined
            assertParamExists('clearMemberFlair', 'username', username)
            const localVarPath = `/ajax/group/{groupPublicId}/members/{username}/flair`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countView2: async (groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('countView2', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/count_view/{groupPublicId}`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateGroupRequest} createGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroup: async (createGroupRequest: CreateGroupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createGroupRequest' is not null or undefined
            assertParamExists('createGroup', 'createGroupRequest', createGroupRequest)
            const localVarPath = `/ajax/group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {CreateGroupResourceRequest} createGroupResourceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroupResource: async (groupPublicId: string, createGroupResourceRequest: CreateGroupResourceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('createGroupResource', 'groupPublicId', groupPublicId)
            // verify required parameter 'createGroupResourceRequest' is not null or undefined
            assertParamExists('createGroupResource', 'createGroupResourceRequest', createGroupResourceRequest)
            const localVarPath = `/ajax/group/{groupPublicId}/resources`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGroupResourceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {CreateGroupRuleRequest} createGroupRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroupRule: async (groupPublicId: string, createGroupRuleRequest: CreateGroupRuleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('createGroupRule', 'groupPublicId', groupPublicId)
            // verify required parameter 'createGroupRuleRequest' is not null or undefined
            assertParamExists('createGroupRule', 'createGroupRuleRequest', createGroupRuleRequest)
            const localVarPath = `/ajax/group/{groupPublicId}/rules`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGroupRuleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {CreateGroupInviteLinkRequest} [createGroupInviteLinkRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInviteLink1: async (groupPublicId: string, createGroupInviteLinkRequest?: CreateGroupInviteLinkRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('createInviteLink1', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/invite-links`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGroupInviteLinkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {CreateGroupInviteRequestRequest} createGroupInviteRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInviteRequest: async (groupPublicId: string, createGroupInviteRequestRequest: CreateGroupInviteRequestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('createInviteRequest', 'groupPublicId', groupPublicId)
            // verify required parameter 'createGroupInviteRequestRequest' is not null or undefined
            assertParamExists('createInviteRequest', 'createGroupInviteRequestRequest', createGroupInviteRequestRequest)
            const localVarPath = `/ajax/group/{groupPublicId}/invite-requests`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGroupInviteRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {CreatePinnedDiscussionRequest} createPinnedDiscussionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPinnedDiscussion: async (groupPublicId: string, createPinnedDiscussionRequest: CreatePinnedDiscussionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('createPinnedDiscussion', 'groupPublicId', groupPublicId)
            // verify required parameter 'createPinnedDiscussionRequest' is not null or undefined
            assertParamExists('createPinnedDiscussion', 'createPinnedDiscussionRequest', createPinnedDiscussionRequest)
            const localVarPath = `/ajax/group/{groupPublicId}/pinned-discussions`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPinnedDiscussionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {CreateRelatedGroupRequest} createRelatedGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRelatedGroup: async (groupPublicId: string, createRelatedGroupRequest: CreateRelatedGroupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('createRelatedGroup', 'groupPublicId', groupPublicId)
            // verify required parameter 'createRelatedGroupRequest' is not null or undefined
            assertParamExists('createRelatedGroup', 'createRelatedGroupRequest', createRelatedGroupRequest)
            const localVarPath = `/ajax/group/{groupPublicId}/related-groups`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRelatedGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} invitationPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineInvitation: async (invitationPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invitationPublicId' is not null or undefined
            assertParamExists('declineInvitation', 'invitationPublicId', invitationPublicId)
            const localVarPath = `/ajax/group/invitations/{invitationPublicId}/decline`
                .replace(`{${"invitationPublicId"}}`, encodeURIComponent(String(invitationPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {DeclineGroupInviteRequestRequest} [declineGroupInviteRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineInviteRequest: async (requestPublicId: string, declineGroupInviteRequestRequest?: DeclineGroupInviteRequestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestPublicId' is not null or undefined
            assertParamExists('declineInviteRequest', 'requestPublicId', requestPublicId)
            const localVarPath = `/ajax/group/invite-request/{requestPublicId}/decline`
                .replace(`{${"requestPublicId"}}`, encodeURIComponent(String(requestPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(declineGroupInviteRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroupResource: async (groupPublicId: string, resourceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('deleteGroupResource', 'groupPublicId', groupPublicId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('deleteGroupResource', 'resourceId', resourceId)
            const localVarPath = `/ajax/group/{groupPublicId}/resources/{resourceId}`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroupRule: async (groupPublicId: string, ruleId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('deleteGroupRule', 'groupPublicId', groupPublicId)
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('deleteGroupRule', 'ruleId', ruleId)
            const localVarPath = `/ajax/group/{groupPublicId}/rules/{ruleId}`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} pinId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePinnedDiscussion: async (groupPublicId: string, pinId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('deletePinnedDiscussion', 'groupPublicId', groupPublicId)
            // verify required parameter 'pinId' is not null or undefined
            assertParamExists('deletePinnedDiscussion', 'pinId', pinId)
            const localVarPath = `/ajax/group/{groupPublicId}/pinned-discussions/{pinId}`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"pinId"}}`, encodeURIComponent(String(pinId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} relationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRelatedGroup: async (groupPublicId: string, relationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('deleteRelatedGroup', 'groupPublicId', groupPublicId)
            // verify required parameter 'relationId' is not null or undefined
            assertParamExists('deleteRelatedGroup', 'relationId', relationId)
            const localVarPath = `/ajax/group/{groupPublicId}/related-groups/{relationId}`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"relationId"}}`, encodeURIComponent(String(relationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} discussionPublicId 
         * @param {{ [key: string]: string; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        excludeDiscussion: async (groupPublicId: string, discussionPublicId: string, requestBody?: { [key: string]: string; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('excludeDiscussion', 'groupPublicId', groupPublicId)
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('excludeDiscussion', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/exclude/{discussionPublicId}`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} submissionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscussionSubmissionReviewDialog: async (submissionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionPublicId' is not null or undefined
            assertParamExists('getDiscussionSubmissionReviewDialog', 'submissionPublicId', submissionPublicId)
            const localVarPath = `/ajax/group/discussion-submissions/{submissionPublicId}/review-dialog`
                .replace(`{${"submissionPublicId"}}`, encodeURIComponent(String(submissionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupNotificationPreference: async (groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('getGroupNotificationPreference', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/notification-preference`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getViewerPendingInvitation: async (groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('getViewerPendingInvitation', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/invitations/viewer`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} submissionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ignoreDiscussionSubmission: async (submissionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionPublicId' is not null or undefined
            assertParamExists('ignoreDiscussionSubmission', 'submissionPublicId', submissionPublicId)
            const localVarPath = `/ajax/group/discussion-submissions/{submissionPublicId}/ignore`
                .replace(`{${"submissionPublicId"}}`, encodeURIComponent(String(submissionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ignoreInviteRequest: async (requestPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestPublicId' is not null or undefined
            assertParamExists('ignoreInviteRequest', 'requestPublicId', requestPublicId)
            const localVarPath = `/ajax/group/invite-request/{requestPublicId}/ignore`
                .replace(`{${"requestPublicId"}}`, encodeURIComponent(String(requestPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ignoreJoinRequest: async (requestPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestPublicId' is not null or undefined
            assertParamExists('ignoreJoinRequest', 'requestPublicId', requestPublicId)
            const localVarPath = `/ajax/group/request/{requestPublicId}/ignore`
                .replace(`{${"requestPublicId"}}`, encodeURIComponent(String(requestPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {GroupLeadershipAssignmentRequest} groupLeadershipAssignmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUser: async (groupPublicId: string, groupLeadershipAssignmentRequest: GroupLeadershipAssignmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('inviteUser', 'groupPublicId', groupPublicId)
            // verify required parameter 'groupLeadershipAssignmentRequest' is not null or undefined
            assertParamExists('inviteUser', 'groupLeadershipAssignmentRequest', groupLeadershipAssignmentRequest)
            const localVarPath = `/ajax/group/{groupPublicId}/invitations`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groupLeadershipAssignmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinGroup: async (groupPublicId: string, surface?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('joinGroup', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (surface !== undefined) {
                localVarQueryParameter['surface'] = surface;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinThroughInviteLink: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('joinThroughInviteLink', 'code', code)
            const localVarPath = `/ajax/group/invite-link/{code}/join`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveGroup: async (groupPublicId: string, surface?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('leaveGroup', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (surface !== undefined) {
                localVarQueryParameter['surface'] = surface;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBannedUsers: async (groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('listBannedUsers', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/banned`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExcludedDiscussions: async (groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('listExcludedDiscussions', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/excluded`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGroupResources: async (groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('listGroupResources', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/resources`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGroupRules: async (groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('listGroupRules', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/rules`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGroupTags: async (groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('listGroupTags', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/tags`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInviteLinks: async (groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('listInviteLinks', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/invite-links`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {Pageable} pageable 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInviteRequests: async (groupPublicId: string, pageable: Pageable, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('listInviteRequests', 'groupPublicId', groupPublicId)
            // verify required parameter 'pageable' is not null or undefined
            assertParamExists('listInviteRequests', 'pageable', pageable)
            const localVarPath = `/ajax/group/{groupPublicId}/invite-requests`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageable !== undefined) {
                for (const [key, value] of Object.entries(pageable)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Pageable} pageable 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOwnInviteRequests: async (pageable: Pageable, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageable' is not null or undefined
            assertParamExists('listOwnInviteRequests', 'pageable', pageable)
            const localVarPath = `/ajax/group/invite-requests/mine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageable !== undefined) {
                for (const [key, value] of Object.entries(pageable)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPendingInvitations: async (groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('listPendingInvitations', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/invitations`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [query] 
         * @param {string} [cutoff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPinnedDiscussionCandidates: async (groupPublicId: string, query?: string, cutoff?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('listPinnedDiscussionCandidates', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/pinned-discussions/candidates`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (cutoff !== undefined) {
                localVarQueryParameter['cutoff'] = cutoff;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPinnedDiscussions: async (groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('listPinnedDiscussions', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/pinned-discussions`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRelatedGroupCandidates: async (groupPublicId: string, source?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('listRelatedGroupCandidates', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/related-groups/candidates`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRelatedGroups: async (groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('listRelatedGroups', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/related-groups`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [source] 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadGroupDiscussionsToAddModal: async (groupPublicId: string, source?: string, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('loadGroupDiscussionsToAddModal', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/discussions`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadGroupDiscussionsToAddModalBootstrap: async (groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('loadGroupDiscussionsToAddModalBootstrap', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/discussions/modal-bootstrap`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        popularGroupTags: async (limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/group/tags/popular`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewInviteLink: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('previewInviteLink', 'code', code)
            const localVarPath = `/ajax/group/invite-link/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} submissionPublicId 
         * @param {RejectGroupRequestRequest} [rejectGroupRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectDiscussionSubmission: async (submissionPublicId: string, rejectGroupRequestRequest?: RejectGroupRequestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionPublicId' is not null or undefined
            assertParamExists('rejectDiscussionSubmission', 'submissionPublicId', submissionPublicId)
            const localVarPath = `/ajax/group/discussion-submissions/{submissionPublicId}/reject`
                .replace(`{${"submissionPublicId"}}`, encodeURIComponent(String(submissionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rejectGroupRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {RejectGroupRequestRequest} [rejectGroupRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectJoinRequest: async (requestPublicId: string, rejectGroupRequestRequest?: RejectGroupRequestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestPublicId' is not null or undefined
            assertParamExists('rejectJoinRequest', 'requestPublicId', requestPublicId)
            const localVarPath = `/ajax/group/request/{requestPublicId}/reject`
                .replace(`{${"requestPublicId"}}`, encodeURIComponent(String(requestPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rejectGroupRequestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDiscussionFromGroup: async (groupPublicId: string, discussionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('removeDiscussionFromGroup', 'groupPublicId', groupPublicId)
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('removeDiscussionFromGroup', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/{discussionPublicId}`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLeadership: async (groupPublicId: string, username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('removeLeadership', 'groupPublicId', groupPublicId)
            // verify required parameter 'username' is not null or undefined
            assertParamExists('removeLeadership', 'username', username)
            const localVarPath = `/ajax/group/{groupPublicId}/leadership/{username}`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMember: async (groupPublicId: string, username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('removeMember', 'groupPublicId', groupPublicId)
            // verify required parameter 'username' is not null or undefined
            assertParamExists('removeMember', 'username', username)
            const localVarPath = `/ajax/group/{groupPublicId}/members/{username}`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {CreateContentReportRequest} createContentReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGroup: async (groupPublicId: string, createContentReportRequest: CreateContentReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('reportGroup', 'groupPublicId', groupPublicId)
            // verify required parameter 'createContentReportRequest' is not null or undefined
            assertParamExists('reportGroup', 'createContentReportRequest', createContentReportRequest)
            const localVarPath = `/ajax/group/{groupPublicId}/report`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createContentReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreGroup: async (groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('restoreGroup', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/restore`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} invitationPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeInvitation: async (invitationPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invitationPublicId' is not null or undefined
            assertParamExists('revokeInvitation', 'invitationPublicId', invitationPublicId)
            const localVarPath = `/ajax/group/invitations/{invitationPublicId}`
                .replace(`{${"invitationPublicId"}}`, encodeURIComponent(String(invitationPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeInviteLink1: async (groupPublicId: string, code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('revokeInviteLink1', 'groupPublicId', groupPublicId)
            // verify required parameter 'code' is not null or undefined
            assertParamExists('revokeInviteLink1', 'code', code)
            const localVarPath = `/ajax/group/{groupPublicId}/invite-links/{code}`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {UpdateGroupNotificationPreferenceRequest} updateGroupNotificationPreferenceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGroupNotificationPreference: async (groupPublicId: string, updateGroupNotificationPreferenceRequest: UpdateGroupNotificationPreferenceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('setGroupNotificationPreference', 'groupPublicId', groupPublicId)
            // verify required parameter 'updateGroupNotificationPreferenceRequest' is not null or undefined
            assertParamExists('setGroupNotificationPreference', 'updateGroupNotificationPreferenceRequest', updateGroupNotificationPreferenceRequest)
            const localVarPath = `/ajax/group/{groupPublicId}/notification-preference`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGroupNotificationPreferenceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} username 
         * @param {UpdateGroupMemberFlairRequest} updateGroupMemberFlairRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMemberFlair: async (groupPublicId: string, username: string, updateGroupMemberFlairRequest: UpdateGroupMemberFlairRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('setMemberFlair', 'groupPublicId', groupPublicId)
            // verify required parameter 'username' is not null or undefined
            assertParamExists('setMemberFlair', 'username', username)
            // verify required parameter 'updateGroupMemberFlairRequest' is not null or undefined
            assertParamExists('setMemberFlair', 'updateGroupMemberFlairRequest', updateGroupMemberFlairRequest)
            const localVarPath = `/ajax/group/{groupPublicId}/members/{username}/flair`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGroupMemberFlairRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDownFromLeadership: async (groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('stepDownFromLeadership', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/leadership/step-down`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {GroupOwnershipTransferRequest} groupOwnershipTransferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferOwnership: async (groupPublicId: string, groupOwnershipTransferRequest: GroupOwnershipTransferRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('transferOwnership', 'groupPublicId', groupPublicId)
            // verify required parameter 'groupOwnershipTransferRequest' is not null or undefined
            assertParamExists('transferOwnership', 'groupOwnershipTransferRequest', groupOwnershipTransferRequest)
            const localVarPath = `/ajax/group/{groupPublicId}/ownership/transfer`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(groupOwnershipTransferRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unbanUser: async (groupPublicId: string, username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('unbanUser', 'groupPublicId', groupPublicId)
            // verify required parameter 'username' is not null or undefined
            assertParamExists('unbanUser', 'username', username)
            const localVarPath = `/ajax/group/{groupPublicId}/ban/{username}`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoApproveJoinRequest: async (requestPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestPublicId' is not null or undefined
            assertParamExists('undoApproveJoinRequest', 'requestPublicId', requestPublicId)
            const localVarPath = `/ajax/group/request/{requestPublicId}/undo-approve`
                .replace(`{${"requestPublicId"}}`, encodeURIComponent(String(requestPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} submissionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoIgnoreDiscussionSubmission: async (submissionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionPublicId' is not null or undefined
            assertParamExists('undoIgnoreDiscussionSubmission', 'submissionPublicId', submissionPublicId)
            const localVarPath = `/ajax/group/discussion-submissions/{submissionPublicId}/undo-ignore`
                .replace(`{${"submissionPublicId"}}`, encodeURIComponent(String(submissionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoIgnoreInviteRequest: async (requestPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestPublicId' is not null or undefined
            assertParamExists('undoIgnoreInviteRequest', 'requestPublicId', requestPublicId)
            const localVarPath = `/ajax/group/invite-request/{requestPublicId}/undo-ignore`
                .replace(`{${"requestPublicId"}}`, encodeURIComponent(String(requestPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoIgnoreJoinRequest: async (requestPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestPublicId' is not null or undefined
            assertParamExists('undoIgnoreJoinRequest', 'requestPublicId', requestPublicId)
            const localVarPath = `/ajax/group/request/{requestPublicId}/undo-ignore`
                .replace(`{${"requestPublicId"}}`, encodeURIComponent(String(requestPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} submissionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoRejectDiscussionSubmission: async (submissionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'submissionPublicId' is not null or undefined
            assertParamExists('undoRejectDiscussionSubmission', 'submissionPublicId', submissionPublicId)
            const localVarPath = `/ajax/group/discussion-submissions/{submissionPublicId}/undo-reject`
                .replace(`{${"submissionPublicId"}}`, encodeURIComponent(String(submissionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unexcludeDiscussion: async (groupPublicId: string, discussionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('unexcludeDiscussion', 'groupPublicId', groupPublicId)
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('unexcludeDiscussion', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/group/{groupPublicId}/exclude/{discussionPublicId}`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {UpdateGroupGeneralRequest} updateGroupGeneralRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroupGeneral: async (groupPublicId: string, updateGroupGeneralRequest: UpdateGroupGeneralRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('updateGroupGeneral', 'groupPublicId', groupPublicId)
            // verify required parameter 'updateGroupGeneralRequest' is not null or undefined
            assertParamExists('updateGroupGeneral', 'updateGroupGeneralRequest', updateGroupGeneralRequest)
            const localVarPath = `/ajax/group/{groupPublicId}/general`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGroupGeneralRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} resourceId 
         * @param {CreateGroupResourceRequest} createGroupResourceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroupResource: async (groupPublicId: string, resourceId: number, createGroupResourceRequest: CreateGroupResourceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('updateGroupResource', 'groupPublicId', groupPublicId)
            // verify required parameter 'resourceId' is not null or undefined
            assertParamExists('updateGroupResource', 'resourceId', resourceId)
            // verify required parameter 'createGroupResourceRequest' is not null or undefined
            assertParamExists('updateGroupResource', 'createGroupResourceRequest', createGroupResourceRequest)
            const localVarPath = `/ajax/group/{groupPublicId}/resources/{resourceId}`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGroupResourceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} ruleId 
         * @param {CreateGroupRuleRequest} createGroupRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroupRule: async (groupPublicId: string, ruleId: number, createGroupRuleRequest: CreateGroupRuleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('updateGroupRule', 'groupPublicId', groupPublicId)
            // verify required parameter 'ruleId' is not null or undefined
            assertParamExists('updateGroupRule', 'ruleId', ruleId)
            // verify required parameter 'createGroupRuleRequest' is not null or undefined
            assertParamExists('updateGroupRule', 'createGroupRuleRequest', createGroupRuleRequest)
            const localVarPath = `/ajax/group/{groupPublicId}/rules/{ruleId}`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"ruleId"}}`, encodeURIComponent(String(ruleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGroupRuleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} pinId 
         * @param {UpdatePinnedDiscussionOrderRequest} updatePinnedDiscussionOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePinnedDiscussionOrder: async (groupPublicId: string, pinId: number, updatePinnedDiscussionOrderRequest: UpdatePinnedDiscussionOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('updatePinnedDiscussionOrder', 'groupPublicId', groupPublicId)
            // verify required parameter 'pinId' is not null or undefined
            assertParamExists('updatePinnedDiscussionOrder', 'pinId', pinId)
            // verify required parameter 'updatePinnedDiscussionOrderRequest' is not null or undefined
            assertParamExists('updatePinnedDiscussionOrder', 'updatePinnedDiscussionOrderRequest', updatePinnedDiscussionOrderRequest)
            const localVarPath = `/ajax/group/{groupPublicId}/pinned-discussions/{pinId}`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"pinId"}}`, encodeURIComponent(String(pinId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePinnedDiscussionOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} relationId 
         * @param {CreateRelatedGroupRequest} createRelatedGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelatedGroup: async (groupPublicId: string, relationId: number, createRelatedGroupRequest: CreateRelatedGroupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('updateRelatedGroup', 'groupPublicId', groupPublicId)
            // verify required parameter 'relationId' is not null or undefined
            assertParamExists('updateRelatedGroup', 'relationId', relationId)
            // verify required parameter 'createRelatedGroupRequest' is not null or undefined
            assertParamExists('updateRelatedGroup', 'createRelatedGroupRequest', createRelatedGroupRequest)
            const localVarPath = `/ajax/group/{groupPublicId}/related-groups/{relationId}`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)))
                .replace(`{${"relationId"}}`, encodeURIComponent(String(relationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRelatedGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        withdrawInviteRequest: async (requestPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestPublicId' is not null or undefined
            assertParamExists('withdrawInviteRequest', 'requestPublicId', requestPublicId)
            const localVarPath = `/ajax/group/invite-request/{requestPublicId}/withdraw`
                .replace(`{${"requestPublicId"}}`, encodeURIComponent(String(requestPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        withdrawJoinRequest: async (requestPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestPublicId' is not null or undefined
            assertParamExists('withdrawJoinRequest', 'requestPublicId', requestPublicId)
            const localVarPath = `/ajax/group/request/{requestPublicId}/withdraw`
                .replace(`{${"requestPublicId"}}`, encodeURIComponent(String(requestPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxGroupRestControllerApi - functional programming interface
 * @export
 */
export const AjaxGroupRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxGroupRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} invitationPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptInvitation(invitationPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptInvitation(invitationPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.acceptInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDiscussionToGroup(groupPublicId: string, discussionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddDiscussionToGroupResultDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDiscussionToGroup(groupPublicId, discussionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.addDiscussionToGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} submissionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveDiscussionSubmission(submissionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveDiscussionSubmission(submissionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.approveDiscussionSubmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveInviteRequest(requestPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveInviteRequest(requestPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.approveInviteRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveJoinRequest(requestPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveJoinRequest(requestPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.approveJoinRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveGroup(groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveGroup(groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.archiveGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {GroupLeadershipAssignmentRequest} groupLeadershipAssignmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignLeadership(groupPublicId: string, groupLeadershipAssignmentRequest: GroupLeadershipAssignmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignLeadership(groupPublicId, groupLeadershipAssignmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.assignLeadership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {BanUserRequest} banUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async banUser(groupPublicId: string, banUserRequest: BanUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.banUser(groupPublicId, banUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.banUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearMemberFlair(groupPublicId: string, username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clearMemberFlair(groupPublicId, username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.clearMemberFlair']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countView2(groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countView2(groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.countView2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateGroupRequest} createGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGroup(createGroupRequest: CreateGroupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGroup(createGroupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.createGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {CreateGroupResourceRequest} createGroupResourceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGroupResource(groupPublicId: string, createGroupResourceRequest: CreateGroupResourceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGroupResource(groupPublicId, createGroupResourceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.createGroupResource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {CreateGroupRuleRequest} createGroupRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGroupRule(groupPublicId: string, createGroupRuleRequest: CreateGroupRuleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupRule>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGroupRule(groupPublicId, createGroupRuleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.createGroupRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {CreateGroupInviteLinkRequest} [createGroupInviteLinkRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInviteLink1(groupPublicId: string, createGroupInviteLinkRequest?: CreateGroupInviteLinkRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupInviteLinkDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInviteLink1(groupPublicId, createGroupInviteLinkRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.createInviteLink1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {CreateGroupInviteRequestRequest} createGroupInviteRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInviteRequest(groupPublicId: string, createGroupInviteRequestRequest: CreateGroupInviteRequestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupInviteRequestResultDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInviteRequest(groupPublicId, createGroupInviteRequestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.createInviteRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {CreatePinnedDiscussionRequest} createPinnedDiscussionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPinnedDiscussion(groupPublicId: string, createPinnedDiscussionRequest: CreatePinnedDiscussionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PinnedGroupDiscussionSummaryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPinnedDiscussion(groupPublicId, createPinnedDiscussionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.createPinnedDiscussion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {CreateRelatedGroupRequest} createRelatedGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRelatedGroup(groupPublicId: string, createRelatedGroupRequest: CreateRelatedGroupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RelatedGroupDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRelatedGroup(groupPublicId, createRelatedGroupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.createRelatedGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} invitationPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async declineInvitation(invitationPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.declineInvitation(invitationPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.declineInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {DeclineGroupInviteRequestRequest} [declineGroupInviteRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async declineInviteRequest(requestPublicId: string, declineGroupInviteRequestRequest?: DeclineGroupInviteRequestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.declineInviteRequest(requestPublicId, declineGroupInviteRequestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.declineInviteRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGroupResource(groupPublicId: string, resourceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGroupResource(groupPublicId, resourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.deleteGroupResource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGroupRule(groupPublicId: string, ruleId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGroupRule(groupPublicId, ruleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.deleteGroupRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} pinId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePinnedDiscussion(groupPublicId: string, pinId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePinnedDiscussion(groupPublicId, pinId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.deletePinnedDiscussion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} relationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRelatedGroup(groupPublicId: string, relationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRelatedGroup(groupPublicId, relationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.deleteRelatedGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} discussionPublicId 
         * @param {{ [key: string]: string; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async excludeDiscussion(groupPublicId: string, discussionPublicId: string, requestBody?: { [key: string]: string; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.excludeDiscussion(groupPublicId, discussionPublicId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.excludeDiscussion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} submissionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiscussionSubmissionReviewDialog(submissionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupDiscussionSubmissionReviewDialogDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiscussionSubmissionReviewDialog(submissionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.getDiscussionSubmissionReviewDialog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupNotificationPreference(groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupNotificationPreference(groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.getGroupNotificationPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getViewerPendingInvitation(groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ViewerGroupInvitationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getViewerPendingInvitation(groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.getViewerPendingInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} submissionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ignoreDiscussionSubmission(submissionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ignoreDiscussionSubmission(submissionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.ignoreDiscussionSubmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ignoreInviteRequest(requestPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ignoreInviteRequest(requestPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.ignoreInviteRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ignoreJoinRequest(requestPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ignoreJoinRequest(requestPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.ignoreJoinRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {GroupLeadershipAssignmentRequest} groupLeadershipAssignmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteUser(groupPublicId: string, groupLeadershipAssignmentRequest: GroupLeadershipAssignmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InviteUserToGroupResultDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteUser(groupPublicId, groupLeadershipAssignmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.inviteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinGroup(groupPublicId: string, surface?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinGroup(groupPublicId, surface, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.joinGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinThroughInviteLink(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupInviteLinkJoinDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinThroughInviteLink(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.joinThroughInviteLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leaveGroup(groupPublicId: string, surface?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leaveGroup(groupPublicId, surface, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.leaveGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBannedUsers(groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BannedUserDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBannedUsers(groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.listBannedUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listExcludedDiscussions(groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupDiscussionDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listExcludedDiscussions(groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.listExcludedDiscussions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listGroupResources(groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupResource>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGroupResources(groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.listGroupResources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listGroupRules(groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupRule>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGroupRules(groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.listGroupRules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listGroupTags(groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGroupTags(groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.listGroupTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInviteLinks(groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupInviteLinkDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInviteLinks(groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.listInviteLinks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {Pageable} pageable 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInviteRequests(groupPublicId: string, pageable: Pageable, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageGroupInviteRequestDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInviteRequests(groupPublicId, pageable, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.listInviteRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Pageable} pageable 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOwnInviteRequests(pageable: Pageable, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageGroupInviteRequestDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOwnInviteRequests(pageable, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.listOwnInviteRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPendingInvitations(groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupInvitationDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPendingInvitations(groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.listPendingInvitations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [query] 
         * @param {string} [cutoff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPinnedDiscussionCandidates(groupPublicId: string, query?: string, cutoff?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PinnedGroupDiscussionSummaryDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPinnedDiscussionCandidates(groupPublicId, query, cutoff, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.listPinnedDiscussionCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPinnedDiscussions(groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PinnedGroupDiscussionSummaryDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPinnedDiscussions(groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.listPinnedDiscussions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRelatedGroupCandidates(groupPublicId: string, source?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRelatedGroupCandidates(groupPublicId, source, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.listRelatedGroupCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRelatedGroups(groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RelatedGroupDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRelatedGroups(groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.listRelatedGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [source] 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadGroupDiscussionsToAddModal(groupPublicId: string, source?: string, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiscussionsToAddToGroupDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadGroupDiscussionsToAddModal(groupPublicId, source, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.loadGroupDiscussionsToAddModal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadGroupDiscussionsToAddModalBootstrap(groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupDiscussionsToAddModalBootstrapDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadGroupDiscussionsToAddModalBootstrap(groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.loadGroupDiscussionsToAddModalBootstrap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async popularGroupTags(limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupTagCountDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.popularGroupTags(limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.popularGroupTags']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewInviteLink(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupInviteLinkPreviewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewInviteLink(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.previewInviteLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} submissionPublicId 
         * @param {RejectGroupRequestRequest} [rejectGroupRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectDiscussionSubmission(submissionPublicId: string, rejectGroupRequestRequest?: RejectGroupRequestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectDiscussionSubmission(submissionPublicId, rejectGroupRequestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.rejectDiscussionSubmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {RejectGroupRequestRequest} [rejectGroupRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectJoinRequest(requestPublicId: string, rejectGroupRequestRequest?: RejectGroupRequestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectJoinRequest(requestPublicId, rejectGroupRequestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.rejectJoinRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeDiscussionFromGroup(groupPublicId: string, discussionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeDiscussionFromGroup(groupPublicId, discussionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.removeDiscussionFromGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeLeadership(groupPublicId: string, username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeLeadership(groupPublicId, username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.removeLeadership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeMember(groupPublicId: string, username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeMember(groupPublicId, username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.removeMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {CreateContentReportRequest} createContentReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportGroup(groupPublicId: string, createContentReportRequest: CreateContentReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportGroup(groupPublicId, createContentReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.reportGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreGroup(groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreGroup(groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.restoreGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} invitationPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeInvitation(invitationPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeInvitation(invitationPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.revokeInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeInviteLink1(groupPublicId: string, code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeInviteLink1(groupPublicId, code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.revokeInviteLink1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {UpdateGroupNotificationPreferenceRequest} updateGroupNotificationPreferenceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setGroupNotificationPreference(groupPublicId: string, updateGroupNotificationPreferenceRequest: UpdateGroupNotificationPreferenceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setGroupNotificationPreference(groupPublicId, updateGroupNotificationPreferenceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.setGroupNotificationPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} username 
         * @param {UpdateGroupMemberFlairRequest} updateGroupMemberFlairRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setMemberFlair(groupPublicId: string, username: string, updateGroupMemberFlairRequest: UpdateGroupMemberFlairRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setMemberFlair(groupPublicId, username, updateGroupMemberFlairRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.setMemberFlair']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stepDownFromLeadership(groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stepDownFromLeadership(groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.stepDownFromLeadership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {GroupOwnershipTransferRequest} groupOwnershipTransferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transferOwnership(groupPublicId: string, groupOwnershipTransferRequest: GroupOwnershipTransferRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transferOwnership(groupPublicId, groupOwnershipTransferRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.transferOwnership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unbanUser(groupPublicId: string, username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unbanUser(groupPublicId, username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.unbanUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async undoApproveJoinRequest(requestPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.undoApproveJoinRequest(requestPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.undoApproveJoinRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} submissionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async undoIgnoreDiscussionSubmission(submissionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.undoIgnoreDiscussionSubmission(submissionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.undoIgnoreDiscussionSubmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async undoIgnoreInviteRequest(requestPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.undoIgnoreInviteRequest(requestPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.undoIgnoreInviteRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async undoIgnoreJoinRequest(requestPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.undoIgnoreJoinRequest(requestPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.undoIgnoreJoinRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} submissionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async undoRejectDiscussionSubmission(submissionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.undoRejectDiscussionSubmission(submissionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.undoRejectDiscussionSubmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unexcludeDiscussion(groupPublicId: string, discussionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unexcludeDiscussion(groupPublicId, discussionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.unexcludeDiscussion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {UpdateGroupGeneralRequest} updateGroupGeneralRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGroupGeneral(groupPublicId: string, updateGroupGeneralRequest: UpdateGroupGeneralRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGroupGeneral(groupPublicId, updateGroupGeneralRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.updateGroupGeneral']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} resourceId 
         * @param {CreateGroupResourceRequest} createGroupResourceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGroupResource(groupPublicId: string, resourceId: number, createGroupResourceRequest: CreateGroupResourceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupResource>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGroupResource(groupPublicId, resourceId, createGroupResourceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.updateGroupResource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} ruleId 
         * @param {CreateGroupRuleRequest} createGroupRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGroupRule(groupPublicId: string, ruleId: number, createGroupRuleRequest: CreateGroupRuleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupRule>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGroupRule(groupPublicId, ruleId, createGroupRuleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.updateGroupRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} pinId 
         * @param {UpdatePinnedDiscussionOrderRequest} updatePinnedDiscussionOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePinnedDiscussionOrder(groupPublicId: string, pinId: number, updatePinnedDiscussionOrderRequest: UpdatePinnedDiscussionOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PinnedGroupDiscussionSummaryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePinnedDiscussionOrder(groupPublicId, pinId, updatePinnedDiscussionOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.updatePinnedDiscussionOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} relationId 
         * @param {CreateRelatedGroupRequest} createRelatedGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRelatedGroup(groupPublicId: string, relationId: number, createRelatedGroupRequest: CreateRelatedGroupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RelatedGroupDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRelatedGroup(groupPublicId, relationId, createRelatedGroupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.updateRelatedGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async withdrawInviteRequest(requestPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.withdrawInviteRequest(requestPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.withdrawInviteRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async withdrawJoinRequest(requestPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.withdrawJoinRequest(requestPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxGroupRestControllerApi.withdrawJoinRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxGroupRestControllerApi - factory interface
 * @export
 */
export const AjaxGroupRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxGroupRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} invitationPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvitation(invitationPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.acceptInvitation(invitationPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDiscussionToGroup(groupPublicId: string, discussionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<AddDiscussionToGroupResultDTO> {
            return localVarFp.addDiscussionToGroup(groupPublicId, discussionPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} submissionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveDiscussionSubmission(submissionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.approveDiscussionSubmission(submissionPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveInviteRequest(requestPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.approveInviteRequest(requestPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveJoinRequest(requestPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.approveJoinRequest(requestPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveGroup(groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.archiveGroup(groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {GroupLeadershipAssignmentRequest} groupLeadershipAssignmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignLeadership(groupPublicId: string, groupLeadershipAssignmentRequest: GroupLeadershipAssignmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assignLeadership(groupPublicId, groupLeadershipAssignmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {BanUserRequest} banUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        banUser(groupPublicId: string, banUserRequest: BanUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.banUser(groupPublicId, banUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearMemberFlair(groupPublicId: string, username: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.clearMemberFlair(groupPublicId, username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countView2(groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.countView2(groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateGroupRequest} createGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroup(createGroupRequest: CreateGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.createGroup(createGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {CreateGroupResourceRequest} createGroupResourceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroupResource(groupPublicId: string, createGroupResourceRequest: CreateGroupResourceRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupResource> {
            return localVarFp.createGroupResource(groupPublicId, createGroupResourceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {CreateGroupRuleRequest} createGroupRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroupRule(groupPublicId: string, createGroupRuleRequest: CreateGroupRuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupRule> {
            return localVarFp.createGroupRule(groupPublicId, createGroupRuleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {CreateGroupInviteLinkRequest} [createGroupInviteLinkRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInviteLink1(groupPublicId: string, createGroupInviteLinkRequest?: CreateGroupInviteLinkRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupInviteLinkDTO> {
            return localVarFp.createInviteLink1(groupPublicId, createGroupInviteLinkRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {CreateGroupInviteRequestRequest} createGroupInviteRequestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInviteRequest(groupPublicId: string, createGroupInviteRequestRequest: CreateGroupInviteRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupInviteRequestResultDTO> {
            return localVarFp.createInviteRequest(groupPublicId, createGroupInviteRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {CreatePinnedDiscussionRequest} createPinnedDiscussionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPinnedDiscussion(groupPublicId: string, createPinnedDiscussionRequest: CreatePinnedDiscussionRequest, options?: RawAxiosRequestConfig): AxiosPromise<PinnedGroupDiscussionSummaryDTO> {
            return localVarFp.createPinnedDiscussion(groupPublicId, createPinnedDiscussionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {CreateRelatedGroupRequest} createRelatedGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRelatedGroup(groupPublicId: string, createRelatedGroupRequest: CreateRelatedGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<RelatedGroupDTO> {
            return localVarFp.createRelatedGroup(groupPublicId, createRelatedGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} invitationPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineInvitation(invitationPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.declineInvitation(invitationPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {DeclineGroupInviteRequestRequest} [declineGroupInviteRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineInviteRequest(requestPublicId: string, declineGroupInviteRequestRequest?: DeclineGroupInviteRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.declineInviteRequest(requestPublicId, declineGroupInviteRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} resourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroupResource(groupPublicId: string, resourceId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteGroupResource(groupPublicId, resourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} ruleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGroupRule(groupPublicId: string, ruleId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteGroupRule(groupPublicId, ruleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} pinId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePinnedDiscussion(groupPublicId: string, pinId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePinnedDiscussion(groupPublicId, pinId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} relationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRelatedGroup(groupPublicId: string, relationId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteRelatedGroup(groupPublicId, relationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} discussionPublicId 
         * @param {{ [key: string]: string; }} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        excludeDiscussion(groupPublicId: string, discussionPublicId: string, requestBody?: { [key: string]: string; }, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.excludeDiscussion(groupPublicId, discussionPublicId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} submissionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscussionSubmissionReviewDialog(submissionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<GroupDiscussionSubmissionReviewDialogDTO> {
            return localVarFp.getDiscussionSubmissionReviewDialog(submissionPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupNotificationPreference(groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.getGroupNotificationPreference(groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getViewerPendingInvitation(groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<ViewerGroupInvitationDTO> {
            return localVarFp.getViewerPendingInvitation(groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} submissionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ignoreDiscussionSubmission(submissionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.ignoreDiscussionSubmission(submissionPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ignoreInviteRequest(requestPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.ignoreInviteRequest(requestPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ignoreJoinRequest(requestPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.ignoreJoinRequest(requestPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {GroupLeadershipAssignmentRequest} groupLeadershipAssignmentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUser(groupPublicId: string, groupLeadershipAssignmentRequest: GroupLeadershipAssignmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<InviteUserToGroupResultDTO> {
            return localVarFp.inviteUser(groupPublicId, groupLeadershipAssignmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinGroup(groupPublicId: string, surface?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.joinGroup(groupPublicId, surface, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinThroughInviteLink(code: string, options?: RawAxiosRequestConfig): AxiosPromise<GroupInviteLinkJoinDTO> {
            return localVarFp.joinThroughInviteLink(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveGroup(groupPublicId: string, surface?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.leaveGroup(groupPublicId, surface, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBannedUsers(groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BannedUserDTO>> {
            return localVarFp.listBannedUsers(groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listExcludedDiscussions(groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupDiscussionDTO>> {
            return localVarFp.listExcludedDiscussions(groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGroupResources(groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupResource>> {
            return localVarFp.listGroupResources(groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGroupRules(groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupRule>> {
            return localVarFp.listGroupRules(groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGroupTags(groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.listGroupTags(groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInviteLinks(groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupInviteLinkDTO>> {
            return localVarFp.listInviteLinks(groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {Pageable} pageable 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInviteRequests(groupPublicId: string, pageable: Pageable, options?: RawAxiosRequestConfig): AxiosPromise<PageGroupInviteRequestDTO> {
            return localVarFp.listInviteRequests(groupPublicId, pageable, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Pageable} pageable 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOwnInviteRequests(pageable: Pageable, options?: RawAxiosRequestConfig): AxiosPromise<PageGroupInviteRequestDTO> {
            return localVarFp.listOwnInviteRequests(pageable, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPendingInvitations(groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupInvitationDTO>> {
            return localVarFp.listPendingInvitations(groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [query] 
         * @param {string} [cutoff] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPinnedDiscussionCandidates(groupPublicId: string, query?: string, cutoff?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PinnedGroupDiscussionSummaryDTO>> {
            return localVarFp.listPinnedDiscussionCandidates(groupPublicId, query, cutoff, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPinnedDiscussions(groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<PinnedGroupDiscussionSummaryDTO>> {
            return localVarFp.listPinnedDiscussions(groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRelatedGroupCandidates(groupPublicId: string, source?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupDTO>> {
            return localVarFp.listRelatedGroupCandidates(groupPublicId, source, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRelatedGroups(groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RelatedGroupDTO>> {
            return localVarFp.listRelatedGroups(groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [source] 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadGroupDiscussionsToAddModal(groupPublicId: string, source?: string, q?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DiscussionsToAddToGroupDTO>> {
            return localVarFp.loadGroupDiscussionsToAddModal(groupPublicId, source, q, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadGroupDiscussionsToAddModalBootstrap(groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<GroupDiscussionsToAddModalBootstrapDTO> {
            return localVarFp.loadGroupDiscussionsToAddModalBootstrap(groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        popularGroupTags(limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupTagCountDTO>> {
            return localVarFp.popularGroupTags(limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewInviteLink(code: string, options?: RawAxiosRequestConfig): AxiosPromise<GroupInviteLinkPreviewDTO> {
            return localVarFp.previewInviteLink(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} submissionPublicId 
         * @param {RejectGroupRequestRequest} [rejectGroupRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectDiscussionSubmission(submissionPublicId: string, rejectGroupRequestRequest?: RejectGroupRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rejectDiscussionSubmission(submissionPublicId, rejectGroupRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {RejectGroupRequestRequest} [rejectGroupRequestRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectJoinRequest(requestPublicId: string, rejectGroupRequestRequest?: RejectGroupRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rejectJoinRequest(requestPublicId, rejectGroupRequestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDiscussionFromGroup(groupPublicId: string, discussionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeDiscussionFromGroup(groupPublicId, discussionPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeLeadership(groupPublicId: string, username: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeLeadership(groupPublicId, username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMember(groupPublicId: string, username: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeMember(groupPublicId, username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {CreateContentReportRequest} createContentReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportGroup(groupPublicId: string, createContentReportRequest: CreateContentReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reportGroup(groupPublicId, createContentReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreGroup(groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.restoreGroup(groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} invitationPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeInvitation(invitationPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.revokeInvitation(invitationPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeInviteLink1(groupPublicId: string, code: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.revokeInviteLink1(groupPublicId, code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {UpdateGroupNotificationPreferenceRequest} updateGroupNotificationPreferenceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setGroupNotificationPreference(groupPublicId: string, updateGroupNotificationPreferenceRequest: UpdateGroupNotificationPreferenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setGroupNotificationPreference(groupPublicId, updateGroupNotificationPreferenceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} username 
         * @param {UpdateGroupMemberFlairRequest} updateGroupMemberFlairRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setMemberFlair(groupPublicId: string, username: string, updateGroupMemberFlairRequest: UpdateGroupMemberFlairRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setMemberFlair(groupPublicId, username, updateGroupMemberFlairRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stepDownFromLeadership(groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.stepDownFromLeadership(groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {GroupOwnershipTransferRequest} groupOwnershipTransferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferOwnership(groupPublicId: string, groupOwnershipTransferRequest: GroupOwnershipTransferRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.transferOwnership(groupPublicId, groupOwnershipTransferRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unbanUser(groupPublicId: string, username: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unbanUser(groupPublicId, username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoApproveJoinRequest(requestPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.undoApproveJoinRequest(requestPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} submissionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoIgnoreDiscussionSubmission(submissionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.undoIgnoreDiscussionSubmission(submissionPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoIgnoreInviteRequest(requestPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.undoIgnoreInviteRequest(requestPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoIgnoreJoinRequest(requestPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.undoIgnoreJoinRequest(requestPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} submissionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undoRejectDiscussionSubmission(submissionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.undoRejectDiscussionSubmission(submissionPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unexcludeDiscussion(groupPublicId: string, discussionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unexcludeDiscussion(groupPublicId, discussionPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {UpdateGroupGeneralRequest} updateGroupGeneralRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroupGeneral(groupPublicId: string, updateGroupGeneralRequest: UpdateGroupGeneralRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateGroupGeneral(groupPublicId, updateGroupGeneralRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} resourceId 
         * @param {CreateGroupResourceRequest} createGroupResourceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroupResource(groupPublicId: string, resourceId: number, createGroupResourceRequest: CreateGroupResourceRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupResource> {
            return localVarFp.updateGroupResource(groupPublicId, resourceId, createGroupResourceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} ruleId 
         * @param {CreateGroupRuleRequest} createGroupRuleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroupRule(groupPublicId: string, ruleId: number, createGroupRuleRequest: CreateGroupRuleRequest, options?: RawAxiosRequestConfig): AxiosPromise<GroupRule> {
            return localVarFp.updateGroupRule(groupPublicId, ruleId, createGroupRuleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} pinId 
         * @param {UpdatePinnedDiscussionOrderRequest} updatePinnedDiscussionOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePinnedDiscussionOrder(groupPublicId: string, pinId: number, updatePinnedDiscussionOrderRequest: UpdatePinnedDiscussionOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<PinnedGroupDiscussionSummaryDTO> {
            return localVarFp.updatePinnedDiscussionOrder(groupPublicId, pinId, updatePinnedDiscussionOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {number} relationId 
         * @param {CreateRelatedGroupRequest} createRelatedGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRelatedGroup(groupPublicId: string, relationId: number, createRelatedGroupRequest: CreateRelatedGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<RelatedGroupDTO> {
            return localVarFp.updateRelatedGroup(groupPublicId, relationId, createRelatedGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        withdrawInviteRequest(requestPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.withdrawInviteRequest(requestPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} requestPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        withdrawJoinRequest(requestPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.withdrawJoinRequest(requestPublicId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxGroupRestControllerApi - object-oriented interface
 * @export
 * @class AjaxGroupRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxGroupRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} invitationPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public acceptInvitation(invitationPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).acceptInvitation(invitationPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} discussionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public addDiscussionToGroup(groupPublicId: string, discussionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).addDiscussionToGroup(groupPublicId, discussionPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} submissionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public approveDiscussionSubmission(submissionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).approveDiscussionSubmission(submissionPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} requestPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public approveInviteRequest(requestPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).approveInviteRequest(requestPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} requestPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public approveJoinRequest(requestPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).approveJoinRequest(requestPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public archiveGroup(groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).archiveGroup(groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {GroupLeadershipAssignmentRequest} groupLeadershipAssignmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public assignLeadership(groupPublicId: string, groupLeadershipAssignmentRequest: GroupLeadershipAssignmentRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).assignLeadership(groupPublicId, groupLeadershipAssignmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {BanUserRequest} banUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public banUser(groupPublicId: string, banUserRequest: BanUserRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).banUser(groupPublicId, banUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public clearMemberFlair(groupPublicId: string, username: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).clearMemberFlair(groupPublicId, username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public countView2(groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).countView2(groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateGroupRequest} createGroupRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public createGroup(createGroupRequest: CreateGroupRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).createGroup(createGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {CreateGroupResourceRequest} createGroupResourceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public createGroupResource(groupPublicId: string, createGroupResourceRequest: CreateGroupResourceRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).createGroupResource(groupPublicId, createGroupResourceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {CreateGroupRuleRequest} createGroupRuleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public createGroupRule(groupPublicId: string, createGroupRuleRequest: CreateGroupRuleRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).createGroupRule(groupPublicId, createGroupRuleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {CreateGroupInviteLinkRequest} [createGroupInviteLinkRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public createInviteLink1(groupPublicId: string, createGroupInviteLinkRequest?: CreateGroupInviteLinkRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).createInviteLink1(groupPublicId, createGroupInviteLinkRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {CreateGroupInviteRequestRequest} createGroupInviteRequestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public createInviteRequest(groupPublicId: string, createGroupInviteRequestRequest: CreateGroupInviteRequestRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).createInviteRequest(groupPublicId, createGroupInviteRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {CreatePinnedDiscussionRequest} createPinnedDiscussionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public createPinnedDiscussion(groupPublicId: string, createPinnedDiscussionRequest: CreatePinnedDiscussionRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).createPinnedDiscussion(groupPublicId, createPinnedDiscussionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {CreateRelatedGroupRequest} createRelatedGroupRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public createRelatedGroup(groupPublicId: string, createRelatedGroupRequest: CreateRelatedGroupRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).createRelatedGroup(groupPublicId, createRelatedGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} invitationPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public declineInvitation(invitationPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).declineInvitation(invitationPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} requestPublicId 
     * @param {DeclineGroupInviteRequestRequest} [declineGroupInviteRequestRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public declineInviteRequest(requestPublicId: string, declineGroupInviteRequestRequest?: DeclineGroupInviteRequestRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).declineInviteRequest(requestPublicId, declineGroupInviteRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {number} resourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public deleteGroupResource(groupPublicId: string, resourceId: number, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).deleteGroupResource(groupPublicId, resourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {number} ruleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public deleteGroupRule(groupPublicId: string, ruleId: number, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).deleteGroupRule(groupPublicId, ruleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {number} pinId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public deletePinnedDiscussion(groupPublicId: string, pinId: number, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).deletePinnedDiscussion(groupPublicId, pinId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {number} relationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public deleteRelatedGroup(groupPublicId: string, relationId: number, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).deleteRelatedGroup(groupPublicId, relationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} discussionPublicId 
     * @param {{ [key: string]: string; }} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public excludeDiscussion(groupPublicId: string, discussionPublicId: string, requestBody?: { [key: string]: string; }, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).excludeDiscussion(groupPublicId, discussionPublicId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} submissionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public getDiscussionSubmissionReviewDialog(submissionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).getDiscussionSubmissionReviewDialog(submissionPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public getGroupNotificationPreference(groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).getGroupNotificationPreference(groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public getViewerPendingInvitation(groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).getViewerPendingInvitation(groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} submissionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public ignoreDiscussionSubmission(submissionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).ignoreDiscussionSubmission(submissionPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} requestPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public ignoreInviteRequest(requestPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).ignoreInviteRequest(requestPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} requestPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public ignoreJoinRequest(requestPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).ignoreJoinRequest(requestPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {GroupLeadershipAssignmentRequest} groupLeadershipAssignmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public inviteUser(groupPublicId: string, groupLeadershipAssignmentRequest: GroupLeadershipAssignmentRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).inviteUser(groupPublicId, groupLeadershipAssignmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} [surface] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public joinGroup(groupPublicId: string, surface?: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).joinGroup(groupPublicId, surface, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public joinThroughInviteLink(code: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).joinThroughInviteLink(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} [surface] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public leaveGroup(groupPublicId: string, surface?: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).leaveGroup(groupPublicId, surface, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public listBannedUsers(groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).listBannedUsers(groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public listExcludedDiscussions(groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).listExcludedDiscussions(groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public listGroupResources(groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).listGroupResources(groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public listGroupRules(groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).listGroupRules(groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public listGroupTags(groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).listGroupTags(groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public listInviteLinks(groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).listInviteLinks(groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {Pageable} pageable 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public listInviteRequests(groupPublicId: string, pageable: Pageable, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).listInviteRequests(groupPublicId, pageable, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Pageable} pageable 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public listOwnInviteRequests(pageable: Pageable, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).listOwnInviteRequests(pageable, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public listPendingInvitations(groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).listPendingInvitations(groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} [query] 
     * @param {string} [cutoff] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public listPinnedDiscussionCandidates(groupPublicId: string, query?: string, cutoff?: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).listPinnedDiscussionCandidates(groupPublicId, query, cutoff, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public listPinnedDiscussions(groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).listPinnedDiscussions(groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} [source] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public listRelatedGroupCandidates(groupPublicId: string, source?: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).listRelatedGroupCandidates(groupPublicId, source, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public listRelatedGroups(groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).listRelatedGroups(groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} [source] 
     * @param {string} [q] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public loadGroupDiscussionsToAddModal(groupPublicId: string, source?: string, q?: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).loadGroupDiscussionsToAddModal(groupPublicId, source, q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public loadGroupDiscussionsToAddModalBootstrap(groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).loadGroupDiscussionsToAddModalBootstrap(groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public popularGroupTags(limit?: number, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).popularGroupTags(limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public previewInviteLink(code: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).previewInviteLink(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} submissionPublicId 
     * @param {RejectGroupRequestRequest} [rejectGroupRequestRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public rejectDiscussionSubmission(submissionPublicId: string, rejectGroupRequestRequest?: RejectGroupRequestRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).rejectDiscussionSubmission(submissionPublicId, rejectGroupRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} requestPublicId 
     * @param {RejectGroupRequestRequest} [rejectGroupRequestRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public rejectJoinRequest(requestPublicId: string, rejectGroupRequestRequest?: RejectGroupRequestRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).rejectJoinRequest(requestPublicId, rejectGroupRequestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} discussionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public removeDiscussionFromGroup(groupPublicId: string, discussionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).removeDiscussionFromGroup(groupPublicId, discussionPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public removeLeadership(groupPublicId: string, username: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).removeLeadership(groupPublicId, username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public removeMember(groupPublicId: string, username: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).removeMember(groupPublicId, username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {CreateContentReportRequest} createContentReportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public reportGroup(groupPublicId: string, createContentReportRequest: CreateContentReportRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).reportGroup(groupPublicId, createContentReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public restoreGroup(groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).restoreGroup(groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} invitationPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public revokeInvitation(invitationPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).revokeInvitation(invitationPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public revokeInviteLink1(groupPublicId: string, code: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).revokeInviteLink1(groupPublicId, code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {UpdateGroupNotificationPreferenceRequest} updateGroupNotificationPreferenceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public setGroupNotificationPreference(groupPublicId: string, updateGroupNotificationPreferenceRequest: UpdateGroupNotificationPreferenceRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).setGroupNotificationPreference(groupPublicId, updateGroupNotificationPreferenceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} username 
     * @param {UpdateGroupMemberFlairRequest} updateGroupMemberFlairRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public setMemberFlair(groupPublicId: string, username: string, updateGroupMemberFlairRequest: UpdateGroupMemberFlairRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).setMemberFlair(groupPublicId, username, updateGroupMemberFlairRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public stepDownFromLeadership(groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).stepDownFromLeadership(groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {GroupOwnershipTransferRequest} groupOwnershipTransferRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public transferOwnership(groupPublicId: string, groupOwnershipTransferRequest: GroupOwnershipTransferRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).transferOwnership(groupPublicId, groupOwnershipTransferRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public unbanUser(groupPublicId: string, username: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).unbanUser(groupPublicId, username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} requestPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public undoApproveJoinRequest(requestPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).undoApproveJoinRequest(requestPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} submissionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public undoIgnoreDiscussionSubmission(submissionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).undoIgnoreDiscussionSubmission(submissionPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} requestPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public undoIgnoreInviteRequest(requestPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).undoIgnoreInviteRequest(requestPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} requestPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public undoIgnoreJoinRequest(requestPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).undoIgnoreJoinRequest(requestPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} submissionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public undoRejectDiscussionSubmission(submissionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).undoRejectDiscussionSubmission(submissionPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} discussionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public unexcludeDiscussion(groupPublicId: string, discussionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).unexcludeDiscussion(groupPublicId, discussionPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {UpdateGroupGeneralRequest} updateGroupGeneralRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public updateGroupGeneral(groupPublicId: string, updateGroupGeneralRequest: UpdateGroupGeneralRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).updateGroupGeneral(groupPublicId, updateGroupGeneralRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {number} resourceId 
     * @param {CreateGroupResourceRequest} createGroupResourceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public updateGroupResource(groupPublicId: string, resourceId: number, createGroupResourceRequest: CreateGroupResourceRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).updateGroupResource(groupPublicId, resourceId, createGroupResourceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {number} ruleId 
     * @param {CreateGroupRuleRequest} createGroupRuleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public updateGroupRule(groupPublicId: string, ruleId: number, createGroupRuleRequest: CreateGroupRuleRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).updateGroupRule(groupPublicId, ruleId, createGroupRuleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {number} pinId 
     * @param {UpdatePinnedDiscussionOrderRequest} updatePinnedDiscussionOrderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public updatePinnedDiscussionOrder(groupPublicId: string, pinId: number, updatePinnedDiscussionOrderRequest: UpdatePinnedDiscussionOrderRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).updatePinnedDiscussionOrder(groupPublicId, pinId, updatePinnedDiscussionOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {number} relationId 
     * @param {CreateRelatedGroupRequest} createRelatedGroupRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public updateRelatedGroup(groupPublicId: string, relationId: number, createRelatedGroupRequest: CreateRelatedGroupRequest, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).updateRelatedGroup(groupPublicId, relationId, createRelatedGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} requestPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public withdrawInviteRequest(requestPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).withdrawInviteRequest(requestPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} requestPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxGroupRestControllerApi
     */
    public withdrawJoinRequest(requestPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxGroupRestControllerApiFp(this.configuration).withdrawJoinRequest(requestPublicId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxHandoffRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxHandoffRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        next: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/discussions/unanswered/next`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxHandoffRestControllerApi - functional programming interface
 * @export
 */
export const AjaxHandoffRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxHandoffRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async next(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HandoffCandidate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.next(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxHandoffRestControllerApi.next']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxHandoffRestControllerApi - factory interface
 * @export
 */
export const AjaxHandoffRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxHandoffRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        next(options?: RawAxiosRequestConfig): AxiosPromise<HandoffCandidate> {
            return localVarFp.next(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxHandoffRestControllerApi - object-oriented interface
 * @export
 * @class AjaxHandoffRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxHandoffRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxHandoffRestControllerApi
     */
    public next(options?: RawAxiosRequestConfig) {
        return AjaxHandoffRestControllerApiFp(this.configuration).next(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxHeaderInboxRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxHeaderInboxRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [mode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHeaderInbox: async (mode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/header-inbox`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxHeaderInboxRestControllerApi - functional programming interface
 * @export
 */
export const AjaxHeaderInboxRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxHeaderInboxRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [mode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHeaderInbox(mode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHeaderInbox(mode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxHeaderInboxRestControllerApi.getHeaderInbox']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxHeaderInboxRestControllerApi - factory interface
 * @export
 */
export const AjaxHeaderInboxRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxHeaderInboxRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [mode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHeaderInbox(mode?: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getHeaderInbox(mode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxHeaderInboxRestControllerApi - object-oriented interface
 * @export
 * @class AjaxHeaderInboxRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxHeaderInboxRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} [mode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxHeaderInboxRestControllerApi
     */
    public getHeaderInbox(mode?: string, options?: RawAxiosRequestConfig) {
        return AjaxHeaderInboxRestControllerApiFp(this.configuration).getHeaderInbox(mode, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxInvitationRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxInvitationRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInviteLink: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/invitation/link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInviteLink: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/invitation/link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeInviteLink: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/invitation/link/revoke`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendInvitationRequest} sendInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendInvitation: async (sendInvitationRequest: SendInvitationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendInvitationRequest' is not null or undefined
            assertParamExists('sendInvitation', 'sendInvitationRequest', sendInvitationRequest)
            const localVarPath = `/ajax/invitation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendInvitationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxInvitationRestControllerApi - functional programming interface
 * @export
 */
export const AjaxInvitationRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxInvitationRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInviteLink(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInviteLink(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxInvitationRestControllerApi.createInviteLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInviteLink(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InviteLinkViewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInviteLink(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxInvitationRestControllerApi.getInviteLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeInviteLink(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InviteLinkViewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeInviteLink(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxInvitationRestControllerApi.revokeInviteLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendInvitationRequest} sendInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendInvitation(sendInvitationRequest: SendInvitationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendInvitation(sendInvitationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxInvitationRestControllerApi.sendInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxInvitationRestControllerApi - factory interface
 * @export
 */
export const AjaxInvitationRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxInvitationRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInviteLink(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.createInviteLink(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInviteLink(options?: RawAxiosRequestConfig): AxiosPromise<InviteLinkViewDTO> {
            return localVarFp.getInviteLink(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeInviteLink(options?: RawAxiosRequestConfig): AxiosPromise<InviteLinkViewDTO> {
            return localVarFp.revokeInviteLink(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SendInvitationRequest} sendInvitationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendInvitation(sendInvitationRequest: SendInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.sendInvitation(sendInvitationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxInvitationRestControllerApi - object-oriented interface
 * @export
 * @class AjaxInvitationRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxInvitationRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxInvitationRestControllerApi
     */
    public createInviteLink(options?: RawAxiosRequestConfig) {
        return AjaxInvitationRestControllerApiFp(this.configuration).createInviteLink(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxInvitationRestControllerApi
     */
    public getInviteLink(options?: RawAxiosRequestConfig) {
        return AjaxInvitationRestControllerApiFp(this.configuration).getInviteLink(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxInvitationRestControllerApi
     */
    public revokeInviteLink(options?: RawAxiosRequestConfig) {
        return AjaxInvitationRestControllerApiFp(this.configuration).revokeInviteLink(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SendInvitationRequest} sendInvitationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxInvitationRestControllerApi
     */
    public sendInvitation(sendInvitationRequest: SendInvitationRequest, options?: RawAxiosRequestConfig) {
        return AjaxInvitationRestControllerApiFp(this.configuration).sendInvitation(sendInvitationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxLinkPreviewRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxLinkPreviewRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateLinkPreviewRequest} createLinkPreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPreview: async (createLinkPreviewRequest: CreateLinkPreviewRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createLinkPreviewRequest' is not null or undefined
            assertParamExists('createPreview', 'createLinkPreviewRequest', createLinkPreviewRequest)
            const localVarPath = `/ajax/link-preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createLinkPreviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxLinkPreviewRestControllerApi - functional programming interface
 * @export
 */
export const AjaxLinkPreviewRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxLinkPreviewRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateLinkPreviewRequest} createLinkPreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPreview(createLinkPreviewRequest: CreateLinkPreviewRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalLinkPreviewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPreview(createLinkPreviewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxLinkPreviewRestControllerApi.createPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxLinkPreviewRestControllerApi - factory interface
 * @export
 */
export const AjaxLinkPreviewRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxLinkPreviewRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateLinkPreviewRequest} createLinkPreviewRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPreview(createLinkPreviewRequest: CreateLinkPreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalLinkPreviewDTO> {
            return localVarFp.createPreview(createLinkPreviewRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxLinkPreviewRestControllerApi - object-oriented interface
 * @export
 * @class AjaxLinkPreviewRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxLinkPreviewRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {CreateLinkPreviewRequest} createLinkPreviewRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxLinkPreviewRestControllerApi
     */
    public createPreview(createLinkPreviewRequest: CreateLinkPreviewRequest, options?: RawAxiosRequestConfig) {
        return AjaxLinkPreviewRestControllerApiFp(this.configuration).createPreview(createLinkPreviewRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxMemberProposalRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxMemberProposalRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} proposalPublicId 
         * @param {MemberProposalAcceptRequest} memberProposalAcceptRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptProposal: async (proposalPublicId: string, memberProposalAcceptRequest: MemberProposalAcceptRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'proposalPublicId' is not null or undefined
            assertParamExists('acceptProposal', 'proposalPublicId', proposalPublicId)
            // verify required parameter 'memberProposalAcceptRequest' is not null or undefined
            assertParamExists('acceptProposal', 'memberProposalAcceptRequest', memberProposalAcceptRequest)
            const localVarPath = `/ajax/member-proposals/{proposalPublicId}/accept`
                .replace(`{${"proposalPublicId"}}`, encodeURIComponent(String(proposalPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(memberProposalAcceptRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} proposalPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissProposal: async (proposalPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'proposalPublicId' is not null or undefined
            assertParamExists('dismissProposal', 'proposalPublicId', proposalPublicId)
            const localVarPath = `/ajax/member-proposals/{proposalPublicId}/dismiss`
                .replace(`{${"proposalPublicId"}}`, encodeURIComponent(String(proposalPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} proposalPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProposal: async (proposalPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'proposalPublicId' is not null or undefined
            assertParamExists('getProposal', 'proposalPublicId', proposalPublicId)
            const localVarPath = `/ajax/member-proposals/{proposalPublicId}`
                .replace(`{${"proposalPublicId"}}`, encodeURIComponent(String(proposalPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxMemberProposalRestControllerApi - functional programming interface
 * @export
 */
export const AjaxMemberProposalRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxMemberProposalRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} proposalPublicId 
         * @param {MemberProposalAcceptRequest} memberProposalAcceptRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptProposal(proposalPublicId: string, memberProposalAcceptRequest: MemberProposalAcceptRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberProposalAcceptResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptProposal(proposalPublicId, memberProposalAcceptRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxMemberProposalRestControllerApi.acceptProposal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} proposalPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dismissProposal(proposalPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dismissProposal(proposalPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxMemberProposalRestControllerApi.dismissProposal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} proposalPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProposal(proposalPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberProposalView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProposal(proposalPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxMemberProposalRestControllerApi.getProposal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxMemberProposalRestControllerApi - factory interface
 * @export
 */
export const AjaxMemberProposalRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxMemberProposalRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} proposalPublicId 
         * @param {MemberProposalAcceptRequest} memberProposalAcceptRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptProposal(proposalPublicId: string, memberProposalAcceptRequest: MemberProposalAcceptRequest, options?: RawAxiosRequestConfig): AxiosPromise<MemberProposalAcceptResult> {
            return localVarFp.acceptProposal(proposalPublicId, memberProposalAcceptRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} proposalPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissProposal(proposalPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.dismissProposal(proposalPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} proposalPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProposal(proposalPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<MemberProposalView> {
            return localVarFp.getProposal(proposalPublicId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxMemberProposalRestControllerApi - object-oriented interface
 * @export
 * @class AjaxMemberProposalRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxMemberProposalRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} proposalPublicId 
     * @param {MemberProposalAcceptRequest} memberProposalAcceptRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxMemberProposalRestControllerApi
     */
    public acceptProposal(proposalPublicId: string, memberProposalAcceptRequest: MemberProposalAcceptRequest, options?: RawAxiosRequestConfig) {
        return AjaxMemberProposalRestControllerApiFp(this.configuration).acceptProposal(proposalPublicId, memberProposalAcceptRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} proposalPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxMemberProposalRestControllerApi
     */
    public dismissProposal(proposalPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxMemberProposalRestControllerApiFp(this.configuration).dismissProposal(proposalPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} proposalPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxMemberProposalRestControllerApi
     */
    public getProposal(proposalPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxMemberProposalRestControllerApiFp(this.configuration).getProposal(proposalPublicId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxMemberProposalTestSupportRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxMemberProposalTestSupportRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seedMemberProposal: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/test-support/member-proposals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxMemberProposalTestSupportRestControllerApi - functional programming interface
 * @export
 */
export const AjaxMemberProposalTestSupportRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxMemberProposalTestSupportRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async seedMemberProposal(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.seedMemberProposal(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxMemberProposalTestSupportRestControllerApi.seedMemberProposal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxMemberProposalTestSupportRestControllerApi - factory interface
 * @export
 */
export const AjaxMemberProposalTestSupportRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxMemberProposalTestSupportRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seedMemberProposal(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.seedMemberProposal(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxMemberProposalTestSupportRestControllerApi - object-oriented interface
 * @export
 * @class AjaxMemberProposalTestSupportRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxMemberProposalTestSupportRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxMemberProposalTestSupportRestControllerApi
     */
    public seedMemberProposal(options?: RawAxiosRequestConfig) {
        return AjaxMemberProposalTestSupportRestControllerApiFp(this.configuration).seedMemberProposal(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxMemeRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxMemeRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimMemes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/meme/claim`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateMemeTemplateRequest} createMemeTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplate: async (createMemeTemplateRequest: CreateMemeTemplateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createMemeTemplateRequest' is not null or undefined
            assertParamExists('createTemplate', 'createMemeTemplateRequest', createMemeTemplateRequest)
            const localVarPath = `/ajax/meme/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMemeTemplateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} publicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplate: async (publicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            assertParamExists('getTemplate', 'publicId', publicId)
            const localVarPath = `/ajax/meme/templates/{publicId}`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyMemes: async (page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/meme/my-memes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyTemplates: async (page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/meme/my-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} publicId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplateMemes: async (publicId: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            assertParamExists('listTemplateMemes', 'publicId', publicId)
            const localVarPath = `/ajax/meme/templates/{publicId}/memes`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [query] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplates: async (query?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/meme/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} hash 
         * @param {number} [maxDistance] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nearDuplicates: async (hash: string, maxDistance?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hash' is not null or undefined
            assertParamExists('nearDuplicates', 'hash', hash)
            const localVarPath = `/ajax/meme/near-duplicates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (hash !== undefined) {
                localVarQueryParameter['hash'] = hash;
            }

            if (maxDistance !== undefined) {
                localVarQueryParameter['maxDistance'] = maxDistance;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} publicId 
         * @param {CreateContentReportRequest} createContentReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportMeme: async (publicId: string, createContentReportRequest: CreateContentReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            assertParamExists('reportMeme', 'publicId', publicId)
            // verify required parameter 'createContentReportRequest' is not null or undefined
            assertParamExists('reportMeme', 'createContentReportRequest', createContentReportRequest)
            const localVarPath = `/ajax/meme/memes/{publicId}/report`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createContentReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} publicId 
         * @param {CreateContentReportRequest} createContentReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplate: async (publicId: string, createContentReportRequest: CreateContentReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            assertParamExists('reportTemplate', 'publicId', publicId)
            // verify required parameter 'createContentReportRequest' is not null or undefined
            assertParamExists('reportTemplate', 'createContentReportRequest', createContentReportRequest)
            const localVarPath = `/ajax/meme/templates/{publicId}/report`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createContentReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [templatePublicId] 
         * @param {string} [layout] 
         * @param {SaveMemeRequest} [saveMemeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMeme: async (templatePublicId?: string, layout?: string, saveMemeRequest?: SaveMemeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/meme/memes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (templatePublicId !== undefined) {
                localVarQueryParameter['templatePublicId'] = templatePublicId;
            }

            if (layout !== undefined) {
                localVarQueryParameter['layout'] = layout;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveMemeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SaveUploadedMemeRequest} saveUploadedMemeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUploadedMeme: async (saveUploadedMemeRequest: SaveUploadedMemeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveUploadedMemeRequest' is not null or undefined
            assertParamExists('saveUploadedMeme', 'saveUploadedMemeRequest', saveUploadedMemeRequest)
            const localVarPath = `/ajax/meme/memes/from-upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveUploadedMemeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxMemeRestControllerApi - functional programming interface
 * @export
 */
export const AjaxMemeRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxMemeRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async claimMemes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.claimMemes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxMemeRestControllerApi.claimMemes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateMemeTemplateRequest} createMemeTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTemplate(createMemeTemplateRequest: CreateMemeTemplateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemeTemplateDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTemplate(createMemeTemplateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxMemeRestControllerApi.createTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} publicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemplate(publicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemeTemplateDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemplate(publicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxMemeRestControllerApi.getTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMyMemes(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MemeImageSummaryDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMyMemes(page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxMemeRestControllerApi.listMyMemes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMyTemplates(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MemeTemplateSummaryDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMyTemplates(page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxMemeRestControllerApi.listMyTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} publicId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTemplateMemes(publicId: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PublicMemeSummaryDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTemplateMemes(publicId, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxMemeRestControllerApi.listTemplateMemes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [query] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTemplates(query?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MemeTemplateSummaryDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTemplates(query, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxMemeRestControllerApi.listTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} hash 
         * @param {number} [maxDistance] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nearDuplicates(hash: string, maxDistance?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MemeTemplateMatchDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nearDuplicates(hash, maxDistance, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxMemeRestControllerApi.nearDuplicates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} publicId 
         * @param {CreateContentReportRequest} createContentReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportMeme(publicId: string, createContentReportRequest: CreateContentReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportMeme(publicId, createContentReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxMemeRestControllerApi.reportMeme']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} publicId 
         * @param {CreateContentReportRequest} createContentReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportTemplate(publicId: string, createContentReportRequest: CreateContentReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportTemplate(publicId, createContentReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxMemeRestControllerApi.reportTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [templatePublicId] 
         * @param {string} [layout] 
         * @param {SaveMemeRequest} [saveMemeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveMeme(templatePublicId?: string, layout?: string, saveMemeRequest?: SaveMemeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveMeme(templatePublicId, layout, saveMemeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxMemeRestControllerApi.saveMeme']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SaveUploadedMemeRequest} saveUploadedMemeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveUploadedMeme(saveUploadedMemeRequest: SaveUploadedMemeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveUploadedMeme(saveUploadedMemeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxMemeRestControllerApi.saveUploadedMeme']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxMemeRestControllerApi - factory interface
 * @export
 */
export const AjaxMemeRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxMemeRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claimMemes(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.claimMemes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateMemeTemplateRequest} createMemeTemplateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplate(createMemeTemplateRequest: CreateMemeTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<MemeTemplateDetailDTO> {
            return localVarFp.createTemplate(createMemeTemplateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} publicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplate(publicId: string, options?: RawAxiosRequestConfig): AxiosPromise<MemeTemplateDetailDTO> {
            return localVarFp.getTemplate(publicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyMemes(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<MemeImageSummaryDTO>> {
            return localVarFp.listMyMemes(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyTemplates(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<MemeTemplateSummaryDTO>> {
            return localVarFp.listMyTemplates(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} publicId 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplateMemes(publicId: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<PublicMemeSummaryDTO>> {
            return localVarFp.listTemplateMemes(publicId, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [query] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplates(query?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<MemeTemplateSummaryDTO>> {
            return localVarFp.listTemplates(query, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} hash 
         * @param {number} [maxDistance] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nearDuplicates(hash: string, maxDistance?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<MemeTemplateMatchDTO>> {
            return localVarFp.nearDuplicates(hash, maxDistance, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} publicId 
         * @param {CreateContentReportRequest} createContentReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportMeme(publicId: string, createContentReportRequest: CreateContentReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reportMeme(publicId, createContentReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} publicId 
         * @param {CreateContentReportRequest} createContentReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportTemplate(publicId: string, createContentReportRequest: CreateContentReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reportTemplate(publicId, createContentReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [templatePublicId] 
         * @param {string} [layout] 
         * @param {SaveMemeRequest} [saveMemeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveMeme(templatePublicId?: string, layout?: string, saveMemeRequest?: SaveMemeRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.saveMeme(templatePublicId, layout, saveMemeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SaveUploadedMemeRequest} saveUploadedMemeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveUploadedMeme(saveUploadedMemeRequest: SaveUploadedMemeRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.saveUploadedMeme(saveUploadedMemeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxMemeRestControllerApi - object-oriented interface
 * @export
 * @class AjaxMemeRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxMemeRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxMemeRestControllerApi
     */
    public claimMemes(options?: RawAxiosRequestConfig) {
        return AjaxMemeRestControllerApiFp(this.configuration).claimMemes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateMemeTemplateRequest} createMemeTemplateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxMemeRestControllerApi
     */
    public createTemplate(createMemeTemplateRequest: CreateMemeTemplateRequest, options?: RawAxiosRequestConfig) {
        return AjaxMemeRestControllerApiFp(this.configuration).createTemplate(createMemeTemplateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} publicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxMemeRestControllerApi
     */
    public getTemplate(publicId: string, options?: RawAxiosRequestConfig) {
        return AjaxMemeRestControllerApiFp(this.configuration).getTemplate(publicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxMemeRestControllerApi
     */
    public listMyMemes(page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return AjaxMemeRestControllerApiFp(this.configuration).listMyMemes(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxMemeRestControllerApi
     */
    public listMyTemplates(page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return AjaxMemeRestControllerApiFp(this.configuration).listMyTemplates(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} publicId 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxMemeRestControllerApi
     */
    public listTemplateMemes(publicId: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return AjaxMemeRestControllerApiFp(this.configuration).listTemplateMemes(publicId, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [query] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxMemeRestControllerApi
     */
    public listTemplates(query?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return AjaxMemeRestControllerApiFp(this.configuration).listTemplates(query, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} hash 
     * @param {number} [maxDistance] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxMemeRestControllerApi
     */
    public nearDuplicates(hash: string, maxDistance?: number, options?: RawAxiosRequestConfig) {
        return AjaxMemeRestControllerApiFp(this.configuration).nearDuplicates(hash, maxDistance, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} publicId 
     * @param {CreateContentReportRequest} createContentReportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxMemeRestControllerApi
     */
    public reportMeme(publicId: string, createContentReportRequest: CreateContentReportRequest, options?: RawAxiosRequestConfig) {
        return AjaxMemeRestControllerApiFp(this.configuration).reportMeme(publicId, createContentReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} publicId 
     * @param {CreateContentReportRequest} createContentReportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxMemeRestControllerApi
     */
    public reportTemplate(publicId: string, createContentReportRequest: CreateContentReportRequest, options?: RawAxiosRequestConfig) {
        return AjaxMemeRestControllerApiFp(this.configuration).reportTemplate(publicId, createContentReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [templatePublicId] 
     * @param {string} [layout] 
     * @param {SaveMemeRequest} [saveMemeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxMemeRestControllerApi
     */
    public saveMeme(templatePublicId?: string, layout?: string, saveMemeRequest?: SaveMemeRequest, options?: RawAxiosRequestConfig) {
        return AjaxMemeRestControllerApiFp(this.configuration).saveMeme(templatePublicId, layout, saveMemeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SaveUploadedMemeRequest} saveUploadedMemeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxMemeRestControllerApi
     */
    public saveUploadedMeme(saveUploadedMemeRequest: SaveUploadedMemeRequest, options?: RawAxiosRequestConfig) {
        return AjaxMemeRestControllerApiFp(this.configuration).saveUploadedMeme(saveUploadedMemeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxMetricRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxMetricRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} username 
         * @param {string} [periodType] 
         * @param {number} [periodCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorPostBreakdown: async (username: string, periodType?: string, periodCount?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getAuthorPostBreakdown', 'username', username)
            const localVarPath = `/api/metrics/user/{username}/posts/breakdown`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (periodType !== undefined) {
                localVarQueryParameter['periodType'] = periodType;
            }

            if (periodCount !== undefined) {
                localVarQueryParameter['periodCount'] = periodCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [periodType] 
         * @param {number} [periodCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorPostMetrics: async (username: string, periodType?: string, periodCount?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getAuthorPostMetrics', 'username', username)
            const localVarPath = `/api/metrics/user/{username}/posts`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (periodType !== undefined) {
                localVarQueryParameter['periodType'] = periodType;
            }

            if (periodCount !== undefined) {
                localVarQueryParameter['periodCount'] = periodCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [periodType] 
         * @param {number} [periodCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupMetrics: async (groupPublicId: string, periodType?: string, periodCount?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('getGroupMetrics', 'groupPublicId', groupPublicId)
            const localVarPath = `/api/metrics/group/{groupPublicId}`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (periodType !== undefined) {
                localVarQueryParameter['periodType'] = periodType;
            }

            if (periodCount !== undefined) {
                localVarQueryParameter['periodCount'] = periodCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [periodType] 
         * @param {number} [periodCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetrics: async (discussionPublicId: string, periodType?: string, periodCount?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('getMetrics', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/api/metrics/{discussionPublicId}`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (periodType !== undefined) {
                localVarQueryParameter['periodType'] = periodType;
            }

            if (periodCount !== undefined) {
                localVarQueryParameter['periodCount'] = periodCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {string} [periodType] 
         * @param {number} [periodCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSeriesMetrics: async (seriesPublicId: string, periodType?: string, periodCount?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seriesPublicId' is not null or undefined
            assertParamExists('getSeriesMetrics', 'seriesPublicId', seriesPublicId)
            const localVarPath = `/api/metrics/series/{seriesPublicId}`
                .replace(`{${"seriesPublicId"}}`, encodeURIComponent(String(seriesPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (periodType !== undefined) {
                localVarQueryParameter['periodType'] = periodType;
            }

            if (periodCount !== undefined) {
                localVarQueryParameter['periodCount'] = periodCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [periodType] 
         * @param {number} [periodCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserMetrics: async (username: string, periodType?: string, periodCount?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getUserMetrics', 'username', username)
            const localVarPath = `/api/metrics/user/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (periodType !== undefined) {
                localVarQueryParameter['periodType'] = periodType;
            }

            if (periodCount !== undefined) {
                localVarQueryParameter['periodCount'] = periodCount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxMetricRestControllerApi - functional programming interface
 * @export
 */
export const AjaxMetricRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxMetricRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} username 
         * @param {string} [periodType] 
         * @param {number} [periodCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthorPostBreakdown(username: string, periodType?: string, periodCount?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthorPostBreakdownDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthorPostBreakdown(username, periodType, periodCount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxMetricRestControllerApi.getAuthorPostBreakdown']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [periodType] 
         * @param {number} [periodCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthorPostMetrics(username: string, periodType?: string, periodCount?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetricsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthorPostMetrics(username, periodType, periodCount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxMetricRestControllerApi.getAuthorPostMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [periodType] 
         * @param {number} [periodCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupMetrics(groupPublicId: string, periodType?: string, periodCount?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetricsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupMetrics(groupPublicId, periodType, periodCount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxMetricRestControllerApi.getGroupMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [periodType] 
         * @param {number} [periodCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMetrics(discussionPublicId: string, periodType?: string, periodCount?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetricsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMetrics(discussionPublicId, periodType, periodCount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxMetricRestControllerApi.getMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {string} [periodType] 
         * @param {number} [periodCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSeriesMetrics(seriesPublicId: string, periodType?: string, periodCount?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetricsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSeriesMetrics(seriesPublicId, periodType, periodCount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxMetricRestControllerApi.getSeriesMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [periodType] 
         * @param {number} [periodCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserMetrics(username: string, periodType?: string, periodCount?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetricsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserMetrics(username, periodType, periodCount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxMetricRestControllerApi.getUserMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxMetricRestControllerApi - factory interface
 * @export
 */
export const AjaxMetricRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxMetricRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} username 
         * @param {string} [periodType] 
         * @param {number} [periodCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorPostBreakdown(username: string, periodType?: string, periodCount?: number, options?: RawAxiosRequestConfig): AxiosPromise<AuthorPostBreakdownDto> {
            return localVarFp.getAuthorPostBreakdown(username, periodType, periodCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [periodType] 
         * @param {number} [periodCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorPostMetrics(username: string, periodType?: string, periodCount?: number, options?: RawAxiosRequestConfig): AxiosPromise<MetricsResponseDto> {
            return localVarFp.getAuthorPostMetrics(username, periodType, periodCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [periodType] 
         * @param {number} [periodCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupMetrics(groupPublicId: string, periodType?: string, periodCount?: number, options?: RawAxiosRequestConfig): AxiosPromise<MetricsResponseDto> {
            return localVarFp.getGroupMetrics(groupPublicId, periodType, periodCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [periodType] 
         * @param {number} [periodCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetrics(discussionPublicId: string, periodType?: string, periodCount?: number, options?: RawAxiosRequestConfig): AxiosPromise<MetricsResponseDto> {
            return localVarFp.getMetrics(discussionPublicId, periodType, periodCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {string} [periodType] 
         * @param {number} [periodCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSeriesMetrics(seriesPublicId: string, periodType?: string, periodCount?: number, options?: RawAxiosRequestConfig): AxiosPromise<MetricsResponseDto> {
            return localVarFp.getSeriesMetrics(seriesPublicId, periodType, periodCount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [periodType] 
         * @param {number} [periodCount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserMetrics(username: string, periodType?: string, periodCount?: number, options?: RawAxiosRequestConfig): AxiosPromise<MetricsResponseDto> {
            return localVarFp.getUserMetrics(username, periodType, periodCount, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxMetricRestControllerApi - object-oriented interface
 * @export
 * @class AjaxMetricRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxMetricRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} username 
     * @param {string} [periodType] 
     * @param {number} [periodCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxMetricRestControllerApi
     */
    public getAuthorPostBreakdown(username: string, periodType?: string, periodCount?: number, options?: RawAxiosRequestConfig) {
        return AjaxMetricRestControllerApiFp(this.configuration).getAuthorPostBreakdown(username, periodType, periodCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {string} [periodType] 
     * @param {number} [periodCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxMetricRestControllerApi
     */
    public getAuthorPostMetrics(username: string, periodType?: string, periodCount?: number, options?: RawAxiosRequestConfig) {
        return AjaxMetricRestControllerApiFp(this.configuration).getAuthorPostMetrics(username, periodType, periodCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} [periodType] 
     * @param {number} [periodCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxMetricRestControllerApi
     */
    public getGroupMetrics(groupPublicId: string, periodType?: string, periodCount?: number, options?: RawAxiosRequestConfig) {
        return AjaxMetricRestControllerApiFp(this.configuration).getGroupMetrics(groupPublicId, periodType, periodCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {string} [periodType] 
     * @param {number} [periodCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxMetricRestControllerApi
     */
    public getMetrics(discussionPublicId: string, periodType?: string, periodCount?: number, options?: RawAxiosRequestConfig) {
        return AjaxMetricRestControllerApiFp(this.configuration).getMetrics(discussionPublicId, periodType, periodCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} seriesPublicId 
     * @param {string} [periodType] 
     * @param {number} [periodCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxMetricRestControllerApi
     */
    public getSeriesMetrics(seriesPublicId: string, periodType?: string, periodCount?: number, options?: RawAxiosRequestConfig) {
        return AjaxMetricRestControllerApiFp(this.configuration).getSeriesMetrics(seriesPublicId, periodType, periodCount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {string} [periodType] 
     * @param {number} [periodCount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxMetricRestControllerApi
     */
    public getUserMetrics(username: string, periodType?: string, periodCount?: number, options?: RawAxiosRequestConfig) {
        return AjaxMetricRestControllerApiFp(this.configuration).getUserMetrics(username, periodType, periodCount, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxMindChangedRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxMindChangedRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} thoughtPublicId 
         * @param {MarkMindChangedRequest} markMindChangedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mark: async (thoughtPublicId: string, markMindChangedRequest: MarkMindChangedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'thoughtPublicId' is not null or undefined
            assertParamExists('mark', 'thoughtPublicId', thoughtPublicId)
            // verify required parameter 'markMindChangedRequest' is not null or undefined
            assertParamExists('mark', 'markMindChangedRequest', markMindChangedRequest)
            const localVarPath = `/ajax/mind-changed/{thoughtPublicId}`
                .replace(`{${"thoughtPublicId"}}`, encodeURIComponent(String(thoughtPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markMindChangedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxMindChangedRestControllerApi - functional programming interface
 * @export
 */
export const AjaxMindChangedRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxMindChangedRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} thoughtPublicId 
         * @param {MarkMindChangedRequest} markMindChangedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mark(thoughtPublicId: string, markMindChangedRequest: MarkMindChangedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublishThoughtResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mark(thoughtPublicId, markMindChangedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxMindChangedRestControllerApi.mark']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxMindChangedRestControllerApi - factory interface
 * @export
 */
export const AjaxMindChangedRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxMindChangedRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} thoughtPublicId 
         * @param {MarkMindChangedRequest} markMindChangedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mark(thoughtPublicId: string, markMindChangedRequest: MarkMindChangedRequest, options?: RawAxiosRequestConfig): AxiosPromise<PublishThoughtResponse> {
            return localVarFp.mark(thoughtPublicId, markMindChangedRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxMindChangedRestControllerApi - object-oriented interface
 * @export
 * @class AjaxMindChangedRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxMindChangedRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} thoughtPublicId 
     * @param {MarkMindChangedRequest} markMindChangedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxMindChangedRestControllerApi
     */
    public mark(thoughtPublicId: string, markMindChangedRequest: MarkMindChangedRequest, options?: RawAxiosRequestConfig) {
        return AjaxMindChangedRestControllerApiFp(this.configuration).mark(thoughtPublicId, markMindChangedRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxNewsletterRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxNewsletterRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analytics: async (newsletterPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newsletterPublicId' is not null or undefined
            assertParamExists('analytics', 'newsletterPublicId', newsletterPublicId)
            const localVarPath = `/ajax/newsletter/{newsletterPublicId}/analytics`
                .replace(`{${"newsletterPublicId"}}`, encodeURIComponent(String(newsletterPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} issuePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelIssueSchedule: async (issuePublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issuePublicId' is not null or undefined
            assertParamExists('cancelIssueSchedule', 'issuePublicId', issuePublicId)
            const localVarPath = `/ajax/newsletter/issues/{issuePublicId}/schedule`
                .replace(`{${"issuePublicId"}}`, encodeURIComponent(String(issuePublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeNewsletter: async (newsletterPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newsletterPublicId' is not null or undefined
            assertParamExists('closeNewsletter', 'newsletterPublicId', newsletterPublicId)
            const localVarPath = `/ajax/newsletter/{newsletterPublicId}/close`
                .replace(`{${"newsletterPublicId"}}`, encodeURIComponent(String(newsletterPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {SaveNewsletterIssueRequest} saveNewsletterIssueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIssue: async (newsletterPublicId: string, saveNewsletterIssueRequest: SaveNewsletterIssueRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newsletterPublicId' is not null or undefined
            assertParamExists('createIssue', 'newsletterPublicId', newsletterPublicId)
            // verify required parameter 'saveNewsletterIssueRequest' is not null or undefined
            assertParamExists('createIssue', 'saveNewsletterIssueRequest', saveNewsletterIssueRequest)
            const localVarPath = `/ajax/newsletter/{newsletterPublicId}/issues`
                .replace(`{${"newsletterPublicId"}}`, encodeURIComponent(String(newsletterPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveNewsletterIssueRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateNewsletterRequest} createNewsletterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewsletter: async (createNewsletterRequest: CreateNewsletterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createNewsletterRequest' is not null or undefined
            assertParamExists('createNewsletter', 'createNewsletterRequest', createNewsletterRequest)
            const localVarPath = `/ajax/newsletter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNewsletterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} issuePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIssue: async (issuePublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issuePublicId' is not null or undefined
            assertParamExists('deleteIssue', 'issuePublicId', issuePublicId)
            const localVarPath = `/ajax/newsletter/issues/{issuePublicId}`
                .replace(`{${"issuePublicId"}}`, encodeURIComponent(String(issuePublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discover: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/newsletter/discover`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportSubscribers: async (newsletterPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newsletterPublicId' is not null or undefined
            assertParamExists('exportSubscribers', 'newsletterPublicId', newsletterPublicId)
            const localVarPath = `/ajax/newsletter/{newsletterPublicId}/subscribers/export`
                .replace(`{${"newsletterPublicId"}}`, encodeURIComponent(String(newsletterPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} issuePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssue: async (issuePublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issuePublicId' is not null or undefined
            assertParamExists('getIssue', 'issuePublicId', issuePublicId)
            const localVarPath = `/ajax/newsletter/issues/{issuePublicId}`
                .replace(`{${"issuePublicId"}}`, encodeURIComponent(String(issuePublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsletter: async (newsletterPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newsletterPublicId' is not null or undefined
            assertParamExists('getNewsletter', 'newsletterPublicId', newsletterPublicId)
            const localVarPath = `/ajax/newsletter/{newsletterPublicId}`
                .replace(`{${"newsletterPublicId"}}`, encodeURIComponent(String(newsletterPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {ImportNewsletterSubscribersRequest} importNewsletterSubscribersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importSubscribers: async (newsletterPublicId: string, importNewsletterSubscribersRequest: ImportNewsletterSubscribersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newsletterPublicId' is not null or undefined
            assertParamExists('importSubscribers', 'newsletterPublicId', newsletterPublicId)
            // verify required parameter 'importNewsletterSubscribersRequest' is not null or undefined
            assertParamExists('importSubscribers', 'importNewsletterSubscribersRequest', importNewsletterSubscribersRequest)
            const localVarPath = `/ajax/newsletter/{newsletterPublicId}/subscribers/import`
                .replace(`{${"newsletterPublicId"}}`, encodeURIComponent(String(newsletterPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importNewsletterSubscribersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listIssues: async (newsletterPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newsletterPublicId' is not null or undefined
            assertParamExists('listIssues', 'newsletterPublicId', newsletterPublicId)
            const localVarPath = `/ajax/newsletter/{newsletterPublicId}/issues`
                .replace(`{${"newsletterPublicId"}}`, encodeURIComponent(String(newsletterPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyNewsletters: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/newsletter/mine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMySubscriptions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/newsletter/subscriptions/mine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPublicNewslettersByUser: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('listPublicNewslettersByUser', 'username', username)
            const localVarPath = `/ajax/newsletter/by-user/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSendPostChoices: async (discussionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('listSendPostChoices', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/newsletter/send-post/{discussionPublicId}`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSubscribers: async (newsletterPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newsletterPublicId' is not null or undefined
            assertParamExists('listSubscribers', 'newsletterPublicId', newsletterPublicId)
            const localVarPath = `/ajax/newsletter/{newsletterPublicId}/subscribers`
                .replace(`{${"newsletterPublicId"}}`, encodeURIComponent(String(newsletterPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} issuePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishIssueToWeb: async (issuePublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issuePublicId' is not null or undefined
            assertParamExists('publishIssueToWeb', 'issuePublicId', issuePublicId)
            const localVarPath = `/ajax/newsletter/issues/{issuePublicId}/publish-web`
                .replace(`{${"issuePublicId"}}`, encodeURIComponent(String(issuePublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {RemoveNewsletterSubscriberRequest} removeNewsletterSubscriberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSubscriber: async (newsletterPublicId: string, removeNewsletterSubscriberRequest: RemoveNewsletterSubscriberRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newsletterPublicId' is not null or undefined
            assertParamExists('removeSubscriber', 'newsletterPublicId', newsletterPublicId)
            // verify required parameter 'removeNewsletterSubscriberRequest' is not null or undefined
            assertParamExists('removeSubscriber', 'removeNewsletterSubscriberRequest', removeNewsletterSubscriberRequest)
            const localVarPath = `/ajax/newsletter/{newsletterPublicId}/subscribers/remove`
                .replace(`{${"newsletterPublicId"}}`, encodeURIComponent(String(newsletterPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeNewsletterSubscriberRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} issuePublicId 
         * @param {ScheduleNewsletterIssueRequest} scheduleNewsletterIssueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleIssue: async (issuePublicId: string, scheduleNewsletterIssueRequest: ScheduleNewsletterIssueRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issuePublicId' is not null or undefined
            assertParamExists('scheduleIssue', 'issuePublicId', issuePublicId)
            // verify required parameter 'scheduleNewsletterIssueRequest' is not null or undefined
            assertParamExists('scheduleIssue', 'scheduleNewsletterIssueRequest', scheduleNewsletterIssueRequest)
            const localVarPath = `/ajax/newsletter/issues/{issuePublicId}/schedule`
                .replace(`{${"issuePublicId"}}`, encodeURIComponent(String(issuePublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scheduleNewsletterIssueRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} issuePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendIssue: async (issuePublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issuePublicId' is not null or undefined
            assertParamExists('sendIssue', 'issuePublicId', issuePublicId)
            const localVarPath = `/ajax/newsletter/issues/{issuePublicId}/send`
                .replace(`{${"issuePublicId"}}`, encodeURIComponent(String(issuePublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {SendPostToNewsletterRequest} [sendPostToNewsletterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPostToNewsletter: async (discussionPublicId: string, sendPostToNewsletterRequest?: SendPostToNewsletterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('sendPostToNewsletter', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/newsletter/send-post/{discussionPublicId}`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendPostToNewsletterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribe: async (newsletterPublicId: string, surface?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newsletterPublicId' is not null or undefined
            assertParamExists('subscribe', 'newsletterPublicId', newsletterPublicId)
            const localVarPath = `/ajax/newsletter/subscribe/{newsletterPublicId}`
                .replace(`{${"newsletterPublicId"}}`, encodeURIComponent(String(newsletterPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (surface !== undefined) {
                localVarQueryParameter['surface'] = surface;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {ExternalSubscribeRequest} externalSubscribeRequest 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeExternal: async (newsletterPublicId: string, externalSubscribeRequest: ExternalSubscribeRequest, surface?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newsletterPublicId' is not null or undefined
            assertParamExists('subscribeExternal', 'newsletterPublicId', newsletterPublicId)
            // verify required parameter 'externalSubscribeRequest' is not null or undefined
            assertParamExists('subscribeExternal', 'externalSubscribeRequest', externalSubscribeRequest)
            const localVarPath = `/ajax/newsletter/{newsletterPublicId}/subscribe-external`
                .replace(`{${"newsletterPublicId"}}`, encodeURIComponent(String(newsletterPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (surface !== undefined) {
                localVarQueryParameter['surface'] = surface;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(externalSubscribeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} issuePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSendIssue: async (issuePublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issuePublicId' is not null or undefined
            assertParamExists('testSendIssue', 'issuePublicId', issuePublicId)
            const localVarPath = `/ajax/newsletter/issues/{issuePublicId}/test-send`
                .replace(`{${"issuePublicId"}}`, encodeURIComponent(String(issuePublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribe: async (newsletterPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newsletterPublicId' is not null or undefined
            assertParamExists('unsubscribe', 'newsletterPublicId', newsletterPublicId)
            const localVarPath = `/ajax/newsletter/subscribe/{newsletterPublicId}`
                .replace(`{${"newsletterPublicId"}}`, encodeURIComponent(String(newsletterPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [token] 
         * @param {NewsletterUnsubscribeRequest} [newsletterUnsubscribeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeByToken: async (token?: string, newsletterUnsubscribeRequest?: NewsletterUnsubscribeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/newsletter/unsubscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newsletterUnsubscribeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} issuePublicId 
         * @param {SaveNewsletterIssueRequest} saveNewsletterIssueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIssue: async (issuePublicId: string, saveNewsletterIssueRequest: SaveNewsletterIssueRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issuePublicId' is not null or undefined
            assertParamExists('updateIssue', 'issuePublicId', issuePublicId)
            // verify required parameter 'saveNewsletterIssueRequest' is not null or undefined
            assertParamExists('updateIssue', 'saveNewsletterIssueRequest', saveNewsletterIssueRequest)
            const localVarPath = `/ajax/newsletter/issues/{issuePublicId}`
                .replace(`{${"issuePublicId"}}`, encodeURIComponent(String(issuePublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveNewsletterIssueRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {UpdateNewsletterRequest} updateNewsletterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNewsletter: async (newsletterPublicId: string, updateNewsletterRequest: UpdateNewsletterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newsletterPublicId' is not null or undefined
            assertParamExists('updateNewsletter', 'newsletterPublicId', newsletterPublicId)
            // verify required parameter 'updateNewsletterRequest' is not null or undefined
            assertParamExists('updateNewsletter', 'updateNewsletterRequest', updateNewsletterRequest)
            const localVarPath = `/ajax/newsletter/{newsletterPublicId}`
                .replace(`{${"newsletterPublicId"}}`, encodeURIComponent(String(newsletterPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNewsletterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxNewsletterRestControllerApi - functional programming interface
 * @export
 */
export const AjaxNewsletterRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxNewsletterRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analytics(newsletterPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsletterAnalyticsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analytics(newsletterPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.analytics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} issuePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelIssueSchedule(issuePublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsletterIssueDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelIssueSchedule(issuePublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.cancelIssueSchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async closeNewsletter(newsletterPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsletterDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.closeNewsletter(newsletterPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.closeNewsletter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {SaveNewsletterIssueRequest} saveNewsletterIssueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createIssue(newsletterPublicId: string, saveNewsletterIssueRequest: SaveNewsletterIssueRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsletterIssueDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createIssue(newsletterPublicId, saveNewsletterIssueRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.createIssue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateNewsletterRequest} createNewsletterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNewsletter(createNewsletterRequest: CreateNewsletterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsletterCreatedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNewsletter(createNewsletterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.createNewsletter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} issuePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteIssue(issuePublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteIssue(issuePublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.deleteIssue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discover(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NewsletterDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discover(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.discover']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportSubscribers(newsletterPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportSubscribers(newsletterPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.exportSubscribers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} issuePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIssue(issuePublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsletterIssueDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIssue(issuePublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.getIssue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewsletter(newsletterPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsletterDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNewsletter(newsletterPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.getNewsletter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {ImportNewsletterSubscribersRequest} importNewsletterSubscribersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importSubscribers(newsletterPublicId: string, importNewsletterSubscribersRequest: ImportNewsletterSubscribersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsletterImportResultDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importSubscribers(newsletterPublicId, importNewsletterSubscribersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.importSubscribers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listIssues(newsletterPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NewsletterIssueDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listIssues(newsletterPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.listIssues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMyNewsletters(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NewsletterDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMyNewsletters(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.listMyNewsletters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMySubscriptions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NewsletterMySubscriptionDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMySubscriptions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.listMySubscriptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPublicNewslettersByUser(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NewsletterDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPublicNewslettersByUser(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.listPublicNewslettersByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSendPostChoices(discussionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NewsletterSendPostChoiceDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSendPostChoices(discussionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.listSendPostChoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSubscribers(newsletterPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NewsletterSubscriberDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSubscribers(newsletterPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.listSubscribers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} issuePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishIssueToWeb(issuePublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsletterIssueDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishIssueToWeb(issuePublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.publishIssueToWeb']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {RemoveNewsletterSubscriberRequest} removeNewsletterSubscriberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeSubscriber(newsletterPublicId: string, removeNewsletterSubscriberRequest: RemoveNewsletterSubscriberRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NewsletterSubscriberDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeSubscriber(newsletterPublicId, removeNewsletterSubscriberRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.removeSubscriber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} issuePublicId 
         * @param {ScheduleNewsletterIssueRequest} scheduleNewsletterIssueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduleIssue(issuePublicId: string, scheduleNewsletterIssueRequest: ScheduleNewsletterIssueRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsletterIssueDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduleIssue(issuePublicId, scheduleNewsletterIssueRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.scheduleIssue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} issuePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendIssue(issuePublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsletterIssueSendResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendIssue(issuePublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.sendIssue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {SendPostToNewsletterRequest} [sendPostToNewsletterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendPostToNewsletter(discussionPublicId: string, sendPostToNewsletterRequest?: SendPostToNewsletterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsletterSendPostResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendPostToNewsletter(discussionPublicId, sendPostToNewsletterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.sendPostToNewsletter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribe(newsletterPublicId: string, surface?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsletterDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribe(newsletterPublicId, surface, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.subscribe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {ExternalSubscribeRequest} externalSubscribeRequest 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribeExternal(newsletterPublicId: string, externalSubscribeRequest: ExternalSubscribeRequest, surface?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsletterExternalSubscribeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribeExternal(newsletterPublicId, externalSubscribeRequest, surface, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.subscribeExternal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} issuePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testSendIssue(issuePublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsletterTestSendResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testSendIssue(issuePublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.testSendIssue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unsubscribe(newsletterPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsletterDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unsubscribe(newsletterPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.unsubscribe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [token] 
         * @param {NewsletterUnsubscribeRequest} [newsletterUnsubscribeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unsubscribeByToken(token?: string, newsletterUnsubscribeRequest?: NewsletterUnsubscribeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unsubscribeByToken(token, newsletterUnsubscribeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.unsubscribeByToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} issuePublicId 
         * @param {SaveNewsletterIssueRequest} saveNewsletterIssueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateIssue(issuePublicId: string, saveNewsletterIssueRequest: SaveNewsletterIssueRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsletterIssueDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateIssue(issuePublicId, saveNewsletterIssueRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.updateIssue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {UpdateNewsletterRequest} updateNewsletterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNewsletter(newsletterPublicId: string, updateNewsletterRequest: UpdateNewsletterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsletterDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNewsletter(newsletterPublicId, updateNewsletterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNewsletterRestControllerApi.updateNewsletter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxNewsletterRestControllerApi - factory interface
 * @export
 */
export const AjaxNewsletterRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxNewsletterRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analytics(newsletterPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<NewsletterAnalyticsDTO> {
            return localVarFp.analytics(newsletterPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} issuePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelIssueSchedule(issuePublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<NewsletterIssueDTO> {
            return localVarFp.cancelIssueSchedule(issuePublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeNewsletter(newsletterPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<NewsletterDTO> {
            return localVarFp.closeNewsletter(newsletterPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {SaveNewsletterIssueRequest} saveNewsletterIssueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createIssue(newsletterPublicId: string, saveNewsletterIssueRequest: SaveNewsletterIssueRequest, options?: RawAxiosRequestConfig): AxiosPromise<NewsletterIssueDTO> {
            return localVarFp.createIssue(newsletterPublicId, saveNewsletterIssueRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateNewsletterRequest} createNewsletterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewsletter(createNewsletterRequest: CreateNewsletterRequest, options?: RawAxiosRequestConfig): AxiosPromise<NewsletterCreatedResponse> {
            return localVarFp.createNewsletter(createNewsletterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} issuePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIssue(issuePublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteIssue(issuePublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discover(options?: RawAxiosRequestConfig): AxiosPromise<Array<NewsletterDTO>> {
            return localVarFp.discover(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportSubscribers(newsletterPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.exportSubscribers(newsletterPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} issuePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIssue(issuePublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<NewsletterIssueDTO> {
            return localVarFp.getIssue(issuePublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsletter(newsletterPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<NewsletterDTO> {
            return localVarFp.getNewsletter(newsletterPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {ImportNewsletterSubscribersRequest} importNewsletterSubscribersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importSubscribers(newsletterPublicId: string, importNewsletterSubscribersRequest: ImportNewsletterSubscribersRequest, options?: RawAxiosRequestConfig): AxiosPromise<NewsletterImportResultDTO> {
            return localVarFp.importSubscribers(newsletterPublicId, importNewsletterSubscribersRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listIssues(newsletterPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<NewsletterIssueDTO>> {
            return localVarFp.listIssues(newsletterPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMyNewsletters(options?: RawAxiosRequestConfig): AxiosPromise<Array<NewsletterDTO>> {
            return localVarFp.listMyNewsletters(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMySubscriptions(options?: RawAxiosRequestConfig): AxiosPromise<Array<NewsletterMySubscriptionDTO>> {
            return localVarFp.listMySubscriptions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPublicNewslettersByUser(username: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<NewsletterDTO>> {
            return localVarFp.listPublicNewslettersByUser(username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSendPostChoices(discussionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<NewsletterSendPostChoiceDTO>> {
            return localVarFp.listSendPostChoices(discussionPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSubscribers(newsletterPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<NewsletterSubscriberDTO>> {
            return localVarFp.listSubscribers(newsletterPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} issuePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishIssueToWeb(issuePublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<NewsletterIssueDTO> {
            return localVarFp.publishIssueToWeb(issuePublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {RemoveNewsletterSubscriberRequest} removeNewsletterSubscriberRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeSubscriber(newsletterPublicId: string, removeNewsletterSubscriberRequest: RemoveNewsletterSubscriberRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<NewsletterSubscriberDTO>> {
            return localVarFp.removeSubscriber(newsletterPublicId, removeNewsletterSubscriberRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} issuePublicId 
         * @param {ScheduleNewsletterIssueRequest} scheduleNewsletterIssueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleIssue(issuePublicId: string, scheduleNewsletterIssueRequest: ScheduleNewsletterIssueRequest, options?: RawAxiosRequestConfig): AxiosPromise<NewsletterIssueDTO> {
            return localVarFp.scheduleIssue(issuePublicId, scheduleNewsletterIssueRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} issuePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendIssue(issuePublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<NewsletterIssueSendResponse> {
            return localVarFp.sendIssue(issuePublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {SendPostToNewsletterRequest} [sendPostToNewsletterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPostToNewsletter(discussionPublicId: string, sendPostToNewsletterRequest?: SendPostToNewsletterRequest, options?: RawAxiosRequestConfig): AxiosPromise<NewsletterSendPostResponse> {
            return localVarFp.sendPostToNewsletter(discussionPublicId, sendPostToNewsletterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribe(newsletterPublicId: string, surface?: string, options?: RawAxiosRequestConfig): AxiosPromise<NewsletterDTO> {
            return localVarFp.subscribe(newsletterPublicId, surface, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {ExternalSubscribeRequest} externalSubscribeRequest 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribeExternal(newsletterPublicId: string, externalSubscribeRequest: ExternalSubscribeRequest, surface?: string, options?: RawAxiosRequestConfig): AxiosPromise<NewsletterExternalSubscribeResponse> {
            return localVarFp.subscribeExternal(newsletterPublicId, externalSubscribeRequest, surface, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} issuePublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSendIssue(issuePublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<NewsletterTestSendResponse> {
            return localVarFp.testSendIssue(issuePublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribe(newsletterPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<NewsletterDTO> {
            return localVarFp.unsubscribe(newsletterPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [token] 
         * @param {NewsletterUnsubscribeRequest} [newsletterUnsubscribeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeByToken(token?: string, newsletterUnsubscribeRequest?: NewsletterUnsubscribeRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.unsubscribeByToken(token, newsletterUnsubscribeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} issuePublicId 
         * @param {SaveNewsletterIssueRequest} saveNewsletterIssueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateIssue(issuePublicId: string, saveNewsletterIssueRequest: SaveNewsletterIssueRequest, options?: RawAxiosRequestConfig): AxiosPromise<NewsletterIssueDTO> {
            return localVarFp.updateIssue(issuePublicId, saveNewsletterIssueRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} newsletterPublicId 
         * @param {UpdateNewsletterRequest} updateNewsletterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNewsletter(newsletterPublicId: string, updateNewsletterRequest: UpdateNewsletterRequest, options?: RawAxiosRequestConfig): AxiosPromise<NewsletterDTO> {
            return localVarFp.updateNewsletter(newsletterPublicId, updateNewsletterRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxNewsletterRestControllerApi - object-oriented interface
 * @export
 * @class AjaxNewsletterRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxNewsletterRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} newsletterPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public analytics(newsletterPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).analytics(newsletterPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} issuePublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public cancelIssueSchedule(issuePublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).cancelIssueSchedule(issuePublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} newsletterPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public closeNewsletter(newsletterPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).closeNewsletter(newsletterPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} newsletterPublicId 
     * @param {SaveNewsletterIssueRequest} saveNewsletterIssueRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public createIssue(newsletterPublicId: string, saveNewsletterIssueRequest: SaveNewsletterIssueRequest, options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).createIssue(newsletterPublicId, saveNewsletterIssueRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateNewsletterRequest} createNewsletterRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public createNewsletter(createNewsletterRequest: CreateNewsletterRequest, options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).createNewsletter(createNewsletterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} issuePublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public deleteIssue(issuePublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).deleteIssue(issuePublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public discover(options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).discover(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} newsletterPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public exportSubscribers(newsletterPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).exportSubscribers(newsletterPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} issuePublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public getIssue(issuePublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).getIssue(issuePublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} newsletterPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public getNewsletter(newsletterPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).getNewsletter(newsletterPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} newsletterPublicId 
     * @param {ImportNewsletterSubscribersRequest} importNewsletterSubscribersRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public importSubscribers(newsletterPublicId: string, importNewsletterSubscribersRequest: ImportNewsletterSubscribersRequest, options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).importSubscribers(newsletterPublicId, importNewsletterSubscribersRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} newsletterPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public listIssues(newsletterPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).listIssues(newsletterPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public listMyNewsletters(options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).listMyNewsletters(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public listMySubscriptions(options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).listMySubscriptions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public listPublicNewslettersByUser(username: string, options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).listPublicNewslettersByUser(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public listSendPostChoices(discussionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).listSendPostChoices(discussionPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} newsletterPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public listSubscribers(newsletterPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).listSubscribers(newsletterPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} issuePublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public publishIssueToWeb(issuePublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).publishIssueToWeb(issuePublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} newsletterPublicId 
     * @param {RemoveNewsletterSubscriberRequest} removeNewsletterSubscriberRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public removeSubscriber(newsletterPublicId: string, removeNewsletterSubscriberRequest: RemoveNewsletterSubscriberRequest, options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).removeSubscriber(newsletterPublicId, removeNewsletterSubscriberRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} issuePublicId 
     * @param {ScheduleNewsletterIssueRequest} scheduleNewsletterIssueRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public scheduleIssue(issuePublicId: string, scheduleNewsletterIssueRequest: ScheduleNewsletterIssueRequest, options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).scheduleIssue(issuePublicId, scheduleNewsletterIssueRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} issuePublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public sendIssue(issuePublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).sendIssue(issuePublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {SendPostToNewsletterRequest} [sendPostToNewsletterRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public sendPostToNewsletter(discussionPublicId: string, sendPostToNewsletterRequest?: SendPostToNewsletterRequest, options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).sendPostToNewsletter(discussionPublicId, sendPostToNewsletterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} newsletterPublicId 
     * @param {string} [surface] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public subscribe(newsletterPublicId: string, surface?: string, options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).subscribe(newsletterPublicId, surface, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} newsletterPublicId 
     * @param {ExternalSubscribeRequest} externalSubscribeRequest 
     * @param {string} [surface] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public subscribeExternal(newsletterPublicId: string, externalSubscribeRequest: ExternalSubscribeRequest, surface?: string, options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).subscribeExternal(newsletterPublicId, externalSubscribeRequest, surface, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} issuePublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public testSendIssue(issuePublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).testSendIssue(issuePublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} newsletterPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public unsubscribe(newsletterPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).unsubscribe(newsletterPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [token] 
     * @param {NewsletterUnsubscribeRequest} [newsletterUnsubscribeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public unsubscribeByToken(token?: string, newsletterUnsubscribeRequest?: NewsletterUnsubscribeRequest, options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).unsubscribeByToken(token, newsletterUnsubscribeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} issuePublicId 
     * @param {SaveNewsletterIssueRequest} saveNewsletterIssueRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public updateIssue(issuePublicId: string, saveNewsletterIssueRequest: SaveNewsletterIssueRequest, options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).updateIssue(issuePublicId, saveNewsletterIssueRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} newsletterPublicId 
     * @param {UpdateNewsletterRequest} updateNewsletterRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNewsletterRestControllerApi
     */
    public updateNewsletter(newsletterPublicId: string, updateNewsletterRequest: UpdateNewsletterRequest, options?: RawAxiosRequestConfig) {
        return AjaxNewsletterRestControllerApiFp(this.configuration).updateNewsletter(newsletterPublicId, updateNewsletterRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxNotificationQuietingSettingsRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxNotificationQuietingSettingsRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMutedPosts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/settings/muted-posts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPushPause: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/settings/push-pause`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} duration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pausePush: async (duration: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'duration' is not null or undefined
            assertParamExists('pausePush', 'duration', duration)
            const localVarPath = `/ajax/settings/push-pause`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (duration !== undefined) {
                localVarQueryParameter['duration'] = duration;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumePush: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/settings/push-pause`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxNotificationQuietingSettingsRestControllerApi - functional programming interface
 * @export
 */
export const AjaxNotificationQuietingSettingsRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxNotificationQuietingSettingsRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMutedPosts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MutedPostDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMutedPosts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNotificationQuietingSettingsRestControllerApi.getMutedPosts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPushPause(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PushPauseStateDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPushPause(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNotificationQuietingSettingsRestControllerApi.getPushPause']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} duration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pausePush(duration: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PushPauseStateDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pausePush(duration, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNotificationQuietingSettingsRestControllerApi.pausePush']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumePush(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PushPauseStateDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumePush(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNotificationQuietingSettingsRestControllerApi.resumePush']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxNotificationQuietingSettingsRestControllerApi - factory interface
 * @export
 */
export const AjaxNotificationQuietingSettingsRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxNotificationQuietingSettingsRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMutedPosts(options?: RawAxiosRequestConfig): AxiosPromise<Array<MutedPostDTO>> {
            return localVarFp.getMutedPosts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPushPause(options?: RawAxiosRequestConfig): AxiosPromise<PushPauseStateDTO> {
            return localVarFp.getPushPause(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} duration 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pausePush(duration: string, options?: RawAxiosRequestConfig): AxiosPromise<PushPauseStateDTO> {
            return localVarFp.pausePush(duration, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumePush(options?: RawAxiosRequestConfig): AxiosPromise<PushPauseStateDTO> {
            return localVarFp.resumePush(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxNotificationQuietingSettingsRestControllerApi - object-oriented interface
 * @export
 * @class AjaxNotificationQuietingSettingsRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxNotificationQuietingSettingsRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNotificationQuietingSettingsRestControllerApi
     */
    public getMutedPosts(options?: RawAxiosRequestConfig) {
        return AjaxNotificationQuietingSettingsRestControllerApiFp(this.configuration).getMutedPosts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNotificationQuietingSettingsRestControllerApi
     */
    public getPushPause(options?: RawAxiosRequestConfig) {
        return AjaxNotificationQuietingSettingsRestControllerApiFp(this.configuration).getPushPause(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} duration 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNotificationQuietingSettingsRestControllerApi
     */
    public pausePush(duration: string, options?: RawAxiosRequestConfig) {
        return AjaxNotificationQuietingSettingsRestControllerApiFp(this.configuration).pausePush(duration, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNotificationQuietingSettingsRestControllerApi
     */
    public resumePush(options?: RawAxiosRequestConfig) {
        return AjaxNotificationQuietingSettingsRestControllerApiFp(this.configuration).resumePush(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxNotificationRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxNotificationRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} notificationSuperType 
         * @param {string} [paginationParameter] 
         * @param {boolean} [unreadOnly] 
         * @param {boolean} [mentionsOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications: async (notificationSuperType: string, paginationParameter?: string, unreadOnly?: boolean, mentionsOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationSuperType' is not null or undefined
            assertParamExists('getNotifications', 'notificationSuperType', notificationSuperType)
            const localVarPath = `/ajax/notification/{notificationSuperType}`
                .replace(`{${"notificationSuperType"}}`, encodeURIComponent(String(notificationSuperType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (paginationParameter !== undefined) {
                localVarQueryParameter['paginationParameter'] = paginationParameter;
            }

            if (unreadOnly !== undefined) {
                localVarQueryParameter['unreadOnly'] = unreadOnly;
            }

            if (mentionsOnly !== undefined) {
                localVarQueryParameter['mentionsOnly'] = mentionsOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} notificationPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationAsRead: async (notificationPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationPublicId' is not null or undefined
            assertParamExists('markNotificationAsRead', 'notificationPublicId', notificationPublicId)
            const localVarPath = `/ajax/notification/read/{notificationPublicId}`
                .replace(`{${"notificationPublicId"}}`, encodeURIComponent(String(notificationPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MarkNotificationsAsReadRequest} [markNotificationsAsReadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationsAsRead: async (markNotificationsAsReadRequest?: MarkNotificationsAsReadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/notification/read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markNotificationsAsReadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MarkNotificationsSeenRequest} [markNotificationsSeenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationsSeen: async (markNotificationsSeenRequest?: MarkNotificationsSeenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/notification/seen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markNotificationsSeenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} notificationPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordNotificationEngagement: async (notificationPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationPublicId' is not null or undefined
            assertParamExists('recordNotificationEngagement', 'notificationPublicId', notificationPublicId)
            const localVarPath = `/ajax/notification/engaged/{notificationPublicId}`
                .replace(`{${"notificationPublicId"}}`, encodeURIComponent(String(notificationPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxNotificationRestControllerApi - functional programming interface
 * @export
 */
export const AjaxNotificationRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxNotificationRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} notificationSuperType 
         * @param {string} [paginationParameter] 
         * @param {boolean} [unreadOnly] 
         * @param {boolean} [mentionsOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotifications(notificationSuperType: string, paginationParameter?: string, unreadOnly?: boolean, mentionsOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotifications(notificationSuperType, paginationParameter, unreadOnly, mentionsOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNotificationRestControllerApi.getNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} notificationPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markNotificationAsRead(notificationPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markNotificationAsRead(notificationPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNotificationRestControllerApi.markNotificationAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MarkNotificationsAsReadRequest} [markNotificationsAsReadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markNotificationsAsRead(markNotificationsAsReadRequest?: MarkNotificationsAsReadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markNotificationsAsRead(markNotificationsAsReadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNotificationRestControllerApi.markNotificationsAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MarkNotificationsSeenRequest} [markNotificationsSeenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markNotificationsSeen(markNotificationsSeenRequest?: MarkNotificationsSeenRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markNotificationsSeen(markNotificationsSeenRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNotificationRestControllerApi.markNotificationsSeen']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} notificationPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordNotificationEngagement(notificationPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordNotificationEngagement(notificationPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxNotificationRestControllerApi.recordNotificationEngagement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxNotificationRestControllerApi - factory interface
 * @export
 */
export const AjaxNotificationRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxNotificationRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} notificationSuperType 
         * @param {string} [paginationParameter] 
         * @param {boolean} [unreadOnly] 
         * @param {boolean} [mentionsOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications(notificationSuperType: string, paginationParameter?: string, unreadOnly?: boolean, mentionsOnly?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getNotifications(notificationSuperType, paginationParameter, unreadOnly, mentionsOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} notificationPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationAsRead(notificationPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.markNotificationAsRead(notificationPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MarkNotificationsAsReadRequest} [markNotificationsAsReadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationsAsRead(markNotificationsAsReadRequest?: MarkNotificationsAsReadRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.markNotificationsAsRead(markNotificationsAsReadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MarkNotificationsSeenRequest} [markNotificationsSeenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationsSeen(markNotificationsSeenRequest?: MarkNotificationsSeenRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.markNotificationsSeen(markNotificationsSeenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} notificationPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordNotificationEngagement(notificationPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.recordNotificationEngagement(notificationPublicId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxNotificationRestControllerApi - object-oriented interface
 * @export
 * @class AjaxNotificationRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxNotificationRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} notificationSuperType 
     * @param {string} [paginationParameter] 
     * @param {boolean} [unreadOnly] 
     * @param {boolean} [mentionsOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNotificationRestControllerApi
     */
    public getNotifications(notificationSuperType: string, paginationParameter?: string, unreadOnly?: boolean, mentionsOnly?: boolean, options?: RawAxiosRequestConfig) {
        return AjaxNotificationRestControllerApiFp(this.configuration).getNotifications(notificationSuperType, paginationParameter, unreadOnly, mentionsOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} notificationPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNotificationRestControllerApi
     */
    public markNotificationAsRead(notificationPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxNotificationRestControllerApiFp(this.configuration).markNotificationAsRead(notificationPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MarkNotificationsAsReadRequest} [markNotificationsAsReadRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNotificationRestControllerApi
     */
    public markNotificationsAsRead(markNotificationsAsReadRequest?: MarkNotificationsAsReadRequest, options?: RawAxiosRequestConfig) {
        return AjaxNotificationRestControllerApiFp(this.configuration).markNotificationsAsRead(markNotificationsAsReadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MarkNotificationsSeenRequest} [markNotificationsSeenRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNotificationRestControllerApi
     */
    public markNotificationsSeen(markNotificationsSeenRequest?: MarkNotificationsSeenRequest, options?: RawAxiosRequestConfig) {
        return AjaxNotificationRestControllerApiFp(this.configuration).markNotificationsSeen(markNotificationsSeenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} notificationPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxNotificationRestControllerApi
     */
    public recordNotificationEngagement(notificationPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxNotificationRestControllerApiFp(this.configuration).recordNotificationEngagement(notificationPublicId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxOnboardingChecklistRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxOnboardingChecklistRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeChecklist: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/onboarding/checklist/close`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChecklist: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/onboarding/checklist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxOnboardingChecklistRestControllerApi - functional programming interface
 * @export
 */
export const AjaxOnboardingChecklistRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxOnboardingChecklistRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async closeChecklist(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FirstSessionChecklistStateDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.closeChecklist(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxOnboardingChecklistRestControllerApi.closeChecklist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChecklist(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FirstSessionChecklistStateDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChecklist(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxOnboardingChecklistRestControllerApi.getChecklist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxOnboardingChecklistRestControllerApi - factory interface
 * @export
 */
export const AjaxOnboardingChecklistRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxOnboardingChecklistRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeChecklist(options?: RawAxiosRequestConfig): AxiosPromise<FirstSessionChecklistStateDTO> {
            return localVarFp.closeChecklist(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChecklist(options?: RawAxiosRequestConfig): AxiosPromise<FirstSessionChecklistStateDTO> {
            return localVarFp.getChecklist(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxOnboardingChecklistRestControllerApi - object-oriented interface
 * @export
 * @class AjaxOnboardingChecklistRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxOnboardingChecklistRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxOnboardingChecklistRestControllerApi
     */
    public closeChecklist(options?: RawAxiosRequestConfig) {
        return AjaxOnboardingChecklistRestControllerApiFp(this.configuration).closeChecklist(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxOnboardingChecklistRestControllerApi
     */
    public getChecklist(options?: RawAxiosRequestConfig) {
        return AjaxOnboardingChecklistRestControllerApiFp(this.configuration).getChecklist(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxPageIssueRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxPageIssueRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PageIssueReportRequest} pageIssueReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportPageIssue: async (pageIssueReportRequest: PageIssueReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageIssueReportRequest' is not null or undefined
            assertParamExists('reportPageIssue', 'pageIssueReportRequest', pageIssueReportRequest)
            const localVarPath = `/ajax/page_issue/report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pageIssueReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxPageIssueRestControllerApi - functional programming interface
 * @export
 */
export const AjaxPageIssueRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxPageIssueRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {PageIssueReportRequest} pageIssueReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportPageIssue(pageIssueReportRequest: PageIssueReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportPageIssue(pageIssueReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPageIssueRestControllerApi.reportPageIssue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxPageIssueRestControllerApi - factory interface
 * @export
 */
export const AjaxPageIssueRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxPageIssueRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {PageIssueReportRequest} pageIssueReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportPageIssue(pageIssueReportRequest: PageIssueReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.reportPageIssue(pageIssueReportRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxPageIssueRestControllerApi - object-oriented interface
 * @export
 * @class AjaxPageIssueRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxPageIssueRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {PageIssueReportRequest} pageIssueReportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPageIssueRestControllerApi
     */
    public reportPageIssue(pageIssueReportRequest: PageIssueReportRequest, options?: RawAxiosRequestConfig) {
        return AjaxPageIssueRestControllerApiFp(this.configuration).reportPageIssue(pageIssueReportRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxPaginationControllerApi - axios parameter creator
 * @export
 */
export const AjaxPaginationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [paginationParameter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activeDiscussionsPage: async (paginationParameter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/page/discussions/all/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (paginationParameter !== undefined) {
                localVarQueryParameter['paginationParameter'] = paginationParameter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cutoffOpenedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        boardsToVoteOnPage: async (cutoffOpenedAt?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/page/discussions/boards/to-vote-on`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cutoffOpenedAt !== undefined) {
                localVarQueryParameter['cutoffOpenedAt'] = cutoffOpenedAt;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discussionDraftCountsForLoggedInUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/page/discussion/drafts/counts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cutoffModifiedAt] 
         * @param {string} [status] 
         * @param {string} [facet] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discussionDraftsForLoggedInUser: async (cutoffModifiedAt?: string, status?: string, facet?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/page/discussion/drafts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cutoffModifiedAt !== undefined) {
                localVarQueryParameter['cutoffModifiedAt'] = cutoffModifiedAt;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (facet !== undefined) {
                localVarQueryParameter['facet'] = facet;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tag 
         * @param {string} [cutoffCreationDate] 
         * @param {string} [languageScope] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discussionsByTag: async (tag: string, cutoffCreationDate?: string, languageScope?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tag' is not null or undefined
            assertParamExists('discussionsByTag', 'tag', tag)
            const localVarPath = `/ajax/page/discussions/by-tag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (tag !== undefined) {
                localVarQueryParameter['tag'] = tag;
            }

            if (cutoffCreationDate !== undefined) {
                localVarQueryParameter['cutoffCreationDate'] = cutoffCreationDate;
            }

            if (languageScope !== undefined) {
                localVarQueryParameter['languageScope'] = languageScope;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [cutoffAddedAt] 
         * @param {string} [orderingStyle] 
         * @param {boolean} [questionsOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discussionsInGroup: async (groupPublicId: string, cutoffAddedAt?: string, orderingStyle?: string, questionsOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('discussionsInGroup', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/page/group/discussions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (groupPublicId !== undefined) {
                localVarQueryParameter['groupPublicId'] = groupPublicId;
            }

            if (cutoffAddedAt !== undefined) {
                localVarQueryParameter['cutoffAddedAt'] = cutoffAddedAt;
            }

            if (orderingStyle !== undefined) {
                localVarQueryParameter['orderingStyle'] = orderingStyle;
            }

            if (questionsOnly !== undefined) {
                localVarQueryParameter['questionsOnly'] = questionsOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {string} [cutoff] 
         * @param {string} [orderingStyle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discussionsInSeries: async (seriesPublicId: string, cutoff?: string, orderingStyle?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seriesPublicId' is not null or undefined
            assertParamExists('discussionsInSeries', 'seriesPublicId', seriesPublicId)
            const localVarPath = `/ajax/page/discussions_in_series`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cutoff !== undefined) {
                localVarQueryParameter['cutoff'] = cutoff;
            }

            if (orderingStyle !== undefined) {
                localVarQueryParameter['orderingStyle'] = orderingStyle;
            }

            if (seriesPublicId !== undefined) {
                localVarQueryParameter['seriesPublicId'] = seriesPublicId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [agreement] 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discussionsUserParticipatedIn: async (agreement?: string, cutoffCreationDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/page/my_dashboard/discussions/participated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (agreement !== undefined) {
                localVarQueryParameter['agreement'] = agreement;
            }

            if (cutoffCreationDate !== undefined) {
                localVarQueryParameter['cutoffCreationDate'] = cutoffCreationDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubjectPageSummary: async (slug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('getSubjectPageSummary', 'slug', slug)
            const localVarPath = `/ajax/page/subjects/{slug}/summary`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} publicId 
         * @param {string} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubjectReviews: async (publicId: string, cursor?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            assertParamExists('getSubjectReviews', 'publicId', publicId)
            const localVarPath = `/ajax/page/subjects/{publicId}/reviews`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [cutoffAssignedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupLeaders: async (groupPublicId: string, cutoffAssignedAt?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('groupLeaders', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/page/group/leaders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (groupPublicId !== undefined) {
                localVarQueryParameter['groupPublicId'] = groupPublicId;
            }

            if (cutoffAssignedAt !== undefined) {
                localVarQueryParameter['cutoffAssignedAt'] = cutoffAssignedAt;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [cutoffAddedAt] 
         * @param {string} [search] 
         * @param {string} [role] 
         * @param {string} [sort] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupMembers: async (groupPublicId: string, cutoffAddedAt?: string, search?: string, role?: string, sort?: string, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('groupMembers', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/page/group/members`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (groupPublicId !== undefined) {
                localVarQueryParameter['groupPublicId'] = groupPublicId;
            }

            if (cutoffAddedAt !== undefined) {
                localVarQueryParameter['cutoffAddedAt'] = cutoffAddedAt;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupNeighborhood: async (groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('groupNeighborhood', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/page/groups/{groupPublicId}/neighborhood`
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tag 
         * @param {string} [cutoffSearchScore] 
         * @param {string} [languageScope] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsByTag: async (tag: string, cutoffSearchScore?: string, languageScope?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tag' is not null or undefined
            assertParamExists('groupsByTag', 'tag', tag)
            const localVarPath = `/ajax/page/groups/by-tag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (tag !== undefined) {
                localVarQueryParameter['tag'] = tag;
            }

            if (cutoffSearchScore !== undefined) {
                localVarQueryParameter['cutoffSearchScore'] = cutoffSearchScore;
            }

            if (languageScope !== undefined) {
                localVarQueryParameter['languageScope'] = languageScope;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cutoffSearchScore] 
         * @param {string} [languageScope] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsDirectory: async (cutoffSearchScore?: string, languageScope?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/page/groups/directory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cutoffSearchScore !== undefined) {
                localVarQueryParameter['cutoffSearchScore'] = cutoffSearchScore;
            }

            if (languageScope !== undefined) {
                localVarQueryParameter['languageScope'] = languageScope;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [cutoffAddedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsForDiscussion: async (discussionPublicId: string, cutoffAddedAt?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('groupsForDiscussion', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/page/groups/discussion/added`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (discussionPublicId !== undefined) {
                localVarQueryParameter['discussionPublicId'] = discussionPublicId;
            }

            if (cutoffAddedAt !== undefined) {
                localVarQueryParameter['cutoffAddedAt'] = cutoffAddedAt;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [username] 
         * @param {string} [cutoffAssignedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsLedByUser: async (username?: string, cutoffAssignedAt?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/page/groups/user/led`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (cutoffAssignedAt !== undefined) {
                localVarQueryParameter['cutoffAssignedAt'] = cutoffAssignedAt;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [username] 
         * @param {string} [cutoffAddedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsMemberOfUser: async (username?: string, cutoffAddedAt?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/page/groups/user/member`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (cutoffAddedAt !== undefined) {
                localVarQueryParameter['cutoffAddedAt'] = cutoffAddedAt;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsRelatedToMine: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/page/groups/related-to-mine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeActivePublishers: async (pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/page/home/users/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [includeRecentlyViewed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeDiscoveryBootstrap: async (includeRecentlyViewed?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/page/home/discovery`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeRecentlyViewed !== undefined) {
                localVarQueryParameter['includeRecentlyViewed'] = includeRecentlyViewed;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cursor] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeDiscussionFeed: async (cursor?: string, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/page/home/feed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cursor] 
         * @param {number} [pageSize] 
         * @param {string} [orderingStyle] 
         * @param {string} [range] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeFollowedSeriesFeed: async (cursor?: string, pageSize?: number, orderingStyle?: string, range?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/page/home/series/feed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (orderingStyle !== undefined) {
                localVarQueryParameter['orderingStyle'] = orderingStyle;
            }

            if (range !== undefined) {
                localVarQueryParameter['range'] = range;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cursor] 
         * @param {number} [pageSize] 
         * @param {string} [orderingStyle] 
         * @param {string} [range] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeFollowingFeed: async (cursor?: string, pageSize?: number, orderingStyle?: string, range?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/page/home/following/feed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (orderingStyle !== undefined) {
                localVarQueryParameter['orderingStyle'] = orderingStyle;
            }

            if (range !== undefined) {
                localVarQueryParameter['range'] = range;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeRecommendedGroups: async (pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/page/home/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [orderingStyle] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeRecommendedSeries: async (orderingStyle?: string, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/page/home/series`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orderingStyle !== undefined) {
                localVarQueryParameter['orderingStyle'] = orderingStyle;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cursor] 
         * @param {number} [pageSize] 
         * @param {string} [orderingStyle] 
         * @param {string} [range] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeYourGroupsFeed: async (cursor?: string, pageSize?: number, orderingStyle?: string, range?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/page/home/groups/feed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (orderingStyle !== undefined) {
                localVarQueryParameter['orderingStyle'] = orderingStyle;
            }

            if (range !== undefined) {
                localVarQueryParameter['range'] = range;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [range] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mostAgreedDiscussionsPage: async (range?: string, cursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/page/discussions/all/agreed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (range !== undefined) {
                localVarQueryParameter['range'] = range;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [range] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mostArguedDiscussionsPage: async (range?: string, cursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/page/discussions/all/arguments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (range !== undefined) {
                localVarQueryParameter['range'] = range;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [range] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mostControversialDiscussionsPage: async (range?: string, cursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/page/discussions/all/controversial`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (range !== undefined) {
                localVarQueryParameter['range'] = range;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorName 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newDiscussionsAuthoredByUser: async (authorName: string, cutoffCreationDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorName' is not null or undefined
            assertParamExists('newDiscussionsAuthoredByUser', 'authorName', authorName)
            const localVarPath = `/ajax/page/discussions/user/new`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorName !== undefined) {
                localVarQueryParameter['authorName'] = authorName;
            }

            if (cutoffCreationDate !== undefined) {
                localVarQueryParameter['cutoffCreationDate'] = cutoffCreationDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newDiscussionsPage: async (cutoffCreationDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/page/discussions/all/new`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cutoffCreationDate !== undefined) {
                localVarQueryParameter['cutoffCreationDate'] = cutoffCreationDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newFollowersForUser: async (username: string, cutoffCreationDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('newFollowersForUser', 'username', username)
            const localVarPath = `/ajax/page/users/followers/new`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (cutoffCreationDate !== undefined) {
                localVarQueryParameter['cutoffCreationDate'] = cutoffCreationDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newFollowingsForUser: async (username: string, cutoffCreationDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('newFollowingsForUser', 'username', username)
            const localVarPath = `/ajax/page/users/followings/new`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (cutoffCreationDate !== undefined) {
                localVarQueryParameter['cutoffCreationDate'] = cutoffCreationDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {string} agreementMode 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newThoughtsAgreedByUser: async (username: string, agreementMode: string, cutoffCreationDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('newThoughtsAgreedByUser', 'username', username)
            // verify required parameter 'agreementMode' is not null or undefined
            assertParamExists('newThoughtsAgreedByUser', 'agreementMode', agreementMode)
            const localVarPath = `/ajax/page/thoughts/user/agreed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (agreementMode !== undefined) {
                localVarQueryParameter['agreementMode'] = agreementMode;
            }

            if (cutoffCreationDate !== undefined) {
                localVarQueryParameter['cutoffCreationDate'] = cutoffCreationDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} authorUsername 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newThoughtsAuthoredByUser: async (authorUsername: string, cutoffCreationDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorUsername' is not null or undefined
            assertParamExists('newThoughtsAuthoredByUser', 'authorUsername', authorUsername)
            const localVarPath = `/ajax/page/thoughts/user/authored`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authorUsername !== undefined) {
                localVarQueryParameter['authorUsername'] = authorUsername;
            }

            if (cutoffCreationDate !== undefined) {
                localVarQueryParameter['cutoffCreationDate'] = cutoffCreationDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [cutoffCreatedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pendingDiscussionSubmissionsForGroup: async (groupPublicId: string, cutoffCreatedAt?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('pendingDiscussionSubmissionsForGroup', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/page/group/discussion-submissions/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (groupPublicId !== undefined) {
                localVarQueryParameter['groupPublicId'] = groupPublicId;
            }

            if (cutoffCreatedAt !== undefined) {
                localVarQueryParameter['cutoffCreatedAt'] = cutoffCreatedAt;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} ownerUsername 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicSeriesByOwner: async (ownerUsername: string, cutoffCreationDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ownerUsername' is not null or undefined
            assertParamExists('publicSeriesByOwner', 'ownerUsername', ownerUsername)
            const localVarPath = `/ajax/page/series/owner/public`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ownerUsername !== undefined) {
                localVarQueryParameter['ownerUsername'] = ownerUsername;
            }

            if (cutoffCreationDate !== undefined) {
                localVarQueryParameter['cutoffCreationDate'] = cutoffCreationDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [paginationParameter] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recentlyViewedDiscussions: async (paginationParameter?: string, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/page/discussions/recently-viewed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (paginationParameter !== undefined) {
                localVarQueryParameter['paginationParameter'] = paginationParameter;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {RelatedDiscussionsRelationKindEnum} [relationKind] 
         * @param {number} [cutoffPosition] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        relatedDiscussions: async (discussionPublicId: string, relationKind?: RelatedDiscussionsRelationKindEnum, cutoffPosition?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('relatedDiscussions', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/page/discussions/related`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (discussionPublicId !== undefined) {
                localVarQueryParameter['discussionPublicId'] = discussionPublicId;
            }

            if (relationKind !== undefined) {
                localVarQueryParameter['relationKind'] = relationKind;
            }

            if (cutoffPosition !== undefined) {
                localVarQueryParameter['cutoffPosition'] = cutoffPosition;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [cutoffCreatedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestsToAddDiscussionToGroup: async (discussionPublicId: string, cutoffCreatedAt?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('requestsToAddDiscussionToGroup', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/page/discussion/requests/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (discussionPublicId !== undefined) {
                localVarQueryParameter['discussionPublicId'] = discussionPublicId;
            }

            if (cutoffCreatedAt !== undefined) {
                localVarQueryParameter['cutoffCreatedAt'] = cutoffCreatedAt;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [cutoffCreatedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requiredGroupsForDiscussion: async (discussionPublicId: string, cutoffCreatedAt?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('requiredGroupsForDiscussion', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/page/groups/required`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (discussionPublicId !== undefined) {
                localVarQueryParameter['discussionPublicId'] = discussionPublicId;
            }

            if (cutoffCreatedAt !== undefined) {
                localVarQueryParameter['cutoffCreatedAt'] = cutoffCreatedAt;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {string} [preferredType] 
         * @param {string} [languageScope] 
         * @param {string} [searchId] 
         * @param {boolean} [sensitiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveSearch: async (searchQuery: string, preferredType?: string, languageScope?: string, searchId?: string, sensitiveOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchQuery' is not null or undefined
            assertParamExists('resolveSearch', 'searchQuery', searchQuery)
            const localVarPath = `/ajax/page/search/resolve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }

            if (preferredType !== undefined) {
                localVarQueryParameter['preferredType'] = preferredType;
            }

            if (languageScope !== undefined) {
                localVarQueryParameter['languageScope'] = languageScope;
            }

            if (searchId !== undefined) {
                localVarQueryParameter['searchId'] = searchId;
            }

            if (sensitiveOnly !== undefined) {
                localVarQueryParameter['sensitiveOnly'] = sensitiveOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {string} [cutoffSearchScore] 
         * @param {string} [languageScope] 
         * @param {boolean} [questionsOnly] 
         * @param {string} [searchId] 
         * @param {boolean} [sensitiveOnly] 
         * @param {string} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDiscussions: async (searchQuery: string, cutoffSearchScore?: string, languageScope?: string, questionsOnly?: boolean, searchId?: string, sensitiveOnly?: boolean, order?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchQuery' is not null or undefined
            assertParamExists('searchDiscussions', 'searchQuery', searchQuery)
            const localVarPath = `/ajax/page/discussions/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }

            if (cutoffSearchScore !== undefined) {
                localVarQueryParameter['cutoffSearchScore'] = cutoffSearchScore;
            }

            if (languageScope !== undefined) {
                localVarQueryParameter['languageScope'] = languageScope;
            }

            if (questionsOnly !== undefined) {
                localVarQueryParameter['questionsOnly'] = questionsOnly;
            }

            if (searchId !== undefined) {
                localVarQueryParameter['searchId'] = searchId;
            }

            if (sensitiveOnly !== undefined) {
                localVarQueryParameter['sensitiveOnly'] = sensitiveOnly;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {string} [cutoffSearchScore] 
         * @param {string} [languageScope] 
         * @param {string} [searchId] 
         * @param {string} [surface] 
         * @param {boolean} [sensitiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGroups: async (searchQuery: string, cutoffSearchScore?: string, languageScope?: string, searchId?: string, surface?: string, sensitiveOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchQuery' is not null or undefined
            assertParamExists('searchGroups', 'searchQuery', searchQuery)
            const localVarPath = `/ajax/page/groups/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }

            if (cutoffSearchScore !== undefined) {
                localVarQueryParameter['cutoffSearchScore'] = cutoffSearchScore;
            }

            if (languageScope !== undefined) {
                localVarQueryParameter['languageScope'] = languageScope;
            }

            if (searchId !== undefined) {
                localVarQueryParameter['searchId'] = searchId;
            }

            if (surface !== undefined) {
                localVarQueryParameter['surface'] = surface;
            }

            if (sensitiveOnly !== undefined) {
                localVarQueryParameter['sensitiveOnly'] = sensitiveOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SearchResultClickedRequest} searchResultClickedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchResultClicked: async (searchResultClickedRequest: SearchResultClickedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchResultClickedRequest' is not null or undefined
            assertParamExists('searchResultClicked', 'searchResultClickedRequest', searchResultClickedRequest)
            const localVarPath = `/ajax/page/search/result_clicked`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchResultClickedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {string} [languageScope] 
         * @param {boolean} [sensitiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchResultCounts: async (searchQuery: string, languageScope?: string, sensitiveOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchQuery' is not null or undefined
            assertParamExists('searchResultCounts', 'searchQuery', searchQuery)
            const localVarPath = `/ajax/page/search/counts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }

            if (languageScope !== undefined) {
                localVarQueryParameter['languageScope'] = languageScope;
            }

            if (sensitiveOnly !== undefined) {
                localVarQueryParameter['sensitiveOnly'] = sensitiveOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {string} [cutoffSearchScore] 
         * @param {string} [languageScope] 
         * @param {string} [searchId] 
         * @param {boolean} [sensitiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSeries: async (searchQuery: string, cutoffSearchScore?: string, languageScope?: string, searchId?: string, sensitiveOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchQuery' is not null or undefined
            assertParamExists('searchSeries', 'searchQuery', searchQuery)
            const localVarPath = `/ajax/page/series/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }

            if (cutoffSearchScore !== undefined) {
                localVarQueryParameter['cutoffSearchScore'] = cutoffSearchScore;
            }

            if (languageScope !== undefined) {
                localVarQueryParameter['languageScope'] = languageScope;
            }

            if (searchId !== undefined) {
                localVarQueryParameter['searchId'] = searchId;
            }

            if (sensitiveOnly !== undefined) {
                localVarQueryParameter['sensitiveOnly'] = sensitiveOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {string} [groupPublicId] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSubjectsForReviewSuggestions: async (searchQuery: string, groupPublicId?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchQuery' is not null or undefined
            assertParamExists('searchSubjectsForReviewSuggestions', 'searchQuery', searchQuery)
            const localVarPath = `/ajax/page/subjects/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }

            if (groupPublicId !== undefined) {
                localVarQueryParameter['groupPublicId'] = groupPublicId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SearchSuggestionSelectedRequest} searchSuggestionSelectedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSuggestionSelected: async (searchSuggestionSelectedRequest: SearchSuggestionSelectedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchSuggestionSelectedRequest' is not null or undefined
            assertParamExists('searchSuggestionSelected', 'searchSuggestionSelectedRequest', searchSuggestionSelectedRequest)
            const localVarPath = `/ajax/page/search/suggestion_selected`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchSuggestionSelectedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {boolean} [questionsOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSuggestions: async (searchQuery: string, questionsOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchQuery' is not null or undefined
            assertParamExists('searchSuggestions', 'searchQuery', searchQuery)
            const localVarPath = `/ajax/page/search/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }

            if (questionsOnly !== undefined) {
                localVarQueryParameter['questionsOnly'] = questionsOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTagsForHashtagSuggestions: async (searchQuery: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchQuery' is not null or undefined
            assertParamExists('searchTagsForHashtagSuggestions', 'searchQuery', searchQuery)
            const localVarPath = `/ajax/page/tags/search/hashtag_suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {string} [cutoffSearchScore] 
         * @param {string} [searchId] 
         * @param {boolean} [sensitiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchThoughts: async (searchQuery: string, cutoffSearchScore?: string, searchId?: string, sensitiveOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchQuery' is not null or undefined
            assertParamExists('searchThoughts', 'searchQuery', searchQuery)
            const localVarPath = `/ajax/page/thoughts/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }

            if (cutoffSearchScore !== undefined) {
                localVarQueryParameter['cutoffSearchScore'] = cutoffSearchScore;
            }

            if (searchId !== undefined) {
                localVarQueryParameter['searchId'] = searchId;
            }

            if (sensitiveOnly !== undefined) {
                localVarQueryParameter['sensitiveOnly'] = sensitiveOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {string} [cutoffSearchScore] 
         * @param {boolean} [hadPriorAttempt] 
         * @param {string} [searchId] 
         * @param {boolean} [sensitiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsers: async (searchQuery: string, cutoffSearchScore?: string, hadPriorAttempt?: boolean, searchId?: string, sensitiveOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchQuery' is not null or undefined
            assertParamExists('searchUsers', 'searchQuery', searchQuery)
            const localVarPath = `/ajax/page/users/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }

            if (cutoffSearchScore !== undefined) {
                localVarQueryParameter['cutoffSearchScore'] = cutoffSearchScore;
            }

            if (hadPriorAttempt !== undefined) {
                localVarQueryParameter['hadPriorAttempt'] = hadPriorAttempt;
            }

            if (searchId !== undefined) {
                localVarQueryParameter['searchId'] = searchId;
            }

            if (sensitiveOnly !== undefined) {
                localVarQueryParameter['sensitiveOnly'] = sensitiveOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {string} [cutoffSearchScore] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsersForMentionSuggestions: async (searchQuery: string, cutoffSearchScore?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchQuery' is not null or undefined
            assertParamExists('searchUsersForMentionSuggestions', 'searchQuery', searchQuery)
            const localVarPath = `/ajax/page/users/search/mention_suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }

            if (cutoffSearchScore !== undefined) {
                localVarQueryParameter['cutoffSearchScore'] = cutoffSearchScore;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} ownerUsername 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seriesByOwner: async (ownerUsername: string, cutoffCreationDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ownerUsername' is not null or undefined
            assertParamExists('seriesByOwner', 'ownerUsername', ownerUsername)
            const localVarPath = `/ajax/page/series/owner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ownerUsername !== undefined) {
                localVarQueryParameter['ownerUsername'] = ownerUsername;
            }

            if (cutoffCreationDate !== undefined) {
                localVarQueryParameter['cutoffCreationDate'] = cutoffCreationDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [cutoffAddedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seriesForDiscussion: async (discussionPublicId: string, cutoffAddedAt?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('seriesForDiscussion', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/page/series/discussion/added`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (discussionPublicId !== undefined) {
                localVarQueryParameter['discussionPublicId'] = discussionPublicId;
            }

            if (cutoffAddedAt !== undefined) {
                localVarQueryParameter['cutoffAddedAt'] = cutoffAddedAt;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unansweredPostsPage: async (cutoffCreationDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/page/discussions/questions/unanswered`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cutoffCreationDate !== undefined) {
                localVarQueryParameter['cutoffCreationDate'] = cutoffCreationDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [mode] 
         * @param {string} [orderingStyle] 
         * @param {string} [paginationParameter] 
         * @param {number} [pageSize] 
         * @param {string} [languageScope] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDiscussions: async (username: string, mode?: string, orderingStyle?: string, paginationParameter?: string, pageSize?: number, languageScope?: string, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('userDiscussions', 'username', username)
            const localVarPath = `/ajax/page/discussions/user/ordered`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }

            if (orderingStyle !== undefined) {
                localVarQueryParameter['orderingStyle'] = orderingStyle;
            }

            if (paginationParameter !== undefined) {
                localVarQueryParameter['paginationParameter'] = paginationParameter;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (languageScope !== undefined) {
                localVarQueryParameter['languageScope'] = languageScope;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [scope] 
         * @param {string} [orderingStyle] 
         * @param {string} [visibility] 
         * @param {string} [paginationParameter] 
         * @param {number} [pageSize] 
         * @param {string} [languageScope] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGroups: async (username: string, scope?: string, orderingStyle?: string, visibility?: string, paginationParameter?: string, pageSize?: number, languageScope?: string, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('userGroups', 'username', username)
            const localVarPath = `/ajax/page/groups/user/ordered`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (orderingStyle !== undefined) {
                localVarQueryParameter['orderingStyle'] = orderingStyle;
            }

            if (visibility !== undefined) {
                localVarQueryParameter['visibility'] = visibility;
            }

            if (paginationParameter !== undefined) {
                localVarQueryParameter['paginationParameter'] = paginationParameter;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (languageScope !== undefined) {
                localVarQueryParameter['languageScope'] = languageScope;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} ownerUsername 
         * @param {string} [orderingStyle] 
         * @param {string} [visibility] 
         * @param {string} [paginationParameter] 
         * @param {number} [pageSize] 
         * @param {string} [languageScope] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSeries: async (ownerUsername: string, orderingStyle?: string, visibility?: string, paginationParameter?: string, pageSize?: number, languageScope?: string, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ownerUsername' is not null or undefined
            assertParamExists('userSeries', 'ownerUsername', ownerUsername)
            const localVarPath = `/ajax/page/series/user/ordered`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ownerUsername !== undefined) {
                localVarQueryParameter['ownerUsername'] = ownerUsername;
            }

            if (orderingStyle !== undefined) {
                localVarQueryParameter['orderingStyle'] = orderingStyle;
            }

            if (visibility !== undefined) {
                localVarQueryParameter['visibility'] = visibility;
            }

            if (paginationParameter !== undefined) {
                localVarQueryParameter['paginationParameter'] = paginationParameter;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (languageScope !== undefined) {
                localVarQueryParameter['languageScope'] = languageScope;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [mode] 
         * @param {string} [orderingStyle] 
         * @param {string} [paginationParameter] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userThoughts: async (username: string, mode?: string, orderingStyle?: string, paginationParameter?: string, pageSize?: number, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('userThoughts', 'username', username)
            const localVarPath = `/ajax/page/thoughts/user/ordered`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }

            if (orderingStyle !== undefined) {
                localVarQueryParameter['orderingStyle'] = orderingStyle;
            }

            if (paginationParameter !== undefined) {
                localVarQueryParameter['paginationParameter'] = paginationParameter;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersParticipatingInDiscussion: async (discussionPublicId: string, cutoffCreationDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('usersParticipatingInDiscussion', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/page/users/discussion/new`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (discussionPublicId !== undefined) {
                localVarQueryParameter['discussionPublicId'] = discussionPublicId;
            }

            if (cutoffCreationDate !== undefined) {
                localVarQueryParameter['cutoffCreationDate'] = cutoffCreationDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [cutoffCreatedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersRequestingToJoinGroup: async (groupPublicId: string, cutoffCreatedAt?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('usersRequestingToJoinGroup', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/page/group/requests/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (groupPublicId !== undefined) {
                localVarQueryParameter['groupPublicId'] = groupPublicId;
            }

            if (cutoffCreatedAt !== undefined) {
                localVarQueryParameter['cutoffCreatedAt'] = cutoffCreatedAt;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [cutoffCreatedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewerRequestsForGroup: async (groupPublicId: string, cutoffCreatedAt?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('viewerRequestsForGroup', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/page/group/requests/viewer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (groupPublicId !== undefined) {
                localVarQueryParameter['groupPublicId'] = groupPublicId;
            }

            if (cutoffCreatedAt !== undefined) {
                localVarQueryParameter['cutoffCreatedAt'] = cutoffCreatedAt;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [cutoffAssignedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visibleGroupsLedByUser: async (username: string, cutoffAssignedAt?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('visibleGroupsLedByUser', 'username', username)
            const localVarPath = `/ajax/page/groups/user/led/visible`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (cutoffAssignedAt !== undefined) {
                localVarQueryParameter['cutoffAssignedAt'] = cutoffAssignedAt;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [cutoffAddedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visibleGroupsMemberOfUser: async (username: string, cutoffAddedAt?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('visibleGroupsMemberOfUser', 'username', username)
            const localVarPath = `/ajax/page/groups/user/member/visible`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }

            if (cutoffAddedAt !== undefined) {
                localVarQueryParameter['cutoffAddedAt'] = cutoffAddedAt;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxPaginationControllerApi - functional programming interface
 * @export
 */
export const AjaxPaginationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxPaginationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [paginationParameter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activeDiscussionsPage(paginationParameter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiscussionWithoutContentDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activeDiscussionsPage(paginationParameter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.activeDiscussionsPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [cutoffOpenedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async boardsToVoteOnPage(cutoffOpenedAt?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiscussionWithoutContentDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.boardsToVoteOnPage(cutoffOpenedAt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.boardsToVoteOnPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discussionDraftCountsForLoggedInUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscussionDraftCountsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discussionDraftCountsForLoggedInUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.discussionDraftCountsForLoggedInUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [cutoffModifiedAt] 
         * @param {string} [status] 
         * @param {string} [facet] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discussionDraftsForLoggedInUser(cutoffModifiedAt?: string, status?: string, facet?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiscussionDraftDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discussionDraftsForLoggedInUser(cutoffModifiedAt, status, facet, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.discussionDraftsForLoggedInUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} tag 
         * @param {string} [cutoffCreationDate] 
         * @param {string} [languageScope] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discussionsByTag(tag: string, cutoffCreationDate?: string, languageScope?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiscussionWithoutContentDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discussionsByTag(tag, cutoffCreationDate, languageScope, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.discussionsByTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [cutoffAddedAt] 
         * @param {string} [orderingStyle] 
         * @param {boolean} [questionsOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discussionsInGroup(groupPublicId: string, cutoffAddedAt?: string, orderingStyle?: string, questionsOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupDiscussionDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discussionsInGroup(groupPublicId, cutoffAddedAt, orderingStyle, questionsOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.discussionsInGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {string} [cutoff] 
         * @param {string} [orderingStyle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discussionsInSeries(seriesPublicId: string, cutoff?: string, orderingStyle?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiscussionWithoutContentDTOInSeries>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discussionsInSeries(seriesPublicId, cutoff, orderingStyle, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.discussionsInSeries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [agreement] 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discussionsUserParticipatedIn(agreement?: string, cutoffCreationDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discussionsUserParticipatedIn(agreement, cutoffCreationDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.discussionsUserParticipatedIn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubjectPageSummary(slug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubjectPageSummaryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubjectPageSummary(slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.getSubjectPageSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} publicId 
         * @param {string} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSubjectReviews(publicId: string, cursor?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SubjectReviewDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSubjectReviews(publicId, cursor, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.getSubjectReviews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [cutoffAssignedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupLeaders(groupPublicId: string, cutoffAssignedAt?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserProfileDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupLeaders(groupPublicId, cutoffAssignedAt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.groupLeaders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [cutoffAddedAt] 
         * @param {string} [search] 
         * @param {string} [role] 
         * @param {string} [sort] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupMembers(groupPublicId: string, cutoffAddedAt?: string, search?: string, role?: string, sort?: string, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupMemberDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupMembers(groupPublicId, cutoffAddedAt, search, role, sort, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.groupMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupNeighborhood(groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupNeighborhood(groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.groupNeighborhood']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} tag 
         * @param {string} [cutoffSearchScore] 
         * @param {string} [languageScope] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupsByTag(tag: string, cutoffSearchScore?: string, languageScope?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupsByTag(tag, cutoffSearchScore, languageScope, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.groupsByTag']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [cutoffSearchScore] 
         * @param {string} [languageScope] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupsDirectory(cutoffSearchScore?: string, languageScope?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupsDirectory(cutoffSearchScore, languageScope, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.groupsDirectory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [cutoffAddedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupsForDiscussion(discussionPublicId: string, cutoffAddedAt?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupsForDiscussion(discussionPublicId, cutoffAddedAt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.groupsForDiscussion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [username] 
         * @param {string} [cutoffAssignedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupsLedByUser(username?: string, cutoffAssignedAt?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupsLedByUser(username, cutoffAssignedAt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.groupsLedByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [username] 
         * @param {string} [cutoffAddedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupsMemberOfUser(username?: string, cutoffAddedAt?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupsMemberOfUser(username, cutoffAddedAt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.groupsMemberOfUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async groupsRelatedToMine(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.groupsRelatedToMine(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.groupsRelatedToMine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async homeActivePublishers(pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserProfileDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.homeActivePublishers(pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.homeActivePublishers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [includeRecentlyViewed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async homeDiscoveryBootstrap(includeRecentlyViewed?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HomeDiscoveryBootstrapDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.homeDiscoveryBootstrap(includeRecentlyViewed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.homeDiscoveryBootstrap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [cursor] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async homeDiscussionFeed(cursor?: string, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HomeDiscussionFeedPageDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.homeDiscussionFeed(cursor, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.homeDiscussionFeed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [cursor] 
         * @param {number} [pageSize] 
         * @param {string} [orderingStyle] 
         * @param {string} [range] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async homeFollowedSeriesFeed(cursor?: string, pageSize?: number, orderingStyle?: string, range?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HomeGroupsFeedPageDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.homeFollowedSeriesFeed(cursor, pageSize, orderingStyle, range, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.homeFollowedSeriesFeed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [cursor] 
         * @param {number} [pageSize] 
         * @param {string} [orderingStyle] 
         * @param {string} [range] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async homeFollowingFeed(cursor?: string, pageSize?: number, orderingStyle?: string, range?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HomeGroupsFeedPageDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.homeFollowingFeed(cursor, pageSize, orderingStyle, range, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.homeFollowingFeed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async homeRecommendedGroups(pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.homeRecommendedGroups(pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.homeRecommendedGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [orderingStyle] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async homeRecommendedSeries(orderingStyle?: string, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SeriesDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.homeRecommendedSeries(orderingStyle, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.homeRecommendedSeries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [cursor] 
         * @param {number} [pageSize] 
         * @param {string} [orderingStyle] 
         * @param {string} [range] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async homeYourGroupsFeed(cursor?: string, pageSize?: number, orderingStyle?: string, range?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HomeGroupsFeedPageDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.homeYourGroupsFeed(cursor, pageSize, orderingStyle, range, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.homeYourGroupsFeed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [range] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mostAgreedDiscussionsPage(range?: string, cursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiscussionWithoutContentDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mostAgreedDiscussionsPage(range, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.mostAgreedDiscussionsPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [range] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mostArguedDiscussionsPage(range?: string, cursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiscussionWithoutContentDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mostArguedDiscussionsPage(range, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.mostArguedDiscussionsPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [range] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mostControversialDiscussionsPage(range?: string, cursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiscussionWithoutContentDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mostControversialDiscussionsPage(range, cursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.mostControversialDiscussionsPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorName 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async newDiscussionsAuthoredByUser(authorName: string, cutoffCreationDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiscussionWithoutContentDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.newDiscussionsAuthoredByUser(authorName, cutoffCreationDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.newDiscussionsAuthoredByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async newDiscussionsPage(cutoffCreationDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiscussionWithoutContentDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.newDiscussionsPage(cutoffCreationDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.newDiscussionsPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async newFollowersForUser(username: string, cutoffCreationDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserAsFollowerDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.newFollowersForUser(username, cutoffCreationDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.newFollowersForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async newFollowingsForUser(username: string, cutoffCreationDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserAsFollowingDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.newFollowingsForUser(username, cutoffCreationDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.newFollowingsForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {string} agreementMode 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async newThoughtsAgreedByUser(username: string, agreementMode: string, cutoffCreationDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.newThoughtsAgreedByUser(username, agreementMode, cutoffCreationDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.newThoughtsAgreedByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} authorUsername 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async newThoughtsAuthoredByUser(authorUsername: string, cutoffCreationDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ThoughtInSearchDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.newThoughtsAuthoredByUser(authorUsername, cutoffCreationDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.newThoughtsAuthoredByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [cutoffCreatedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pendingDiscussionSubmissionsForGroup(groupPublicId: string, cutoffCreatedAt?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupDiscussionSubmissionDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pendingDiscussionSubmissionsForGroup(groupPublicId, cutoffCreatedAt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.pendingDiscussionSubmissionsForGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} ownerUsername 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicSeriesByOwner(ownerUsername: string, cutoffCreationDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SeriesDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicSeriesByOwner(ownerUsername, cutoffCreationDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.publicSeriesByOwner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [paginationParameter] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recentlyViewedDiscussions(paginationParameter?: string, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RecentlyViewedDiscussionDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recentlyViewedDiscussions(paginationParameter, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.recentlyViewedDiscussions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {RelatedDiscussionsRelationKindEnum} [relationKind] 
         * @param {number} [cutoffPosition] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async relatedDiscussions(discussionPublicId: string, relationKind?: RelatedDiscussionsRelationKindEnum, cutoffPosition?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RelatedDiscussionDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.relatedDiscussions(discussionPublicId, relationKind, cutoffPosition, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.relatedDiscussions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [cutoffCreatedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestsToAddDiscussionToGroup(discussionPublicId: string, cutoffCreatedAt?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiscussionRequestToAddToGroupDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestsToAddDiscussionToGroup(discussionPublicId, cutoffCreatedAt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.requestsToAddDiscussionToGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [cutoffCreatedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requiredGroupsForDiscussion(discussionPublicId: string, cutoffCreatedAt?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requiredGroupsForDiscussion(discussionPublicId, cutoffCreatedAt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.requiredGroupsForDiscussion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {string} [preferredType] 
         * @param {string} [languageScope] 
         * @param {string} [searchId] 
         * @param {boolean} [sensitiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveSearch(searchQuery: string, preferredType?: string, languageScope?: string, searchId?: string, sensitiveOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchTypeResolutionDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveSearch(searchQuery, preferredType, languageScope, searchId, sensitiveOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.resolveSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {string} [cutoffSearchScore] 
         * @param {string} [languageScope] 
         * @param {boolean} [questionsOnly] 
         * @param {string} [searchId] 
         * @param {boolean} [sensitiveOnly] 
         * @param {string} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchDiscussions(searchQuery: string, cutoffSearchScore?: string, languageScope?: string, questionsOnly?: boolean, searchId?: string, sensitiveOnly?: boolean, order?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiscussionWithoutContentDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchDiscussions(searchQuery, cutoffSearchScore, languageScope, questionsOnly, searchId, sensitiveOnly, order, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.searchDiscussions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {string} [cutoffSearchScore] 
         * @param {string} [languageScope] 
         * @param {string} [searchId] 
         * @param {string} [surface] 
         * @param {boolean} [sensitiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchGroups(searchQuery: string, cutoffSearchScore?: string, languageScope?: string, searchId?: string, surface?: string, sensitiveOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchGroups(searchQuery, cutoffSearchScore, languageScope, searchId, surface, sensitiveOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.searchGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SearchResultClickedRequest} searchResultClickedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchResultClicked(searchResultClickedRequest: SearchResultClickedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchResultClicked(searchResultClickedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.searchResultClicked']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {string} [languageScope] 
         * @param {boolean} [sensitiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchResultCounts(searchQuery: string, languageScope?: string, sensitiveOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchResultCountsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchResultCounts(searchQuery, languageScope, sensitiveOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.searchResultCounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {string} [cutoffSearchScore] 
         * @param {string} [languageScope] 
         * @param {string} [searchId] 
         * @param {boolean} [sensitiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchSeries(searchQuery: string, cutoffSearchScore?: string, languageScope?: string, searchId?: string, sensitiveOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SeriesDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchSeries(searchQuery, cutoffSearchScore, languageScope, searchId, sensitiveOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.searchSeries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {string} [groupPublicId] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchSubjectsForReviewSuggestions(searchQuery: string, groupPublicId?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SubjectSuggestionDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchSubjectsForReviewSuggestions(searchQuery, groupPublicId, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.searchSubjectsForReviewSuggestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SearchSuggestionSelectedRequest} searchSuggestionSelectedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchSuggestionSelected(searchSuggestionSelectedRequest: SearchSuggestionSelectedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchSuggestionSelected(searchSuggestionSelectedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.searchSuggestionSelected']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {boolean} [questionsOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchSuggestions(searchQuery: string, questionsOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchSuggestionsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchSuggestions(searchQuery, questionsOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.searchSuggestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchTagsForHashtagSuggestions(searchQuery: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TagSuggestionDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchTagsForHashtagSuggestions(searchQuery, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.searchTagsForHashtagSuggestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {string} [cutoffSearchScore] 
         * @param {string} [searchId] 
         * @param {boolean} [sensitiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchThoughts(searchQuery: string, cutoffSearchScore?: string, searchId?: string, sensitiveOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ThoughtInSearchDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchThoughts(searchQuery, cutoffSearchScore, searchId, sensitiveOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.searchThoughts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {string} [cutoffSearchScore] 
         * @param {boolean} [hadPriorAttempt] 
         * @param {string} [searchId] 
         * @param {boolean} [sensitiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchUsers(searchQuery: string, cutoffSearchScore?: string, hadPriorAttempt?: boolean, searchId?: string, sensitiveOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserProfileDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchUsers(searchQuery, cutoffSearchScore, hadPriorAttempt, searchId, sensitiveOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.searchUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {string} [cutoffSearchScore] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchUsersForMentionSuggestions(searchQuery: string, cutoffSearchScore?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserProfileDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchUsersForMentionSuggestions(searchQuery, cutoffSearchScore, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.searchUsersForMentionSuggestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} ownerUsername 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async seriesByOwner(ownerUsername: string, cutoffCreationDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SeriesDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.seriesByOwner(ownerUsername, cutoffCreationDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.seriesByOwner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [cutoffAddedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async seriesForDiscussion(discussionPublicId: string, cutoffAddedAt?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SeriesDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.seriesForDiscussion(discussionPublicId, cutoffAddedAt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.seriesForDiscussion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unansweredPostsPage(cutoffCreationDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiscussionWithoutContentDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unansweredPostsPage(cutoffCreationDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.unansweredPostsPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [mode] 
         * @param {string} [orderingStyle] 
         * @param {string} [paginationParameter] 
         * @param {number} [pageSize] 
         * @param {string} [languageScope] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userDiscussions(username: string, mode?: string, orderingStyle?: string, paginationParameter?: string, pageSize?: number, languageScope?: string, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiscussionWithoutContentDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userDiscussions(username, mode, orderingStyle, paginationParameter, pageSize, languageScope, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.userDiscussions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [scope] 
         * @param {string} [orderingStyle] 
         * @param {string} [visibility] 
         * @param {string} [paginationParameter] 
         * @param {number} [pageSize] 
         * @param {string} [languageScope] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userGroups(username: string, scope?: string, orderingStyle?: string, visibility?: string, paginationParameter?: string, pageSize?: number, languageScope?: string, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userGroups(username, scope, orderingStyle, visibility, paginationParameter, pageSize, languageScope, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.userGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} ownerUsername 
         * @param {string} [orderingStyle] 
         * @param {string} [visibility] 
         * @param {string} [paginationParameter] 
         * @param {number} [pageSize] 
         * @param {string} [languageScope] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userSeries(ownerUsername: string, orderingStyle?: string, visibility?: string, paginationParameter?: string, pageSize?: number, languageScope?: string, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SeriesDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userSeries(ownerUsername, orderingStyle, visibility, paginationParameter, pageSize, languageScope, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.userSeries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [mode] 
         * @param {string} [orderingStyle] 
         * @param {string} [paginationParameter] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userThoughts(username: string, mode?: string, orderingStyle?: string, paginationParameter?: string, pageSize?: number, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ThoughtInSearchDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userThoughts(username, mode, orderingStyle, paginationParameter, pageSize, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.userThoughts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersParticipatingInDiscussion(discussionPublicId: string, cutoffCreationDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserParticipatingInDiscussionDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersParticipatingInDiscussion(discussionPublicId, cutoffCreationDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.usersParticipatingInDiscussion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [cutoffCreatedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersRequestingToJoinGroup(groupPublicId: string, cutoffCreatedAt?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserRequestingToJoinDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersRequestingToJoinGroup(groupPublicId, cutoffCreatedAt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.usersRequestingToJoinGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [cutoffCreatedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewerRequestsForGroup(groupPublicId: string, cutoffCreatedAt?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ViewerGroupRequestDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewerRequestsForGroup(groupPublicId, cutoffCreatedAt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.viewerRequestsForGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [cutoffAssignedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visibleGroupsLedByUser(username: string, cutoffAssignedAt?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visibleGroupsLedByUser(username, cutoffAssignedAt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.visibleGroupsLedByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [cutoffAddedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visibleGroupsMemberOfUser(username: string, cutoffAddedAt?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visibleGroupsMemberOfUser(username, cutoffAddedAt, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPaginationControllerApi.visibleGroupsMemberOfUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxPaginationControllerApi - factory interface
 * @export
 */
export const AjaxPaginationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxPaginationControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [paginationParameter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activeDiscussionsPage(paginationParameter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DiscussionWithoutContentDTO>> {
            return localVarFp.activeDiscussionsPage(paginationParameter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cutoffOpenedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        boardsToVoteOnPage(cutoffOpenedAt?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DiscussionWithoutContentDTO>> {
            return localVarFp.boardsToVoteOnPage(cutoffOpenedAt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discussionDraftCountsForLoggedInUser(options?: RawAxiosRequestConfig): AxiosPromise<DiscussionDraftCountsDTO> {
            return localVarFp.discussionDraftCountsForLoggedInUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cutoffModifiedAt] 
         * @param {string} [status] 
         * @param {string} [facet] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discussionDraftsForLoggedInUser(cutoffModifiedAt?: string, status?: string, facet?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DiscussionDraftDTO>> {
            return localVarFp.discussionDraftsForLoggedInUser(cutoffModifiedAt, status, facet, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tag 
         * @param {string} [cutoffCreationDate] 
         * @param {string} [languageScope] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discussionsByTag(tag: string, cutoffCreationDate?: string, languageScope?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DiscussionWithoutContentDTO>> {
            return localVarFp.discussionsByTag(tag, cutoffCreationDate, languageScope, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [cutoffAddedAt] 
         * @param {string} [orderingStyle] 
         * @param {boolean} [questionsOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discussionsInGroup(groupPublicId: string, cutoffAddedAt?: string, orderingStyle?: string, questionsOnly?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupDiscussionDTO>> {
            return localVarFp.discussionsInGroup(groupPublicId, cutoffAddedAt, orderingStyle, questionsOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {string} [cutoff] 
         * @param {string} [orderingStyle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discussionsInSeries(seriesPublicId: string, cutoff?: string, orderingStyle?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DiscussionWithoutContentDTOInSeries>> {
            return localVarFp.discussionsInSeries(seriesPublicId, cutoff, orderingStyle, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [agreement] 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discussionsUserParticipatedIn(agreement?: string, cutoffCreationDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.discussionsUserParticipatedIn(agreement, cutoffCreationDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubjectPageSummary(slug: string, options?: RawAxiosRequestConfig): AxiosPromise<SubjectPageSummaryDTO> {
            return localVarFp.getSubjectPageSummary(slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} publicId 
         * @param {string} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubjectReviews(publicId: string, cursor?: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<SubjectReviewDTO>> {
            return localVarFp.getSubjectReviews(publicId, cursor, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [cutoffAssignedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupLeaders(groupPublicId: string, cutoffAssignedAt?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserProfileDTO>> {
            return localVarFp.groupLeaders(groupPublicId, cutoffAssignedAt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [cutoffAddedAt] 
         * @param {string} [search] 
         * @param {string} [role] 
         * @param {string} [sort] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupMembers(groupPublicId: string, cutoffAddedAt?: string, search?: string, role?: string, sort?: string, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupMemberDTO>> {
            return localVarFp.groupMembers(groupPublicId, cutoffAddedAt, search, role, sort, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupNeighborhood(groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupDTO>> {
            return localVarFp.groupNeighborhood(groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tag 
         * @param {string} [cutoffSearchScore] 
         * @param {string} [languageScope] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsByTag(tag: string, cutoffSearchScore?: string, languageScope?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupDTO>> {
            return localVarFp.groupsByTag(tag, cutoffSearchScore, languageScope, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cutoffSearchScore] 
         * @param {string} [languageScope] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsDirectory(cutoffSearchScore?: string, languageScope?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupDTO>> {
            return localVarFp.groupsDirectory(cutoffSearchScore, languageScope, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [cutoffAddedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsForDiscussion(discussionPublicId: string, cutoffAddedAt?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupDTO>> {
            return localVarFp.groupsForDiscussion(discussionPublicId, cutoffAddedAt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [username] 
         * @param {string} [cutoffAssignedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsLedByUser(username?: string, cutoffAssignedAt?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupDTO>> {
            return localVarFp.groupsLedByUser(username, cutoffAssignedAt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [username] 
         * @param {string} [cutoffAddedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsMemberOfUser(username?: string, cutoffAddedAt?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupDTO>> {
            return localVarFp.groupsMemberOfUser(username, cutoffAddedAt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupsRelatedToMine(options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupDTO>> {
            return localVarFp.groupsRelatedToMine(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeActivePublishers(pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserProfileDTO>> {
            return localVarFp.homeActivePublishers(pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [includeRecentlyViewed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeDiscoveryBootstrap(includeRecentlyViewed?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<HomeDiscoveryBootstrapDTO> {
            return localVarFp.homeDiscoveryBootstrap(includeRecentlyViewed, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cursor] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeDiscussionFeed(cursor?: string, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<HomeDiscussionFeedPageDTO> {
            return localVarFp.homeDiscussionFeed(cursor, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cursor] 
         * @param {number} [pageSize] 
         * @param {string} [orderingStyle] 
         * @param {string} [range] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeFollowedSeriesFeed(cursor?: string, pageSize?: number, orderingStyle?: string, range?: string, options?: RawAxiosRequestConfig): AxiosPromise<HomeGroupsFeedPageDTO> {
            return localVarFp.homeFollowedSeriesFeed(cursor, pageSize, orderingStyle, range, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cursor] 
         * @param {number} [pageSize] 
         * @param {string} [orderingStyle] 
         * @param {string} [range] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeFollowingFeed(cursor?: string, pageSize?: number, orderingStyle?: string, range?: string, options?: RawAxiosRequestConfig): AxiosPromise<HomeGroupsFeedPageDTO> {
            return localVarFp.homeFollowingFeed(cursor, pageSize, orderingStyle, range, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeRecommendedGroups(pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupDTO>> {
            return localVarFp.homeRecommendedGroups(pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [orderingStyle] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeRecommendedSeries(orderingStyle?: string, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<SeriesDTO>> {
            return localVarFp.homeRecommendedSeries(orderingStyle, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cursor] 
         * @param {number} [pageSize] 
         * @param {string} [orderingStyle] 
         * @param {string} [range] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        homeYourGroupsFeed(cursor?: string, pageSize?: number, orderingStyle?: string, range?: string, options?: RawAxiosRequestConfig): AxiosPromise<HomeGroupsFeedPageDTO> {
            return localVarFp.homeYourGroupsFeed(cursor, pageSize, orderingStyle, range, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [range] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mostAgreedDiscussionsPage(range?: string, cursor?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DiscussionWithoutContentDTO>> {
            return localVarFp.mostAgreedDiscussionsPage(range, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [range] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mostArguedDiscussionsPage(range?: string, cursor?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DiscussionWithoutContentDTO>> {
            return localVarFp.mostArguedDiscussionsPage(range, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [range] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mostControversialDiscussionsPage(range?: string, cursor?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DiscussionWithoutContentDTO>> {
            return localVarFp.mostControversialDiscussionsPage(range, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorName 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newDiscussionsAuthoredByUser(authorName: string, cutoffCreationDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DiscussionWithoutContentDTO>> {
            return localVarFp.newDiscussionsAuthoredByUser(authorName, cutoffCreationDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newDiscussionsPage(cutoffCreationDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DiscussionWithoutContentDTO>> {
            return localVarFp.newDiscussionsPage(cutoffCreationDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newFollowersForUser(username: string, cutoffCreationDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserAsFollowerDTO>> {
            return localVarFp.newFollowersForUser(username, cutoffCreationDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newFollowingsForUser(username: string, cutoffCreationDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserAsFollowingDTO>> {
            return localVarFp.newFollowingsForUser(username, cutoffCreationDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {string} agreementMode 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newThoughtsAgreedByUser(username: string, agreementMode: string, cutoffCreationDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.newThoughtsAgreedByUser(username, agreementMode, cutoffCreationDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} authorUsername 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newThoughtsAuthoredByUser(authorUsername: string, cutoffCreationDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ThoughtInSearchDTO>> {
            return localVarFp.newThoughtsAuthoredByUser(authorUsername, cutoffCreationDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [cutoffCreatedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pendingDiscussionSubmissionsForGroup(groupPublicId: string, cutoffCreatedAt?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupDiscussionSubmissionDTO>> {
            return localVarFp.pendingDiscussionSubmissionsForGroup(groupPublicId, cutoffCreatedAt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} ownerUsername 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicSeriesByOwner(ownerUsername: string, cutoffCreationDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SeriesDTO>> {
            return localVarFp.publicSeriesByOwner(ownerUsername, cutoffCreationDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [paginationParameter] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recentlyViewedDiscussions(paginationParameter?: string, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<RecentlyViewedDiscussionDTO>> {
            return localVarFp.recentlyViewedDiscussions(paginationParameter, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {RelatedDiscussionsRelationKindEnum} [relationKind] 
         * @param {number} [cutoffPosition] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        relatedDiscussions(discussionPublicId: string, relationKind?: RelatedDiscussionsRelationKindEnum, cutoffPosition?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<RelatedDiscussionDTO>> {
            return localVarFp.relatedDiscussions(discussionPublicId, relationKind, cutoffPosition, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [cutoffCreatedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestsToAddDiscussionToGroup(discussionPublicId: string, cutoffCreatedAt?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DiscussionRequestToAddToGroupDTO>> {
            return localVarFp.requestsToAddDiscussionToGroup(discussionPublicId, cutoffCreatedAt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [cutoffCreatedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requiredGroupsForDiscussion(discussionPublicId: string, cutoffCreatedAt?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupDTO>> {
            return localVarFp.requiredGroupsForDiscussion(discussionPublicId, cutoffCreatedAt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {string} [preferredType] 
         * @param {string} [languageScope] 
         * @param {string} [searchId] 
         * @param {boolean} [sensitiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveSearch(searchQuery: string, preferredType?: string, languageScope?: string, searchId?: string, sensitiveOnly?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<SearchTypeResolutionDTO> {
            return localVarFp.resolveSearch(searchQuery, preferredType, languageScope, searchId, sensitiveOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {string} [cutoffSearchScore] 
         * @param {string} [languageScope] 
         * @param {boolean} [questionsOnly] 
         * @param {string} [searchId] 
         * @param {boolean} [sensitiveOnly] 
         * @param {string} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDiscussions(searchQuery: string, cutoffSearchScore?: string, languageScope?: string, questionsOnly?: boolean, searchId?: string, sensitiveOnly?: boolean, order?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DiscussionWithoutContentDTO>> {
            return localVarFp.searchDiscussions(searchQuery, cutoffSearchScore, languageScope, questionsOnly, searchId, sensitiveOnly, order, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {string} [cutoffSearchScore] 
         * @param {string} [languageScope] 
         * @param {string} [searchId] 
         * @param {string} [surface] 
         * @param {boolean} [sensitiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchGroups(searchQuery: string, cutoffSearchScore?: string, languageScope?: string, searchId?: string, surface?: string, sensitiveOnly?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupDTO>> {
            return localVarFp.searchGroups(searchQuery, cutoffSearchScore, languageScope, searchId, surface, sensitiveOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SearchResultClickedRequest} searchResultClickedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchResultClicked(searchResultClickedRequest: SearchResultClickedRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.searchResultClicked(searchResultClickedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {string} [languageScope] 
         * @param {boolean} [sensitiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchResultCounts(searchQuery: string, languageScope?: string, sensitiveOnly?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<SearchResultCountsDTO> {
            return localVarFp.searchResultCounts(searchQuery, languageScope, sensitiveOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {string} [cutoffSearchScore] 
         * @param {string} [languageScope] 
         * @param {string} [searchId] 
         * @param {boolean} [sensitiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSeries(searchQuery: string, cutoffSearchScore?: string, languageScope?: string, searchId?: string, sensitiveOnly?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<SeriesDTO>> {
            return localVarFp.searchSeries(searchQuery, cutoffSearchScore, languageScope, searchId, sensitiveOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {string} [groupPublicId] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSubjectsForReviewSuggestions(searchQuery: string, groupPublicId?: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<SubjectSuggestionDTO>> {
            return localVarFp.searchSubjectsForReviewSuggestions(searchQuery, groupPublicId, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SearchSuggestionSelectedRequest} searchSuggestionSelectedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSuggestionSelected(searchSuggestionSelectedRequest: SearchSuggestionSelectedRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.searchSuggestionSelected(searchSuggestionSelectedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {boolean} [questionsOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSuggestions(searchQuery: string, questionsOnly?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<SearchSuggestionsDTO> {
            return localVarFp.searchSuggestions(searchQuery, questionsOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTagsForHashtagSuggestions(searchQuery: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<TagSuggestionDTO>> {
            return localVarFp.searchTagsForHashtagSuggestions(searchQuery, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {string} [cutoffSearchScore] 
         * @param {string} [searchId] 
         * @param {boolean} [sensitiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchThoughts(searchQuery: string, cutoffSearchScore?: string, searchId?: string, sensitiveOnly?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<ThoughtInSearchDTO>> {
            return localVarFp.searchThoughts(searchQuery, cutoffSearchScore, searchId, sensitiveOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {string} [cutoffSearchScore] 
         * @param {boolean} [hadPriorAttempt] 
         * @param {string} [searchId] 
         * @param {boolean} [sensitiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsers(searchQuery: string, cutoffSearchScore?: string, hadPriorAttempt?: boolean, searchId?: string, sensitiveOnly?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserProfileDTO>> {
            return localVarFp.searchUsers(searchQuery, cutoffSearchScore, hadPriorAttempt, searchId, sensitiveOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} searchQuery 
         * @param {string} [cutoffSearchScore] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsersForMentionSuggestions(searchQuery: string, cutoffSearchScore?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserProfileDTO>> {
            return localVarFp.searchUsersForMentionSuggestions(searchQuery, cutoffSearchScore, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} ownerUsername 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seriesByOwner(ownerUsername: string, cutoffCreationDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SeriesDTO>> {
            return localVarFp.seriesByOwner(ownerUsername, cutoffCreationDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [cutoffAddedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seriesForDiscussion(discussionPublicId: string, cutoffAddedAt?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SeriesDTO>> {
            return localVarFp.seriesForDiscussion(discussionPublicId, cutoffAddedAt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unansweredPostsPage(cutoffCreationDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DiscussionWithoutContentDTO>> {
            return localVarFp.unansweredPostsPage(cutoffCreationDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [mode] 
         * @param {string} [orderingStyle] 
         * @param {string} [paginationParameter] 
         * @param {number} [pageSize] 
         * @param {string} [languageScope] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userDiscussions(username: string, mode?: string, orderingStyle?: string, paginationParameter?: string, pageSize?: number, languageScope?: string, query?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DiscussionWithoutContentDTO>> {
            return localVarFp.userDiscussions(username, mode, orderingStyle, paginationParameter, pageSize, languageScope, query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [scope] 
         * @param {string} [orderingStyle] 
         * @param {string} [visibility] 
         * @param {string} [paginationParameter] 
         * @param {number} [pageSize] 
         * @param {string} [languageScope] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userGroups(username: string, scope?: string, orderingStyle?: string, visibility?: string, paginationParameter?: string, pageSize?: number, languageScope?: string, query?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupDTO>> {
            return localVarFp.userGroups(username, scope, orderingStyle, visibility, paginationParameter, pageSize, languageScope, query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} ownerUsername 
         * @param {string} [orderingStyle] 
         * @param {string} [visibility] 
         * @param {string} [paginationParameter] 
         * @param {number} [pageSize] 
         * @param {string} [languageScope] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userSeries(ownerUsername: string, orderingStyle?: string, visibility?: string, paginationParameter?: string, pageSize?: number, languageScope?: string, query?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SeriesDTO>> {
            return localVarFp.userSeries(ownerUsername, orderingStyle, visibility, paginationParameter, pageSize, languageScope, query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [mode] 
         * @param {string} [orderingStyle] 
         * @param {string} [paginationParameter] 
         * @param {number} [pageSize] 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userThoughts(username: string, mode?: string, orderingStyle?: string, paginationParameter?: string, pageSize?: number, query?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ThoughtInSearchDTO>> {
            return localVarFp.userThoughts(username, mode, orderingStyle, paginationParameter, pageSize, query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [cutoffCreationDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersParticipatingInDiscussion(discussionPublicId: string, cutoffCreationDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserParticipatingInDiscussionDTO>> {
            return localVarFp.usersParticipatingInDiscussion(discussionPublicId, cutoffCreationDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [cutoffCreatedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersRequestingToJoinGroup(groupPublicId: string, cutoffCreatedAt?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserRequestingToJoinDTO>> {
            return localVarFp.usersRequestingToJoinGroup(groupPublicId, cutoffCreatedAt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} groupPublicId 
         * @param {string} [cutoffCreatedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewerRequestsForGroup(groupPublicId: string, cutoffCreatedAt?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ViewerGroupRequestDTO>> {
            return localVarFp.viewerRequestsForGroup(groupPublicId, cutoffCreatedAt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [cutoffAssignedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visibleGroupsLedByUser(username: string, cutoffAssignedAt?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupDTO>> {
            return localVarFp.visibleGroupsLedByUser(username, cutoffAssignedAt, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [cutoffAddedAt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visibleGroupsMemberOfUser(username: string, cutoffAddedAt?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupDTO>> {
            return localVarFp.visibleGroupsMemberOfUser(username, cutoffAddedAt, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxPaginationControllerApi - object-oriented interface
 * @export
 * @class AjaxPaginationControllerApi
 * @extends {BaseAPI}
 */
export class AjaxPaginationControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} [paginationParameter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public activeDiscussionsPage(paginationParameter?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).activeDiscussionsPage(paginationParameter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cutoffOpenedAt] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public boardsToVoteOnPage(cutoffOpenedAt?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).boardsToVoteOnPage(cutoffOpenedAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public discussionDraftCountsForLoggedInUser(options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).discussionDraftCountsForLoggedInUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cutoffModifiedAt] 
     * @param {string} [status] 
     * @param {string} [facet] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public discussionDraftsForLoggedInUser(cutoffModifiedAt?: string, status?: string, facet?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).discussionDraftsForLoggedInUser(cutoffModifiedAt, status, facet, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tag 
     * @param {string} [cutoffCreationDate] 
     * @param {string} [languageScope] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public discussionsByTag(tag: string, cutoffCreationDate?: string, languageScope?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).discussionsByTag(tag, cutoffCreationDate, languageScope, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} [cutoffAddedAt] 
     * @param {string} [orderingStyle] 
     * @param {boolean} [questionsOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public discussionsInGroup(groupPublicId: string, cutoffAddedAt?: string, orderingStyle?: string, questionsOnly?: boolean, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).discussionsInGroup(groupPublicId, cutoffAddedAt, orderingStyle, questionsOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} seriesPublicId 
     * @param {string} [cutoff] 
     * @param {string} [orderingStyle] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public discussionsInSeries(seriesPublicId: string, cutoff?: string, orderingStyle?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).discussionsInSeries(seriesPublicId, cutoff, orderingStyle, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [agreement] 
     * @param {string} [cutoffCreationDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public discussionsUserParticipatedIn(agreement?: string, cutoffCreationDate?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).discussionsUserParticipatedIn(agreement, cutoffCreationDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public getSubjectPageSummary(slug: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).getSubjectPageSummary(slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} publicId 
     * @param {string} [cursor] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public getSubjectReviews(publicId: string, cursor?: string, limit?: number, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).getSubjectReviews(publicId, cursor, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} [cutoffAssignedAt] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public groupLeaders(groupPublicId: string, cutoffAssignedAt?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).groupLeaders(groupPublicId, cutoffAssignedAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} [cutoffAddedAt] 
     * @param {string} [search] 
     * @param {string} [role] 
     * @param {string} [sort] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public groupMembers(groupPublicId: string, cutoffAddedAt?: string, search?: string, role?: string, sort?: string, pageSize?: number, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).groupMembers(groupPublicId, cutoffAddedAt, search, role, sort, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public groupNeighborhood(groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).groupNeighborhood(groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tag 
     * @param {string} [cutoffSearchScore] 
     * @param {string} [languageScope] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public groupsByTag(tag: string, cutoffSearchScore?: string, languageScope?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).groupsByTag(tag, cutoffSearchScore, languageScope, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cutoffSearchScore] 
     * @param {string} [languageScope] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public groupsDirectory(cutoffSearchScore?: string, languageScope?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).groupsDirectory(cutoffSearchScore, languageScope, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {string} [cutoffAddedAt] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public groupsForDiscussion(discussionPublicId: string, cutoffAddedAt?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).groupsForDiscussion(discussionPublicId, cutoffAddedAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [username] 
     * @param {string} [cutoffAssignedAt] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public groupsLedByUser(username?: string, cutoffAssignedAt?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).groupsLedByUser(username, cutoffAssignedAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [username] 
     * @param {string} [cutoffAddedAt] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public groupsMemberOfUser(username?: string, cutoffAddedAt?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).groupsMemberOfUser(username, cutoffAddedAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public groupsRelatedToMine(options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).groupsRelatedToMine(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public homeActivePublishers(pageSize?: number, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).homeActivePublishers(pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [includeRecentlyViewed] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public homeDiscoveryBootstrap(includeRecentlyViewed?: boolean, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).homeDiscoveryBootstrap(includeRecentlyViewed, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cursor] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public homeDiscussionFeed(cursor?: string, pageSize?: number, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).homeDiscussionFeed(cursor, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cursor] 
     * @param {number} [pageSize] 
     * @param {string} [orderingStyle] 
     * @param {string} [range] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public homeFollowedSeriesFeed(cursor?: string, pageSize?: number, orderingStyle?: string, range?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).homeFollowedSeriesFeed(cursor, pageSize, orderingStyle, range, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cursor] 
     * @param {number} [pageSize] 
     * @param {string} [orderingStyle] 
     * @param {string} [range] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public homeFollowingFeed(cursor?: string, pageSize?: number, orderingStyle?: string, range?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).homeFollowingFeed(cursor, pageSize, orderingStyle, range, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public homeRecommendedGroups(pageSize?: number, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).homeRecommendedGroups(pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [orderingStyle] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public homeRecommendedSeries(orderingStyle?: string, pageSize?: number, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).homeRecommendedSeries(orderingStyle, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cursor] 
     * @param {number} [pageSize] 
     * @param {string} [orderingStyle] 
     * @param {string} [range] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public homeYourGroupsFeed(cursor?: string, pageSize?: number, orderingStyle?: string, range?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).homeYourGroupsFeed(cursor, pageSize, orderingStyle, range, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [range] 
     * @param {string} [cursor] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public mostAgreedDiscussionsPage(range?: string, cursor?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).mostAgreedDiscussionsPage(range, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [range] 
     * @param {string} [cursor] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public mostArguedDiscussionsPage(range?: string, cursor?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).mostArguedDiscussionsPage(range, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [range] 
     * @param {string} [cursor] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public mostControversialDiscussionsPage(range?: string, cursor?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).mostControversialDiscussionsPage(range, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorName 
     * @param {string} [cutoffCreationDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public newDiscussionsAuthoredByUser(authorName: string, cutoffCreationDate?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).newDiscussionsAuthoredByUser(authorName, cutoffCreationDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cutoffCreationDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public newDiscussionsPage(cutoffCreationDate?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).newDiscussionsPage(cutoffCreationDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {string} [cutoffCreationDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public newFollowersForUser(username: string, cutoffCreationDate?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).newFollowersForUser(username, cutoffCreationDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {string} [cutoffCreationDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public newFollowingsForUser(username: string, cutoffCreationDate?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).newFollowingsForUser(username, cutoffCreationDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {string} agreementMode 
     * @param {string} [cutoffCreationDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public newThoughtsAgreedByUser(username: string, agreementMode: string, cutoffCreationDate?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).newThoughtsAgreedByUser(username, agreementMode, cutoffCreationDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} authorUsername 
     * @param {string} [cutoffCreationDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public newThoughtsAuthoredByUser(authorUsername: string, cutoffCreationDate?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).newThoughtsAuthoredByUser(authorUsername, cutoffCreationDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} [cutoffCreatedAt] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public pendingDiscussionSubmissionsForGroup(groupPublicId: string, cutoffCreatedAt?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).pendingDiscussionSubmissionsForGroup(groupPublicId, cutoffCreatedAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} ownerUsername 
     * @param {string} [cutoffCreationDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public publicSeriesByOwner(ownerUsername: string, cutoffCreationDate?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).publicSeriesByOwner(ownerUsername, cutoffCreationDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [paginationParameter] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public recentlyViewedDiscussions(paginationParameter?: string, pageSize?: number, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).recentlyViewedDiscussions(paginationParameter, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {RelatedDiscussionsRelationKindEnum} [relationKind] 
     * @param {number} [cutoffPosition] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public relatedDiscussions(discussionPublicId: string, relationKind?: RelatedDiscussionsRelationKindEnum, cutoffPosition?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).relatedDiscussions(discussionPublicId, relationKind, cutoffPosition, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {string} [cutoffCreatedAt] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public requestsToAddDiscussionToGroup(discussionPublicId: string, cutoffCreatedAt?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).requestsToAddDiscussionToGroup(discussionPublicId, cutoffCreatedAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {string} [cutoffCreatedAt] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public requiredGroupsForDiscussion(discussionPublicId: string, cutoffCreatedAt?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).requiredGroupsForDiscussion(discussionPublicId, cutoffCreatedAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} searchQuery 
     * @param {string} [preferredType] 
     * @param {string} [languageScope] 
     * @param {string} [searchId] 
     * @param {boolean} [sensitiveOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public resolveSearch(searchQuery: string, preferredType?: string, languageScope?: string, searchId?: string, sensitiveOnly?: boolean, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).resolveSearch(searchQuery, preferredType, languageScope, searchId, sensitiveOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} searchQuery 
     * @param {string} [cutoffSearchScore] 
     * @param {string} [languageScope] 
     * @param {boolean} [questionsOnly] 
     * @param {string} [searchId] 
     * @param {boolean} [sensitiveOnly] 
     * @param {string} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public searchDiscussions(searchQuery: string, cutoffSearchScore?: string, languageScope?: string, questionsOnly?: boolean, searchId?: string, sensitiveOnly?: boolean, order?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).searchDiscussions(searchQuery, cutoffSearchScore, languageScope, questionsOnly, searchId, sensitiveOnly, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} searchQuery 
     * @param {string} [cutoffSearchScore] 
     * @param {string} [languageScope] 
     * @param {string} [searchId] 
     * @param {string} [surface] 
     * @param {boolean} [sensitiveOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public searchGroups(searchQuery: string, cutoffSearchScore?: string, languageScope?: string, searchId?: string, surface?: string, sensitiveOnly?: boolean, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).searchGroups(searchQuery, cutoffSearchScore, languageScope, searchId, surface, sensitiveOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SearchResultClickedRequest} searchResultClickedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public searchResultClicked(searchResultClickedRequest: SearchResultClickedRequest, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).searchResultClicked(searchResultClickedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} searchQuery 
     * @param {string} [languageScope] 
     * @param {boolean} [sensitiveOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public searchResultCounts(searchQuery: string, languageScope?: string, sensitiveOnly?: boolean, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).searchResultCounts(searchQuery, languageScope, sensitiveOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} searchQuery 
     * @param {string} [cutoffSearchScore] 
     * @param {string} [languageScope] 
     * @param {string} [searchId] 
     * @param {boolean} [sensitiveOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public searchSeries(searchQuery: string, cutoffSearchScore?: string, languageScope?: string, searchId?: string, sensitiveOnly?: boolean, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).searchSeries(searchQuery, cutoffSearchScore, languageScope, searchId, sensitiveOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} searchQuery 
     * @param {string} [groupPublicId] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public searchSubjectsForReviewSuggestions(searchQuery: string, groupPublicId?: string, limit?: number, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).searchSubjectsForReviewSuggestions(searchQuery, groupPublicId, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SearchSuggestionSelectedRequest} searchSuggestionSelectedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public searchSuggestionSelected(searchSuggestionSelectedRequest: SearchSuggestionSelectedRequest, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).searchSuggestionSelected(searchSuggestionSelectedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} searchQuery 
     * @param {boolean} [questionsOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public searchSuggestions(searchQuery: string, questionsOnly?: boolean, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).searchSuggestions(searchQuery, questionsOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} searchQuery 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public searchTagsForHashtagSuggestions(searchQuery: string, limit?: number, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).searchTagsForHashtagSuggestions(searchQuery, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} searchQuery 
     * @param {string} [cutoffSearchScore] 
     * @param {string} [searchId] 
     * @param {boolean} [sensitiveOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public searchThoughts(searchQuery: string, cutoffSearchScore?: string, searchId?: string, sensitiveOnly?: boolean, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).searchThoughts(searchQuery, cutoffSearchScore, searchId, sensitiveOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} searchQuery 
     * @param {string} [cutoffSearchScore] 
     * @param {boolean} [hadPriorAttempt] 
     * @param {string} [searchId] 
     * @param {boolean} [sensitiveOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public searchUsers(searchQuery: string, cutoffSearchScore?: string, hadPriorAttempt?: boolean, searchId?: string, sensitiveOnly?: boolean, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).searchUsers(searchQuery, cutoffSearchScore, hadPriorAttempt, searchId, sensitiveOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} searchQuery 
     * @param {string} [cutoffSearchScore] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public searchUsersForMentionSuggestions(searchQuery: string, cutoffSearchScore?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).searchUsersForMentionSuggestions(searchQuery, cutoffSearchScore, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} ownerUsername 
     * @param {string} [cutoffCreationDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public seriesByOwner(ownerUsername: string, cutoffCreationDate?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).seriesByOwner(ownerUsername, cutoffCreationDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {string} [cutoffAddedAt] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public seriesForDiscussion(discussionPublicId: string, cutoffAddedAt?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).seriesForDiscussion(discussionPublicId, cutoffAddedAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [cutoffCreationDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public unansweredPostsPage(cutoffCreationDate?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).unansweredPostsPage(cutoffCreationDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {string} [mode] 
     * @param {string} [orderingStyle] 
     * @param {string} [paginationParameter] 
     * @param {number} [pageSize] 
     * @param {string} [languageScope] 
     * @param {string} [query] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public userDiscussions(username: string, mode?: string, orderingStyle?: string, paginationParameter?: string, pageSize?: number, languageScope?: string, query?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).userDiscussions(username, mode, orderingStyle, paginationParameter, pageSize, languageScope, query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {string} [scope] 
     * @param {string} [orderingStyle] 
     * @param {string} [visibility] 
     * @param {string} [paginationParameter] 
     * @param {number} [pageSize] 
     * @param {string} [languageScope] 
     * @param {string} [query] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public userGroups(username: string, scope?: string, orderingStyle?: string, visibility?: string, paginationParameter?: string, pageSize?: number, languageScope?: string, query?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).userGroups(username, scope, orderingStyle, visibility, paginationParameter, pageSize, languageScope, query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} ownerUsername 
     * @param {string} [orderingStyle] 
     * @param {string} [visibility] 
     * @param {string} [paginationParameter] 
     * @param {number} [pageSize] 
     * @param {string} [languageScope] 
     * @param {string} [query] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public userSeries(ownerUsername: string, orderingStyle?: string, visibility?: string, paginationParameter?: string, pageSize?: number, languageScope?: string, query?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).userSeries(ownerUsername, orderingStyle, visibility, paginationParameter, pageSize, languageScope, query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {string} [mode] 
     * @param {string} [orderingStyle] 
     * @param {string} [paginationParameter] 
     * @param {number} [pageSize] 
     * @param {string} [query] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public userThoughts(username: string, mode?: string, orderingStyle?: string, paginationParameter?: string, pageSize?: number, query?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).userThoughts(username, mode, orderingStyle, paginationParameter, pageSize, query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {string} [cutoffCreationDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public usersParticipatingInDiscussion(discussionPublicId: string, cutoffCreationDate?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).usersParticipatingInDiscussion(discussionPublicId, cutoffCreationDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} [cutoffCreatedAt] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public usersRequestingToJoinGroup(groupPublicId: string, cutoffCreatedAt?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).usersRequestingToJoinGroup(groupPublicId, cutoffCreatedAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} groupPublicId 
     * @param {string} [cutoffCreatedAt] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public viewerRequestsForGroup(groupPublicId: string, cutoffCreatedAt?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).viewerRequestsForGroup(groupPublicId, cutoffCreatedAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {string} [cutoffAssignedAt] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public visibleGroupsLedByUser(username: string, cutoffAssignedAt?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).visibleGroupsLedByUser(username, cutoffAssignedAt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {string} [cutoffAddedAt] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPaginationControllerApi
     */
    public visibleGroupsMemberOfUser(username: string, cutoffAddedAt?: string, options?: RawAxiosRequestConfig) {
        return AjaxPaginationControllerApiFp(this.configuration).visibleGroupsMemberOfUser(username, cutoffAddedAt, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const RelatedDiscussionsRelationKindEnum = {
    Similar: 'SIMILAR',
    Contrasting: 'CONTRASTING'
} as const;
export type RelatedDiscussionsRelationKindEnum = typeof RelatedDiscussionsRelationKindEnum[keyof typeof RelatedDiscussionsRelationKindEnum];


/**
 * AjaxPollRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxPollRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {number} [side] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        results: async (discussionPublicId: string, side?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('results', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/poll/{discussionPublicId}/results`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (side !== undefined) {
                localVarQueryParameter['side'] = side;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {PollVoteRequest} [pollVoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vote: async (discussionPublicId: string, pollVoteRequest?: PollVoteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('vote', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/poll/{discussionPublicId}/vote`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pollVoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxPollRestControllerApi - functional programming interface
 * @export
 */
export const AjaxPollRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxPollRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {number} [side] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async results(discussionPublicId: string, side?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PollResultsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.results(discussionPublicId, side, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPollRestControllerApi.results']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {PollVoteRequest} [pollVoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vote(discussionPublicId: string, pollVoteRequest?: PollVoteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vote(discussionPublicId, pollVoteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPollRestControllerApi.vote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxPollRestControllerApi - factory interface
 * @export
 */
export const AjaxPollRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxPollRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {number} [side] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        results(discussionPublicId: string, side?: number, options?: RawAxiosRequestConfig): AxiosPromise<PollResultsDTO> {
            return localVarFp.results(discussionPublicId, side, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {PollVoteRequest} [pollVoteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vote(discussionPublicId: string, pollVoteRequest?: PollVoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.vote(discussionPublicId, pollVoteRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxPollRestControllerApi - object-oriented interface
 * @export
 * @class AjaxPollRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxPollRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} discussionPublicId 
     * @param {number} [side] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPollRestControllerApi
     */
    public results(discussionPublicId: string, side?: number, options?: RawAxiosRequestConfig) {
        return AjaxPollRestControllerApiFp(this.configuration).results(discussionPublicId, side, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {PollVoteRequest} [pollVoteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPollRestControllerApi
     */
    public vote(discussionPublicId: string, pollVoteRequest?: PollVoteRequest, options?: RawAxiosRequestConfig) {
        return AjaxPollRestControllerApiFp(this.configuration).vote(discussionPublicId, pollVoteRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxProfileWallRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxProfileWallRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readPreferences: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/user/wall/preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [cursor] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readWall: async (username: string, cursor?: string, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('readWall', 'username', username)
            const localVarPath = `/ajax/user/wall/profile/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} kind 
         * @param {number} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEntry: async (kind: string, sourceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'kind' is not null or undefined
            assertParamExists('removeEntry', 'kind', kind)
            // verify required parameter 'sourceId' is not null or undefined
            assertParamExists('removeEntry', 'sourceId', sourceId)
            const localVarPath = `/ajax/user/wall/entry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }

            if (sourceId !== undefined) {
                localVarQueryParameter['sourceId'] = sourceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WallPreferencesRequest} wallPreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePreferences: async (wallPreferencesRequest: WallPreferencesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'wallPreferencesRequest' is not null or undefined
            assertParamExists('updatePreferences', 'wallPreferencesRequest', wallPreferencesRequest)
            const localVarPath = `/ajax/user/wall/preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(wallPreferencesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxProfileWallRestControllerApi - functional programming interface
 * @export
 */
export const AjaxProfileWallRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxProfileWallRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readPreferences(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readPreferences(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxProfileWallRestControllerApi.readPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [cursor] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readWall(username: string, cursor?: string, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileWallPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readWall(username, cursor, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxProfileWallRestControllerApi.readWall']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} kind 
         * @param {number} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeEntry(kind: string, sourceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeEntry(kind, sourceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxProfileWallRestControllerApi.removeEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {WallPreferencesRequest} wallPreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePreferences(wallPreferencesRequest: WallPreferencesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePreferences(wallPreferencesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxProfileWallRestControllerApi.updatePreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxProfileWallRestControllerApi - factory interface
 * @export
 */
export const AjaxProfileWallRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxProfileWallRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readPreferences(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.readPreferences(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [cursor] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readWall(username: string, cursor?: string, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<ProfileWallPage> {
            return localVarFp.readWall(username, cursor, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} kind 
         * @param {number} sourceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeEntry(kind: string, sourceId: number, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.removeEntry(kind, sourceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WallPreferencesRequest} wallPreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePreferences(wallPreferencesRequest: WallPreferencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.updatePreferences(wallPreferencesRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxProfileWallRestControllerApi - object-oriented interface
 * @export
 * @class AjaxProfileWallRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxProfileWallRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxProfileWallRestControllerApi
     */
    public readPreferences(options?: RawAxiosRequestConfig) {
        return AjaxProfileWallRestControllerApiFp(this.configuration).readPreferences(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {string} [cursor] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxProfileWallRestControllerApi
     */
    public readWall(username: string, cursor?: string, pageSize?: number, options?: RawAxiosRequestConfig) {
        return AjaxProfileWallRestControllerApiFp(this.configuration).readWall(username, cursor, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} kind 
     * @param {number} sourceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxProfileWallRestControllerApi
     */
    public removeEntry(kind: string, sourceId: number, options?: RawAxiosRequestConfig) {
        return AjaxProfileWallRestControllerApiFp(this.configuration).removeEntry(kind, sourceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WallPreferencesRequest} wallPreferencesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxProfileWallRestControllerApi
     */
    public updatePreferences(wallPreferencesRequest: WallPreferencesRequest, options?: RawAxiosRequestConfig) {
        return AjaxProfileWallRestControllerApiFp(this.configuration).updatePreferences(wallPreferencesRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxPushSubscriptionRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxPushSubscriptionRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVapidPublicKey: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/push/vapid-public-key`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PushDeviceRegistrationRequest} pushDeviceRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerDevice: async (pushDeviceRegistrationRequest: PushDeviceRegistrationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pushDeviceRegistrationRequest' is not null or undefined
            assertParamExists('registerDevice', 'pushDeviceRegistrationRequest', pushDeviceRegistrationRequest)
            const localVarPath = `/ajax/push/device`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pushDeviceRegistrationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PushSubscriptionRequest} pushSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribe1: async (pushSubscriptionRequest: PushSubscriptionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pushSubscriptionRequest' is not null or undefined
            assertParamExists('subscribe1', 'pushSubscriptionRequest', pushSubscriptionRequest)
            const localVarPath = `/ajax/push/subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pushSubscriptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unregisterDevice: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('unregisterDevice', 'token', token)
            const localVarPath = `/ajax/push/device`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} endpoint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribe1: async (endpoint: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'endpoint' is not null or undefined
            assertParamExists('unsubscribe1', 'endpoint', endpoint)
            const localVarPath = `/ajax/push/subscription`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (endpoint !== undefined) {
                localVarQueryParameter['endpoint'] = endpoint;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxPushSubscriptionRestControllerApi - functional programming interface
 * @export
 */
export const AjaxPushSubscriptionRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxPushSubscriptionRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVapidPublicKey(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVapidPublicKey(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPushSubscriptionRestControllerApi.getVapidPublicKey']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PushDeviceRegistrationRequest} pushDeviceRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerDevice(pushDeviceRegistrationRequest: PushDeviceRegistrationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerDevice(pushDeviceRegistrationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPushSubscriptionRestControllerApi.registerDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PushSubscriptionRequest} pushSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subscribe1(pushSubscriptionRequest: PushSubscriptionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subscribe1(pushSubscriptionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPushSubscriptionRestControllerApi.subscribe1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unregisterDevice(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unregisterDevice(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPushSubscriptionRestControllerApi.unregisterDevice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} endpoint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unsubscribe1(endpoint: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unsubscribe1(endpoint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxPushSubscriptionRestControllerApi.unsubscribe1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxPushSubscriptionRestControllerApi - factory interface
 * @export
 */
export const AjaxPushSubscriptionRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxPushSubscriptionRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVapidPublicKey(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.getVapidPublicKey(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PushDeviceRegistrationRequest} pushDeviceRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerDevice(pushDeviceRegistrationRequest: PushDeviceRegistrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.registerDevice(pushDeviceRegistrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PushSubscriptionRequest} pushSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subscribe1(pushSubscriptionRequest: PushSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.subscribe1(pushSubscriptionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unregisterDevice(token: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unregisterDevice(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} endpoint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribe1(endpoint: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unsubscribe1(endpoint, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxPushSubscriptionRestControllerApi - object-oriented interface
 * @export
 * @class AjaxPushSubscriptionRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxPushSubscriptionRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPushSubscriptionRestControllerApi
     */
    public getVapidPublicKey(options?: RawAxiosRequestConfig) {
        return AjaxPushSubscriptionRestControllerApiFp(this.configuration).getVapidPublicKey(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PushDeviceRegistrationRequest} pushDeviceRegistrationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPushSubscriptionRestControllerApi
     */
    public registerDevice(pushDeviceRegistrationRequest: PushDeviceRegistrationRequest, options?: RawAxiosRequestConfig) {
        return AjaxPushSubscriptionRestControllerApiFp(this.configuration).registerDevice(pushDeviceRegistrationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PushSubscriptionRequest} pushSubscriptionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPushSubscriptionRestControllerApi
     */
    public subscribe1(pushSubscriptionRequest: PushSubscriptionRequest, options?: RawAxiosRequestConfig) {
        return AjaxPushSubscriptionRestControllerApiFp(this.configuration).subscribe1(pushSubscriptionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPushSubscriptionRestControllerApi
     */
    public unregisterDevice(token: string, options?: RawAxiosRequestConfig) {
        return AjaxPushSubscriptionRestControllerApiFp(this.configuration).unregisterDevice(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} endpoint 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxPushSubscriptionRestControllerApi
     */
    public unsubscribe1(endpoint: string, options?: RawAxiosRequestConfig) {
        return AjaxPushSubscriptionRestControllerApiFp(this.configuration).unsubscribe1(endpoint, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxQuestionRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxQuestionRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {AcceptAnswerRequest} acceptAnswerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accept: async (discussionPublicId: string, acceptAnswerRequest: AcceptAnswerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('accept', 'discussionPublicId', discussionPublicId)
            // verify required parameter 'acceptAnswerRequest' is not null or undefined
            assertParamExists('accept', 'acceptAnswerRequest', acceptAnswerRequest)
            const localVarPath = `/ajax/question/{discussionPublicId}/accept`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptAnswerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reopen: async (discussionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('reopen', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/question/{discussionPublicId}/reopen`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolve: async (discussionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('resolve', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/question/{discussionPublicId}/resolve`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unaccept: async (discussionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('unaccept', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/question/{discussionPublicId}/unaccept`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxQuestionRestControllerApi - functional programming interface
 * @export
 */
export const AjaxQuestionRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxQuestionRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {AcceptAnswerRequest} acceptAnswerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accept(discussionPublicId: string, acceptAnswerRequest: AcceptAnswerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionStateView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accept(discussionPublicId, acceptAnswerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxQuestionRestControllerApi.accept']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reopen(discussionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionStateView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reopen(discussionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxQuestionRestControllerApi.reopen']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolve(discussionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionStateView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolve(discussionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxQuestionRestControllerApi.resolve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unaccept(discussionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionStateView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unaccept(discussionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxQuestionRestControllerApi.unaccept']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxQuestionRestControllerApi - factory interface
 * @export
 */
export const AjaxQuestionRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxQuestionRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {AcceptAnswerRequest} acceptAnswerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accept(discussionPublicId: string, acceptAnswerRequest: AcceptAnswerRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionStateView> {
            return localVarFp.accept(discussionPublicId, acceptAnswerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reopen(discussionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<QuestionStateView> {
            return localVarFp.reopen(discussionPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolve(discussionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<QuestionStateView> {
            return localVarFp.resolve(discussionPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unaccept(discussionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<QuestionStateView> {
            return localVarFp.unaccept(discussionPublicId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxQuestionRestControllerApi - object-oriented interface
 * @export
 * @class AjaxQuestionRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxQuestionRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} discussionPublicId 
     * @param {AcceptAnswerRequest} acceptAnswerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxQuestionRestControllerApi
     */
    public accept(discussionPublicId: string, acceptAnswerRequest: AcceptAnswerRequest, options?: RawAxiosRequestConfig) {
        return AjaxQuestionRestControllerApiFp(this.configuration).accept(discussionPublicId, acceptAnswerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxQuestionRestControllerApi
     */
    public reopen(discussionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxQuestionRestControllerApiFp(this.configuration).reopen(discussionPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxQuestionRestControllerApi
     */
    public resolve(discussionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxQuestionRestControllerApiFp(this.configuration).resolve(discussionPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxQuestionRestControllerApi
     */
    public unaccept(discussionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxQuestionRestControllerApiFp(this.configuration).unaccept(discussionPublicId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxReadingHistoryRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxReadingHistoryRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearReadingHistory: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/reading-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeReadingHistoryEntry: async (discussionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('removeReadingHistoryEntry', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/reading-history/{discussionPublicId}`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxReadingHistoryRestControllerApi - functional programming interface
 * @export
 */
export const AjaxReadingHistoryRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxReadingHistoryRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearReadingHistory(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clearReadingHistory(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxReadingHistoryRestControllerApi.clearReadingHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeReadingHistoryEntry(discussionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeReadingHistoryEntry(discussionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxReadingHistoryRestControllerApi.removeReadingHistoryEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxReadingHistoryRestControllerApi - factory interface
 * @export
 */
export const AjaxReadingHistoryRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxReadingHistoryRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearReadingHistory(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.clearReadingHistory(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeReadingHistoryEntry(discussionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeReadingHistoryEntry(discussionPublicId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxReadingHistoryRestControllerApi - object-oriented interface
 * @export
 * @class AjaxReadingHistoryRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxReadingHistoryRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxReadingHistoryRestControllerApi
     */
    public clearReadingHistory(options?: RawAxiosRequestConfig) {
        return AjaxReadingHistoryRestControllerApiFp(this.configuration).clearReadingHistory(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxReadingHistoryRestControllerApi
     */
    public removeReadingHistoryEntry(discussionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxReadingHistoryRestControllerApiFp(this.configuration).removeReadingHistoryEntry(discussionPublicId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxReplyRequestDismissalRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxReplyRequestDismissalRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissReplyRequest: async (discussionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('dismissReplyRequest', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/discussion/{discussionPublicId}/reply_request/dismiss`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxReplyRequestDismissalRestControllerApi - functional programming interface
 * @export
 */
export const AjaxReplyRequestDismissalRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxReplyRequestDismissalRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dismissReplyRequest(discussionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dismissReplyRequest(discussionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxReplyRequestDismissalRestControllerApi.dismissReplyRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxReplyRequestDismissalRestControllerApi - factory interface
 * @export
 */
export const AjaxReplyRequestDismissalRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxReplyRequestDismissalRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissReplyRequest(discussionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.dismissReplyRequest(discussionPublicId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxReplyRequestDismissalRestControllerApi - object-oriented interface
 * @export
 * @class AjaxReplyRequestDismissalRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxReplyRequestDismissalRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} discussionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxReplyRequestDismissalRestControllerApi
     */
    public dismissReplyRequest(discussionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxReplyRequestDismissalRestControllerApiFp(this.configuration).dismissReplyRequest(discussionPublicId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxReplyRequestTestSupportRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxReplyRequestTestSupportRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {SeedReplyRequestBody} [seedReplyRequestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seedReplyRequest: async (seedReplyRequestBody?: SeedReplyRequestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/test-support/reply-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(seedReplyRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxReplyRequestTestSupportRestControllerApi - functional programming interface
 * @export
 */
export const AjaxReplyRequestTestSupportRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxReplyRequestTestSupportRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {SeedReplyRequestBody} [seedReplyRequestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async seedReplyRequest(seedReplyRequestBody?: SeedReplyRequestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.seedReplyRequest(seedReplyRequestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxReplyRequestTestSupportRestControllerApi.seedReplyRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxReplyRequestTestSupportRestControllerApi - factory interface
 * @export
 */
export const AjaxReplyRequestTestSupportRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxReplyRequestTestSupportRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {SeedReplyRequestBody} [seedReplyRequestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seedReplyRequest(seedReplyRequestBody?: SeedReplyRequestBody, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.seedReplyRequest(seedReplyRequestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxReplyRequestTestSupportRestControllerApi - object-oriented interface
 * @export
 * @class AjaxReplyRequestTestSupportRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxReplyRequestTestSupportRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {SeedReplyRequestBody} [seedReplyRequestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxReplyRequestTestSupportRestControllerApi
     */
    public seedReplyRequest(seedReplyRequestBody?: SeedReplyRequestBody, options?: RawAxiosRequestConfig) {
        return AjaxReplyRequestTestSupportRestControllerApiFp(this.configuration).seedReplyRequest(seedReplyRequestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} publicId 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDraftGroupTarget: async (publicId: string, groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            assertParamExists('addDraftGroupTarget', 'publicId', publicId)
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('addDraftGroupTarget', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/discussion_draft/{publicId}/groups/{groupPublicId}`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)))
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} publicId 
         * @param {string} seriesPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDraftSeriesTarget: async (publicId: string, seriesPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            assertParamExists('addDraftSeriesTarget', 'publicId', publicId)
            // verify required parameter 'seriesPublicId' is not null or undefined
            assertParamExists('addDraftSeriesTarget', 'seriesPublicId', seriesPublicId)
            const localVarPath = `/ajax/discussion_draft/{publicId}/series/{seriesPublicId}`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)))
                .replace(`{${"seriesPublicId"}}`, encodeURIComponent(String(seriesPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ClipMultipartCompleteRequest} clipMultipartCompleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeClipMultipartUpload: async (clipMultipartCompleteRequest: ClipMultipartCompleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clipMultipartCompleteRequest' is not null or undefined
            assertParamExists('completeClipMultipartUpload', 'clipMultipartCompleteRequest', clipMultipartCompleteRequest)
            const localVarPath = `/ajax/clip/upload/multipart/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clipMultipartCompleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ImportFilesCompleteRequest} importFilesCompleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeDiscussionDraftImportFiles: async (importFilesCompleteRequest: ImportFilesCompleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importFilesCompleteRequest' is not null or undefined
            assertParamExists('completeDiscussionDraftImportFiles', 'importFilesCompleteRequest', importFilesCompleteRequest)
            const localVarPath = `/ajax/discussion_draft/import_files/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importFilesCompleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePresignedUploadImageUrlRequest} createPresignedUploadImageUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClipMultipartUpload: async (createPresignedUploadImageUrlRequest: CreatePresignedUploadImageUrlRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPresignedUploadImageUrlRequest' is not null or undefined
            assertParamExists('createClipMultipartUpload', 'createPresignedUploadImageUrlRequest', createPresignedUploadImageUrlRequest)
            const localVarPath = `/ajax/clip/upload/multipart/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPresignedUploadImageUrlRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDiscussionDraftForEditor: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/discussion_draft/new`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} publicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDraft: async (publicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            assertParamExists('deleteDraft', 'publicId', publicId)
            const localVarPath = `/ajax/discussion_draft/{publicId}`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} publicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscussionDraftForEditor: async (publicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            assertParamExists('getDiscussionDraftForEditor', 'publicId', publicId)
            const localVarPath = `/ajax/discussion_draft/{publicId}`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestOrCreateDiscussionDraftForEditor: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/discussion_draft/latest-or-create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreatePresignedUploadImageUrlRequest} createPresignedUploadImageUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUploadPresignedUrl: async (createPresignedUploadImageUrlRequest: CreatePresignedUploadImageUrlRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPresignedUploadImageUrlRequest' is not null or undefined
            assertParamExists('getUploadPresignedUrl', 'createPresignedUploadImageUrlRequest', createPresignedUploadImageUrlRequest)
            const localVarPath = `/ajax/image/upload/presigned`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPresignedUploadImageUrlRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ImportDiscussionDraftRequest} importDiscussionDraftRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importDiscussionDraftFromUrl: async (importDiscussionDraftRequest: ImportDiscussionDraftRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importDiscussionDraftRequest' is not null or undefined
            assertParamExists('importDiscussionDraftFromUrl', 'importDiscussionDraftRequest', importDiscussionDraftRequest)
            const localVarPath = `/ajax/discussion_draft/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importDiscussionDraftRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LandDiscussionDraftFeedItemsRequest} landDiscussionDraftFeedItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        landDiscussionDraftImportFeedItems: async (landDiscussionDraftFeedItemsRequest: LandDiscussionDraftFeedItemsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'landDiscussionDraftFeedItemsRequest' is not null or undefined
            assertParamExists('landDiscussionDraftImportFeedItems', 'landDiscussionDraftFeedItemsRequest', landDiscussionDraftFeedItemsRequest)
            const localVarPath = `/ajax/discussion_draft/import_feed/land`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(landDiscussionDraftFeedItemsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        latestDiscussionDraftImportFileSet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/discussion_draft/import_files/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} publicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDraftVersions: async (publicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            assertParamExists('listDraftVersions', 'publicId', publicId)
            const localVarPath = `/ajax/discussion_draft/{publicId}/versions`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecentlyDeletedDrafts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/discussion_draft/recently_deleted`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} publicId 
         * @param {string} source 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadDraftGroupsModal: async (publicId: string, source: string, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            assertParamExists('loadDraftGroupsModal', 'publicId', publicId)
            // verify required parameter 'source' is not null or undefined
            assertParamExists('loadDraftGroupsModal', 'source', source)
            const localVarPath = `/ajax/discussion_draft/{publicId}/groups`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} publicId 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadDraftGroupsModalBootstrap: async (publicId: string, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            assertParamExists('loadDraftGroupsModalBootstrap', 'publicId', publicId)
            const localVarPath = `/ajax/discussion_draft/{publicId}/groups/modal-bootstrap`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} publicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadDraftSeriesToAddDiscussionTo: async (publicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            assertParamExists('loadDraftSeriesToAddDiscussionTo', 'publicId', publicId)
            const localVarPath = `/ajax/discussion_draft/{publicId}/series`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [beforeDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadImagesForUser: async (beforeDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/images/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (beforeDate !== undefined) {
                localVarQueryParameter['beforeDate'] = beforeDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeDiscussionPublic: async (discussionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('makeDiscussionPublic', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/discussion/{discussionPublicId}/make-public`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MarkImageAsUploadedRequest} markImageAsUploadedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markImageAsUploadedRest: async (markImageAsUploadedRequest: MarkImageAsUploadedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'markImageAsUploadedRequest' is not null or undefined
            assertParamExists('markImageAsUploadedRest', 'markImageAsUploadedRequest', markImageAsUploadedRequest)
            const localVarPath = `/ajax/image/mark/uploaded`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(markImageAsUploadedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ClipMultipartPartUrlRequest} clipMultipartPartUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presignClipMultipartPart: async (clipMultipartPartUrlRequest: ClipMultipartPartUrlRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clipMultipartPartUrlRequest' is not null or undefined
            assertParamExists('presignClipMultipartPart', 'clipMultipartPartUrlRequest', clipMultipartPartUrlRequest)
            const localVarPath = `/ajax/clip/upload/multipart/part`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clipMultipartPartUrlRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ImportFilesPresignRequest} importFilesPresignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presignDiscussionDraftImportFiles: async (importFilesPresignRequest: ImportFilesPresignRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importFilesPresignRequest' is not null or undefined
            assertParamExists('presignDiscussionDraftImportFiles', 'importFilesPresignRequest', importFilesPresignRequest)
            const localVarPath = `/ajax/discussion_draft/import_files/presign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importFilesPresignRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ImportDiscussionDraftFeedRequest} importDiscussionDraftFeedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewDiscussionDraftImportFeed: async (importDiscussionDraftFeedRequest: ImportDiscussionDraftFeedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importDiscussionDraftFeedRequest' is not null or undefined
            assertParamExists('previewDiscussionDraftImportFeed', 'importDiscussionDraftFeedRequest', importDiscussionDraftFeedRequest)
            const localVarPath = `/ajax/discussion_draft/import_feed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importDiscussionDraftFeedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PublishDiscussionRequest} publishDiscussionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishDiscussion: async (publishDiscussionRequest: PublishDiscussionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publishDiscussionRequest' is not null or undefined
            assertParamExists('publishDiscussion', 'publishDiscussionRequest', publishDiscussionRequest)
            const localVarPath = `/ajax/discussion_draft/publish`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publishDiscussionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} publicId 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDraftGroupTarget: async (publicId: string, groupPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            assertParamExists('removeDraftGroupTarget', 'publicId', publicId)
            // verify required parameter 'groupPublicId' is not null or undefined
            assertParamExists('removeDraftGroupTarget', 'groupPublicId', groupPublicId)
            const localVarPath = `/ajax/discussion_draft/{publicId}/groups/{groupPublicId}`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)))
                .replace(`{${"groupPublicId"}}`, encodeURIComponent(String(groupPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} publicId 
         * @param {string} seriesPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDraftSeriesTarget: async (publicId: string, seriesPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            assertParamExists('removeDraftSeriesTarget', 'publicId', publicId)
            // verify required parameter 'seriesPublicId' is not null or undefined
            assertParamExists('removeDraftSeriesTarget', 'seriesPublicId', seriesPublicId)
            const localVarPath = `/ajax/discussion_draft/{publicId}/series/{seriesPublicId}`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)))
                .replace(`{${"seriesPublicId"}}`, encodeURIComponent(String(seriesPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} publicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreDeletedDraft: async (publicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            assertParamExists('restoreDeletedDraft', 'publicId', publicId)
            const localVarPath = `/ajax/discussion_draft/{publicId}/restore`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} publicId 
         * @param {number} versionNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreDraftVersion: async (publicId: string, versionNumber: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            assertParamExists('restoreDraftVersion', 'publicId', publicId)
            // verify required parameter 'versionNumber' is not null or undefined
            assertParamExists('restoreDraftVersion', 'versionNumber', versionNumber)
            const localVarPath = `/ajax/discussion_draft/{publicId}/versions/{versionNumber}/restore`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)))
                .replace(`{${"versionNumber"}}`, encodeURIComponent(String(versionNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateDiscussionDraftRequest} updateDiscussionDraftRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDraft: async (updateDiscussionDraftRequest: UpdateDiscussionDraftRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateDiscussionDraftRequest' is not null or undefined
            assertParamExists('updateDraft', 'updateDiscussionDraftRequest', updateDiscussionDraftRequest)
            const localVarPath = `/ajax/discussion_draft/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDiscussionDraftRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxRestControllerApi - functional programming interface
 * @export
 */
export const AjaxRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} publicId 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDraftGroupTarget(publicId: string, groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscussionDraftPublishTargetCountsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDraftGroupTarget(publicId, groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.addDraftGroupTarget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} publicId 
         * @param {string} seriesPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDraftSeriesTarget(publicId: string, seriesPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscussionDraftPublishTargetCountsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDraftSeriesTarget(publicId, seriesPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.addDraftSeriesTarget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ClipMultipartCompleteRequest} clipMultipartCompleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeClipMultipartUpload(clipMultipartCompleteRequest: ClipMultipartCompleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClipMultipartUploadCompletedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeClipMultipartUpload(clipMultipartCompleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.completeClipMultipartUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ImportFilesCompleteRequest} importFilesCompleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async completeDiscussionDraftImportFiles(importFilesCompleteRequest: ImportFilesCompleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.completeDiscussionDraftImportFiles(importFilesCompleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.completeDiscussionDraftImportFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreatePresignedUploadImageUrlRequest} createPresignedUploadImageUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClipMultipartUpload(createPresignedUploadImageUrlRequest: CreatePresignedUploadImageUrlRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClipMultipartUploadCreatedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClipMultipartUpload(createPresignedUploadImageUrlRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.createClipMultipartUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDiscussionDraftForEditor(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscussionDraftEditorDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDiscussionDraftForEditor(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.createDiscussionDraftForEditor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} publicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDraft(publicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDraft(publicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.deleteDraft']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} publicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDiscussionDraftForEditor(publicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscussionDraftEditorDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDiscussionDraftForEditor(publicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.getDiscussionDraftForEditor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestOrCreateDiscussionDraftForEditor(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscussionDraftEditorDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestOrCreateDiscussionDraftForEditor(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.getLatestOrCreateDiscussionDraftForEditor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreatePresignedUploadImageUrlRequest} createPresignedUploadImageUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUploadPresignedUrl(createPresignedUploadImageUrlRequest: CreatePresignedUploadImageUrlRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUploadPresignedUrl(createPresignedUploadImageUrlRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.getUploadPresignedUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ImportDiscussionDraftRequest} importDiscussionDraftRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importDiscussionDraftFromUrl(importDiscussionDraftRequest: ImportDiscussionDraftRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importDiscussionDraftFromUrl(importDiscussionDraftRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.importDiscussionDraftFromUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LandDiscussionDraftFeedItemsRequest} landDiscussionDraftFeedItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async landDiscussionDraftImportFeedItems(landDiscussionDraftFeedItemsRequest: LandDiscussionDraftFeedItemsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.landDiscussionDraftImportFeedItems(landDiscussionDraftFeedItemsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.landDiscussionDraftImportFeedItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async latestDiscussionDraftImportFileSet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.latestDiscussionDraftImportFileSet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.latestDiscussionDraftImportFileSet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} publicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDraftVersions(publicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiscussionDraftVersionDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDraftVersions(publicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.listDraftVersions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRecentlyDeletedDrafts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiscussionDraftDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRecentlyDeletedDrafts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.listRecentlyDeletedDrafts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} publicId 
         * @param {string} source 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadDraftGroupsModal(publicId: string, source: string, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DraftGroupsToAddDiscussionToDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadDraftGroupsModal(publicId, source, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.loadDraftGroupsModal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} publicId 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadDraftGroupsModalBootstrap(publicId: string, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DraftGroupsToAddDiscussionModalBootstrapDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadDraftGroupsModalBootstrap(publicId, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.loadDraftGroupsModalBootstrap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} publicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadDraftSeriesToAddDiscussionTo(publicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DraftSeriesToAddDiscussionToDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadDraftSeriesToAddDiscussionTo(publicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.loadDraftSeriesToAddDiscussionTo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [beforeDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadImagesForUser(beforeDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ImageDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadImagesForUser(beforeDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.loadImagesForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async makeDiscussionPublic(discussionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.makeDiscussionPublic(discussionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.makeDiscussionPublic']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MarkImageAsUploadedRequest} markImageAsUploadedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markImageAsUploadedRest(markImageAsUploadedRequest: MarkImageAsUploadedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markImageAsUploadedRest(markImageAsUploadedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.markImageAsUploadedRest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ClipMultipartPartUrlRequest} clipMultipartPartUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async presignClipMultipartPart(clipMultipartPartUrlRequest: ClipMultipartPartUrlRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClipMultipartPartUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.presignClipMultipartPart(clipMultipartPartUrlRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.presignClipMultipartPart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ImportFilesPresignRequest} importFilesPresignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async presignDiscussionDraftImportFiles(importFilesPresignRequest: ImportFilesPresignRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.presignDiscussionDraftImportFiles(importFilesPresignRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.presignDiscussionDraftImportFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ImportDiscussionDraftFeedRequest} importDiscussionDraftFeedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewDiscussionDraftImportFeed(importDiscussionDraftFeedRequest: ImportDiscussionDraftFeedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewDiscussionDraftImportFeed(importDiscussionDraftFeedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.previewDiscussionDraftImportFeed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PublishDiscussionRequest} publishDiscussionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishDiscussion(publishDiscussionRequest: PublishDiscussionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublishDiscussionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishDiscussion(publishDiscussionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.publishDiscussion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} publicId 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeDraftGroupTarget(publicId: string, groupPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscussionDraftPublishTargetCountsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeDraftGroupTarget(publicId, groupPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.removeDraftGroupTarget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} publicId 
         * @param {string} seriesPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeDraftSeriesTarget(publicId: string, seriesPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscussionDraftPublishTargetCountsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeDraftSeriesTarget(publicId, seriesPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.removeDraftSeriesTarget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} publicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreDeletedDraft(publicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscussionDraftEditorDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreDeletedDraft(publicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.restoreDeletedDraft']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} publicId 
         * @param {number} versionNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreDraftVersion(publicId: string, versionNumber: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DiscussionDraftEditorDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreDraftVersion(publicId, versionNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.restoreDraftVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateDiscussionDraftRequest} updateDiscussionDraftRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDraft(updateDiscussionDraftRequest: UpdateDiscussionDraftRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDraft(updateDiscussionDraftRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxRestControllerApi.updateDraft']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxRestControllerApi - factory interface
 * @export
 */
export const AjaxRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} publicId 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDraftGroupTarget(publicId: string, groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<DiscussionDraftPublishTargetCountsDTO> {
            return localVarFp.addDraftGroupTarget(publicId, groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} publicId 
         * @param {string} seriesPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDraftSeriesTarget(publicId: string, seriesPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<DiscussionDraftPublishTargetCountsDTO> {
            return localVarFp.addDraftSeriesTarget(publicId, seriesPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClipMultipartCompleteRequest} clipMultipartCompleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeClipMultipartUpload(clipMultipartCompleteRequest: ClipMultipartCompleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClipMultipartUploadCompletedResponse> {
            return localVarFp.completeClipMultipartUpload(clipMultipartCompleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ImportFilesCompleteRequest} importFilesCompleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeDiscussionDraftImportFiles(importFilesCompleteRequest: ImportFilesCompleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.completeDiscussionDraftImportFiles(importFilesCompleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreatePresignedUploadImageUrlRequest} createPresignedUploadImageUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClipMultipartUpload(createPresignedUploadImageUrlRequest: CreatePresignedUploadImageUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClipMultipartUploadCreatedResponse> {
            return localVarFp.createClipMultipartUpload(createPresignedUploadImageUrlRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDiscussionDraftForEditor(options?: RawAxiosRequestConfig): AxiosPromise<DiscussionDraftEditorDTO> {
            return localVarFp.createDiscussionDraftForEditor(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} publicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDraft(publicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDraft(publicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} publicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscussionDraftForEditor(publicId: string, options?: RawAxiosRequestConfig): AxiosPromise<DiscussionDraftEditorDTO> {
            return localVarFp.getDiscussionDraftForEditor(publicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestOrCreateDiscussionDraftForEditor(options?: RawAxiosRequestConfig): AxiosPromise<DiscussionDraftEditorDTO> {
            return localVarFp.getLatestOrCreateDiscussionDraftForEditor(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreatePresignedUploadImageUrlRequest} createPresignedUploadImageUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUploadPresignedUrl(createPresignedUploadImageUrlRequest: CreatePresignedUploadImageUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getUploadPresignedUrl(createPresignedUploadImageUrlRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ImportDiscussionDraftRequest} importDiscussionDraftRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importDiscussionDraftFromUrl(importDiscussionDraftRequest: ImportDiscussionDraftRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.importDiscussionDraftFromUrl(importDiscussionDraftRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LandDiscussionDraftFeedItemsRequest} landDiscussionDraftFeedItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        landDiscussionDraftImportFeedItems(landDiscussionDraftFeedItemsRequest: LandDiscussionDraftFeedItemsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.landDiscussionDraftImportFeedItems(landDiscussionDraftFeedItemsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        latestDiscussionDraftImportFileSet(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.latestDiscussionDraftImportFileSet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} publicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDraftVersions(publicId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DiscussionDraftVersionDTO>> {
            return localVarFp.listDraftVersions(publicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRecentlyDeletedDrafts(options?: RawAxiosRequestConfig): AxiosPromise<Array<DiscussionDraftDTO>> {
            return localVarFp.listRecentlyDeletedDrafts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} publicId 
         * @param {string} source 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadDraftGroupsModal(publicId: string, source: string, q?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DraftGroupsToAddDiscussionToDTO>> {
            return localVarFp.loadDraftGroupsModal(publicId, source, q, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} publicId 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadDraftGroupsModalBootstrap(publicId: string, q?: string, options?: RawAxiosRequestConfig): AxiosPromise<DraftGroupsToAddDiscussionModalBootstrapDTO> {
            return localVarFp.loadDraftGroupsModalBootstrap(publicId, q, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} publicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadDraftSeriesToAddDiscussionTo(publicId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DraftSeriesToAddDiscussionToDTO>> {
            return localVarFp.loadDraftSeriesToAddDiscussionTo(publicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [beforeDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadImagesForUser(beforeDate?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ImageDTO>> {
            return localVarFp.loadImagesForUser(beforeDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        makeDiscussionPublic(discussionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.makeDiscussionPublic(discussionPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MarkImageAsUploadedRequest} markImageAsUploadedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markImageAsUploadedRest(markImageAsUploadedRequest: MarkImageAsUploadedRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImageDTO> {
            return localVarFp.markImageAsUploadedRest(markImageAsUploadedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClipMultipartPartUrlRequest} clipMultipartPartUrlRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presignClipMultipartPart(clipMultipartPartUrlRequest: ClipMultipartPartUrlRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClipMultipartPartUrlResponse> {
            return localVarFp.presignClipMultipartPart(clipMultipartPartUrlRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ImportFilesPresignRequest} importFilesPresignRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        presignDiscussionDraftImportFiles(importFilesPresignRequest: ImportFilesPresignRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.presignDiscussionDraftImportFiles(importFilesPresignRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ImportDiscussionDraftFeedRequest} importDiscussionDraftFeedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewDiscussionDraftImportFeed(importDiscussionDraftFeedRequest: ImportDiscussionDraftFeedRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.previewDiscussionDraftImportFeed(importDiscussionDraftFeedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PublishDiscussionRequest} publishDiscussionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishDiscussion(publishDiscussionRequest: PublishDiscussionRequest, options?: RawAxiosRequestConfig): AxiosPromise<PublishDiscussionResponse> {
            return localVarFp.publishDiscussion(publishDiscussionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} publicId 
         * @param {string} groupPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDraftGroupTarget(publicId: string, groupPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<DiscussionDraftPublishTargetCountsDTO> {
            return localVarFp.removeDraftGroupTarget(publicId, groupPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} publicId 
         * @param {string} seriesPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDraftSeriesTarget(publicId: string, seriesPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<DiscussionDraftPublishTargetCountsDTO> {
            return localVarFp.removeDraftSeriesTarget(publicId, seriesPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} publicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreDeletedDraft(publicId: string, options?: RawAxiosRequestConfig): AxiosPromise<DiscussionDraftEditorDTO> {
            return localVarFp.restoreDeletedDraft(publicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} publicId 
         * @param {number} versionNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreDraftVersion(publicId: string, versionNumber: number, options?: RawAxiosRequestConfig): AxiosPromise<DiscussionDraftEditorDTO> {
            return localVarFp.restoreDraftVersion(publicId, versionNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateDiscussionDraftRequest} updateDiscussionDraftRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDraft(updateDiscussionDraftRequest: UpdateDiscussionDraftRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.updateDraft(updateDiscussionDraftRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxRestControllerApi - object-oriented interface
 * @export
 * @class AjaxRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} publicId 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public addDraftGroupTarget(publicId: string, groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).addDraftGroupTarget(publicId, groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} publicId 
     * @param {string} seriesPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public addDraftSeriesTarget(publicId: string, seriesPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).addDraftSeriesTarget(publicId, seriesPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClipMultipartCompleteRequest} clipMultipartCompleteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public completeClipMultipartUpload(clipMultipartCompleteRequest: ClipMultipartCompleteRequest, options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).completeClipMultipartUpload(clipMultipartCompleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ImportFilesCompleteRequest} importFilesCompleteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public completeDiscussionDraftImportFiles(importFilesCompleteRequest: ImportFilesCompleteRequest, options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).completeDiscussionDraftImportFiles(importFilesCompleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreatePresignedUploadImageUrlRequest} createPresignedUploadImageUrlRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public createClipMultipartUpload(createPresignedUploadImageUrlRequest: CreatePresignedUploadImageUrlRequest, options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).createClipMultipartUpload(createPresignedUploadImageUrlRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public createDiscussionDraftForEditor(options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).createDiscussionDraftForEditor(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} publicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public deleteDraft(publicId: string, options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).deleteDraft(publicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} publicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public getDiscussionDraftForEditor(publicId: string, options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).getDiscussionDraftForEditor(publicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public getLatestOrCreateDiscussionDraftForEditor(options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).getLatestOrCreateDiscussionDraftForEditor(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreatePresignedUploadImageUrlRequest} createPresignedUploadImageUrlRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public getUploadPresignedUrl(createPresignedUploadImageUrlRequest: CreatePresignedUploadImageUrlRequest, options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).getUploadPresignedUrl(createPresignedUploadImageUrlRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ImportDiscussionDraftRequest} importDiscussionDraftRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public importDiscussionDraftFromUrl(importDiscussionDraftRequest: ImportDiscussionDraftRequest, options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).importDiscussionDraftFromUrl(importDiscussionDraftRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LandDiscussionDraftFeedItemsRequest} landDiscussionDraftFeedItemsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public landDiscussionDraftImportFeedItems(landDiscussionDraftFeedItemsRequest: LandDiscussionDraftFeedItemsRequest, options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).landDiscussionDraftImportFeedItems(landDiscussionDraftFeedItemsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public latestDiscussionDraftImportFileSet(options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).latestDiscussionDraftImportFileSet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} publicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public listDraftVersions(publicId: string, options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).listDraftVersions(publicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public listRecentlyDeletedDrafts(options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).listRecentlyDeletedDrafts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} publicId 
     * @param {string} source 
     * @param {string} [q] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public loadDraftGroupsModal(publicId: string, source: string, q?: string, options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).loadDraftGroupsModal(publicId, source, q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} publicId 
     * @param {string} [q] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public loadDraftGroupsModalBootstrap(publicId: string, q?: string, options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).loadDraftGroupsModalBootstrap(publicId, q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} publicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public loadDraftSeriesToAddDiscussionTo(publicId: string, options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).loadDraftSeriesToAddDiscussionTo(publicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [beforeDate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public loadImagesForUser(beforeDate?: string, options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).loadImagesForUser(beforeDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public makeDiscussionPublic(discussionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).makeDiscussionPublic(discussionPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MarkImageAsUploadedRequest} markImageAsUploadedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public markImageAsUploadedRest(markImageAsUploadedRequest: MarkImageAsUploadedRequest, options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).markImageAsUploadedRest(markImageAsUploadedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClipMultipartPartUrlRequest} clipMultipartPartUrlRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public presignClipMultipartPart(clipMultipartPartUrlRequest: ClipMultipartPartUrlRequest, options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).presignClipMultipartPart(clipMultipartPartUrlRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ImportFilesPresignRequest} importFilesPresignRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public presignDiscussionDraftImportFiles(importFilesPresignRequest: ImportFilesPresignRequest, options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).presignDiscussionDraftImportFiles(importFilesPresignRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ImportDiscussionDraftFeedRequest} importDiscussionDraftFeedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public previewDiscussionDraftImportFeed(importDiscussionDraftFeedRequest: ImportDiscussionDraftFeedRequest, options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).previewDiscussionDraftImportFeed(importDiscussionDraftFeedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PublishDiscussionRequest} publishDiscussionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public publishDiscussion(publishDiscussionRequest: PublishDiscussionRequest, options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).publishDiscussion(publishDiscussionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} publicId 
     * @param {string} groupPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public removeDraftGroupTarget(publicId: string, groupPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).removeDraftGroupTarget(publicId, groupPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} publicId 
     * @param {string} seriesPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public removeDraftSeriesTarget(publicId: string, seriesPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).removeDraftSeriesTarget(publicId, seriesPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} publicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public restoreDeletedDraft(publicId: string, options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).restoreDeletedDraft(publicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} publicId 
     * @param {number} versionNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public restoreDraftVersion(publicId: string, versionNumber: number, options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).restoreDraftVersion(publicId, versionNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateDiscussionDraftRequest} updateDiscussionDraftRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxRestControllerApi
     */
    public updateDraft(updateDiscussionDraftRequest: UpdateDiscussionDraftRequest, options?: RawAxiosRequestConfig) {
        return AjaxRestControllerApiFp(this.configuration).updateDraft(updateDiscussionDraftRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxReviewRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxReviewRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeReviewFacet: async (discussionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('removeReviewFacet', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/review/{discussionPublicId}`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {UpdateReviewFacetRequest} [updateReviewFacetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReviewFacet: async (discussionPublicId: string, updateReviewFacetRequest?: UpdateReviewFacetRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('updateReviewFacet', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/review/{discussionPublicId}`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReviewFacetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxReviewRestControllerApi - functional programming interface
 * @export
 */
export const AjaxReviewRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxReviewRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeReviewFacet(discussionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeReviewFacet(discussionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxReviewRestControllerApi.removeReviewFacet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {UpdateReviewFacetRequest} [updateReviewFacetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReviewFacet(discussionPublicId: string, updateReviewFacetRequest?: UpdateReviewFacetRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReviewFacet(discussionPublicId, updateReviewFacetRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxReviewRestControllerApi.updateReviewFacet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxReviewRestControllerApi - factory interface
 * @export
 */
export const AjaxReviewRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxReviewRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeReviewFacet(discussionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.removeReviewFacet(discussionPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {UpdateReviewFacetRequest} [updateReviewFacetRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReviewFacet(discussionPublicId: string, updateReviewFacetRequest?: UpdateReviewFacetRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.updateReviewFacet(discussionPublicId, updateReviewFacetRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxReviewRestControllerApi - object-oriented interface
 * @export
 * @class AjaxReviewRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxReviewRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} discussionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxReviewRestControllerApi
     */
    public removeReviewFacet(discussionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxReviewRestControllerApiFp(this.configuration).removeReviewFacet(discussionPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {UpdateReviewFacetRequest} [updateReviewFacetRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxReviewRestControllerApi
     */
    public updateReviewFacet(discussionPublicId: string, updateReviewFacetRequest?: UpdateReviewFacetRequest, options?: RawAxiosRequestConfig) {
        return AjaxReviewRestControllerApiFp(this.configuration).updateReviewFacet(discussionPublicId, updateReviewFacetRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxSeriesRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxSeriesRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDiscussionToBookmarks: async (discussionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('addDiscussionToBookmarks', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/series/bookmarks/discussion/{discussionPublicId}`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDiscussionToSeries: async (seriesPublicId: string, discussionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seriesPublicId' is not null or undefined
            assertParamExists('addDiscussionToSeries', 'seriesPublicId', seriesPublicId)
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('addDiscussionToSeries', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/series/{seriesPublicId}/add/{discussionPublicId}`
                .replace(`{${"seriesPublicId"}}`, encodeURIComponent(String(seriesPublicId)))
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countView1: async (seriesPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seriesPublicId' is not null or undefined
            assertParamExists('countView1', 'seriesPublicId', seriesPublicId)
            const localVarPath = `/ajax/series/count_view/{seriesPublicId}`
                .replace(`{${"seriesPublicId"}}`, encodeURIComponent(String(seriesPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateSeriesRequest} createSeriesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSeries: async (createSeriesRequest: CreateSeriesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSeriesRequest' is not null or undefined
            assertParamExists('createSeries', 'createSeriesRequest', createSeriesRequest)
            const localVarPath = `/ajax/series`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSeriesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followSeries: async (seriesPublicId: string, surface?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seriesPublicId' is not null or undefined
            assertParamExists('followSeries', 'seriesPublicId', seriesPublicId)
            const localVarPath = `/ajax/series/follow/{seriesPublicId}`
                .replace(`{${"seriesPublicId"}}`, encodeURIComponent(String(seriesPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (surface !== undefined) {
                localVarQueryParameter['surface'] = surface;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {string} source 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadDiscussionToAddToSeries: async (seriesPublicId: string, source: string, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seriesPublicId' is not null or undefined
            assertParamExists('loadDiscussionToAddToSeries', 'seriesPublicId', seriesPublicId)
            // verify required parameter 'source' is not null or undefined
            assertParamExists('loadDiscussionToAddToSeries', 'source', source)
            const localVarPath = `/ajax/series/{seriesPublicId}/discussions`
                .replace(`{${"seriesPublicId"}}`, encodeURIComponent(String(seriesPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadDiscussionToAddToSeriesBootstrap: async (seriesPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seriesPublicId' is not null or undefined
            assertParamExists('loadDiscussionToAddToSeriesBootstrap', 'seriesPublicId', seriesPublicId)
            const localVarPath = `/ajax/series/{seriesPublicId}/discussions/modal-bootstrap`
                .replace(`{${"seriesPublicId"}}`, encodeURIComponent(String(seriesPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDiscussionFromBookmarks: async (discussionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('removeDiscussionFromBookmarks', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/series/bookmarks/discussion/{discussionPublicId}`
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDiscussionFromSeries: async (seriesPublicId: string, discussionPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seriesPublicId' is not null or undefined
            assertParamExists('removeDiscussionFromSeries', 'seriesPublicId', seriesPublicId)
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('removeDiscussionFromSeries', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/series/{seriesPublicId}/remove/{discussionPublicId}`
                .replace(`{${"seriesPublicId"}}`, encodeURIComponent(String(seriesPublicId)))
                .replace(`{${"discussionPublicId"}}`, encodeURIComponent(String(discussionPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {CreateContentReportRequest} createContentReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportSeries: async (seriesPublicId: string, createContentReportRequest: CreateContentReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seriesPublicId' is not null or undefined
            assertParamExists('reportSeries', 'seriesPublicId', seriesPublicId)
            // verify required parameter 'createContentReportRequest' is not null or undefined
            assertParamExists('reportSeries', 'createContentReportRequest', createContentReportRequest)
            const localVarPath = `/ajax/series/{seriesPublicId}/report`
                .replace(`{${"seriesPublicId"}}`, encodeURIComponent(String(seriesPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createContentReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unfollowSeries: async (seriesPublicId: string, surface?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seriesPublicId' is not null or undefined
            assertParamExists('unfollowSeries', 'seriesPublicId', seriesPublicId)
            const localVarPath = `/ajax/series/follow/{seriesPublicId}`
                .replace(`{${"seriesPublicId"}}`, encodeURIComponent(String(seriesPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (surface !== undefined) {
                localVarQueryParameter['surface'] = surface;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {UpdateSeriesDiscussionOrderRequest} updateSeriesDiscussionOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDiscussionOrder: async (seriesPublicId: string, updateSeriesDiscussionOrderRequest: UpdateSeriesDiscussionOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seriesPublicId' is not null or undefined
            assertParamExists('updateDiscussionOrder', 'seriesPublicId', seriesPublicId)
            // verify required parameter 'updateSeriesDiscussionOrderRequest' is not null or undefined
            assertParamExists('updateDiscussionOrder', 'updateSeriesDiscussionOrderRequest', updateSeriesDiscussionOrderRequest)
            const localVarPath = `/ajax/series/{seriesPublicId}/discussions/order`
                .replace(`{${"seriesPublicId"}}`, encodeURIComponent(String(seriesPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSeriesDiscussionOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {UpdateSeriesGeneralRequest} updateSeriesGeneralRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeriesGeneral: async (seriesPublicId: string, updateSeriesGeneralRequest: UpdateSeriesGeneralRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seriesPublicId' is not null or undefined
            assertParamExists('updateSeriesGeneral', 'seriesPublicId', seriesPublicId)
            // verify required parameter 'updateSeriesGeneralRequest' is not null or undefined
            assertParamExists('updateSeriesGeneral', 'updateSeriesGeneralRequest', updateSeriesGeneralRequest)
            const localVarPath = `/ajax/series/{seriesPublicId}/general`
                .replace(`{${"seriesPublicId"}}`, encodeURIComponent(String(seriesPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSeriesGeneralRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxSeriesRestControllerApi - functional programming interface
 * @export
 */
export const AjaxSeriesRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxSeriesRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDiscussionToBookmarks(discussionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SeriesDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDiscussionToBookmarks(discussionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSeriesRestControllerApi.addDiscussionToBookmarks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDiscussionToSeries(seriesPublicId: string, discussionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SeriesDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDiscussionToSeries(seriesPublicId, discussionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSeriesRestControllerApi.addDiscussionToSeries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countView1(seriesPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countView1(seriesPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSeriesRestControllerApi.countView1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateSeriesRequest} createSeriesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSeries(createSeriesRequest: CreateSeriesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSeries(createSeriesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSeriesRestControllerApi.createSeries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followSeries(seriesPublicId: string, surface?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followSeries(seriesPublicId, surface, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSeriesRestControllerApi.followSeries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {string} source 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadDiscussionToAddToSeries(seriesPublicId: string, source: string, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiscussionsToAddToSeriesDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadDiscussionToAddToSeries(seriesPublicId, source, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSeriesRestControllerApi.loadDiscussionToAddToSeries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadDiscussionToAddToSeriesBootstrap(seriesPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SeriesDiscussionsToAddModalBootstrapDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadDiscussionToAddToSeriesBootstrap(seriesPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSeriesRestControllerApi.loadDiscussionToAddToSeriesBootstrap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeDiscussionFromBookmarks(discussionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SeriesDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeDiscussionFromBookmarks(discussionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSeriesRestControllerApi.removeDiscussionFromBookmarks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeDiscussionFromSeries(seriesPublicId: string, discussionPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SeriesDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeDiscussionFromSeries(seriesPublicId, discussionPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSeriesRestControllerApi.removeDiscussionFromSeries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {CreateContentReportRequest} createContentReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportSeries(seriesPublicId: string, createContentReportRequest: CreateContentReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportSeries(seriesPublicId, createContentReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSeriesRestControllerApi.reportSeries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unfollowSeries(seriesPublicId: string, surface?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unfollowSeries(seriesPublicId, surface, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSeriesRestControllerApi.unfollowSeries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {UpdateSeriesDiscussionOrderRequest} updateSeriesDiscussionOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDiscussionOrder(seriesPublicId: string, updateSeriesDiscussionOrderRequest: UpdateSeriesDiscussionOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDiscussionOrder(seriesPublicId, updateSeriesDiscussionOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSeriesRestControllerApi.updateDiscussionOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {UpdateSeriesGeneralRequest} updateSeriesGeneralRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSeriesGeneral(seriesPublicId: string, updateSeriesGeneralRequest: UpdateSeriesGeneralRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSeriesGeneral(seriesPublicId, updateSeriesGeneralRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSeriesRestControllerApi.updateSeriesGeneral']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxSeriesRestControllerApi - factory interface
 * @export
 */
export const AjaxSeriesRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxSeriesRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDiscussionToBookmarks(discussionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<SeriesDTO> {
            return localVarFp.addDiscussionToBookmarks(discussionPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDiscussionToSeries(seriesPublicId: string, discussionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<SeriesDTO> {
            return localVarFp.addDiscussionToSeries(seriesPublicId, discussionPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countView1(seriesPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.countView1(seriesPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateSeriesRequest} createSeriesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSeries(createSeriesRequest: CreateSeriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.createSeries(createSeriesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followSeries(seriesPublicId: string, surface?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.followSeries(seriesPublicId, surface, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {string} source 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadDiscussionToAddToSeries(seriesPublicId: string, source: string, q?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DiscussionsToAddToSeriesDTO>> {
            return localVarFp.loadDiscussionToAddToSeries(seriesPublicId, source, q, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadDiscussionToAddToSeriesBootstrap(seriesPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<SeriesDiscussionsToAddModalBootstrapDTO> {
            return localVarFp.loadDiscussionToAddToSeriesBootstrap(seriesPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDiscussionFromBookmarks(discussionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<SeriesDTO> {
            return localVarFp.removeDiscussionFromBookmarks(discussionPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {string} discussionPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDiscussionFromSeries(seriesPublicId: string, discussionPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<SeriesDTO> {
            return localVarFp.removeDiscussionFromSeries(seriesPublicId, discussionPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {CreateContentReportRequest} createContentReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportSeries(seriesPublicId: string, createContentReportRequest: CreateContentReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reportSeries(seriesPublicId, createContentReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unfollowSeries(seriesPublicId: string, surface?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unfollowSeries(seriesPublicId, surface, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {UpdateSeriesDiscussionOrderRequest} updateSeriesDiscussionOrderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDiscussionOrder(seriesPublicId: string, updateSeriesDiscussionOrderRequest: UpdateSeriesDiscussionOrderRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateDiscussionOrder(seriesPublicId, updateSeriesDiscussionOrderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} seriesPublicId 
         * @param {UpdateSeriesGeneralRequest} updateSeriesGeneralRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSeriesGeneral(seriesPublicId: string, updateSeriesGeneralRequest: UpdateSeriesGeneralRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSeriesGeneral(seriesPublicId, updateSeriesGeneralRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxSeriesRestControllerApi - object-oriented interface
 * @export
 * @class AjaxSeriesRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxSeriesRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} discussionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSeriesRestControllerApi
     */
    public addDiscussionToBookmarks(discussionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxSeriesRestControllerApiFp(this.configuration).addDiscussionToBookmarks(discussionPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} seriesPublicId 
     * @param {string} discussionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSeriesRestControllerApi
     */
    public addDiscussionToSeries(seriesPublicId: string, discussionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxSeriesRestControllerApiFp(this.configuration).addDiscussionToSeries(seriesPublicId, discussionPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} seriesPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSeriesRestControllerApi
     */
    public countView1(seriesPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxSeriesRestControllerApiFp(this.configuration).countView1(seriesPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateSeriesRequest} createSeriesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSeriesRestControllerApi
     */
    public createSeries(createSeriesRequest: CreateSeriesRequest, options?: RawAxiosRequestConfig) {
        return AjaxSeriesRestControllerApiFp(this.configuration).createSeries(createSeriesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} seriesPublicId 
     * @param {string} [surface] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSeriesRestControllerApi
     */
    public followSeries(seriesPublicId: string, surface?: string, options?: RawAxiosRequestConfig) {
        return AjaxSeriesRestControllerApiFp(this.configuration).followSeries(seriesPublicId, surface, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} seriesPublicId 
     * @param {string} source 
     * @param {string} [q] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSeriesRestControllerApi
     */
    public loadDiscussionToAddToSeries(seriesPublicId: string, source: string, q?: string, options?: RawAxiosRequestConfig) {
        return AjaxSeriesRestControllerApiFp(this.configuration).loadDiscussionToAddToSeries(seriesPublicId, source, q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} seriesPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSeriesRestControllerApi
     */
    public loadDiscussionToAddToSeriesBootstrap(seriesPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxSeriesRestControllerApiFp(this.configuration).loadDiscussionToAddToSeriesBootstrap(seriesPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSeriesRestControllerApi
     */
    public removeDiscussionFromBookmarks(discussionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxSeriesRestControllerApiFp(this.configuration).removeDiscussionFromBookmarks(discussionPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} seriesPublicId 
     * @param {string} discussionPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSeriesRestControllerApi
     */
    public removeDiscussionFromSeries(seriesPublicId: string, discussionPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxSeriesRestControllerApiFp(this.configuration).removeDiscussionFromSeries(seriesPublicId, discussionPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} seriesPublicId 
     * @param {CreateContentReportRequest} createContentReportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSeriesRestControllerApi
     */
    public reportSeries(seriesPublicId: string, createContentReportRequest: CreateContentReportRequest, options?: RawAxiosRequestConfig) {
        return AjaxSeriesRestControllerApiFp(this.configuration).reportSeries(seriesPublicId, createContentReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} seriesPublicId 
     * @param {string} [surface] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSeriesRestControllerApi
     */
    public unfollowSeries(seriesPublicId: string, surface?: string, options?: RawAxiosRequestConfig) {
        return AjaxSeriesRestControllerApiFp(this.configuration).unfollowSeries(seriesPublicId, surface, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} seriesPublicId 
     * @param {UpdateSeriesDiscussionOrderRequest} updateSeriesDiscussionOrderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSeriesRestControllerApi
     */
    public updateDiscussionOrder(seriesPublicId: string, updateSeriesDiscussionOrderRequest: UpdateSeriesDiscussionOrderRequest, options?: RawAxiosRequestConfig) {
        return AjaxSeriesRestControllerApiFp(this.configuration).updateDiscussionOrder(seriesPublicId, updateSeriesDiscussionOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} seriesPublicId 
     * @param {UpdateSeriesGeneralRequest} updateSeriesGeneralRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSeriesRestControllerApi
     */
    public updateSeriesGeneral(seriesPublicId: string, updateSeriesGeneralRequest: UpdateSeriesGeneralRequest, options?: RawAxiosRequestConfig) {
        return AjaxSeriesRestControllerApiFp(this.configuration).updateSeriesGeneral(seriesPublicId, updateSeriesGeneralRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxSettingsConnectionOriginRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxSettingsConnectionOriginRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnConnectionOrigins: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/settings/connection-origins`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxSettingsConnectionOriginRestControllerApi - functional programming interface
 * @export
 */
export const AjaxSettingsConnectionOriginRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxSettingsConnectionOriginRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOwnConnectionOrigins(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MemberConnectionOriginDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOwnConnectionOrigins(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSettingsConnectionOriginRestControllerApi.getOwnConnectionOrigins']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxSettingsConnectionOriginRestControllerApi - factory interface
 * @export
 */
export const AjaxSettingsConnectionOriginRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxSettingsConnectionOriginRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnConnectionOrigins(options?: RawAxiosRequestConfig): AxiosPromise<Array<MemberConnectionOriginDTO>> {
            return localVarFp.getOwnConnectionOrigins(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxSettingsConnectionOriginRestControllerApi - object-oriented interface
 * @export
 * @class AjaxSettingsConnectionOriginRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxSettingsConnectionOriginRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSettingsConnectionOriginRestControllerApi
     */
    public getOwnConnectionOrigins(options?: RawAxiosRequestConfig) {
        return AjaxSettingsConnectionOriginRestControllerApiFp(this.configuration).getOwnConnectionOrigins(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxSettingsControllerApi - axios parameter creator
 * @export
 */
export const AjaxSettingsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ChangePasswordRequest} changePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: async (changePasswordRequest: ChangePasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changePasswordRequest' is not null or undefined
            assertParamExists('changePassword', 'changePasswordRequest', changePasswordRequest)
            const localVarPath = `/ajax/settings/change_password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ChangeUsernameRequest} changeUsernameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeUsername: async (changeUsernameRequest: ChangeUsernameRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changeUsernameRequest' is not null or undefined
            assertParamExists('changeUsername', 'changeUsernameRequest', changeUsernameRequest)
            const localVarPath = `/ajax/settings/change_username`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeUsernameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DeleteAccountRequest} deleteAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount: async (deleteAccountRequest: DeleteAccountRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteAccountRequest' is not null or undefined
            assertParamExists('deleteAccount', 'deleteAccountRequest', deleteAccountRequest)
            const localVarPath = `/ajax/settings/delete_account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBootstrap: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/settings/bootstrap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReadingLanguages: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/settings/reading_languages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSafetyControls: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/settings/safety_controls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MuteReadingLanguageRequest} muteReadingLanguageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        muteReadingLanguage: async (muteReadingLanguageRequest: MuteReadingLanguageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'muteReadingLanguageRequest' is not null or undefined
            assertParamExists('muteReadingLanguage', 'muteReadingLanguageRequest', muteReadingLanguageRequest)
            const localVarPath = `/ajax/settings/mute_reading_language`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(muteReadingLanguageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ChangeEmailRequest} changeEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestEmailChange: async (changeEmailRequest: ChangeEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changeEmailRequest' is not null or undefined
            assertParamExists('requestEmailChange', 'changeEmailRequest', changeEmailRequest)
            const localVarPath = `/ajax/settings/email_change`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendEmailVerification: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/settings/resend_email_verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailChangeCode: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/settings/email_change/code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSetPasswordEmail: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/settings/send_set_password_email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetReadingLanguageRequest} setReadingLanguageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setReadingLanguage: async (setReadingLanguageRequest: SetReadingLanguageRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setReadingLanguageRequest' is not null or undefined
            assertParamExists('setReadingLanguage', 'setReadingLanguageRequest', setReadingLanguageRequest)
            const localVarPath = `/ajax/settings/set_reading_language`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setReadingLanguageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signOutEverywhere: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/settings/sign_out_everywhere`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateContentPreferencesRequest} updateContentPreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContentPreferences: async (updateContentPreferencesRequest: UpdateContentPreferencesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateContentPreferencesRequest' is not null or undefined
            assertParamExists('updateContentPreferences', 'updateContentPreferencesRequest', updateContentPreferencesRequest)
            const localVarPath = `/ajax/settings/update_content_preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateContentPreferencesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateDirectMessagePolicyRequest} updateDirectMessagePolicyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDirectMessagePolicy: async (updateDirectMessagePolicyRequest: UpdateDirectMessagePolicyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateDirectMessagePolicyRequest' is not null or undefined
            assertParamExists('updateDirectMessagePolicy', 'updateDirectMessagePolicyRequest', updateDirectMessagePolicyRequest)
            const localVarPath = `/ajax/settings/update_direct_message_policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDirectMessagePolicyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateHomeFeedPreferenceRequest} updateHomeFeedPreferenceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHomeFeedPreference: async (updateHomeFeedPreferenceRequest: UpdateHomeFeedPreferenceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateHomeFeedPreferenceRequest' is not null or undefined
            assertParamExists('updateHomeFeedPreference', 'updateHomeFeedPreferenceRequest', updateHomeFeedPreferenceRequest)
            const localVarPath = `/ajax/settings/update_home_feed_preference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateHomeFeedPreferenceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateLanguagePreferenceRequest} [updateLanguagePreferenceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLanguagePreference: async (updateLanguagePreferenceRequest?: UpdateLanguagePreferenceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/settings/language`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateLanguagePreferenceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateNotificationPreferencesRequest} updateNotificationPreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationPreferences: async (updateNotificationPreferencesRequest: UpdateNotificationPreferencesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateNotificationPreferencesRequest' is not null or undefined
            assertParamExists('updateNotificationPreferences', 'updateNotificationPreferencesRequest', updateNotificationPreferencesRequest)
            const localVarPath = `/ajax/settings/update_notification_preferences`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateNotificationPreferencesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateProfileSettingsRequest} updateProfileSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfileSettings: async (updateProfileSettingsRequest: UpdateProfileSettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateProfileSettingsRequest' is not null or undefined
            assertParamExists('updateProfileSettings', 'updateProfileSettingsRequest', updateProfileSettingsRequest)
            const localVarPath = `/ajax/settings/update_profile_settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProfileSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateReadingLanguageAutoAddRequest} updateReadingLanguageAutoAddRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReadingLanguageAutoAdd: async (updateReadingLanguageAutoAddRequest: UpdateReadingLanguageAutoAddRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateReadingLanguageAutoAddRequest' is not null or undefined
            assertParamExists('updateReadingLanguageAutoAdd', 'updateReadingLanguageAutoAddRequest', updateReadingLanguageAutoAddRequest)
            const localVarPath = `/ajax/settings/update_reading_language_auto_add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReadingLanguageAutoAddRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateReadingLanguagesRequest} updateReadingLanguagesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReadingLanguages: async (updateReadingLanguagesRequest: UpdateReadingLanguagesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateReadingLanguagesRequest' is not null or undefined
            assertParamExists('updateReadingLanguages', 'updateReadingLanguagesRequest', updateReadingLanguagesRequest)
            const localVarPath = `/ajax/settings/update_reading_languages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateReadingLanguagesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateThemePreferenceRequest} updateThemePreferenceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateThemePreference: async (updateThemePreferenceRequest: UpdateThemePreferenceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateThemePreferenceRequest' is not null or undefined
            assertParamExists('updateThemePreference', 'updateThemePreferenceRequest', updateThemePreferenceRequest)
            const localVarPath = `/ajax/settings/update_theme_preference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateThemePreferenceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxSettingsControllerApi - functional programming interface
 * @export
 */
export const AjaxSettingsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxSettingsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ChangePasswordRequest} changePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePassword(changePasswordRequest: ChangePasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePassword(changePasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSettingsControllerApi.changePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ChangeUsernameRequest} changeUsernameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeUsername(changeUsernameRequest: ChangeUsernameRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeUsername(changeUsernameRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSettingsControllerApi.changeUsername']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DeleteAccountRequest} deleteAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAccount(deleteAccountRequest: DeleteAccountRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAccount(deleteAccountRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSettingsControllerApi.deleteAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBootstrap(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SettingsBootstrapDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBootstrap(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSettingsControllerApi.getBootstrap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReadingLanguages(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReadingLanguagesViewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReadingLanguages(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSettingsControllerApi.getReadingLanguages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSafetyControls(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SafetyControlsSettingsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSafetyControls(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSettingsControllerApi.getSafetyControls']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MuteReadingLanguageRequest} muteReadingLanguageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async muteReadingLanguage(muteReadingLanguageRequest: MuteReadingLanguageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.muteReadingLanguage(muteReadingLanguageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSettingsControllerApi.muteReadingLanguage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ChangeEmailRequest} changeEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestEmailChange(changeEmailRequest: ChangeEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestEmailChange(changeEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSettingsControllerApi.requestEmailChange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendEmailVerification(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendEmailVerification(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSettingsControllerApi.resendEmailVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendEmailChangeCode(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendEmailChangeCode(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSettingsControllerApi.sendEmailChangeCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendSetPasswordEmail(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendSetPasswordEmail(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSettingsControllerApi.sendSetPasswordEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SetReadingLanguageRequest} setReadingLanguageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setReadingLanguage(setReadingLanguageRequest: SetReadingLanguageRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setReadingLanguage(setReadingLanguageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSettingsControllerApi.setReadingLanguage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signOutEverywhere(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signOutEverywhere(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSettingsControllerApi.signOutEverywhere']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateContentPreferencesRequest} updateContentPreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContentPreferences(updateContentPreferencesRequest: UpdateContentPreferencesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContentPreferences(updateContentPreferencesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSettingsControllerApi.updateContentPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateDirectMessagePolicyRequest} updateDirectMessagePolicyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDirectMessagePolicy(updateDirectMessagePolicyRequest: UpdateDirectMessagePolicyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDirectMessagePolicy(updateDirectMessagePolicyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSettingsControllerApi.updateDirectMessagePolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateHomeFeedPreferenceRequest} updateHomeFeedPreferenceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHomeFeedPreference(updateHomeFeedPreferenceRequest: UpdateHomeFeedPreferenceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHomeFeedPreference(updateHomeFeedPreferenceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSettingsControllerApi.updateHomeFeedPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateLanguagePreferenceRequest} [updateLanguagePreferenceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLanguagePreference(updateLanguagePreferenceRequest?: UpdateLanguagePreferenceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLanguagePreference(updateLanguagePreferenceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSettingsControllerApi.updateLanguagePreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateNotificationPreferencesRequest} updateNotificationPreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateNotificationPreferences(updateNotificationPreferencesRequest: UpdateNotificationPreferencesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateNotificationPreferences(updateNotificationPreferencesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSettingsControllerApi.updateNotificationPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateProfileSettingsRequest} updateProfileSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProfileSettings(updateProfileSettingsRequest: UpdateProfileSettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProfileSettings(updateProfileSettingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSettingsControllerApi.updateProfileSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateReadingLanguageAutoAddRequest} updateReadingLanguageAutoAddRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReadingLanguageAutoAdd(updateReadingLanguageAutoAddRequest: UpdateReadingLanguageAutoAddRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReadingLanguageAutoAdd(updateReadingLanguageAutoAddRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSettingsControllerApi.updateReadingLanguageAutoAdd']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateReadingLanguagesRequest} updateReadingLanguagesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReadingLanguages(updateReadingLanguagesRequest: UpdateReadingLanguagesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReadingLanguagesViewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReadingLanguages(updateReadingLanguagesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSettingsControllerApi.updateReadingLanguages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateThemePreferenceRequest} updateThemePreferenceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateThemePreference(updateThemePreferenceRequest: UpdateThemePreferenceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateThemePreference(updateThemePreferenceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxSettingsControllerApi.updateThemePreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxSettingsControllerApi - factory interface
 * @export
 */
export const AjaxSettingsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxSettingsControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {ChangePasswordRequest} changePasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(changePasswordRequest: ChangePasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.changePassword(changePasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChangeUsernameRequest} changeUsernameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeUsername(changeUsernameRequest: ChangeUsernameRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.changeUsername(changeUsernameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DeleteAccountRequest} deleteAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(deleteAccountRequest: DeleteAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.deleteAccount(deleteAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBootstrap(options?: RawAxiosRequestConfig): AxiosPromise<SettingsBootstrapDTO> {
            return localVarFp.getBootstrap(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReadingLanguages(options?: RawAxiosRequestConfig): AxiosPromise<ReadingLanguagesViewDTO> {
            return localVarFp.getReadingLanguages(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSafetyControls(options?: RawAxiosRequestConfig): AxiosPromise<SafetyControlsSettingsDTO> {
            return localVarFp.getSafetyControls(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MuteReadingLanguageRequest} muteReadingLanguageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        muteReadingLanguage(muteReadingLanguageRequest: MuteReadingLanguageRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.muteReadingLanguage(muteReadingLanguageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChangeEmailRequest} changeEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestEmailChange(changeEmailRequest: ChangeEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.requestEmailChange(changeEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendEmailVerification(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.resendEmailVerification(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailChangeCode(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.sendEmailChangeCode(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSetPasswordEmail(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.sendSetPasswordEmail(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetReadingLanguageRequest} setReadingLanguageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setReadingLanguage(setReadingLanguageRequest: SetReadingLanguageRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.setReadingLanguage(setReadingLanguageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signOutEverywhere(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.signOutEverywhere(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateContentPreferencesRequest} updateContentPreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContentPreferences(updateContentPreferencesRequest: UpdateContentPreferencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.updateContentPreferences(updateContentPreferencesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateDirectMessagePolicyRequest} updateDirectMessagePolicyRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDirectMessagePolicy(updateDirectMessagePolicyRequest: UpdateDirectMessagePolicyRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.updateDirectMessagePolicy(updateDirectMessagePolicyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateHomeFeedPreferenceRequest} updateHomeFeedPreferenceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHomeFeedPreference(updateHomeFeedPreferenceRequest: UpdateHomeFeedPreferenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.updateHomeFeedPreference(updateHomeFeedPreferenceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateLanguagePreferenceRequest} [updateLanguagePreferenceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLanguagePreference(updateLanguagePreferenceRequest?: UpdateLanguagePreferenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.updateLanguagePreference(updateLanguagePreferenceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateNotificationPreferencesRequest} updateNotificationPreferencesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNotificationPreferences(updateNotificationPreferencesRequest: UpdateNotificationPreferencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.updateNotificationPreferences(updateNotificationPreferencesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateProfileSettingsRequest} updateProfileSettingsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfileSettings(updateProfileSettingsRequest: UpdateProfileSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.updateProfileSettings(updateProfileSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateReadingLanguageAutoAddRequest} updateReadingLanguageAutoAddRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReadingLanguageAutoAdd(updateReadingLanguageAutoAddRequest: UpdateReadingLanguageAutoAddRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.updateReadingLanguageAutoAdd(updateReadingLanguageAutoAddRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateReadingLanguagesRequest} updateReadingLanguagesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReadingLanguages(updateReadingLanguagesRequest: UpdateReadingLanguagesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReadingLanguagesViewDTO> {
            return localVarFp.updateReadingLanguages(updateReadingLanguagesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateThemePreferenceRequest} updateThemePreferenceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateThemePreference(updateThemePreferenceRequest: UpdateThemePreferenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.updateThemePreference(updateThemePreferenceRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxSettingsControllerApi - object-oriented interface
 * @export
 * @class AjaxSettingsControllerApi
 * @extends {BaseAPI}
 */
export class AjaxSettingsControllerApi extends BaseAPI {
    /**
     * 
     * @param {ChangePasswordRequest} changePasswordRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSettingsControllerApi
     */
    public changePassword(changePasswordRequest: ChangePasswordRequest, options?: RawAxiosRequestConfig) {
        return AjaxSettingsControllerApiFp(this.configuration).changePassword(changePasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChangeUsernameRequest} changeUsernameRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSettingsControllerApi
     */
    public changeUsername(changeUsernameRequest: ChangeUsernameRequest, options?: RawAxiosRequestConfig) {
        return AjaxSettingsControllerApiFp(this.configuration).changeUsername(changeUsernameRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DeleteAccountRequest} deleteAccountRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSettingsControllerApi
     */
    public deleteAccount(deleteAccountRequest: DeleteAccountRequest, options?: RawAxiosRequestConfig) {
        return AjaxSettingsControllerApiFp(this.configuration).deleteAccount(deleteAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSettingsControllerApi
     */
    public getBootstrap(options?: RawAxiosRequestConfig) {
        return AjaxSettingsControllerApiFp(this.configuration).getBootstrap(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSettingsControllerApi
     */
    public getReadingLanguages(options?: RawAxiosRequestConfig) {
        return AjaxSettingsControllerApiFp(this.configuration).getReadingLanguages(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSettingsControllerApi
     */
    public getSafetyControls(options?: RawAxiosRequestConfig) {
        return AjaxSettingsControllerApiFp(this.configuration).getSafetyControls(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MuteReadingLanguageRequest} muteReadingLanguageRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSettingsControllerApi
     */
    public muteReadingLanguage(muteReadingLanguageRequest: MuteReadingLanguageRequest, options?: RawAxiosRequestConfig) {
        return AjaxSettingsControllerApiFp(this.configuration).muteReadingLanguage(muteReadingLanguageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChangeEmailRequest} changeEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSettingsControllerApi
     */
    public requestEmailChange(changeEmailRequest: ChangeEmailRequest, options?: RawAxiosRequestConfig) {
        return AjaxSettingsControllerApiFp(this.configuration).requestEmailChange(changeEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSettingsControllerApi
     */
    public resendEmailVerification(options?: RawAxiosRequestConfig) {
        return AjaxSettingsControllerApiFp(this.configuration).resendEmailVerification(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSettingsControllerApi
     */
    public sendEmailChangeCode(options?: RawAxiosRequestConfig) {
        return AjaxSettingsControllerApiFp(this.configuration).sendEmailChangeCode(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSettingsControllerApi
     */
    public sendSetPasswordEmail(options?: RawAxiosRequestConfig) {
        return AjaxSettingsControllerApiFp(this.configuration).sendSetPasswordEmail(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetReadingLanguageRequest} setReadingLanguageRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSettingsControllerApi
     */
    public setReadingLanguage(setReadingLanguageRequest: SetReadingLanguageRequest, options?: RawAxiosRequestConfig) {
        return AjaxSettingsControllerApiFp(this.configuration).setReadingLanguage(setReadingLanguageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSettingsControllerApi
     */
    public signOutEverywhere(options?: RawAxiosRequestConfig) {
        return AjaxSettingsControllerApiFp(this.configuration).signOutEverywhere(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateContentPreferencesRequest} updateContentPreferencesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSettingsControllerApi
     */
    public updateContentPreferences(updateContentPreferencesRequest: UpdateContentPreferencesRequest, options?: RawAxiosRequestConfig) {
        return AjaxSettingsControllerApiFp(this.configuration).updateContentPreferences(updateContentPreferencesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateDirectMessagePolicyRequest} updateDirectMessagePolicyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSettingsControllerApi
     */
    public updateDirectMessagePolicy(updateDirectMessagePolicyRequest: UpdateDirectMessagePolicyRequest, options?: RawAxiosRequestConfig) {
        return AjaxSettingsControllerApiFp(this.configuration).updateDirectMessagePolicy(updateDirectMessagePolicyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateHomeFeedPreferenceRequest} updateHomeFeedPreferenceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSettingsControllerApi
     */
    public updateHomeFeedPreference(updateHomeFeedPreferenceRequest: UpdateHomeFeedPreferenceRequest, options?: RawAxiosRequestConfig) {
        return AjaxSettingsControllerApiFp(this.configuration).updateHomeFeedPreference(updateHomeFeedPreferenceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateLanguagePreferenceRequest} [updateLanguagePreferenceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSettingsControllerApi
     */
    public updateLanguagePreference(updateLanguagePreferenceRequest?: UpdateLanguagePreferenceRequest, options?: RawAxiosRequestConfig) {
        return AjaxSettingsControllerApiFp(this.configuration).updateLanguagePreference(updateLanguagePreferenceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateNotificationPreferencesRequest} updateNotificationPreferencesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSettingsControllerApi
     */
    public updateNotificationPreferences(updateNotificationPreferencesRequest: UpdateNotificationPreferencesRequest, options?: RawAxiosRequestConfig) {
        return AjaxSettingsControllerApiFp(this.configuration).updateNotificationPreferences(updateNotificationPreferencesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateProfileSettingsRequest} updateProfileSettingsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSettingsControllerApi
     */
    public updateProfileSettings(updateProfileSettingsRequest: UpdateProfileSettingsRequest, options?: RawAxiosRequestConfig) {
        return AjaxSettingsControllerApiFp(this.configuration).updateProfileSettings(updateProfileSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateReadingLanguageAutoAddRequest} updateReadingLanguageAutoAddRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSettingsControllerApi
     */
    public updateReadingLanguageAutoAdd(updateReadingLanguageAutoAddRequest: UpdateReadingLanguageAutoAddRequest, options?: RawAxiosRequestConfig) {
        return AjaxSettingsControllerApiFp(this.configuration).updateReadingLanguageAutoAdd(updateReadingLanguageAutoAddRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateReadingLanguagesRequest} updateReadingLanguagesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSettingsControllerApi
     */
    public updateReadingLanguages(updateReadingLanguagesRequest: UpdateReadingLanguagesRequest, options?: RawAxiosRequestConfig) {
        return AjaxSettingsControllerApiFp(this.configuration).updateReadingLanguages(updateReadingLanguagesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateThemePreferenceRequest} updateThemePreferenceRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxSettingsControllerApi
     */
    public updateThemePreference(updateThemePreferenceRequest: UpdateThemePreferenceRequest, options?: RawAxiosRequestConfig) {
        return AjaxSettingsControllerApiFp(this.configuration).updateThemePreference(updateThemePreferenceRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxShareRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxShareRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ShareInitiatedRequest} shareInitiatedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareInitiated: async (shareInitiatedRequest: ShareInitiatedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'shareInitiatedRequest' is not null or undefined
            assertParamExists('shareInitiated', 'shareInitiatedRequest', shareInitiatedRequest)
            const localVarPath = `/ajax/share/initiated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(shareInitiatedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxShareRestControllerApi - functional programming interface
 * @export
 */
export const AjaxShareRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxShareRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ShareInitiatedRequest} shareInitiatedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shareInitiated(shareInitiatedRequest: ShareInitiatedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shareInitiated(shareInitiatedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxShareRestControllerApi.shareInitiated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxShareRestControllerApi - factory interface
 * @export
 */
export const AjaxShareRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxShareRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {ShareInitiatedRequest} shareInitiatedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareInitiated(shareInitiatedRequest: ShareInitiatedRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.shareInitiated(shareInitiatedRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxShareRestControllerApi - object-oriented interface
 * @export
 * @class AjaxShareRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxShareRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {ShareInitiatedRequest} shareInitiatedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxShareRestControllerApi
     */
    public shareInitiated(shareInitiatedRequest: ShareInitiatedRequest, options?: RawAxiosRequestConfig) {
        return AjaxShareRestControllerApiFp(this.configuration).shareInitiated(shareInitiatedRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxTestSupportRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxTestSupportRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [email] 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailChangeCode: async (email?: string, username?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/test-support/email-change-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [email] 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailChangeToken: async (email?: string, username?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/test-support/email-change-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [email] 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailSignInToken: async (email?: string, username?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/test-support/email-signin-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [email] 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailVerificationToken: async (email?: string, username?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/test-support/email-verification-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [shareToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirstTouchByShareToken: async (shareToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/test-support/first-touch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (shareToken !== undefined) {
                localVarQueryParameter['shareToken'] = shareToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [email] 
         * @param {string} [newsletterPublicId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsletterConfirmToken: async (email?: string, newsletterPublicId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/test-support/newsletter-confirm-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (newsletterPublicId !== undefined) {
                localVarQueryParameter['newsletterPublicId'] = newsletterPublicId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [email] 
         * @param {string} [newsletterPublicId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsletterUnsubscribeToken: async (email?: string, newsletterPublicId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/test-support/newsletter-unsubscribe-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (newsletterPublicId !== undefined) {
                localVarQueryParameter['newsletterPublicId'] = newsletterPublicId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [email] 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPasswordResetToken: async (email?: string, username?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/test-support/password-reset-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [email] 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAcquisition: async (email?: string, username?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/test-support/acquisition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxTestSupportRestControllerApi - functional programming interface
 * @export
 */
export const AjaxTestSupportRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxTestSupportRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [email] 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailChangeCode(email?: string, username?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmailChangeCode(email, username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxTestSupportRestControllerApi.getEmailChangeCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [email] 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailChangeToken(email?: string, username?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmailChangeToken(email, username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxTestSupportRestControllerApi.getEmailChangeToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [email] 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailSignInToken(email?: string, username?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmailSignInToken(email, username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxTestSupportRestControllerApi.getEmailSignInToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [email] 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEmailVerificationToken(email?: string, username?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEmailVerificationToken(email, username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxTestSupportRestControllerApi.getEmailVerificationToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [shareToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFirstTouchByShareToken(shareToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFirstTouchByShareToken(shareToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxTestSupportRestControllerApi.getFirstTouchByShareToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [email] 
         * @param {string} [newsletterPublicId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewsletterConfirmToken(email?: string, newsletterPublicId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNewsletterConfirmToken(email, newsletterPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxTestSupportRestControllerApi.getNewsletterConfirmToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [email] 
         * @param {string} [newsletterPublicId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewsletterUnsubscribeToken(email?: string, newsletterPublicId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNewsletterUnsubscribeToken(email, newsletterPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxTestSupportRestControllerApi.getNewsletterUnsubscribeToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [email] 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPasswordResetToken(email?: string, username?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPasswordResetToken(email, username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxTestSupportRestControllerApi.getPasswordResetToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [email] 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserAcquisition(email?: string, username?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserAcquisition(email, username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxTestSupportRestControllerApi.getUserAcquisition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxTestSupportRestControllerApi - factory interface
 * @export
 */
export const AjaxTestSupportRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxTestSupportRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [email] 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailChangeCode(email?: string, username?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getEmailChangeCode(email, username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [email] 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailChangeToken(email?: string, username?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getEmailChangeToken(email, username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [email] 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailSignInToken(email?: string, username?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getEmailSignInToken(email, username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [email] 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEmailVerificationToken(email?: string, username?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getEmailVerificationToken(email, username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [shareToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFirstTouchByShareToken(shareToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getFirstTouchByShareToken(shareToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [email] 
         * @param {string} [newsletterPublicId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsletterConfirmToken(email?: string, newsletterPublicId?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getNewsletterConfirmToken(email, newsletterPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [email] 
         * @param {string} [newsletterPublicId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewsletterUnsubscribeToken(email?: string, newsletterPublicId?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getNewsletterUnsubscribeToken(email, newsletterPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [email] 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPasswordResetToken(email?: string, username?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getPasswordResetToken(email, username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [email] 
         * @param {string} [username] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAcquisition(email?: string, username?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getUserAcquisition(email, username, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxTestSupportRestControllerApi - object-oriented interface
 * @export
 * @class AjaxTestSupportRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxTestSupportRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} [email] 
     * @param {string} [username] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxTestSupportRestControllerApi
     */
    public getEmailChangeCode(email?: string, username?: string, options?: RawAxiosRequestConfig) {
        return AjaxTestSupportRestControllerApiFp(this.configuration).getEmailChangeCode(email, username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [email] 
     * @param {string} [username] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxTestSupportRestControllerApi
     */
    public getEmailChangeToken(email?: string, username?: string, options?: RawAxiosRequestConfig) {
        return AjaxTestSupportRestControllerApiFp(this.configuration).getEmailChangeToken(email, username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [email] 
     * @param {string} [username] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxTestSupportRestControllerApi
     */
    public getEmailSignInToken(email?: string, username?: string, options?: RawAxiosRequestConfig) {
        return AjaxTestSupportRestControllerApiFp(this.configuration).getEmailSignInToken(email, username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [email] 
     * @param {string} [username] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxTestSupportRestControllerApi
     */
    public getEmailVerificationToken(email?: string, username?: string, options?: RawAxiosRequestConfig) {
        return AjaxTestSupportRestControllerApiFp(this.configuration).getEmailVerificationToken(email, username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [shareToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxTestSupportRestControllerApi
     */
    public getFirstTouchByShareToken(shareToken?: string, options?: RawAxiosRequestConfig) {
        return AjaxTestSupportRestControllerApiFp(this.configuration).getFirstTouchByShareToken(shareToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [email] 
     * @param {string} [newsletterPublicId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxTestSupportRestControllerApi
     */
    public getNewsletterConfirmToken(email?: string, newsletterPublicId?: string, options?: RawAxiosRequestConfig) {
        return AjaxTestSupportRestControllerApiFp(this.configuration).getNewsletterConfirmToken(email, newsletterPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [email] 
     * @param {string} [newsletterPublicId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxTestSupportRestControllerApi
     */
    public getNewsletterUnsubscribeToken(email?: string, newsletterPublicId?: string, options?: RawAxiosRequestConfig) {
        return AjaxTestSupportRestControllerApiFp(this.configuration).getNewsletterUnsubscribeToken(email, newsletterPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [email] 
     * @param {string} [username] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxTestSupportRestControllerApi
     */
    public getPasswordResetToken(email?: string, username?: string, options?: RawAxiosRequestConfig) {
        return AjaxTestSupportRestControllerApiFp(this.configuration).getPasswordResetToken(email, username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [email] 
     * @param {string} [username] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxTestSupportRestControllerApi
     */
    public getUserAcquisition(email?: string, username?: string, options?: RawAxiosRequestConfig) {
        return AjaxTestSupportRestControllerApiFp(this.configuration).getUserAcquisition(email, username, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxThoughtRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxThoughtRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} argumentPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ancestorsOfThought: async (argumentPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'argumentPublicId' is not null or undefined
            assertParamExists('ancestorsOfThought', 'argumentPublicId', argumentPublicId)
            const localVarPath = `/ajax/thoughts/ancestors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (argumentPublicId !== undefined) {
                localVarQueryParameter['argumentPublicId'] = argumentPublicId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} publicArgumentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookmarkThought: async (publicArgumentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicArgumentId' is not null or undefined
            assertParamExists('bookmarkThought', 'publicArgumentId', publicArgumentId)
            const localVarPath = `/ajax/thought/bookmark/{publicArgumentId}`
                .replace(`{${"publicArgumentId"}}`, encodeURIComponent(String(publicArgumentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} anchorArgumentPublicId 
         * @param {string} [order] Follow-rule for which child to follow at each level: best (Wilson confidence, default), old (oldest first), new (newest first).
         * @param {number} [limit] Max descendant levels below the anchor (default 20, clamped to the depth cap).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chainUnderAnchorThought: async (anchorArgumentPublicId: string, order?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'anchorArgumentPublicId' is not null or undefined
            assertParamExists('chainUnderAnchorThought', 'anchorArgumentPublicId', anchorArgumentPublicId)
            const localVarPath = `/ajax/thoughts/chain`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (anchorArgumentPublicId !== undefined) {
                localVarQueryParameter['anchorArgumentPublicId'] = anchorArgumentPublicId;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} thoughtPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countThoughtView: async (thoughtPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'thoughtPublicId' is not null or undefined
            assertParamExists('countThoughtView', 'thoughtPublicId', thoughtPublicId)
            const localVarPath = `/ajax/thought/count_view/{thoughtPublicId}`
                .replace(`{${"thoughtPublicId"}}`, encodeURIComponent(String(thoughtPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} argumentPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteThought: async (argumentPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'argumentPublicId' is not null or undefined
            assertParamExists('deleteThought', 'argumentPublicId', argumentPublicId)
            const localVarPath = `/ajax/thought/{argumentPublicId}`
                .replace(`{${"argumentPublicId"}}`, encodeURIComponent(String(argumentPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} thoughtPublicId 
         * @param {EditThoughtRequest} editThoughtRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editThought: async (thoughtPublicId: string, editThoughtRequest: EditThoughtRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'thoughtPublicId' is not null or undefined
            assertParamExists('editThought', 'thoughtPublicId', thoughtPublicId)
            // verify required parameter 'editThoughtRequest' is not null or undefined
            assertParamExists('editThought', 'editThoughtRequest', editThoughtRequest)
            const localVarPath = `/ajax/thought/{thoughtPublicId}`
                .replace(`{${"thoughtPublicId"}}`, encodeURIComponent(String(thoughtPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editThoughtRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} thoughtPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinThought: async (thoughtPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'thoughtPublicId' is not null or undefined
            assertParamExists('pinThought', 'thoughtPublicId', thoughtPublicId)
            const localVarPath = `/ajax/thought/{thoughtPublicId}/pin`
                .replace(`{${"thoughtPublicId"}}`, encodeURIComponent(String(thoughtPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PublishThoughtRequest} publishThoughtRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishThought: async (publishThoughtRequest: PublishThoughtRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publishThoughtRequest' is not null or undefined
            assertParamExists('publishThought', 'publishThoughtRequest', publishThoughtRequest)
            const localVarPath = `/ajax/thought/publish`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publishThoughtRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} publicArgumentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeVoteFromThought: async (publicArgumentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicArgumentId' is not null or undefined
            assertParamExists('removeVoteFromThought', 'publicArgumentId', publicArgumentId)
            const localVarPath = `/ajax/thought/vote/{publicArgumentId}`
                .replace(`{${"publicArgumentId"}}`, encodeURIComponent(String(publicArgumentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} parentArgumentPublicId 
         * @param {string} [paginationParameter] Opaque keyset cursor from the last row\&#39;s paginationParameter (iso|id). Absent/blank returns the first page.
         * @param {number} [pageSize] Page size (default 20, capped at 100).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repliesUnderParentThought: async (parentArgumentPublicId: string, paginationParameter?: string, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parentArgumentPublicId' is not null or undefined
            assertParamExists('repliesUnderParentThought', 'parentArgumentPublicId', parentArgumentPublicId)
            const localVarPath = `/ajax/thoughts/replies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (parentArgumentPublicId !== undefined) {
                localVarQueryParameter['parentArgumentPublicId'] = parentArgumentPublicId;
            }

            if (paginationParameter !== undefined) {
                localVarQueryParameter['paginationParameter'] = paginationParameter;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} argumentPublicId 
         * @param {CreateContentReportRequest} createContentReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportThought: async (argumentPublicId: string, createContentReportRequest: CreateContentReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'argumentPublicId' is not null or undefined
            assertParamExists('reportThought', 'argumentPublicId', argumentPublicId)
            // verify required parameter 'createContentReportRequest' is not null or undefined
            assertParamExists('reportThought', 'createContentReportRequest', createContentReportRequest)
            const localVarPath = `/ajax/thought/{argumentPublicId}/report`
                .replace(`{${"argumentPublicId"}}`, encodeURIComponent(String(argumentPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createContentReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} argumentPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreOwnDeletedThought: async (argumentPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'argumentPublicId' is not null or undefined
            assertParamExists('restoreOwnDeletedThought', 'argumentPublicId', argumentPublicId)
            const localVarPath = `/ajax/thought/{argumentPublicId}/restore`
                .replace(`{${"argumentPublicId"}}`, encodeURIComponent(String(argumentPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} rootArgumentPublicId 
         * @param {number} [maxDepth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subtreeUnderRootThought: async (rootArgumentPublicId: string, maxDepth?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rootArgumentPublicId' is not null or undefined
            assertParamExists('subtreeUnderRootThought', 'rootArgumentPublicId', rootArgumentPublicId)
            const localVarPath = `/ajax/thoughts/subtree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (rootArgumentPublicId !== undefined) {
                localVarQueryParameter['rootArgumentPublicId'] = rootArgumentPublicId;
            }

            if (maxDepth !== undefined) {
                localVarQueryParameter['maxDepth'] = maxDepth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} anchorThoughtPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thoughtConversationContext: async (anchorThoughtPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'anchorThoughtPublicId' is not null or undefined
            assertParamExists('thoughtConversationContext', 'anchorThoughtPublicId', anchorThoughtPublicId)
            const localVarPath = `/ajax/thoughts/conversation-context`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (anchorThoughtPublicId !== undefined) {
                localVarQueryParameter['anchorThoughtPublicId'] = anchorThoughtPublicId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} argumentPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thoughtEmbedSnapshot: async (argumentPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'argumentPublicId' is not null or undefined
            assertParamExists('thoughtEmbedSnapshot', 'argumentPublicId', argumentPublicId)
            const localVarPath = `/ajax/thought/{argumentPublicId}/embed`
                .replace(`{${"argumentPublicId"}}`, encodeURIComponent(String(argumentPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} openingPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thoughtOpening: async (openingPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'openingPublicId' is not null or undefined
            assertParamExists('thoughtOpening', 'openingPublicId', openingPublicId)
            const localVarPath = `/ajax/thought/opening/{openingPublicId}`
                .replace(`{${"openingPublicId"}}`, encodeURIComponent(String(openingPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} thoughtPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thoughtVersions: async (thoughtPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'thoughtPublicId' is not null or undefined
            assertParamExists('thoughtVersions', 'thoughtPublicId', thoughtPublicId)
            const localVarPath = `/ajax/thought/{thoughtPublicId}/versions`
                .replace(`{${"thoughtPublicId"}}`, encodeURIComponent(String(thoughtPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [paginationParameter] Pagination timestamp (ISO_LOCAL_DATE_TIME). Nullable — backend will use current time when absent.
         * @param {string} [groupPublicIds] Optional comma-separated discussion group public ids used to filter opening arguments by author group membership.
         * @param {string} [openingArgumentOrdering] Optional ordering style for opening arguments. Supported values: best (Wilson confidence, default), controversial, new, old, agreed, disagreed, conversations. Legacy top is still accepted as an alias for agreed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thoughtsInDiscussion: async (discussionPublicId: string, paginationParameter?: string, groupPublicIds?: string, openingArgumentOrdering?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'discussionPublicId' is not null or undefined
            assertParamExists('thoughtsInDiscussion', 'discussionPublicId', discussionPublicId)
            const localVarPath = `/ajax/thoughts/discussion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (paginationParameter !== undefined) {
                localVarQueryParameter['paginationParameter'] = (paginationParameter as any instanceof Date) ?
                    (paginationParameter as any).toISOString() :
                    paginationParameter;
            }

            if (groupPublicIds !== undefined) {
                localVarQueryParameter['groupPublicIds'] = groupPublicIds;
            }

            if (openingArgumentOrdering !== undefined) {
                localVarQueryParameter['openingArgumentOrdering'] = openingArgumentOrdering;
            }

            if (discussionPublicId !== undefined) {
                localVarQueryParameter['discussionPublicId'] = discussionPublicId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} publicArgumentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unbookmarkThought: async (publicArgumentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicArgumentId' is not null or undefined
            assertParamExists('unbookmarkThought', 'publicArgumentId', publicArgumentId)
            const localVarPath = `/ajax/thought/bookmark/{publicArgumentId}`
                .replace(`{${"publicArgumentId"}}`, encodeURIComponent(String(publicArgumentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} thoughtPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unpinThought: async (thoughtPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'thoughtPublicId' is not null or undefined
            assertParamExists('unpinThought', 'thoughtPublicId', thoughtPublicId)
            const localVarPath = `/ajax/thought/{thoughtPublicId}/pin`
                .replace(`{${"thoughtPublicId"}}`, encodeURIComponent(String(thoughtPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} publicArgumentId 
         * @param {string} agreementMode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voteOnThought: async (publicArgumentId: string, agreementMode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicArgumentId' is not null or undefined
            assertParamExists('voteOnThought', 'publicArgumentId', publicArgumentId)
            // verify required parameter 'agreementMode' is not null or undefined
            assertParamExists('voteOnThought', 'agreementMode', agreementMode)
            const localVarPath = `/ajax/thought/vote/{publicArgumentId}/{agreementMode}`
                .replace(`{${"publicArgumentId"}}`, encodeURIComponent(String(publicArgumentId)))
                .replace(`{${"agreementMode"}}`, encodeURIComponent(String(agreementMode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxThoughtRestControllerApi - functional programming interface
 * @export
 */
export const AjaxThoughtRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxThoughtRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} argumentPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ancestorsOfThought(argumentPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ThoughtInConversationDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ancestorsOfThought(argumentPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxThoughtRestControllerApi.ancestorsOfThought']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} publicArgumentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bookmarkThought(publicArgumentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bookmarkThought(publicArgumentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxThoughtRestControllerApi.bookmarkThought']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} anchorArgumentPublicId 
         * @param {string} [order] Follow-rule for which child to follow at each level: best (Wilson confidence, default), old (oldest first), new (newest first).
         * @param {number} [limit] Max descendant levels below the anchor (default 20, clamped to the depth cap).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chainUnderAnchorThought(anchorArgumentPublicId: string, order?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ThoughtInConversationDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chainUnderAnchorThought(anchorArgumentPublicId, order, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxThoughtRestControllerApi.chainUnderAnchorThought']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} thoughtPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countThoughtView(thoughtPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countThoughtView(thoughtPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxThoughtRestControllerApi.countThoughtView']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} argumentPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteThought(argumentPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThoughtInConversationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteThought(argumentPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxThoughtRestControllerApi.deleteThought']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} thoughtPublicId 
         * @param {EditThoughtRequest} editThoughtRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editThought(thoughtPublicId: string, editThoughtRequest: EditThoughtRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EditThoughtResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editThought(thoughtPublicId, editThoughtRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxThoughtRestControllerApi.editThought']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} thoughtPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pinThought(thoughtPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThoughtDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pinThought(thoughtPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxThoughtRestControllerApi.pinThought']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PublishThoughtRequest} publishThoughtRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishThought(publishThoughtRequest: PublishThoughtRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublishThoughtResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishThought(publishThoughtRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxThoughtRestControllerApi.publishThought']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} publicArgumentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeVoteFromThought(publicArgumentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeVoteFromThought(publicArgumentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxThoughtRestControllerApi.removeVoteFromThought']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} parentArgumentPublicId 
         * @param {string} [paginationParameter] Opaque keyset cursor from the last row\&#39;s paginationParameter (iso|id). Absent/blank returns the first page.
         * @param {number} [pageSize] Page size (default 20, capped at 100).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repliesUnderParentThought(parentArgumentPublicId: string, paginationParameter?: string, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ThoughtInConversationDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repliesUnderParentThought(parentArgumentPublicId, paginationParameter, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxThoughtRestControllerApi.repliesUnderParentThought']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} argumentPublicId 
         * @param {CreateContentReportRequest} createContentReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportThought(argumentPublicId: string, createContentReportRequest: CreateContentReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportThought(argumentPublicId, createContentReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxThoughtRestControllerApi.reportThought']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} argumentPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async restoreOwnDeletedThought(argumentPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThoughtInConversationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.restoreOwnDeletedThought(argumentPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxThoughtRestControllerApi.restoreOwnDeletedThought']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} rootArgumentPublicId 
         * @param {number} [maxDepth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async subtreeUnderRootThought(rootArgumentPublicId: string, maxDepth?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ThoughtInConversationDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.subtreeUnderRootThought(rootArgumentPublicId, maxDepth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxThoughtRestControllerApi.subtreeUnderRootThought']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} anchorThoughtPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async thoughtConversationContext(anchorThoughtPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThoughtConversationContextDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.thoughtConversationContext(anchorThoughtPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxThoughtRestControllerApi.thoughtConversationContext']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} argumentPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async thoughtEmbedSnapshot(argumentPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThoughtEmbedSnapshotDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.thoughtEmbedSnapshot(argumentPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxThoughtRestControllerApi.thoughtEmbedSnapshot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} openingPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async thoughtOpening(openingPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OpeningThoughtWithConversationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.thoughtOpening(openingPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxThoughtRestControllerApi.thoughtOpening']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} thoughtPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async thoughtVersions(thoughtPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThoughtVersionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.thoughtVersions(thoughtPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxThoughtRestControllerApi.thoughtVersions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [paginationParameter] Pagination timestamp (ISO_LOCAL_DATE_TIME). Nullable — backend will use current time when absent.
         * @param {string} [groupPublicIds] Optional comma-separated discussion group public ids used to filter opening arguments by author group membership.
         * @param {string} [openingArgumentOrdering] Optional ordering style for opening arguments. Supported values: best (Wilson confidence, default), controversial, new, old, agreed, disagreed, conversations. Legacy top is still accepted as an alias for agreed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async thoughtsInDiscussion(discussionPublicId: string, paginationParameter?: string, groupPublicIds?: string, openingArgumentOrdering?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.thoughtsInDiscussion(discussionPublicId, paginationParameter, groupPublicIds, openingArgumentOrdering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxThoughtRestControllerApi.thoughtsInDiscussion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} publicArgumentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unbookmarkThought(publicArgumentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unbookmarkThought(publicArgumentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxThoughtRestControllerApi.unbookmarkThought']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} thoughtPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unpinThought(thoughtPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unpinThought(thoughtPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxThoughtRestControllerApi.unpinThought']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} publicArgumentId 
         * @param {string} agreementMode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voteOnThought(publicArgumentId: string, agreementMode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voteOnThought(publicArgumentId, agreementMode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxThoughtRestControllerApi.voteOnThought']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxThoughtRestControllerApi - factory interface
 * @export
 */
export const AjaxThoughtRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxThoughtRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} argumentPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ancestorsOfThought(argumentPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ThoughtInConversationDTO>> {
            return localVarFp.ancestorsOfThought(argumentPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} publicArgumentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bookmarkThought(publicArgumentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.bookmarkThought(publicArgumentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} anchorArgumentPublicId 
         * @param {string} [order] Follow-rule for which child to follow at each level: best (Wilson confidence, default), old (oldest first), new (newest first).
         * @param {number} [limit] Max descendant levels below the anchor (default 20, clamped to the depth cap).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chainUnderAnchorThought(anchorArgumentPublicId: string, order?: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ThoughtInConversationDTO>> {
            return localVarFp.chainUnderAnchorThought(anchorArgumentPublicId, order, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} thoughtPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countThoughtView(thoughtPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.countThoughtView(thoughtPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} argumentPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteThought(argumentPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<ThoughtInConversationDTO> {
            return localVarFp.deleteThought(argumentPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} thoughtPublicId 
         * @param {EditThoughtRequest} editThoughtRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editThought(thoughtPublicId: string, editThoughtRequest: EditThoughtRequest, options?: RawAxiosRequestConfig): AxiosPromise<EditThoughtResponse> {
            return localVarFp.editThought(thoughtPublicId, editThoughtRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} thoughtPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinThought(thoughtPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<ThoughtDTO> {
            return localVarFp.pinThought(thoughtPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PublishThoughtRequest} publishThoughtRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishThought(publishThoughtRequest: PublishThoughtRequest, options?: RawAxiosRequestConfig): AxiosPromise<PublishThoughtResponse> {
            return localVarFp.publishThought(publishThoughtRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} publicArgumentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeVoteFromThought(publicArgumentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeVoteFromThought(publicArgumentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} parentArgumentPublicId 
         * @param {string} [paginationParameter] Opaque keyset cursor from the last row\&#39;s paginationParameter (iso|id). Absent/blank returns the first page.
         * @param {number} [pageSize] Page size (default 20, capped at 100).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repliesUnderParentThought(parentArgumentPublicId: string, paginationParameter?: string, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ThoughtInConversationDTO>> {
            return localVarFp.repliesUnderParentThought(parentArgumentPublicId, paginationParameter, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} argumentPublicId 
         * @param {CreateContentReportRequest} createContentReportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportThought(argumentPublicId: string, createContentReportRequest: CreateContentReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reportThought(argumentPublicId, createContentReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} argumentPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restoreOwnDeletedThought(argumentPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<ThoughtInConversationDTO> {
            return localVarFp.restoreOwnDeletedThought(argumentPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} rootArgumentPublicId 
         * @param {number} [maxDepth] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        subtreeUnderRootThought(rootArgumentPublicId: string, maxDepth?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ThoughtInConversationDTO>> {
            return localVarFp.subtreeUnderRootThought(rootArgumentPublicId, maxDepth, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} anchorThoughtPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thoughtConversationContext(anchorThoughtPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<ThoughtConversationContextDTO> {
            return localVarFp.thoughtConversationContext(anchorThoughtPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} argumentPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thoughtEmbedSnapshot(argumentPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<ThoughtEmbedSnapshotDTO> {
            return localVarFp.thoughtEmbedSnapshot(argumentPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} openingPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thoughtOpening(openingPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<OpeningThoughtWithConversationDTO> {
            return localVarFp.thoughtOpening(openingPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} thoughtPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thoughtVersions(thoughtPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<ThoughtVersionsResponse> {
            return localVarFp.thoughtVersions(thoughtPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} discussionPublicId 
         * @param {string} [paginationParameter] Pagination timestamp (ISO_LOCAL_DATE_TIME). Nullable — backend will use current time when absent.
         * @param {string} [groupPublicIds] Optional comma-separated discussion group public ids used to filter opening arguments by author group membership.
         * @param {string} [openingArgumentOrdering] Optional ordering style for opening arguments. Supported values: best (Wilson confidence, default), controversial, new, old, agreed, disagreed, conversations. Legacy top is still accepted as an alias for agreed.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        thoughtsInDiscussion(discussionPublicId: string, paginationParameter?: string, groupPublicIds?: string, openingArgumentOrdering?: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.thoughtsInDiscussion(discussionPublicId, paginationParameter, groupPublicIds, openingArgumentOrdering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} publicArgumentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unbookmarkThought(publicArgumentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unbookmarkThought(publicArgumentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} thoughtPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unpinThought(thoughtPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unpinThought(thoughtPublicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} publicArgumentId 
         * @param {string} agreementMode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voteOnThought(publicArgumentId: string, agreementMode: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.voteOnThought(publicArgumentId, agreementMode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxThoughtRestControllerApi - object-oriented interface
 * @export
 * @class AjaxThoughtRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxThoughtRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} argumentPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxThoughtRestControllerApi
     */
    public ancestorsOfThought(argumentPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxThoughtRestControllerApiFp(this.configuration).ancestorsOfThought(argumentPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} publicArgumentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxThoughtRestControllerApi
     */
    public bookmarkThought(publicArgumentId: string, options?: RawAxiosRequestConfig) {
        return AjaxThoughtRestControllerApiFp(this.configuration).bookmarkThought(publicArgumentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} anchorArgumentPublicId 
     * @param {string} [order] Follow-rule for which child to follow at each level: best (Wilson confidence, default), old (oldest first), new (newest first).
     * @param {number} [limit] Max descendant levels below the anchor (default 20, clamped to the depth cap).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxThoughtRestControllerApi
     */
    public chainUnderAnchorThought(anchorArgumentPublicId: string, order?: string, limit?: number, options?: RawAxiosRequestConfig) {
        return AjaxThoughtRestControllerApiFp(this.configuration).chainUnderAnchorThought(anchorArgumentPublicId, order, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} thoughtPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxThoughtRestControllerApi
     */
    public countThoughtView(thoughtPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxThoughtRestControllerApiFp(this.configuration).countThoughtView(thoughtPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} argumentPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxThoughtRestControllerApi
     */
    public deleteThought(argumentPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxThoughtRestControllerApiFp(this.configuration).deleteThought(argumentPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} thoughtPublicId 
     * @param {EditThoughtRequest} editThoughtRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxThoughtRestControllerApi
     */
    public editThought(thoughtPublicId: string, editThoughtRequest: EditThoughtRequest, options?: RawAxiosRequestConfig) {
        return AjaxThoughtRestControllerApiFp(this.configuration).editThought(thoughtPublicId, editThoughtRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} thoughtPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxThoughtRestControllerApi
     */
    public pinThought(thoughtPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxThoughtRestControllerApiFp(this.configuration).pinThought(thoughtPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PublishThoughtRequest} publishThoughtRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxThoughtRestControllerApi
     */
    public publishThought(publishThoughtRequest: PublishThoughtRequest, options?: RawAxiosRequestConfig) {
        return AjaxThoughtRestControllerApiFp(this.configuration).publishThought(publishThoughtRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} publicArgumentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxThoughtRestControllerApi
     */
    public removeVoteFromThought(publicArgumentId: string, options?: RawAxiosRequestConfig) {
        return AjaxThoughtRestControllerApiFp(this.configuration).removeVoteFromThought(publicArgumentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} parentArgumentPublicId 
     * @param {string} [paginationParameter] Opaque keyset cursor from the last row\&#39;s paginationParameter (iso|id). Absent/blank returns the first page.
     * @param {number} [pageSize] Page size (default 20, capped at 100).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxThoughtRestControllerApi
     */
    public repliesUnderParentThought(parentArgumentPublicId: string, paginationParameter?: string, pageSize?: number, options?: RawAxiosRequestConfig) {
        return AjaxThoughtRestControllerApiFp(this.configuration).repliesUnderParentThought(parentArgumentPublicId, paginationParameter, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} argumentPublicId 
     * @param {CreateContentReportRequest} createContentReportRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxThoughtRestControllerApi
     */
    public reportThought(argumentPublicId: string, createContentReportRequest: CreateContentReportRequest, options?: RawAxiosRequestConfig) {
        return AjaxThoughtRestControllerApiFp(this.configuration).reportThought(argumentPublicId, createContentReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} argumentPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxThoughtRestControllerApi
     */
    public restoreOwnDeletedThought(argumentPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxThoughtRestControllerApiFp(this.configuration).restoreOwnDeletedThought(argumentPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} rootArgumentPublicId 
     * @param {number} [maxDepth] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxThoughtRestControllerApi
     */
    public subtreeUnderRootThought(rootArgumentPublicId: string, maxDepth?: number, options?: RawAxiosRequestConfig) {
        return AjaxThoughtRestControllerApiFp(this.configuration).subtreeUnderRootThought(rootArgumentPublicId, maxDepth, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} anchorThoughtPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxThoughtRestControllerApi
     */
    public thoughtConversationContext(anchorThoughtPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxThoughtRestControllerApiFp(this.configuration).thoughtConversationContext(anchorThoughtPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} argumentPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxThoughtRestControllerApi
     */
    public thoughtEmbedSnapshot(argumentPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxThoughtRestControllerApiFp(this.configuration).thoughtEmbedSnapshot(argumentPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} openingPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxThoughtRestControllerApi
     */
    public thoughtOpening(openingPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxThoughtRestControllerApiFp(this.configuration).thoughtOpening(openingPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} thoughtPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxThoughtRestControllerApi
     */
    public thoughtVersions(thoughtPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxThoughtRestControllerApiFp(this.configuration).thoughtVersions(thoughtPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} discussionPublicId 
     * @param {string} [paginationParameter] Pagination timestamp (ISO_LOCAL_DATE_TIME). Nullable — backend will use current time when absent.
     * @param {string} [groupPublicIds] Optional comma-separated discussion group public ids used to filter opening arguments by author group membership.
     * @param {string} [openingArgumentOrdering] Optional ordering style for opening arguments. Supported values: best (Wilson confidence, default), controversial, new, old, agreed, disagreed, conversations. Legacy top is still accepted as an alias for agreed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxThoughtRestControllerApi
     */
    public thoughtsInDiscussion(discussionPublicId: string, paginationParameter?: string, groupPublicIds?: string, openingArgumentOrdering?: string, options?: RawAxiosRequestConfig) {
        return AjaxThoughtRestControllerApiFp(this.configuration).thoughtsInDiscussion(discussionPublicId, paginationParameter, groupPublicIds, openingArgumentOrdering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} publicArgumentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxThoughtRestControllerApi
     */
    public unbookmarkThought(publicArgumentId: string, options?: RawAxiosRequestConfig) {
        return AjaxThoughtRestControllerApiFp(this.configuration).unbookmarkThought(publicArgumentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} thoughtPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxThoughtRestControllerApi
     */
    public unpinThought(thoughtPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxThoughtRestControllerApiFp(this.configuration).unpinThought(thoughtPublicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} publicArgumentId 
     * @param {string} agreementMode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxThoughtRestControllerApi
     */
    public voteOnThought(publicArgumentId: string, agreementMode: string, options?: RawAxiosRequestConfig) {
        return AjaxThoughtRestControllerApiFp(this.configuration).voteOnThought(publicArgumentId, agreementMode, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxUiCensusRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxUiCensusRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {UiCensusBatchRequest} [uiCensusBatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordBatch: async (uiCensusBatchRequest?: UiCensusBatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/ui-census/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uiCensusBatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxUiCensusRestControllerApi - functional programming interface
 * @export
 */
export const AjaxUiCensusRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxUiCensusRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {UiCensusBatchRequest} [uiCensusBatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordBatch(uiCensusBatchRequest?: UiCensusBatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordBatch(uiCensusBatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxUiCensusRestControllerApi.recordBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxUiCensusRestControllerApi - factory interface
 * @export
 */
export const AjaxUiCensusRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxUiCensusRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {UiCensusBatchRequest} [uiCensusBatchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordBatch(uiCensusBatchRequest?: UiCensusBatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.recordBatch(uiCensusBatchRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxUiCensusRestControllerApi - object-oriented interface
 * @export
 * @class AjaxUiCensusRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxUiCensusRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {UiCensusBatchRequest} [uiCensusBatchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxUiCensusRestControllerApi
     */
    public recordBatch(uiCensusBatchRequest?: UiCensusBatchRequest, options?: RawAxiosRequestConfig) {
        return AjaxUiCensusRestControllerApiFp(this.configuration).recordBatch(uiCensusBatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxUserFeaturedRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxUserFeaturedRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {FeatureItemRequest} featureItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feature: async (featureItemRequest: FeatureItemRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'featureItemRequest' is not null or undefined
            assertParamExists('feature', 'featureItemRequest', featureItemRequest)
            const localVarPath = `/ajax/user/featured`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(featureItemRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidates: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/user/featured/candidates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShowcase: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getShowcase', 'username', username)
            const localVarPath = `/ajax/user/featured/profile/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReorderRequest} reorderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorder: async (reorderRequest: ReorderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reorderRequest' is not null or undefined
            assertParamExists('reorder', 'reorderRequest', reorderRequest)
            const localVarPath = `/ajax/user/featured/order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reorderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} kind 
         * @param {string} targetPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unfeature: async (kind: string, targetPublicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'kind' is not null or undefined
            assertParamExists('unfeature', 'kind', kind)
            // verify required parameter 'targetPublicId' is not null or undefined
            assertParamExists('unfeature', 'targetPublicId', targetPublicId)
            const localVarPath = `/ajax/user/featured/{kind}/{targetPublicId}`
                .replace(`{${"kind"}}`, encodeURIComponent(String(kind)))
                .replace(`{${"targetPublicId"}}`, encodeURIComponent(String(targetPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxUserFeaturedRestControllerApi - functional programming interface
 * @export
 */
export const AjaxUserFeaturedRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxUserFeaturedRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {FeatureItemRequest} featureItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async feature(featureItemRequest: FeatureItemRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileShowcaseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.feature(featureItemRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxUserFeaturedRestControllerApi.feature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidates(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeaturedCandidatesDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidates(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxUserFeaturedRestControllerApi.getCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShowcase(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileShowcaseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShowcase(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxUserFeaturedRestControllerApi.getShowcase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ReorderRequest} reorderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorder(reorderRequest: ReorderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileShowcaseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorder(reorderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxUserFeaturedRestControllerApi.reorder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} kind 
         * @param {string} targetPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unfeature(kind: string, targetPublicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileShowcaseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unfeature(kind, targetPublicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxUserFeaturedRestControllerApi.unfeature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxUserFeaturedRestControllerApi - factory interface
 * @export
 */
export const AjaxUserFeaturedRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxUserFeaturedRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {FeatureItemRequest} featureItemRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        feature(featureItemRequest: FeatureItemRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProfileShowcaseDTO> {
            return localVarFp.feature(featureItemRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidates(options?: RawAxiosRequestConfig): AxiosPromise<FeaturedCandidatesDTO> {
            return localVarFp.getCandidates(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShowcase(username: string, options?: RawAxiosRequestConfig): AxiosPromise<ProfileShowcaseDTO> {
            return localVarFp.getShowcase(username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReorderRequest} reorderRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorder(reorderRequest: ReorderRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProfileShowcaseDTO> {
            return localVarFp.reorder(reorderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} kind 
         * @param {string} targetPublicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unfeature(kind: string, targetPublicId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProfileShowcaseDTO> {
            return localVarFp.unfeature(kind, targetPublicId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxUserFeaturedRestControllerApi - object-oriented interface
 * @export
 * @class AjaxUserFeaturedRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxUserFeaturedRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {FeatureItemRequest} featureItemRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxUserFeaturedRestControllerApi
     */
    public feature(featureItemRequest: FeatureItemRequest, options?: RawAxiosRequestConfig) {
        return AjaxUserFeaturedRestControllerApiFp(this.configuration).feature(featureItemRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxUserFeaturedRestControllerApi
     */
    public getCandidates(options?: RawAxiosRequestConfig) {
        return AjaxUserFeaturedRestControllerApiFp(this.configuration).getCandidates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxUserFeaturedRestControllerApi
     */
    public getShowcase(username: string, options?: RawAxiosRequestConfig) {
        return AjaxUserFeaturedRestControllerApiFp(this.configuration).getShowcase(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReorderRequest} reorderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxUserFeaturedRestControllerApi
     */
    public reorder(reorderRequest: ReorderRequest, options?: RawAxiosRequestConfig) {
        return AjaxUserFeaturedRestControllerApiFp(this.configuration).reorder(reorderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} kind 
     * @param {string} targetPublicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxUserFeaturedRestControllerApi
     */
    public unfeature(kind: string, targetPublicId: string, options?: RawAxiosRequestConfig) {
        return AjaxUserFeaturedRestControllerApiFp(this.configuration).unfeature(kind, targetPublicId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxUserFeedbackControllerApi - axios parameter creator
 * @export
 */
export const AjaxUserFeedbackControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deferPrompt: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/feedback/defer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserFeedbackRequest} userFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFeedback: async (userFeedbackRequest: UserFeedbackRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userFeedbackRequest' is not null or undefined
            assertParamExists('submitFeedback', 'userFeedbackRequest', userFeedbackRequest)
            const localVarPath = `/ajax/feedback/submit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userFeedbackRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxUserFeedbackControllerApi - functional programming interface
 * @export
 */
export const AjaxUserFeedbackControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxUserFeedbackControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deferPrompt(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deferPrompt(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxUserFeedbackControllerApi.deferPrompt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UserFeedbackRequest} userFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitFeedback(userFeedbackRequest: UserFeedbackRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitFeedback(userFeedbackRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxUserFeedbackControllerApi.submitFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxUserFeedbackControllerApi - factory interface
 * @export
 */
export const AjaxUserFeedbackControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxUserFeedbackControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deferPrompt(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.deferPrompt(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserFeedbackRequest} userFeedbackRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitFeedback(userFeedbackRequest: UserFeedbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.submitFeedback(userFeedbackRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxUserFeedbackControllerApi - object-oriented interface
 * @export
 * @class AjaxUserFeedbackControllerApi
 * @extends {BaseAPI}
 */
export class AjaxUserFeedbackControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxUserFeedbackControllerApi
     */
    public deferPrompt(options?: RawAxiosRequestConfig) {
        return AjaxUserFeedbackControllerApiFp(this.configuration).deferPrompt(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserFeedbackRequest} userFeedbackRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxUserFeedbackControllerApi
     */
    public submitFeedback(userFeedbackRequest: UserFeedbackRequest, options?: RawAxiosRequestConfig) {
        return AjaxUserFeedbackControllerApiFp(this.configuration).submitFeedback(userFeedbackRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxUserRestControllerApi - axios parameter creator
 * @export
 */
export const AjaxUserRestControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {TargetUsernameRequest} targetUsernameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockUser: async (targetUsernameRequest: TargetUsernameRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'targetUsernameRequest' is not null or undefined
            assertParamExists('blockUser', 'targetUsernameRequest', targetUsernameRequest)
            const localVarPath = `/ajax/user/block`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(targetUsernameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countView: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('countView', 'username', username)
            const localVarPath = `/ajax/user/count_view/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followUser: async (username: string, surface?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('followUser', 'username', username)
            const localVarPath = `/ajax/user/follow/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (surface !== undefined) {
                localVarQueryParameter['surface'] = surface;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {string} source 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupsToInviteUserTo: async (username: string, source: string, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getGroupsToInviteUserTo', 'username', username)
            // verify required parameter 'source' is not null or undefined
            assertParamExists('getGroupsToInviteUserTo', 'source', source)
            const localVarPath = `/ajax/user/{username}/groups`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupsToInviteUserToBootstrap: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getGroupsToInviteUserToBootstrap', 'username', username)
            const localVarPath = `/ajax/user/{username}/groups/modal-bootstrap`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSafetyState: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getSafetyState', 'username', username)
            const localVarPath = `/ajax/user/safety-state/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAchievements: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getUserAchievements', 'username', username)
            const localVarPath = `/ajax/user/achievements/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPageBootstrap: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getUserPageBootstrap', 'username', username)
            const localVarPath = `/ajax/user/profile-bootstrap/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVisitorInsights: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getVisitorInsights', 'username', username)
            const localVarPath = `/ajax/user/visitor-insights/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markOnboardingComplete: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/user/onboarding/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TargetUsernameRequest} targetUsernameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        muteUser: async (targetUsernameRequest: TargetUsernameRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'targetUsernameRequest' is not null or undefined
            assertParamExists('muteUser', 'targetUsernameRequest', targetUsernameRequest)
            const localVarPath = `/ajax/user/mute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(targetUsernameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportUserRequest} reportUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportUser: async (reportUserRequest: ReportUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportUserRequest' is not null or undefined
            assertParamExists('reportUser', 'reportUserRequest', reportUserRequest)
            const localVarPath = `/ajax/user/report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOwnDiscussions: async (q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/user/me/discussions/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockUser: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('unblockUser', 'username', username)
            const localVarPath = `/ajax/user/block/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unfollowUser: async (username: string, surface?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('unfollowUser', 'username', username)
            const localVarPath = `/ajax/user/follow/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (surface !== undefined) {
                localVarQueryParameter['surface'] = surface;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmuteUser: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('unmuteUser', 'username', username)
            const localVarPath = `/ajax/user/mute/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxUserRestControllerApi - functional programming interface
 * @export
 */
export const AjaxUserRestControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxUserRestControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {TargetUsernameRequest} targetUsernameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async blockUser(targetUsernameRequest: TargetUsernameRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.blockUser(targetUsernameRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxUserRestControllerApi.blockUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countView(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countView(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxUserRestControllerApi.countView']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followUser(username: string, surface?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followUser(username, surface, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxUserRestControllerApi.followUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {string} source 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupsToInviteUserTo(username: string, source: string, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupsToInviteUserToDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupsToInviteUserTo(username, source, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxUserRestControllerApi.getGroupsToInviteUserTo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupsToInviteUserToBootstrap(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupsToInviteUserToModalBootstrapDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupsToInviteUserToBootstrap(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxUserRestControllerApi.getGroupsToInviteUserToBootstrap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSafetyState(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSafetyStateDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSafetyState(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxUserRestControllerApi.getSafetyState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserAchievements(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AchievementCabinetDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserAchievements(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxUserRestControllerApi.getUserAchievements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserPageBootstrap(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserPageBootstrapDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserPageBootstrap(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxUserRestControllerApi.getUserPageBootstrap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVisitorInsights(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserVisitorInsightsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVisitorInsights(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxUserRestControllerApi.getVisitorInsights']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markOnboardingComplete(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markOnboardingComplete(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxUserRestControllerApi.markOnboardingComplete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TargetUsernameRequest} targetUsernameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async muteUser(targetUsernameRequest: TargetUsernameRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.muteUser(targetUsernameRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxUserRestControllerApi.muteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ReportUserRequest} reportUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportUser(reportUserRequest: ReportUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportUser(reportUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxUserRestControllerApi.reportUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchOwnDiscussions(q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiscussionsToAddToSeriesDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchOwnDiscussions(q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxUserRestControllerApi.searchOwnDiscussions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unblockUser(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unblockUser(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxUserRestControllerApi.unblockUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unfollowUser(username: string, surface?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unfollowUser(username, surface, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxUserRestControllerApi.unfollowUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unmuteUser(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unmuteUser(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxUserRestControllerApi.unmuteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxUserRestControllerApi - factory interface
 * @export
 */
export const AjaxUserRestControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxUserRestControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {TargetUsernameRequest} targetUsernameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        blockUser(targetUsernameRequest: TargetUsernameRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.blockUser(targetUsernameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countView(username: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.countView(username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followUser(username: string, surface?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.followUser(username, surface, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {string} source 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupsToInviteUserTo(username: string, source: string, q?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupsToInviteUserToDTO>> {
            return localVarFp.getGroupsToInviteUserTo(username, source, q, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupsToInviteUserToBootstrap(username: string, options?: RawAxiosRequestConfig): AxiosPromise<GroupsToInviteUserToModalBootstrapDTO> {
            return localVarFp.getGroupsToInviteUserToBootstrap(username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSafetyState(username: string, options?: RawAxiosRequestConfig): AxiosPromise<UserSafetyStateDTO> {
            return localVarFp.getSafetyState(username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAchievements(username: string, options?: RawAxiosRequestConfig): AxiosPromise<AchievementCabinetDTO> {
            return localVarFp.getUserAchievements(username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserPageBootstrap(username: string, options?: RawAxiosRequestConfig): AxiosPromise<UserPageBootstrapDTO> {
            return localVarFp.getUserPageBootstrap(username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVisitorInsights(username: string, options?: RawAxiosRequestConfig): AxiosPromise<UserVisitorInsightsDTO> {
            return localVarFp.getVisitorInsights(username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markOnboardingComplete(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markOnboardingComplete(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TargetUsernameRequest} targetUsernameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        muteUser(targetUsernameRequest: TargetUsernameRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.muteUser(targetUsernameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportUserRequest} reportUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportUser(reportUserRequest: ReportUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reportUser(reportUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOwnDiscussions(q?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DiscussionsToAddToSeriesDTO>> {
            return localVarFp.searchOwnDiscussions(q, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unblockUser(username: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unblockUser(username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [surface] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unfollowUser(username: string, surface?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unfollowUser(username, surface, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmuteUser(username: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unmuteUser(username, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxUserRestControllerApi - object-oriented interface
 * @export
 * @class AjaxUserRestControllerApi
 * @extends {BaseAPI}
 */
export class AjaxUserRestControllerApi extends BaseAPI {
    /**
     * 
     * @param {TargetUsernameRequest} targetUsernameRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxUserRestControllerApi
     */
    public blockUser(targetUsernameRequest: TargetUsernameRequest, options?: RawAxiosRequestConfig) {
        return AjaxUserRestControllerApiFp(this.configuration).blockUser(targetUsernameRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxUserRestControllerApi
     */
    public countView(username: string, options?: RawAxiosRequestConfig) {
        return AjaxUserRestControllerApiFp(this.configuration).countView(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {string} [surface] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxUserRestControllerApi
     */
    public followUser(username: string, surface?: string, options?: RawAxiosRequestConfig) {
        return AjaxUserRestControllerApiFp(this.configuration).followUser(username, surface, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {string} source 
     * @param {string} [q] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxUserRestControllerApi
     */
    public getGroupsToInviteUserTo(username: string, source: string, q?: string, options?: RawAxiosRequestConfig) {
        return AjaxUserRestControllerApiFp(this.configuration).getGroupsToInviteUserTo(username, source, q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxUserRestControllerApi
     */
    public getGroupsToInviteUserToBootstrap(username: string, options?: RawAxiosRequestConfig) {
        return AjaxUserRestControllerApiFp(this.configuration).getGroupsToInviteUserToBootstrap(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxUserRestControllerApi
     */
    public getSafetyState(username: string, options?: RawAxiosRequestConfig) {
        return AjaxUserRestControllerApiFp(this.configuration).getSafetyState(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxUserRestControllerApi
     */
    public getUserAchievements(username: string, options?: RawAxiosRequestConfig) {
        return AjaxUserRestControllerApiFp(this.configuration).getUserAchievements(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxUserRestControllerApi
     */
    public getUserPageBootstrap(username: string, options?: RawAxiosRequestConfig) {
        return AjaxUserRestControllerApiFp(this.configuration).getUserPageBootstrap(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxUserRestControllerApi
     */
    public getVisitorInsights(username: string, options?: RawAxiosRequestConfig) {
        return AjaxUserRestControllerApiFp(this.configuration).getVisitorInsights(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxUserRestControllerApi
     */
    public markOnboardingComplete(options?: RawAxiosRequestConfig) {
        return AjaxUserRestControllerApiFp(this.configuration).markOnboardingComplete(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TargetUsernameRequest} targetUsernameRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxUserRestControllerApi
     */
    public muteUser(targetUsernameRequest: TargetUsernameRequest, options?: RawAxiosRequestConfig) {
        return AjaxUserRestControllerApiFp(this.configuration).muteUser(targetUsernameRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportUserRequest} reportUserRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxUserRestControllerApi
     */
    public reportUser(reportUserRequest: ReportUserRequest, options?: RawAxiosRequestConfig) {
        return AjaxUserRestControllerApiFp(this.configuration).reportUser(reportUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [q] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxUserRestControllerApi
     */
    public searchOwnDiscussions(q?: string, options?: RawAxiosRequestConfig) {
        return AjaxUserRestControllerApiFp(this.configuration).searchOwnDiscussions(q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxUserRestControllerApi
     */
    public unblockUser(username: string, options?: RawAxiosRequestConfig) {
        return AjaxUserRestControllerApiFp(this.configuration).unblockUser(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {string} [surface] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxUserRestControllerApi
     */
    public unfollowUser(username: string, surface?: string, options?: RawAxiosRequestConfig) {
        return AjaxUserRestControllerApiFp(this.configuration).unfollowUser(username, surface, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxUserRestControllerApi
     */
    public unmuteUser(username: string, options?: RawAxiosRequestConfig) {
        return AjaxUserRestControllerApiFp(this.configuration).unmuteUser(username, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjaxWelcomeHostControllerApi - axios parameter creator
 * @export
 */
export const AjaxWelcomeHostControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {WelcomeHostInvitationAnswerRequest} welcomeHostInvitationAnswerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answerInvitation: async (welcomeHostInvitationAnswerRequest: WelcomeHostInvitationAnswerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'welcomeHostInvitationAnswerRequest' is not null or undefined
            assertParamExists('answerInvitation', 'welcomeHostInvitationAnswerRequest', welcomeHostInvitationAnswerRequest)
            const localVarPath = `/ajax/welcome_host/invitation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(welcomeHostInvitationAnswerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitation: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/welcome_host/invitation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjaxWelcomeHostControllerApi - functional programming interface
 * @export
 */
export const AjaxWelcomeHostControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjaxWelcomeHostControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {WelcomeHostInvitationAnswerRequest} welcomeHostInvitationAnswerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async answerInvitation(welcomeHostInvitationAnswerRequest: WelcomeHostInvitationAnswerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.answerInvitation(welcomeHostInvitationAnswerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxWelcomeHostControllerApi.answerInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvitation(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WelcomeHostInvitationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvitation(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjaxWelcomeHostControllerApi.getInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjaxWelcomeHostControllerApi - factory interface
 * @export
 */
export const AjaxWelcomeHostControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjaxWelcomeHostControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {WelcomeHostInvitationAnswerRequest} welcomeHostInvitationAnswerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answerInvitation(welcomeHostInvitationAnswerRequest: WelcomeHostInvitationAnswerRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.answerInvitation(welcomeHostInvitationAnswerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitation(options?: RawAxiosRequestConfig): AxiosPromise<WelcomeHostInvitationDTO> {
            return localVarFp.getInvitation(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AjaxWelcomeHostControllerApi - object-oriented interface
 * @export
 * @class AjaxWelcomeHostControllerApi
 * @extends {BaseAPI}
 */
export class AjaxWelcomeHostControllerApi extends BaseAPI {
    /**
     * 
     * @param {WelcomeHostInvitationAnswerRequest} welcomeHostInvitationAnswerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxWelcomeHostControllerApi
     */
    public answerInvitation(welcomeHostInvitationAnswerRequest: WelcomeHostInvitationAnswerRequest, options?: RawAxiosRequestConfig) {
        return AjaxWelcomeHostControllerApiFp(this.configuration).answerInvitation(welcomeHostInvitationAnswerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjaxWelcomeHostControllerApi
     */
    public getInvitation(options?: RawAxiosRequestConfig) {
        return AjaxWelcomeHostControllerApiFp(this.configuration).getInvitation(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AppleAppSiteAssociationControllerApi - axios parameter creator
 * @export
 */
export const AppleAppSiteAssociationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleAppSiteAssociation: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/.well-known/apple-app-site-association`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppleAppSiteAssociationControllerApi - functional programming interface
 * @export
 */
export const AppleAppSiteAssociationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppleAppSiteAssociationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appleAppSiteAssociation(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appleAppSiteAssociation(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppleAppSiteAssociationControllerApi.appleAppSiteAssociation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AppleAppSiteAssociationControllerApi - factory interface
 * @export
 */
export const AppleAppSiteAssociationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppleAppSiteAssociationControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appleAppSiteAssociation(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.appleAppSiteAssociation(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppleAppSiteAssociationControllerApi - object-oriented interface
 * @export
 * @class AppleAppSiteAssociationControllerApi
 * @extends {BaseAPI}
 */
export class AppleAppSiteAssociationControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppleAppSiteAssociationControllerApi
     */
    public appleAppSiteAssociation(options?: RawAxiosRequestConfig) {
        return AppleAppSiteAssociationControllerApiFp(this.configuration).appleAppSiteAssociation(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AssetLinksControllerApi - axios parameter creator
 * @export
 */
export const AssetLinksControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetLinks: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/.well-known/assetlinks.json`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssetLinksControllerApi - functional programming interface
 * @export
 */
export const AssetLinksControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssetLinksControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetLinks(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: any; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetLinks(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AssetLinksControllerApi.assetLinks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AssetLinksControllerApi - factory interface
 * @export
 */
export const AssetLinksControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssetLinksControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetLinks(options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: any; }>> {
            return localVarFp.assetLinks(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssetLinksControllerApi - object-oriented interface
 * @export
 * @class AssetLinksControllerApi
 * @extends {BaseAPI}
 */
export class AssetLinksControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetLinksControllerApi
     */
    public assetLinks(options?: RawAxiosRequestConfig) {
        return AssetLinksControllerApiFp(this.configuration).assetLinks(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmailOpenTrackingControllerApi - axios parameter creator
 * @export
 */
export const EmailOpenTrackingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} deliveryPublicId 
         * @param {string} [emlane] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        open: async (deliveryPublicId: string, emlane?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deliveryPublicId' is not null or undefined
            assertParamExists('open', 'deliveryPublicId', deliveryPublicId)
            const localVarPath = `/e/o/{deliveryPublicId}`
                .replace(`{${"deliveryPublicId"}}`, encodeURIComponent(String(deliveryPublicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (emlane !== undefined) {
                localVarQueryParameter['emlane'] = emlane;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailOpenTrackingControllerApi - functional programming interface
 * @export
 */
export const EmailOpenTrackingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailOpenTrackingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} deliveryPublicId 
         * @param {string} [emlane] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async open(deliveryPublicId: string, emlane?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.open(deliveryPublicId, emlane, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailOpenTrackingControllerApi.open']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmailOpenTrackingControllerApi - factory interface
 * @export
 */
export const EmailOpenTrackingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailOpenTrackingControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} deliveryPublicId 
         * @param {string} [emlane] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        open(deliveryPublicId: string, emlane?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.open(deliveryPublicId, emlane, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailOpenTrackingControllerApi - object-oriented interface
 * @export
 * @class EmailOpenTrackingControllerApi
 * @extends {BaseAPI}
 */
export class EmailOpenTrackingControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} deliveryPublicId 
     * @param {string} [emlane] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailOpenTrackingControllerApi
     */
    public open(deliveryPublicId: string, emlane?: string, options?: RawAxiosRequestConfig) {
        return EmailOpenTrackingControllerApiFp(this.configuration).open(deliveryPublicId, emlane, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmailPreviewControllerApi - axios parameter creator
 * @export
 */
export const EmailPreviewControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [template] 
         * @param {string} [scenario] 
         * @param {string} [locale] 
         * @param {string} [viewport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renderEmailPreview: async (template?: string, scenario?: string, locale?: string, viewport?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/page/email-previews/render`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (template !== undefined) {
                localVarQueryParameter['template'] = template;
            }

            if (scenario !== undefined) {
                localVarQueryParameter['scenario'] = scenario;
            }

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (viewport !== undefined) {
                localVarQueryParameter['viewport'] = viewport;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [template] 
         * @param {string} [scenario] 
         * @param {string} [locale] 
         * @param {string} [viewport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTestEmail: async (template?: string, scenario?: string, locale?: string, viewport?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/page/email-previews/send-test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (template !== undefined) {
                localVarQueryParameter['template'] = template;
            }

            if (scenario !== undefined) {
                localVarQueryParameter['scenario'] = scenario;
            }

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (viewport !== undefined) {
                localVarQueryParameter['viewport'] = viewport;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailPreviewControllerApi - functional programming interface
 * @export
 */
export const EmailPreviewControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailPreviewControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [template] 
         * @param {string} [scenario] 
         * @param {string} [locale] 
         * @param {string} [viewport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async renderEmailPreview(template?: string, scenario?: string, locale?: string, viewport?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.renderEmailPreview(template, scenario, locale, viewport, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailPreviewControllerApi.renderEmailPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [template] 
         * @param {string} [scenario] 
         * @param {string} [locale] 
         * @param {string} [viewport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendTestEmail(template?: string, scenario?: string, locale?: string, viewport?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendTestEmail(template, scenario, locale, viewport, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailPreviewControllerApi.sendTestEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmailPreviewControllerApi - factory interface
 * @export
 */
export const EmailPreviewControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailPreviewControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [template] 
         * @param {string} [scenario] 
         * @param {string} [locale] 
         * @param {string} [viewport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        renderEmailPreview(template?: string, scenario?: string, locale?: string, viewport?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.renderEmailPreview(template, scenario, locale, viewport, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [template] 
         * @param {string} [scenario] 
         * @param {string} [locale] 
         * @param {string} [viewport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTestEmail(template?: string, scenario?: string, locale?: string, viewport?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.sendTestEmail(template, scenario, locale, viewport, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailPreviewControllerApi - object-oriented interface
 * @export
 * @class EmailPreviewControllerApi
 * @extends {BaseAPI}
 */
export class EmailPreviewControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} [template] 
     * @param {string} [scenario] 
     * @param {string} [locale] 
     * @param {string} [viewport] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailPreviewControllerApi
     */
    public renderEmailPreview(template?: string, scenario?: string, locale?: string, viewport?: string, options?: RawAxiosRequestConfig) {
        return EmailPreviewControllerApiFp(this.configuration).renderEmailPreview(template, scenario, locale, viewport, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [template] 
     * @param {string} [scenario] 
     * @param {string} [locale] 
     * @param {string} [viewport] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailPreviewControllerApi
     */
    public sendTestEmail(template?: string, scenario?: string, locale?: string, viewport?: string, options?: RawAxiosRequestConfig) {
        return EmailPreviewControllerApiFp(this.configuration).sendTestEmail(template, scenario, locale, viewport, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmailSesNotificationControllerApi - axios parameter creator
 * @export
 */
export const EmailSesNotificationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [token] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receive1: async (token?: string, body?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/webhooks/email/ses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailSesNotificationControllerApi - functional programming interface
 * @export
 */
export const EmailSesNotificationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailSesNotificationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [token] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receive1(token?: string, body?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receive1(token, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailSesNotificationControllerApi.receive1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmailSesNotificationControllerApi - factory interface
 * @export
 */
export const EmailSesNotificationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailSesNotificationControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [token] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receive1(token?: string, body?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.receive1(token, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailSesNotificationControllerApi - object-oriented interface
 * @export
 * @class EmailSesNotificationControllerApi
 * @extends {BaseAPI}
 */
export class EmailSesNotificationControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} [token] 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailSesNotificationControllerApi
     */
    public receive1(token?: string, body?: string, options?: RawAxiosRequestConfig) {
        return EmailSesNotificationControllerApiFp(this.configuration).receive1(token, body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmailUnsubscribeControllerApi - axios parameter creator
 * @export
 */
export const EmailUnsubscribeControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [token] 
         * @param {string} [lane] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resubscribe1: async (token?: string, lane?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/email/resubscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (lane !== undefined) {
                localVarQueryParameter['lane'] = lane;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [token] 
         * @param {string} [lane] 
         * @param {string} [delivery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeOneClick2: async (token?: string, lane?: string, delivery?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/email/unsubscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (lane !== undefined) {
                localVarQueryParameter['lane'] = lane;
            }

            if (delivery !== undefined) {
                localVarQueryParameter['delivery'] = delivery;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [token] 
         * @param {string} [lane] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeSimilar: async (token?: string, lane?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/email/unsubscribe-similar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (lane !== undefined) {
                localVarQueryParameter['lane'] = lane;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailUnsubscribeControllerApi - functional programming interface
 * @export
 */
export const EmailUnsubscribeControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailUnsubscribeControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [token] 
         * @param {string} [lane] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resubscribe1(token?: string, lane?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resubscribe1(token, lane, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailUnsubscribeControllerApi.resubscribe1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [token] 
         * @param {string} [lane] 
         * @param {string} [delivery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unsubscribeOneClick2(token?: string, lane?: string, delivery?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unsubscribeOneClick2(token, lane, delivery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailUnsubscribeControllerApi.unsubscribeOneClick2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [token] 
         * @param {string} [lane] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unsubscribeSimilar(token?: string, lane?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unsubscribeSimilar(token, lane, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailUnsubscribeControllerApi.unsubscribeSimilar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmailUnsubscribeControllerApi - factory interface
 * @export
 */
export const EmailUnsubscribeControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailUnsubscribeControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [token] 
         * @param {string} [lane] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resubscribe1(token?: string, lane?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.resubscribe1(token, lane, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [token] 
         * @param {string} [lane] 
         * @param {string} [delivery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeOneClick2(token?: string, lane?: string, delivery?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.unsubscribeOneClick2(token, lane, delivery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [token] 
         * @param {string} [lane] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeSimilar(token?: string, lane?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.unsubscribeSimilar(token, lane, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailUnsubscribeControllerApi - object-oriented interface
 * @export
 * @class EmailUnsubscribeControllerApi
 * @extends {BaseAPI}
 */
export class EmailUnsubscribeControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} [token] 
     * @param {string} [lane] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailUnsubscribeControllerApi
     */
    public resubscribe1(token?: string, lane?: string, options?: RawAxiosRequestConfig) {
        return EmailUnsubscribeControllerApiFp(this.configuration).resubscribe1(token, lane, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [token] 
     * @param {string} [lane] 
     * @param {string} [delivery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailUnsubscribeControllerApi
     */
    public unsubscribeOneClick2(token?: string, lane?: string, delivery?: string, options?: RawAxiosRequestConfig) {
        return EmailUnsubscribeControllerApiFp(this.configuration).unsubscribeOneClick2(token, lane, delivery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [token] 
     * @param {string} [lane] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailUnsubscribeControllerApi
     */
    public unsubscribeSimilar(token?: string, lane?: string, options?: RawAxiosRequestConfig) {
        return EmailUnsubscribeControllerApiFp(this.configuration).unsubscribeSimilar(token, lane, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HealthCheckControllerApi - axios parameter creator
 * @export
 */
export const HealthCheckControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/healthcheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthCheckControllerApi - functional programming interface
 * @export
 */
export const HealthCheckControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthCheckControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthCheck(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthCheck(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthCheckControllerApi.healthCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HealthCheckControllerApi - factory interface
 * @export
 */
export const HealthCheckControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthCheckControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthCheck(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.healthCheck(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthCheckControllerApi - object-oriented interface
 * @export
 * @class HealthCheckControllerApi
 * @extends {BaseAPI}
 */
export class HealthCheckControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthCheckControllerApi
     */
    public healthCheck(options?: RawAxiosRequestConfig) {
        return HealthCheckControllerApiFp(this.configuration).healthCheck(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LandingShowcaseControllerApi - axios parameter creator
 * @export
 */
export const LandingShowcaseControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showcaseDiscussions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/landing/showcase/discussions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showcaseGroups: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/landing/showcase/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showcaseSeries: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/landing/showcase/series`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LandingShowcaseControllerApi - functional programming interface
 * @export
 */
export const LandingShowcaseControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LandingShowcaseControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async showcaseDiscussions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DiscussionWithoutContentDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.showcaseDiscussions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LandingShowcaseControllerApi.showcaseDiscussions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async showcaseGroups(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GroupDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.showcaseGroups(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LandingShowcaseControllerApi.showcaseGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async showcaseSeries(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SeriesDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.showcaseSeries(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LandingShowcaseControllerApi.showcaseSeries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LandingShowcaseControllerApi - factory interface
 * @export
 */
export const LandingShowcaseControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LandingShowcaseControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showcaseDiscussions(options?: RawAxiosRequestConfig): AxiosPromise<Array<DiscussionWithoutContentDTO>> {
            return localVarFp.showcaseDiscussions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showcaseGroups(options?: RawAxiosRequestConfig): AxiosPromise<Array<GroupDTO>> {
            return localVarFp.showcaseGroups(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        showcaseSeries(options?: RawAxiosRequestConfig): AxiosPromise<Array<SeriesDTO>> {
            return localVarFp.showcaseSeries(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LandingShowcaseControllerApi - object-oriented interface
 * @export
 * @class LandingShowcaseControllerApi
 * @extends {BaseAPI}
 */
export class LandingShowcaseControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandingShowcaseControllerApi
     */
    public showcaseDiscussions(options?: RawAxiosRequestConfig) {
        return LandingShowcaseControllerApiFp(this.configuration).showcaseDiscussions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandingShowcaseControllerApi
     */
    public showcaseGroups(options?: RawAxiosRequestConfig) {
        return LandingShowcaseControllerApiFp(this.configuration).showcaseGroups(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandingShowcaseControllerApi
     */
    public showcaseSeries(options?: RawAxiosRequestConfig) {
        return LandingShowcaseControllerApiFp(this.configuration).showcaseSeries(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NewsletterSesNotificationControllerApi - axios parameter creator
 * @export
 */
export const NewsletterSesNotificationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [token] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receive: async (token?: string, body?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/webhooks/newsletter/ses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NewsletterSesNotificationControllerApi - functional programming interface
 * @export
 */
export const NewsletterSesNotificationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NewsletterSesNotificationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [token] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async receive(token?: string, body?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.receive(token, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsletterSesNotificationControllerApi.receive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NewsletterSesNotificationControllerApi - factory interface
 * @export
 */
export const NewsletterSesNotificationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NewsletterSesNotificationControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [token] 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        receive(token?: string, body?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.receive(token, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NewsletterSesNotificationControllerApi - object-oriented interface
 * @export
 * @class NewsletterSesNotificationControllerApi
 * @extends {BaseAPI}
 */
export class NewsletterSesNotificationControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} [token] 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsletterSesNotificationControllerApi
     */
    public receive(token?: string, body?: string, options?: RawAxiosRequestConfig) {
        return NewsletterSesNotificationControllerApiFp(this.configuration).receive(token, body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OgImageControllerApi - axios parameter creator
 * @export
 */
export const OgImageControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} publicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discussionCard: async (publicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'publicId' is not null or undefined
            assertParamExists('discussionCard', 'publicId', publicId)
            const localVarPath = `/og/discussion/{publicId}.png`
                .replace(`{${"publicId"}}`, encodeURIComponent(String(publicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OgImageControllerApi - functional programming interface
 * @export
 */
export const OgImageControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OgImageControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} publicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async discussionCard(publicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.discussionCard(publicId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OgImageControllerApi.discussionCard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OgImageControllerApi - factory interface
 * @export
 */
export const OgImageControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OgImageControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} publicId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        discussionCard(publicId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.discussionCard(publicId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OgImageControllerApi - object-oriented interface
 * @export
 * @class OgImageControllerApi
 * @extends {BaseAPI}
 */
export class OgImageControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} publicId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OgImageControllerApi
     */
    public discussionCard(publicId: string, options?: RawAxiosRequestConfig) {
        return OgImageControllerApiFp(this.configuration).discussionCard(publicId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RssControllerApi - axios parameter creator
 * @export
 */
export const RssControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} newsletterSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newsletterFeed: async (newsletterSlug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newsletterSlug' is not null or undefined
            assertParamExists('newsletterFeed', 'newsletterSlug', newsletterSlug)
            const localVarPath = `/newsletter/{newsletterSlug}/rss`
                .replace(`{${"newsletterSlug"}}`, encodeURIComponent(String(newsletterSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} seriesSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seriesFeed: async (seriesSlug: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'seriesSlug' is not null or undefined
            assertParamExists('seriesFeed', 'seriesSlug', seriesSlug)
            const localVarPath = `/series/{seriesSlug}/rss`
                .replace(`{${"seriesSlug"}}`, encodeURIComponent(String(seriesSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagFeed: async (tag: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tag' is not null or undefined
            assertParamExists('tagFeed', 'tag', tag)
            const localVarPath = `/tag/{tag}/rss`
                .replace(`{${"tag"}}`, encodeURIComponent(String(tag)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFeed: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('userFeed', 'username', username)
            const localVarPath = `/user/{username}/rss`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RssControllerApi - functional programming interface
 * @export
 */
export const RssControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RssControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} newsletterSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async newsletterFeed(newsletterSlug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.newsletterFeed(newsletterSlug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RssControllerApi.newsletterFeed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} seriesSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async seriesFeed(seriesSlug: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.seriesFeed(seriesSlug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RssControllerApi.seriesFeed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} tag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tagFeed(tag: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tagFeed(tag, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RssControllerApi.tagFeed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userFeed(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userFeed(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RssControllerApi.userFeed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RssControllerApi - factory interface
 * @export
 */
export const RssControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RssControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} newsletterSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newsletterFeed(newsletterSlug: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.newsletterFeed(newsletterSlug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} seriesSlug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seriesFeed(seriesSlug: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.seriesFeed(seriesSlug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tag 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tagFeed(tag: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.tagFeed(tag, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userFeed(username: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.userFeed(username, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RssControllerApi - object-oriented interface
 * @export
 * @class RssControllerApi
 * @extends {BaseAPI}
 */
export class RssControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} newsletterSlug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RssControllerApi
     */
    public newsletterFeed(newsletterSlug: string, options?: RawAxiosRequestConfig) {
        return RssControllerApiFp(this.configuration).newsletterFeed(newsletterSlug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} seriesSlug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RssControllerApi
     */
    public seriesFeed(seriesSlug: string, options?: RawAxiosRequestConfig) {
        return RssControllerApiFp(this.configuration).seriesFeed(seriesSlug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} tag 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RssControllerApi
     */
    public tagFeed(tag: string, options?: RawAxiosRequestConfig) {
        return RssControllerApiFp(this.configuration).tagFeed(tag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RssControllerApi
     */
    public userFeed(username: string, options?: RawAxiosRequestConfig) {
        return RssControllerApiFp(this.configuration).userFeed(username, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SecurityTxtControllerApi - axios parameter creator
 * @export
 */
export const SecurityTxtControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityTxt: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/.well-known/security.txt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SecurityTxtControllerApi - functional programming interface
 * @export
 */
export const SecurityTxtControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SecurityTxtControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async securityTxt(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.securityTxt(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SecurityTxtControllerApi.securityTxt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SecurityTxtControllerApi - factory interface
 * @export
 */
export const SecurityTxtControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SecurityTxtControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        securityTxt(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.securityTxt(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SecurityTxtControllerApi - object-oriented interface
 * @export
 * @class SecurityTxtControllerApi
 * @extends {BaseAPI}
 */
export class SecurityTxtControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityTxtControllerApi
     */
    public securityTxt(options?: RawAxiosRequestConfig) {
        return SecurityTxtControllerApiFp(this.configuration).securityTxt(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SignupNudgeUnsubscribeControllerApi - axios parameter creator
 * @export
 */
export const SignupNudgeUnsubscribeControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeOneClick1: async (token?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/signup-nudge/unsubscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SignupNudgeUnsubscribeControllerApi - functional programming interface
 * @export
 */
export const SignupNudgeUnsubscribeControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SignupNudgeUnsubscribeControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unsubscribeOneClick1(token?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unsubscribeOneClick1(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SignupNudgeUnsubscribeControllerApi.unsubscribeOneClick1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SignupNudgeUnsubscribeControllerApi - factory interface
 * @export
 */
export const SignupNudgeUnsubscribeControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SignupNudgeUnsubscribeControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeOneClick1(token?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.unsubscribeOneClick1(token, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SignupNudgeUnsubscribeControllerApi - object-oriented interface
 * @export
 * @class SignupNudgeUnsubscribeControllerApi
 * @extends {BaseAPI}
 */
export class SignupNudgeUnsubscribeControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} [token] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SignupNudgeUnsubscribeControllerApi
     */
    public unsubscribeOneClick1(token?: string, options?: RawAxiosRequestConfig) {
        return SignupNudgeUnsubscribeControllerApiFp(this.configuration).unsubscribeOneClick1(token, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SitemapControllerApi - axios parameter creator
 * @export
 */
export const SitemapControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSitemapArtifact: async (fileName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('getSitemapArtifact', 'fileName', fileName)
            const localVarPath = `/sitemaps/{fileName}`
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSitemapIndex: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sitemap.xml`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SitemapControllerApi - functional programming interface
 * @export
 */
export const SitemapControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SitemapControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSitemapArtifact(fileName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSitemapArtifact(fileName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SitemapControllerApi.getSitemapArtifact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSitemapIndex(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSitemapIndex(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SitemapControllerApi.getSitemapIndex']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SitemapControllerApi - factory interface
 * @export
 */
export const SitemapControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SitemapControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSitemapArtifact(fileName: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getSitemapArtifact(fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSitemapIndex(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getSitemapIndex(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SitemapControllerApi - object-oriented interface
 * @export
 * @class SitemapControllerApi
 * @extends {BaseAPI}
 */
export class SitemapControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} fileName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitemapControllerApi
     */
    public getSitemapArtifact(fileName: string, options?: RawAxiosRequestConfig) {
        return SitemapControllerApiFp(this.configuration).getSitemapArtifact(fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SitemapControllerApi
     */
    public getSitemapIndex(options?: RawAxiosRequestConfig) {
        return SitemapControllerApiFp(this.configuration).getSitemapIndex(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VerifyNudgeUnsubscribeControllerApi - axios parameter creator
 * @export
 */
export const VerifyNudgeUnsubscribeControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resubscribe: async (token?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/verify-nudge/resubscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeOneClick: async (token?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ajax/verify-nudge/unsubscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VerifyNudgeUnsubscribeControllerApi - functional programming interface
 * @export
 */
export const VerifyNudgeUnsubscribeControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VerifyNudgeUnsubscribeControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resubscribe(token?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resubscribe(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerifyNudgeUnsubscribeControllerApi.resubscribe']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unsubscribeOneClick(token?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unsubscribeOneClick(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerifyNudgeUnsubscribeControllerApi.unsubscribeOneClick']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VerifyNudgeUnsubscribeControllerApi - factory interface
 * @export
 */
export const VerifyNudgeUnsubscribeControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VerifyNudgeUnsubscribeControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resubscribe(token?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.resubscribe(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [token] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeOneClick(token?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.unsubscribeOneClick(token, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VerifyNudgeUnsubscribeControllerApi - object-oriented interface
 * @export
 * @class VerifyNudgeUnsubscribeControllerApi
 * @extends {BaseAPI}
 */
export class VerifyNudgeUnsubscribeControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} [token] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifyNudgeUnsubscribeControllerApi
     */
    public resubscribe(token?: string, options?: RawAxiosRequestConfig) {
        return VerifyNudgeUnsubscribeControllerApiFp(this.configuration).resubscribe(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [token] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerifyNudgeUnsubscribeControllerApi
     */
    public unsubscribeOneClick(token?: string, options?: RawAxiosRequestConfig) {
        return VerifyNudgeUnsubscribeControllerApiFp(this.configuration).unsubscribeOneClick(token, options).then((request) => request(this.axios, this.basePath));
    }
}



